// Inicialización básica de i18next para CRA sin romper la UI.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/common.json';
import es from './locales/es/common.json';
// Namespaces dedicados
import studyTutorEn from './locales/en/studyTutor.json';
import studyTutorEs from './locales/es/studyTutor.json';
import studyTutorPt from './locales/pt/studyTutor.json';
import studyTutorFr from './locales/fr/studyTutor.json';
import studyTutorDe from './locales/de/studyTutor.json';
import studyTutorIt from './locales/it/studyTutor.json';
import studyTutorZh from './locales/zh/studyTutor.json';
import studyTutorJa from './locales/ja/studyTutor.json';
import studyTutorKo from './locales/ko/studyTutor.json';
import studyTutorAr from './locales/ar/studyTutor.json';
import studyTutorHi from './locales/hi/studyTutor.json';
import studyTutorRu from './locales/ru/studyTutor.json';
import studyTutorTr from './locales/tr/studyTutor.json';
// Cargas perezosas simples: por ahora incluimos paquetes mínimos embebidos.
// Para un bundle pequeño, podríamos pasar a lazy + dynamic import más tarde.
const pt = { translation: {
  "dashboard.hero.powered_by":"Impulsionado por múltiplas inteligências artificiais",
  "auth.promo.subscribe":"Cadastre-se grátis",
  "auth.promo.trial":"Experimente a plataforma por 7 dias",
  "auth.promo.nocard":"Sem cartão de crédito",
  "dashboard.hero.rotating":[
    "Aprenda, crie e pesquise com múltiplas inteligências artificiais."
  ],
  "plans.cards":{
    "trial":{"name":"Trial","price":"Grátis","period":"Avaliação de 7 dias","features":["15 ações/dia","Orchestrator múltiplas IAs","Ferramentas básicas","Suporte da comunidade"],"limitations":["Recursos limitados","Sem exportações","Sem Deep Research","Termina após 7 dias"]},
    "pro":{"name":"Pro","period":"por mês","features":["25 perguntas (vitalícias)","300 ações/dia","Acesso a múltiplas IAs","Maioria das ferramentas desbloqueadas","Processamento prioritário"],"limitations":["Deep Research limitado","Sem ações ilimitadas"]},
    "pro_plus":{"name":"Pro+","period":"por mês","features":["50 perguntas (vitalícias)","Ações ilimitadas","Deep Research completo","Todas as ferramentas desbloqueadas","Suporte prioritário 24/7"],"limitations":[]}
  },
  "plans.popular":"Mais Popular","plans.current":"Plano Atual","plans.select":"Selecionar Plano","plans.paypal.success":"Assinatura bem-sucedida! ID: ","plans.trial_active":"Trial Ativo",
  "dashboard.cta.life_director":"Plano Pessoal IA","dashboard.cta.study_tutor":"Tutor de Estudo IA","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"Conexões por Interesses","dashboard.cta.propose_ideas":"Ideias e Projetos","dashboard.cta.mass_control":"IA de Impacto Comunitário",
  "dashboard.desc.life_director":"Coaching personalizado por IA","dashboard.desc.study_tutor":"Aprendizagem adaptativa inteligente","dashboard.desc.create_project":"Desenvolvimento completo guiado","dashboard.desc.deepweb":"Pesquisa acadêmica profunda","dashboard.desc.connect_people":"Rede de conhecimento colaborativo","dashboard.desc.propose_ideas":"Gerador de oportunidades","dashboard.desc.mass_control":"Impacto social construtivo",
  "dashboard.quick.prompts.life_director":"Aja como meu coach de vida pessoal...","dashboard.quick.prompts.study_tutor":"Torne-se meu tutor pessoal...","dashboard.quick.prompts.deepweb":"Acesse informações acadêmicas e legais profundas...","dashboard.quick.prompts.connect_people":"Ajude-me a encontrar e conectar pessoas com interesses semelhantes.","dashboard.quick.prompts.propose_ideas":"Gere ideias inovadoras de projetos ou negócios...",
  "dashboard.meta.title":"Meta‑resposta de {{count}} IAs","dashboard.meta.confidence":"confiança","dashboard.meta.queried_ais":"IAs consultadas:","dashboard.meta.more":"+{{count}} mais...","dashboard.meta.specialized_ais":"{{count}} IAs especializadas","dashboard.meta.categories":"Categorias","dashboard.meta.general":"Geral",
  "dashboard.welcome.title":"Bem-vindo, {{name}}!","dashboard.welcome.body":"Você está conectado à rede de IA mais avançada...","dashboard.welcome.precision.title":"Precisão","dashboard.welcome.precision.desc":"Respostas verificadas por múltiplas IAs","dashboard.welcome.speed.title":"Velocidade","dashboard.welcome.speed.desc":"Processamento paralelo para respostas rápidas","dashboard.welcome.intelligence.title":"Inteligência","dashboard.welcome.intelligence.desc":"Síntese de conhecimento multiárea",
  "dashboard.trial.title":"Você está usando apenas 8% do poder real do IntelliVerseOne","dashboard.trial.body":"Desbloqueie acesso total às múltiplas IAs, ferramentas premium e recursos avançados.","dashboard.trial.view_plans":"Ver Planos Premium","dashboard.trial.continue":"Continuar Trial ({{days}} dias)",
  "dashboard.stats.today":"Consultas Hoje","dashboard.stats.accuracy":"Precisão",
  "dashboard.quick_actions.title":"Ações Rápidas",
  "dashboard.quick_actions.subtitle":"Explore as capacidades do IntelliVerseOne",
  "dashboard.quick_actions.unlock_title":"Desbloqueie Todo o Potencial",
  "dashboard.quick_actions.unlock_desc":"Acesse todas as ferramentas e recursos premium",
  "prompt.suggestions.title":"💡 Sugestões inteligentes:","prompt.suggestions.1":"Como melhorar minha produtividade pessoal?","prompt.suggestions.2":"Explique os algoritmos de ordenação mais eficientes","prompt.suggestions.3":"Ideias para um projeto React","prompt.suggestions.4":"Estratégias de marketing digital para 2024","prompt.suggestions.5":"Tendências em inteligência artificial","prompt.suggestions.6":"Como criar uma startup de sucesso passo a passo",
  "prompt.process.analyzing":"🔍 Analisando sua consulta...","prompt.process.selecting":"🧠 Selecionando IAs especializadas...","prompt.process.querying":"⚡ Consultando rede neural...","prompt.process.synthesizing":"🔄 Sintetizando respostas...","prompt.process.optimizing":"✨ Otimizando meta‑resposta...",
  "prompt.placeholder.trial":"Faça sua pergunta... (Restantes hoje: 8/10)","prompt.placeholder.default":"Faça sua pergunta às múltiplas inteligências artificiais...",
  "prompt.placeholder.search":"Buscar informação específica...",
  "prompt.search.mode":"Modo pesquisa",
  "prompt.search.truncated":"Texto truncado (limite modo pesquisa).",
  "prompt.attach.limit_files":"Máximo de arquivos atingido",
  "prompt.attach.file_too_big":"Arquivo muito grande (60KB máx): ",
  "prompt.attach.total_too_big":"Limite total de anexos excedido",
  "prompt.attach.unsupported_now":"Formato suportado em breve (requer modo nuvem): ",
  "prompt.attach.unsupported":"Formato não suportado: ",
  "prompt.attach.read_error":"Erro ao ler: ",
  "prompt.attach.remove":"Remover anexo",
  "prompt.voice.recording":"Gravando áudio... (máx 60s)",
  "prompt.voice.unsupported":"Reconhecimento de voz não suportado neste navegador.",
  "prompt.actions.Adjuntar arquivo":"Anexar arquivo","prompt.actions.Búsqueda avanzada":"Pesquisa avançada","prompt.actions.Voz a texto":"Voz para texto","prompt.actions.Prompt inteligente":"Prompt inteligente",
  "prompt.status.querying":"Consultando...","prompt.status.optimizing":"Otimizando...","prompt.cta.consult_ais":"Consultar {{count}} IAs","prompt.trial.info":"Plano gratuito: {{days}} dias restantes •","prompt.trial.upgrade":"Atualize para consultas ilimitadas",
  "common.ok":"OK","common.sending":"Enviando...","common.sent":"Enviado","common.error":"Erro","common.send":"Enviar","common.close":"Fechar","common.cancel":"Cancelar","common.loading":"Carregando...",
  "auth.login":"Iniciar sessão","auth.signup":"Registre-se gratuitamente","auth.password":"Senha","auth.forgot":"Esqueceu sua senha?","auth.continue":"Continuar","auth.magic_short":"Magic link","auth.check_email":"Verifique seu email para confirmar a conta","auth.reset":"Redefinir senha","auth.resend":"Reenviar",
  "time.just_now":"Agora mesmo","time.minutes_ago":"Há {{count}} minutos","time.hours_ago":"Há {{count}} horas","time.days_ago":"Há {{count}} dias",
  "auth.with.google":"Continuar com Google","auth.with.apple":"Continuar com Apple","auth.with.microsoft":"Continuar com Microsoft","auth.with.facebook":"Continuar com Facebook","auth.with.github":"Continuar com GitHub","auth.with.linkedin":"Continuar com LinkedIn","auth.or":"ou","auth.legal":"Ao continuar você aceita nossos","auth.terms":"Termos","auth.and":"e","auth.privacy":"Privacidade","auth.errors.social":"Não foi possível entrar com o provedor selecionado","auth.protected_route":"Rota protegida: inicie sessão para continuar",
  "auth.email":"Email","auth.remember_me":"Lembrar-me","auth.magic.send":"Enviar link","auth.magic.resend_btn":"Reenviar","auth.magic.resend_in":"Reenviar ({{s}})","auth.logged_in":"Sessão iniciada","auth.password.requirements_failed":"A senha não atende aos requisitos","auth.reset.sent_conditional":"Se a conta existir, enviamos um email para redefini-la.","auth.verification.unverified":"Seu email não está verificado.","auth.verification.resent":"Email de verificação reenviado.","auth.errors.login_failed":"Não foi possível iniciar sessão","auth.errors.signup_failed":"Não foi possível registrar","auth.errors.magic_failed":"Não foi possível enviar o link","auth.errors.resend_failed":"Não foi possível reenviar",
  "auth.env.missing":"Variáveis do Supabase não detectadas. Defina REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY ou VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY e reinicie o servidor.",
  "sidebar.dashboard":"Painel","sidebar.new_chat":"Novo Chat","sidebar.new_project":"Novo Projeto","sidebar.history":"Histórico","sidebar.tools":"Ferramentas","sidebar.my_gpts":"Meus GPTs","sidebar.plans":"Planos","sidebar.my_profile":"Meu Perfil","sidebar.days_left":"{{count}} dias restantes",
  "pages.plans.title":"Planos e Preços","pages.plans.subtitle":"Escolha o plano perfeito para desbloquear todo o potencial do IntelliVerseOne","pages.plans.stats.ais":"IAs Disponíveis","pages.plans.stats.tools":"Ferramentas","pages.plans.stats.availability":"Disponibilidade","pages.plans.compare":"Comparação Detalhada","pages.plans.trial_expiring":"Sua avaliação gratuita expira em {{days}} dias","pages.plans.trial_expiring_hint":"Atualize agora para manter acesso total a todos os recursos","pages.plans.trial_expired_ago":"Sua avaliação gratuita expirou há {{days}} dias","plans.cta.start_pro":"Começar Plano Pro","plans.cta.go_pro_plus":"Ir direto ao Pro+","pages.plans.view_plans":"Ver Planos",
  "pages.faq.title":"Perguntas Frequentes","pages.faq.q.change_anytime":"Posso mudar de plano a qualquer momento?","pages.faq.a.change_anytime":"Sim, você pode atualizar ou rebaixar seu plano quando quiser. As mudanças são aplicadas imediatamente.","pages.faq.q.free_includes":"O que inclui o plano gratuito?","pages.faq.a.free_includes":"Acesso básico a 5 IAs, 10 consultas diárias e ferramentas essenciais por 7 dias.","pages.faq.q.annual_discounts":"Há descontos para pagamento anual?","pages.faq.a.annual_discounts":"Sim, oferecemos 2 meses grátis no pagamento anual. Contate o suporte para mais detalhes.","pages.faq.q.payment_methods":"Quais métodos de pagamento vocês aceitam?","pages.faq.a.payment_methods":"Aceitamos cartões de crédito/débito, PayPal e transferências bancárias.","pages.faq.q.cancel_anytime":"Posso cancelar a qualquer momento?","pages.faq.a.cancel_anytime":"Sim, você pode cancelar sua assinatura sem penalidades.","pages.faq.q.support":"Vocês oferecem suporte técnico?","pages.faq.a.support":"Sim, todos os planos incluem suporte. Planos pagos têm suporte prioritário 24/7.",
  "pages.history.title":"Histórico de Conversas","pages.history.subtitle":"Revise e pesquise suas conversas anteriores",
  "pages.tools.title":"Ferramentas de IA","pages.tools.subtitle":"Suíte completa de ferramentas com inteligência artificial","pages.tools.search_placeholder":"Buscar ferramentas...","pages.tools.empty":"Nenhuma ferramenta encontrada","pages.tools.empty_hint":"Tente outros termos de busca ou mude a categoria","pages.tools.more_coming":"Mais Ferramentas em Desenvolvimento","pages.tools.more_coming_desc":"Adicionamos constantemente novas ferramentas de IA para impulsionar sua produtividade",
  "pages.projects.create_title":"Criar Projeto","pages.projects.step1_title":"Que tipo de projeto você quer criar?","pages.projects.details_title":"Detalhes do projeto","pages.projects.name_label":"Nome do projeto","pages.projects.name_ph":"Ex.: Meu Portfólio Pessoal","pages.projects.desc_label":"Descrição","pages.projects.desc_ph":"Descreva o que seu projeto faz...","pages.projects.purpose_label":"Propósito principal","pages.projects.purpose_ph":"Ex.: Mostrar minhas habilidades como desenvolvedor","pages.projects.audience_label":"Público-alvo","pages.projects.audience_ph":"Ex.: Recrutadores e empresas de tecnologia","pages.projects.summary_title":"Resumo do projeto","pages.projects.type":"Tipo","pages.projects.purpose":"Propósito","pages.projects.audience":"Público","pages.projects.title":"Meus Projetos","pages.projects.subtitle":"Crie projetos completos de programação com IA","pages.projects.empty":"Você ainda não tem projetos","pages.projects.first_project":"Crie seu primeiro projeto com IA","pages.projects.unlock_title":"Desbloqueie a Criação de Projetos","pages.projects.reached_limit":"Você atingiu o limite de projetos do seu plano. Faça upgrade para continuar.","pages.projects.upgrade_benefits":"Gere projetos completos com o plano Pro e obtenha exportações avançadas com o Pro+",
  "pages.cta.boost_productivity":"Pronto para turbinar sua produtividade?","pages.cta.join_many":"Junte-se a milhares que já aproveitam o poder da IA coletiva",
  "user.plan.current":"Plano atual","user.plan.trial":"Avaliação","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"Atualizar Plano",
  "goodbye.title":"Sua conta foi excluída","goodbye.subtitle":"Obrigado por experimentar o IntelliVerseOne. Esperamos vê-lo novamente.","goodbye.feedback":"Se quiser nos contar por que está saindo, seu feedback nos ajuda a melhorar.","goodbye.contact":"Contatar suporte","goodbye.home":"Voltar ao início",
    "common.copy":"Copiar","common.coming_soon":"Em breve","common.in_development":"Em desenvolvimento",
    "tools.categories.all":"Todas","tools.categories.content":"Conteúdo","tools.categories.productivity":"Produtividade","tools.categories.analysis":"Análise","tools.categories.social":"Social e Impacto","tools.categories.development":"Desenvolvimento",
  "plans.limitations":"Limitações:",
  "plans.table.available":"Planos Disponíveis",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"Grátis",
  "plans.table.trial.features":"15 ações/dia • Orchestrator múltiplas IAs",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/mês",
  "plans.table.pro.features":"25 perguntas (vitalícias) • 300 ações/dia",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/mês",
  "plans.table.pro_plus.features":"50 perguntas (vitalícias) • Ações ilimitadas • Deep Research completo",
  "pages.history.search_placeholder":"Buscar em conversas...",
  "history.stats.conversations":"Conversas",
  "history.stats.total_responses":"Respostas Totais",
  "history.stats.average_rating":"Avaliação Média",
  "history.stats.active_days":"Dias Ativos",
  "history.category.all":"Todas",
  "history.category.productivity":"Produtividade",
  "history.category.education":"Educação",
  "history.category.development":"Desenvolvimento",
  "history.category.career":"Carreira",
  "history.category.finance":"Finanças",
  "history.label.responses":"respostas",
  "history.empty.title":"Nenhuma conversa encontrada",
  "history.empty.hint_search":"Tente outros termos de busca",
  "history.empty.hint_empty":"Você ainda não tem conversas salvas",
  "history.empty.cta":"Iniciar Nova Conversa",
  "history.smart_search.title":"Busca Semântica Inteligente",
  "history.smart_search.subtitle":"Em breve: busque por conceitos e contexto, não apenas palavras-chave",
  "history.smart_search.card.semantic_ai.title":"IA Semântica",
  "history.smart_search.card.semantic_ai.desc":"Encontre conversas por significado",
  "history.smart_search.card.auto_tagging.title":"Autoetiquetagem",
  "history.smart_search.card.auto_tagging.desc":"Categorização automática inteligente",
  "history.smart_search.card.patterns.title":"Análise de Padrões",
  "history.smart_search.card.patterns.desc":"Insights sobre suas consultas",
  "mygpts.title":"Meus GPTs",
  "mygpts.subtitle":"Crie e gerencie seus assistentes de IA personalizados",
  "mygpts.create_new":"Criar Novo GPT",
  "mygpts.stats.created":"GPTs Criados",
  "mygpts.stats.uses":"Usos Totais",
  "mygpts.stats.limit":"Limite de GPTs",
  "mygpts.stats.templates":"Modelos Disponíveis",
  "mygpts.empty.title":"Você ainda não tem GPTs",
  "mygpts.empty.subtitle":"Crie seu primeiro assistente de IA personalizado",
  "mygpts.empty.cta":"Criar Meu Primeiro GPT",
  "mygpts.locked.title":"Desbloqueie a Criação de GPTs",
  "mygpts.locked.desc.hard":"Você atingiu o limite de GPTs do seu plano. Faça upgrade para continuar.",
  "mygpts.locked.desc.info":"Crie até 5 GPTs personalizados com o plano Pro, ou ilimitados com o Pro+",
  "mygpts.locked.cta":"Ver Planos",
  "mygpts.card.uses":"usos",
  "mygpts.card.created":"Criado",
  "mygpts.card.tone":"Tom",
  "mygpts.card.depth":"Profundidade",
  "mygpts.card.style":"Estilo",
  "mygpts.card.use":"Usar",
  "mygpts.creator.title":"Criar Novo GPT",
  "mygpts.creator.step":"Etapa {{n}} de 4",
  "mygpts.creator.step1.title":"Selecione um modelo base",
  "mygpts.creator.step2.title":"Personalize seu GPT",
  "mygpts.creator.name.placeholder":"ex.: Meu Assistente Pessoal",
  "mygpts.creator.desc.placeholder":"Descreva o que seu GPT faz e como ajuda...",
  "mygpts.creator.icon":"Ícone",
  "mygpts.creator.step3.title":"Configuração de personalidade",
  "mygpts.creator.tone.label":"Tom de comunicação",
  "mygpts.creator.tone.professional":"Profissional",
  "mygpts.creator.tone.friendly":"Amigável",
  "mygpts.creator.tone.casual":"Casual",
  "mygpts.creator.tone.empatic":"Empático",
  "mygpts.creator.tone.direct":"Direto",
  "mygpts.creator.depth.label":"Profundidade das respostas",
  "mygpts.creator.depth.basic":"Básico",
  "mygpts.creator.depth.intermediate":"Intermediário",
  "mygpts.creator.depth.advanced":"Avançado",
  "mygpts.creator.depth.expert":"Especialista",
  "mygpts.creator.style.label":"Estilo de comunicação",
  "mygpts.creator.style.conversational":"Conversacional",
  "mygpts.creator.style.structured":"Estruturado",
  "mygpts.creator.style.creative":"Criativo",
  "mygpts.creator.style.analytical":"Analítico",
  "mygpts.creator.style.reflective":"Reflexivo",
  "mygpts.creator.step4.title":"Prévia do seu GPT",
  "mygpts.creator.preview_hint":"Tudo certo? Você poderá editar seu GPT depois.",
  "mygpts.creator.create":"Criar GPT",
  "mygpts.templates.tutor.name":"Meu Tutor",
  "mygpts.templates.tutor.desc":"Especializado em ensino e explicações",
  "mygpts.templates.emotional.name":"Mentor Emocional",
  "mygpts.templates.emotional.desc":"Apoio emocional e bem‑estar",
  "mygpts.templates.productivity.name":"Minha Produtividade",
  "mygpts.templates.productivity.desc":"Otimização e organização",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"Pesquisa acadêmica profunda",
  "mygpts.templates.crypto.name":"CriptoAtivos",
  "mygpts.templates.crypto.desc":"Análise de criptomoedas e blockchain",
  "mygpts.templates.business.name":"Estrategista de Negócios",
  "mygpts.templates.business.desc":"Consultoria empresarial e estratégia",
  "mygpts.sample.tutor.name":"Meu Tutor Pessoal",
  "mygpts.sample.tutor.desc":"Especializado em explicar conceitos complexos de forma simples",
  "mygpts.sample.productivity.name":"Assistente de Produtividade",
  "mygpts.sample.productivity.desc":"Otimização de tarefas e gestão do tempo",
  "mygpts.sample.emotional.name":"Mentor Emocional",
  "mygpts.sample.emotional.desc":"Apoio emocional e dicas de bem‑estar mental",
  "mygpts.sample.tone.friendly":"amigável",
  "mygpts.sample.tone.direct":"direto",
  "mygpts.sample.tone.empatic":"empático",
  "mygpts.sample.depth.intermediate":"intermediário",
  "mygpts.sample.depth.practical":"prático",
  "mygpts.sample.depth.deep":"profundo",
  "mygpts.sample.style.conversational":"conversacional",
  "mygpts.sample.style.structured":"estruturado",
  "mygpts.sample.style.reflective":"reflexivo",
  "projects.types.web.name":"Aplicação Web",
  "projects.types.web.desc":"Frontend completo com React, Vue ou Angular",
  "projects.types.api.name":"API Backend",
  "projects.types.api.desc":"Servidor e banco de dados com Node.js ou Python",
  "projects.types.mobile.name":"App Móvel",
  "projects.types.mobile.desc":"Aplicativo nativo ou híbrido",
  "projects.types.fullstack.name":"Full Stack",
  "projects.types.fullstack.desc":"Projeto completo frontend + backend",
  "projects.actions.download_zip":"Baixar ZIP",
  "projects.actions.continue":"Continuar",
  "projects.actions.new_project":"Novo Projeto",
  "projects.progress":"Progresso",
  "projects.created_on":"Criado",
  "projects.status.completed":"Concluído",
  "projects.status.in_progress":"Em progresso",
  "projects.status.generating":"Gerando",
  "projects.status.generating_dots":"Gerando...",
  "projects.actions.view":"Ver",
  "projects.detail.untitled":"Projeto sem título",
  "projects.detail.loading_desc":"Buscando detalhes do projeto…",
  "projects.detail.no_desc":"Sem descrição",
  "projects.detail.view":"Ver",
  "projects.detail.summary":"Resumo",
  "projects.detail.actions":"Ações rápidas",
  "projects.detail.view_code":"Ver código",
  "projects.detail.activity":"Atividade",
  "projects.detail.activity_init":"Projeto criado e em fila de geração",
  "projects.detail.activity_ai":"IA preparando estrutura e dependências",
  "projects.detail.activity_docs":"Documentação base inicializada",
  "projects.detail.tech":"Tecnologias",
  "history.sample.1.title":"Como melhorar minha produtividade pessoal",
  "history.sample.1.preview":"Preciso de dicas para ser mais produtivo no meu trabalho diário...",
  "history.sample.2.title":"Explicação de algoritmos de ordenação",
  "history.sample.2.preview":"Você pode explicar os diferentes algoritmos de ordenação...",
  "history.sample.3.title":"Ideias para um projeto React",
  "history.sample.3.preview":"Procuro ideias inovadoras para um projeto em React...",
  "history.sample.4.title":"Dicas para entrevistas de emprego",
  "history.sample.4.preview":"Tenho uma entrevista importante na próxima semana...",
  "history.sample.5.title":"Análise do mercado de criptomoedas",
  "history.sample.5.preview":"O que você acha das tendências atuais do mercado cripto...",
  "projects.mock.1.name":"Portfólio Pessoal",
  "projects.mock.1.desc":"Site profissional com React e Tailwind CSS",
  "projects.mock.2.name":"Aplicativo de Tarefas",
  "projects.mock.2.desc":"Aplicativo de gestão de tarefas com autenticação",
  "projects.mock.3.name":"API REST de E-commerce",
  "projects.mock.3.desc":"Backend completo para loja online",
  "tools.items.emotional-translator.name":"Tradutor IA Emocional",
  "tools.items.emotional-translator.description":"Traduze preservando o tom e o contexto emocional",
  "tools.items.text-reformulator.name":"Reformulador de Textos",
  "tools.items.text-reformulator.description":"Reescreve textos mantendo o significado",
  "tools.items.voice-converter.name":"Conversor Texto para Voz",
  "tools.items.voice-converter.description":"Converte texto em áudio natural",
  "tools.items.prompt-creator.name":"Criador de Prompts",
  "tools.items.prompt-creator.description":"Gera prompts otimizados para qualquer IA",
  "tools.items.viral-titles.name":"Gerador de Títulos Virais",
  "tools.items.viral-titles.description":"Cria títulos que capturam a atenção",
  "tools.items.audience-segmenter.name":"Segmentador de Audiências",
  "tools.items.audience-segmenter.description":"Analisa e segmenta audiências‑alvo",
  "tools.items.idea-repairer.name":"Reparador de Ideias Incompletas",
  "tools.items.idea-repairer.description":"Completa e melhora ideias parciais",
  "tools.items.copy-pulse.name":"CopyPulse – Copiar, Melhorar e Lançar",
  "tools.items.copy-pulse.description":"Analisa, melhora e otimiza qualquer conteúdo",
  "tools.items.file-converter.name":"Conversor Inteligente de Arquivos",
  "tools.items.file-converter.description":"Converte arquivos com IA para otimizar conteúdo",
  "tools.items.arconte-ai.name":"Contato Arconte AI",
  "tools.items.arconte-ai.description":"Acesso direto à IA mais avançada",
  "tools.items.mass-control.name":"IA de Impacto Comunitário",
  "tools.items.mass-control.description":"Ferramentas para impacto social construtivo",
  "pages.not_found.title":"Página Não Encontrada",
  "pages.not_found.body":"Parece que esta página se perdeu no multiverso da inteligência artificial. Nossas múltiplas IAs estão trabalhando para encontrá-la.",
  "pages.not_found.help_title":"Precisa de ajuda?",
  "pages.not_found.help_body":"Se você achar que é um erro, pode nos contatar ou voltar à página principal.",
  "pages.not_found.cta_home":"🏠 Voltar ao Início",
  "pages.not_found.cta_tools":"🛠️ Explorar Ferramentas",
  "pages.not_found.link_support":"📧 Suporte",
  "pages.not_found.link_home":"🏠 Início",
  "pages.not_found.link_plans":"💎 Planos",
  "user.panel_title":"Painel de Usuário",
  "user.security.change_password":"Alterar senha",
  "user.security.change_password_prompt":"Nova senha (mínimo 8 caracteres)",
  "user.security.password_changed":"Senha atualizada",
  "user.security.reset_password":"Enviar link de redefinição",
  "user.security.reset_sent":"Enviamos um email para redefinir sua senha",
  "user.security.title":"Segurança da Conta",
  "user.security.subtitle":"Gerencie credenciais e opções de segurança.",
  "user.security.password":"Senha",
  "user.security.password_hint":"Use uma senha longa e única. MFA em breve.",
  "user.security.email_hint":"Se mudar seu email, você deverá verificá-lo antes de usá-lo.",
  "user.security.password_error":"Não foi possível atualizar a senha",
  "user.security.password_placeholder":"Nova senha segura",
  "user.security.change_password_title":"Atualizar Senha",
  "user.security.change_password_action":"Atualizar",
  "user.security.cancel":"Cancelar",
  "user.security.password_min":"Mínimo 8 caracteres",
  "user.security.logout":"Sair",
  "user.security.delete_account_btn":"Excluir conta",
  "user.security.delete_account":"Excluir conta",
  "user.security.delete_account_desc":"Esta ação é permanente. Você perderá seus projetos, GPTs e dados associados.",
  "user.security.delete_account_type":"Digite EXCLUIR para confirmar:",
  "user.security.delete_account_confirm":"Excluir definitivamente",
  "user.security.delete_account_done":"Solicitação de exclusão enviada. Notificaremos você por email.",
  "user.security.delete_account_signout":"Sessão encerrada. Para concluir a exclusão, configure o webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL.",
  "trial.expired.title":"Seu Trial de 7 dias encerrou!",
  "trial.expired.body":"Você experimentou o poder completo do IntelliVerseOne. Para continuar usando {{feature}}, escolha seu plano.",
  "trial.expired.stats_title":"🎉 Durante seu trial você experimentou:",
  "trial.expired.stat_ias":"IAs consultadas",
  "trial.expired.stat_functionality":"Funcionalidade completa",
  "trial.expired.stat_projects":"Projetos criados",
  "trial.expired.stat_costs":"Custos ocultos",
  "trial.expired.pro_plus_label":"🚀 Plano Pro+ - $9,79/mês",
  "trial.expired.pro_plus_desc":"Funcionalidade completa + prioridade + multimídia IA",
  "trial.expired.pro_label":"⭐ Plano Pro - $5,79/mês",
  "trial.expired.pro_desc":"Perfeito para uso completo e profissional",
  "trial.expired.free_option":"Ou continue com funcionalidade limitada:",
  "trial.expired.free_plan_title":"🆓 Plano Free (Limitado):",
  "trial.expired.free_blocked":"ACESSO COMPLETAMENTE BLOQUEADO",
  "trial.expired.free_no_ias":"Sem consultas às IAs",
  "trial.expired.free_no_premium":"Sem funções premium",
  "trial.expired.free_history_only":"Apenas visualização do histórico anterior",
  "trial.expired.continue_free":"Continuar com Plano Free",
  "trial.expired.benefits":"✨ Garantia de 30 dias • 🔒 Cancele quando quiser • 💰 Preços justos",
  "notifications.welcome.activated":"🚀 IntelliVerseOne ativado - múltiplas IAs prontas para consultar",
  "notifications.welcome.optimized":"🧠 Sistema Meta-IA otimizado para máxima precisão",
  "notifications.welcome.new_features":"⚡ Novos recursos disponíveis - Explore as ferramentas",
  "chat.error.auth":"Não autenticado. Faça login para continuar.",
  "chat.error.quota":"Limite diário de consultas atingido. Atualize seu plano.",
  "chat.error.timeout":"A solicitação expirou. Por favor, tente novamente.",
  "chat.error.server":"Erro do servidor. Por favor, tente mais tarde.",
  "chat.error":"Ocorreu um erro. Por favor, tente novamente.",
  "chat.placeholder.answer":"Resposta da IA...",
  "history.auto.title":"Conversa {{date}}",
  "history.actions.confirm":"Excluir esta conversa?",
  "life_coach":{
    "common":{"select":"Selecionar…","selected_count":"{{count}} selecionadas","other":"Outro","other_ph":"Descreva outra opção"},
    "hero":{"title":"Plano Pessoal IA","subtitle":"Plano diário personalizado para organizar prioridades, hábitos e próximos passos."},
    "stats":{"areas":"Áreas selecionadas","habits":"Total de hábitos","remaining":"Ações restantes hoje"},
    "form":{"title":"Seu foco de vida","areas_label":"Áreas prioritárias","daily_time":"Tempo diário disponível","emotions_label":"Como você se sente no geral","emotions.low":"Baixo","emotions.medium":"Médio","emotions.high":"Alto","motivation":"O que te motiva agora?","motivation_ph":"Descreva sua motivação","routine":"Como é sua rotina?","routine_ph":"Descreva brevemente","constraints":"Restrições ou desafios (opcional)","sleep_hours":"Horas de sono","sleep":{"less6":"Menos de 6","6_7":"6-7","7_8":"7-8","more8":"Mais de 8"},"exercise_freq":"Frequência de exercícios","exercise":{"never":"Nunca","1_2":"1-2 vezes/semana","3_4":"3-4 vezes/semana","more4":"Mais de 4/semana"},"diet_focus":"Foco alimentar","diet":{"balanced":"Equilibrado","high_protein":"Alto em proteínas","low_carb":"Baixo carboidrato","plant_based":"Baseado em plantas"},"stress_level":"Nível de estresse","level":{"low":"Baixo","medium":"Médio","high":"Alto"},"productivity_peak":"Pico de produtividade","daytime":{"morning":"Manhã","afternoon":"Tarde","evening":"Noite"},"reminder_time":"Horário preferido para lembrete","distractions":"Principais distrações","learning_goal":"Meta de aprendizado","learning_goal_ph":"O que você quer aprender?","financial_goal":"Meta financeira","financial_goal_ph":"Ex.: poupar X, pagar dívida","relationship_goal":"Meta de relacionamento","relationship_goal_ph":"Família, parceiro, amigos","weekend_routine":"Rotina de fim de semana","weekend_routine_ph":"Atividades típicas","accountability":{"label":"Responsabilidade","solo":"Sozinho","buddy":"Com parceiro","coach":"Com coach"},"comm_style":"Estilo de comunicação","comm":{"concise":"Conciso","detailed":"Detalhado","motivational":"Motivacional"}},
    "area":{"health":"Saúde","career":"Carreira","finance":"Finanças","relationships":"Relacionamentos","personal":"Crescimento pessoal"},
    "motivation":{"health":"Melhorar saúde","career":"Crescer profissionalmente","balance":"Equilíbrio vida-trabalho","learn":"Aprender uma habilidade","finance":"Melhorar finanças","emotional":"Bem-estar emocional","consistency":"Ser consistente","project":"Projeto pessoal","exam":"Preparar exame/certificação","stress":"Reduzir estresse"},
    "routine":{"office":"Escritório 9-5","remote":"Remoto flexível","student":"Estudante","shift":"Turno/rotativo","entrepreneur":"Empreendedor","caretaker":"Cuidador","night":"Noturno","parent":"Pai/mãe com filhos","variable":"Muito variável"},
    "constraints":{"time":"Falta de tempo","stress":"Estresse/Ansiedade","health":"Saúde física","finance":"Finanças","family":"Família/Cuidados","environment":"Ambiente/Espaço","sleep":"Sono irregular","motivation":"Baixa motivação","tech":"Tecnologia/Equipamento"},
    "distractions":{"social":"Redes sociais","notifs":"Notificações","chat":"Mensagens","noise":"Ruído ambiente","multitask":"Multitarefa","phone":"Celular","fatigue":"Fadiga","perfect":"Perfeccionismo","procrast":"Procrastinação","family":"Interrupções familiares","tv":"TV/Jogos"},
    "learning":{"languages":"Idiomas","programming":"Programação","dataai":"Dados/IA","marketing":"Marketing","sales":"Vendas","personal_finance":"Finanças pessoais","music":"Música","design":"Arte/Design","cert":"Exame/Certificação","softskills":"Habilidades interpessoais"},
    "finance":{"emergency":"Fundo de emergência","pay_debt":"Pagar dívidas","cut_expenses":"Reduzir gastos","increase_income":"Aumentar renda","invest":"Investir","buy_house":"Comprar casa/veículo","save_trip":"Poupar para viagem/estudo","credit_score":"Melhorar crédito"},
    "relation":{"communication":"Melhorar comunicação","family_time":"Mais tempo em família","partner":"Fortalecer relacionamento","friends":"Fazer novos amigos","network":"Networking profissional","conflict":"Resolver conflito","boundaries":"Estabelecer limites saudáveis"},
    "weekend":{"rest":"Descanso","family":"Família","sport":"Esporte/atividade","social":"Social","creative":"Criativo/hobby","chores":"Tarefas domésticas","study":"Estudo/projeto","travel":"Viagem"},
    "cta":{"generate":"Gerar Plano","regenerate":"Regenerar","refine_area":"Refinar área"},
    "plan":{"title":"Seu Plano de Vida","progress":"Progresso","weekly_goals":"Metas Semanais","monthly_goals":"Metas Mensais","habits":"Hábitos"},
    "module":{"reminders":"Lembretes inteligentes","feedback":"Feedback semanal"},
    "reminders":{"active":"Você receberá lembretes diários e semanais personalizados.","locked":"Disponível no Pro+. Desbloqueie lembretes automáticos e personalizados."},
    "feedback":{"active":"Você receberá uma análise semanal com recomendações personalizadas.","locked":"Disponível no Pro+. Receba um relatório semanal com melhorias sugeridas."},
    "errors":{"areas":"Selecione pelo menos uma área.","limit":"Você atingiu seu limite diário."},
    "copy":{"m1":"Estou aqui para ajudá-lo a construir a melhor versão de si mesmo.","m2":"Hoje podemos dar mais um passo. Pronto?","m3":"Pequenas mudanças, grandes resultados."},
    "mock":{"goal":{"week":"Complete 3 sessões relacionadas a {{area}}","month":"Alcance um marco importante em {{area}}","learn":{"week":"Estude {{skill}} (3 x 20m)","month":"Complete um módulo em {{skill}}"},"finance":{"week":"Avançe em direção a: {{goal}}","month":"Alcance a meta financeira: {{goal}}"},"weekend":"Atividade de fim de semana: {{w}}","refine":"Ação refinada em {{area}}"},"habit":{"1":"Hábito de 5 minutos em {{area}}","2":"Escreva uma reflexão sobre {{area}}","learn":"Aprenda {{skill}} (15m)","budget":"Revise gastos e orçamento (10m)","relation":"Contato significativo (mensagem/ligação)","sleep":"Higiene do sono (rotina de 10m)","exercise":{"start":"Caminhe 10m","progress":"Sessão de 20m de exercício","maintain":"Manter condicionamento 25m"},"diet":{"pb":"Adicione 1 porção extra de vegetais","hp":"Planeje proteínas em todas as refeições","lc":"Evite açúcares refinados"},"morning":"Bloco AM profundo (20m) para {{area}}","focus":"Sessão sem notificações (15m)","stress":"Técnica de respiração 4-7-8","accountability":"Check-in com parceiro/coach (5m)"}},
    "career":{"habit":{"focus":"Bloco de foco de {{m}}m"}},
    "remark":{"privacy":"Suas respostas são salvas de forma privada."}
  },
  "stats.ias":"IAs consultadas",
  "stats.remaining":"Restantes hoje",
  "stats.accuracy":"Precisão",
  "prompt.actions.search":"Buscar",
  "prompt.actions.voice":"Voz",
  "prompt.actions.suggest":"Sugerir",
  "prompt.actions.attach":"Anexar",
  "prompt.cta.consult_ias":"Consultar {{count}} IAs",
  "prompt.remaining":"Restantes",
  "prompt.placeholder.expired":"Trial expirado —",
  "prompt.placeholder.limit":"Limite atingido —",
  "prompt.trial.expired_msg":"Seu trial expirou. Escolha um plano para continuar.",
  "prompt.trial.choose_plan":"Escolher plano",
  "prompt.search.active":"Modo busca ativo",
  "prompt.voice.no_mic":"Sem acesso ao microfone",
  "prompt.limit.exceeded":"Limite de consultas atingido",
  "prompt.trial.expired":"Trial expirado",
  "auth.logout":"Sair",
  "mygpts.updated":"GPT atualizado",
  "mygpts.created":"GPT criado com sucesso",
  "mygpts.error.save":"Erro ao salvar",
  "mygpts.creator.title_new":"Criar Novo GPT",
  "mygpts.creator.title_edit":"Editar GPT",
  "tools.copy_empty":"Esta ferramenta não tem texto para copiar",
  "tools.copy_ok":"Prompt copiado para a área de transferência",
  "tools.copy_fail":"Não foi possível copiar. Tente novamente.",
  "tools.copy_tooltip":"Copiar prompt para a área de transferência",
  "tools.run_tooltip":"Executar ferramenta com IA",
  "common.run":"Executar",
  "plans.paypal.error":"Ocorreu um erro no pagamento. Tente novamente.",
  "plans.paypal.cancel":"Pagamento cancelado pelo usuário.",
  "plans.paypal.required":"Para ativar este plano, você deve concluir o pagamento via PayPal.",
  "plans.cancel.confirm":"Tem certeza de que deseja cancelar sua assinatura? Você manterá o acesso até o final do período pago.",
  "plans.cancel.no_auth":"Não há sessão ativa. Faça login novamente.",
  "plans.cancel.error":"Erro ao cancelar. Tente novamente ou contate o suporte.",
  "plans.cancel.success":"Assinatura cancelada! Você manterá acesso até {{date}}.",
  "user.connections.title":"Conexões de conta",
  "user.connections.hint":"Vincule provedores para poder fazer login com qualquer um deles.",
  "projects.generated_success":"Projeto gerado! Você já pode baixar o ZIP.",
  "projects.wizard.mvp_includes":"Seu projeto MVP incluirá:",
  "projects.wizard.gen.structure_mvp":"Estrutura base do projeto",
  "projects.wizard.gen.starter":"Arquivos de início funcionais",
  "projects.wizard.gen.readme":"README com instruções",
  "projects.wizard.gen.config":"Configuração inicial",
  "projects.wizard.mvp_note":"Baixe o ZIP e personalize o código como quiser",
  "projects.actions.generating":"Gerando...",
  "common.login_required":"Faça login para continuar",
  "common.reset":"Reiniciar",
  "share.copied":"Link copiado: ",
  "limits.share_pro":"Compartilhar requer plano Pro ou superior.",
  "common.back":"Voltar"
} };
const fr = { translation: {
  "dashboard.hero.powered_by":"Propulsé par plusieurs intelligences artificielles",
  "auth.promo.subscribe":"Inscrivez-vous gratuitement",
  "auth.promo.trial":"Essayez la plateforme 7 jours",
  "auth.promo.nocard":"Sans carte de crédit",
  "dashboard.hero.rotating":[
    "Apprenez, créez et recherchez avec plusieurs intelligences artificielles."
  ],
  "plans.cards":{
    "trial":{"name":"Trial","price":"Gratuit","period":"Essai de 7 jours","features":["15 actions/jour","Orchestrateur IA multiples","Outils de base","Support communautaire"],"limitations":["Fonctionnalités limitées","Pas d’export","Pas d’accès Deep Research","Se termine après 7 jours"]},
    "pro":{"name":"Pro","period":"par mois","features":["25 questions (à vie)","300 actions/jour","Accès à plusieurs IA","La plupart des outils débloqués","Traitement prioritaire"],"limitations":["Deep Research limitée","Pas d’actions illimitées"]},
    "pro_plus":{"name":"Pro+","period":"par mois","features":["50 questions (à vie)","Actions illimitées","Deep Research complète","Tous les outils débloqués","Support prioritaire 24/7"],"limitations":[]}
  },
  "plans.popular":"Le plus populaire","plans.current":"Forfait actuel","plans.select":"Choisir le forfait","plans.paypal.success":"Abonnement réussi ! ID : ","plans.trial_active":"Essai actif",
  "dashboard.cta.life_director":"Plan Personnel IA","dashboard.cta.study_tutor":"Tuteur d'Étude IA","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"Connexion par Intérêts","dashboard.cta.propose_ideas":"Idées et Projets","dashboard.cta.mass_control":"IA d'Impact Communautaire",
  "dashboard.desc.life_director":"Coaching personnalisé par IA","dashboard.desc.study_tutor":"Apprentissage adaptatif intelligent","dashboard.desc.create_project":"Développement complet guidé","dashboard.desc.deepweb":"Recherche académique approfondie","dashboard.desc.connect_people":"Réseau de connaissance collaboratif","dashboard.desc.propose_ideas":"Générateur d’opportunités","dashboard.desc.mass_control":"Impact social constructif",
  "dashboard.quick.prompts.life_director":"Agis comme mon coach de vie personnel...","dashboard.quick.prompts.study_tutor":"Deviens mon tuteur personnel...","dashboard.quick.prompts.deepweb":"Accède à des informations académiques et juridiques approfondies...","dashboard.quick.prompts.connect_people":"Aide-moi à trouver et connecter des personnes partageant mes intérêts.","dashboard.quick.prompts.propose_ideas":"Génère des idées innovantes de projets ou d’entreprises...",
  "dashboard.meta.title":"Méta‑réponse de {{count}} IA","dashboard.meta.confidence":"confiance","dashboard.meta.queried_ais":"IA consultées :","dashboard.meta.more":"+{{count}} de plus...","dashboard.meta.specialized_ais":"{{count}} IA spécialisées","dashboard.meta.categories":"Catégories","dashboard.meta.general":"Général",
  "dashboard.welcome.title":"Bienvenue, {{name}} !","dashboard.welcome.body":"Vous êtes connecté au réseau d’IA le plus avancé...","dashboard.welcome.precision.title":"Précision","dashboard.welcome.precision.desc":"Réponses vérifiées par plusieurs IA","dashboard.welcome.speed.title":"Vitesse","dashboard.welcome.speed.desc":"Traitement parallèle pour des réponses rapides","dashboard.welcome.intelligence.title":"Intelligence","dashboard.welcome.intelligence.desc":"Synthèse de connaissances multi‑domaines",
  "dashboard.trial.title":"Vous n’utilisez que 8% de la puissance réelle d’IntelliVerseOne","dashboard.trial.body":"Débloquez l’accès complet à plusieurs IA, outils premium et fonctions avancées.","dashboard.trial.view_plans":"Voir les Plans Premium","dashboard.trial.continue":"Continuer l’essai ({{days}} jours)",
  "dashboard.stats.today":"Requêtes aujourd’hui","dashboard.stats.accuracy":"Précision",
  "dashboard.quick_actions.title":"Actions Rapides",
  "dashboard.quick_actions.subtitle":"Explorez les capacités d’IntelliVerseOne",
  "dashboard.quick_actions.unlock_title":"Débloquez tout le potentiel",
  "dashboard.quick_actions.unlock_desc":"Accédez à tous les outils et fonctionnalités premium",
  "prompt.suggestions.title":"💡 Suggestions intelligentes :","prompt.suggestions.1":"Comment améliorer ma productivité personnelle ?","prompt.suggestions.2":"Expliquez les algorithmes de tri les plus efficaces","prompt.suggestions.3":"Idées pour un projet React","prompt.suggestions.4":"Stratégies de marketing digital pour 2024","prompt.suggestions.5":"Quelles sont les tendances de l’IA ?","prompt.suggestions.6":"Comment créer une startup à succès étape par étape",
  "prompt.process.analyzing":"🔍 Analyse de votre requête...","prompt.process.selecting":"🧠 Sélection des IA spécialisées...","prompt.process.querying":"⚡ Interrogation du réseau...","prompt.process.synthesizing":"🔄 Synthèse des réponses...","prompt.process.optimizing":"✨ Optimisation de la méta‑réponse...",
  "prompt.placeholder.trial":"Posez votre question... (Restant aujourd’hui : 8/10)","prompt.placeholder.default":"Posez votre question aux plusieurs intelligences artificielles...",
  "prompt.placeholder.search":"Rechercher une information spécifique...",
  "prompt.search.mode":"Mode recherche",
  "prompt.search.truncated":"Texte tronqué (limite du mode recherche).",
  "prompt.attach.limit_files":"Nombre maximum de fichiers atteint",
  "prompt.attach.file_too_big":"Fichier trop volumineux (60KB max) : ",
  "prompt.attach.total_too_big":"Taille totale des pièces jointe dépassée",
  "prompt.attach.unsupported_now":"Format bientôt supporté (mode cloud requis) : ",
  "prompt.attach.unsupported":"Format non supporté : ",
  "prompt.attach.read_error":"Erreur de lecture : ",
  "prompt.attach.remove":"Retirer la pièce jointe",
  "prompt.voice.recording":"Enregistrement vocal... (max 60s)",
  "prompt.voice.unsupported":"Reconnaissance vocale non supportée par ce navigateur.",
  "prompt.actions.Adjuntar archivo":"Joindre un fichier","prompt.actions.Búsqueda avanzada":"Recherche avancée","prompt.actions.Voz a texto":"Voix en texte","prompt.actions.Prompt inteligente":"Prompt intelligent",
  "prompt.status.querying":"Interrogation...","prompt.status.optimizing":"Optimisation...","prompt.cta.consult_ais":"Consulter {{count}} IA","prompt.trial.info":"Offre gratuite : {{days}} jours restants •","prompt.trial.upgrade":"Passez à des requêtes illimitées",
  "common.ok":"OK","common.sending":"Envoi...","common.sent":"Envoyé","common.error":"Erreur","common.send":"Envoyer","common.close":"Fermer","common.cancel":"Annuler","common.loading":"Chargement...",
  "auth.login":"Se connecter","auth.signup":"Inscription gratuite","auth.password":"Mot de passe","auth.forgot":"Mot de passe oublié ?","auth.continue":"Continuer","auth.magic_short":"Magic link","auth.check_email":"Vérifiez votre e‑mail pour confirmer votre compte","auth.reset":"Réinitialiser le mot de passe","auth.resend":"Renvoyer",
  "time.just_now":"À l’instant","time.minutes_ago":"Il y a {{count}} minutes","time.hours_ago":"Il y a {{count}} heures","time.days_ago":"Il y a {{count}} jours",
  "auth.with.google":"Continuer avec Google","auth.with.apple":"Continuer avec Apple","auth.with.microsoft":"Continuer avec Microsoft","auth.with.facebook":"Continuer avec Facebook","auth.with.github":"Continuer avec GitHub","auth.with.linkedin":"Continuer avec LinkedIn","auth.or":"ou","auth.legal":"En continuant, vous acceptez nos","auth.terms":"Conditions","auth.and":"et","auth.privacy":"Confidentialité","auth.errors.social":"Impossible de se connecter avec le fournisseur sélectionné","auth.protected_route":"Route protégée : connectez-vous pour continuer",
  "auth.email":"E‑mail","auth.remember_me":"Se souvenir de moi","auth.magic.send":"Envoyer le lien","auth.magic.resend_btn":"Renvoyer","auth.magic.resend_in":"Renvoyer ({{s}})","auth.logged_in":"Connecté","auth.password.requirements_failed":"Le mot de passe ne respecte pas les critères","auth.reset.sent_conditional":"Si le compte existe, nous avons envoyé un e‑mail de réinitialisation.","auth.verification.unverified":"Votre e‑mail n’est pas vérifié.","auth.verification.resent":"E‑mail de vérification renvoyé.","auth.errors.login_failed":"Échec de connexion","auth.errors.signup_failed":"Échec d’inscription","auth.errors.magic_failed":"Impossible d’envoyer le lien","auth.errors.resend_failed":"Impossible de renvoyer",
  "auth.env.missing":"Variables Supabase non détectées. Définissez REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY ou VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY puis redémarrez le serveur.",
  "sidebar.dashboard":"Tableau de bord","sidebar.new_chat":"Nouveau Chat","sidebar.new_project":"Nouveau Projet","sidebar.history":"Historique","sidebar.tools":"Outils","sidebar.my_gpts":"Mes GPTs","sidebar.plans":"Plans","sidebar.my_profile":"Mon Profil","sidebar.days_left":"{{count}} jours restants",
  "pages.plans.title":"Plans et Tarifs","pages.plans.subtitle":"Choisissez le plan idéal pour libérer tout le potentiel d’IntelliVerseOne","pages.plans.stats.ais":"IA Disponibles","pages.plans.stats.tools":"Outils","pages.plans.stats.availability":"Disponibilité","pages.plans.compare":"Comparaison détaillée","pages.plans.trial_expiring":"Votre essai gratuit expire dans {{days}} jours","pages.plans.trial_expiring_hint":"Mettez à niveau maintenant pour conserver l’accès complet à toutes les fonctionnalités","pages.plans.trial_expired_ago":"Votre essai gratuit a expiré il y a {{days}} jours","plans.cta.start_pro":"Commencer le plan Pro","plans.cta.go_pro_plus":"Passer directement à Pro+","pages.plans.view_plans":"Voir les Plans",
  "pages.faq.title":"Foire Aux Questions","pages.faq.q.change_anytime":"Puis-je changer de plan à tout moment ?","pages.faq.a.change_anytime":"Oui, vous pouvez mettre à niveau ou rétrograder votre plan à tout moment. Les changements s’appliquent immédiatement.","pages.faq.q.free_includes":"Que comprend le plan gratuit ?","pages.faq.a.free_includes":"Accès de base à 5 IA, 10 requêtes par jour et outils essentiels pendant 7 jours.","pages.faq.q.annual_discounts":"Y a-t-il des remises pour un paiement annuel ?","pages.faq.a.annual_discounts":"Oui, 2 mois offerts pour un paiement annuel. Contactez le support pour plus d’infos.","pages.faq.q.payment_methods":"Quels moyens de paiement acceptez-vous ?","pages.faq.a.payment_methods":"Cartes, PayPal et virements bancaires.","pages.faq.q.cancel_anytime":"Puis-je annuler à tout moment ?","pages.faq.a.cancel_anytime":"Oui, vous pouvez annuler votre abonnement sans pénalité.","pages.faq.q.support":"Proposez-vous un support technique ?","pages.faq.a.support":"Oui, tous les plans incluent le support. Les plans payants ont un support prioritaire 24/7.",
  "pages.history.title":"Historique des Conversations","pages.history.subtitle":"Consultez et recherchez vos conversations passées",
  "pages.tools.title":"Outils IA","pages.tools.subtitle":"Suite complète d’outils propulsés par l’IA","pages.tools.search_placeholder":"Rechercher des outils...","pages.tools.empty":"Aucun outil trouvé","pages.tools.empty_hint":"Essayez d’autres termes ou changez de catégorie","pages.tools.more_coming":"Plus d’outils en développement","pages.tools.more_coming_desc":"Nous ajoutons constamment de nouveaux outils IA pour booster votre productivité",
  "pages.projects.create_title":"Créer un Projet","pages.projects.step1_title":"Quel type de projet souhaitez-vous créer ?","pages.projects.details_title":"Détails du projet","pages.projects.name_label":"Nom du projet","pages.projects.name_ph":"Ex. : Mon Portfolio Personnel","pages.projects.desc_label":"Description","pages.projects.desc_ph":"Décrivez votre projet...","pages.projects.purpose_label":"Objectif principal","pages.projects.purpose_ph":"Ex. : Mettre en valeur mes compétences","pages.projects.audience_label":"Public cible","pages.projects.audience_ph":"Ex. : Recruteurs et entreprises tech","pages.projects.summary_title":"Résumé du projet","pages.projects.type":"Type","pages.projects.purpose":"Objectif","pages.projects.audience":"Audience","pages.projects.title":"Mes Projets","pages.projects.subtitle":"Créez des projets complets avec l’IA","pages.projects.empty":"Vous n’avez pas encore de projets","pages.projects.first_project":"Créez votre premier projet avec l’IA","pages.projects.unlock_title":"Débloquez la Création de Projets","pages.projects.reached_limit":"Vous avez atteint la limite de projets de votre plan. Mettez à niveau pour continuer.","pages.projects.upgrade_benefits":"Générez des projets complets avec le plan Pro et obtenez des exports avancés avec Pro+",
  "pages.cta.boost_productivity":"Prêt à doper votre productivité ?","pages.cta.join_many":"Rejoignez des milliers d’utilisateurs qui tirent parti de l’IA collective",
  "user.plan.current":"Plan actuel","user.plan.trial":"Essai","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"Mettre à niveau",
  "goodbye.title":"Votre compte a été supprimé","goodbye.subtitle":"Merci d’avoir essayé IntelliVerseOne. À bientôt.","goodbye.feedback":"Dites-nous pourquoi vous partez, vos retours nous aident à nous améliorer.","goodbye.contact":"Contacter le support","goodbye.home":"Retour à l’accueil",
    "common.copy":"Copier","common.coming_soon":"Bientôt","common.in_development":"En développement",
    "tools.categories.all":"Toutes","tools.categories.content":"Contenu","tools.categories.productivity":"Productivité","tools.categories.analysis":"Analyse","tools.categories.social":"Social & Impact","tools.categories.development":"Développement",
  "plans.limitations":"Limitations :",
  "plans.table.available":"Plans disponibles",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"Gratuit",
  "plans.table.trial.features":"15 actions/jour • Orchestrateur IA multiples",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/mois",
  "plans.table.pro.features":"25 questions (à vie) • 300 actions/jour",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/mois",
  "plans.table.pro_plus.features":"50 questions (à vie) • Actions illimitées • Deep Research complète",
  "pages.history.search_placeholder":"Rechercher dans les conversations...",
  "history.stats.conversations":"Conversations",
  "history.stats.total_responses":"Réponses totales",
  "history.stats.average_rating":"Note moyenne",
  "history.stats.active_days":"Jours actifs",
  "history.category.all":"Toutes",
  "history.category.productivity":"Productivité",
  "history.category.education":"Éducation",
  "history.category.development":"Développement",
  "history.category.career":"Carrière",
  "history.category.finance":"Finance",
  "history.label.responses":"réponses",
  "history.empty.title":"Aucune conversation trouvée",
  "history.empty.hint_search":"Essayez d'autres termes de recherche",
  "history.empty.hint_empty":"Vous n'avez pas encore de conversations enregistrées",
  "history.empty.cta":"Démarrer une nouvelle conversation",
  "history.smart_search.title":"Recherche sémantique intelligente",
  "history.smart_search.subtitle":"Bientôt : recherchez par concepts et contexte, pas seulement par mots-clés",
  "history.smart_search.card.semantic_ai.title":"IA Sémantique",
  "history.smart_search.card.semantic_ai.desc":"Trouvez des conversations par le sens",
  "history.smart_search.card.auto_tagging.title":"Auto-étiquetage",
  "history.smart_search.card.auto_tagging.desc":"Catégorisation automatique intelligente",
  "history.smart_search.card.patterns.title":"Analyse des schémas",
  "history.smart_search.card.patterns.desc":"Informations sur vos requêtes",
  "mygpts.title":"Mes GPTs",
  "mygpts.subtitle":"Créez et gérez vos assistants IA personnalisés",
  "mygpts.create_new":"Créer un nouveau GPT",
  "mygpts.stats.created":"GPTs créés",
  "mygpts.stats.uses":"Utilisations totales",
  "mygpts.stats.limit":"Limite de GPTs",
  "mygpts.stats.templates":"Modèles disponibles",
  "mygpts.empty.title":"Vous n’avez pas encore de GPTs",
  "mygpts.empty.subtitle":"Créez votre premier assistant IA personnalisé",
  "mygpts.empty.cta":"Créer mon premier GPT",
  "mygpts.locked.title":"Débloquez la création de GPTs",
  "mygpts.locked.desc.hard":"Vous avez atteint la limite de GPTs de votre forfait. Mettez à niveau pour continuer.",
  "mygpts.locked.desc.info":"Créez jusqu’à 5 GPTs personnalisés avec Pro, ou illimités avec Pro+",
  "mygpts.locked.cta":"Voir les Plans",
  "mygpts.card.uses":"utilisations",
  "mygpts.card.created":"Créé",
  "mygpts.card.tone":"Ton",
  "mygpts.card.depth":"Profondeur",
  "mygpts.card.style":"Style",
  "mygpts.card.use":"Utiliser",
  "mygpts.creator.title":"Créer un nouveau GPT",
  "mygpts.creator.step":"Étape {{n}} sur 4",
  "mygpts.creator.step1.title":"Sélectionnez un modèle de base",
  "mygpts.creator.step2.title":"Personnalisez votre GPT",
  "mygpts.creator.name.placeholder":"ex. : Mon assistant personnel",
  "mygpts.creator.desc.placeholder":"Décrivez ce que fait votre GPT et comment il aide...",
  "mygpts.creator.icon":"Icône",
  "mygpts.creator.step3.title":"Configuration de la personnalité",
  "mygpts.creator.tone.label":"Ton de communication",
  "mygpts.creator.tone.professional":"Professionnel",
  "mygpts.creator.tone.friendly":"Amical",
  "mygpts.creator.tone.casual":"Décontracté",
  "mygpts.creator.tone.empatic":"Empathique",
  "mygpts.creator.tone.direct":"Direct",
  "mygpts.creator.depth.label":"Profondeur des réponses",
  "mygpts.creator.depth.basic":"Basique",
  "mygpts.creator.depth.intermediate":"Intermédiaire",
  "mygpts.creator.depth.advanced":"Avancé",
  "mygpts.creator.depth.expert":"Expert",
  "mygpts.creator.style.label":"Style de communication",
  "mygpts.creator.style.conversational":"Conversationnel",
  "mygpts.creator.style.structured":"Structuré",
  "mygpts.creator.style.creative":"Créatif",
  "mygpts.creator.style.analytical":"Analytique",
  "mygpts.creator.style.reflective":"Réflexif",
  "mygpts.creator.step4.title":"Aperçu de votre GPT",
  "mygpts.creator.preview_hint":"Tout semble bon ? Vous pourrez modifier votre GPT plus tard.",
  "mygpts.creator.create":"Créer le GPT",
  "mygpts.templates.tutor.name":"Mon Tuteur",
  "mygpts.templates.tutor.desc":"Spécialisé dans l’enseignement et les explications",
  "mygpts.templates.emotional.name":"Mentor Émotionnel",
  "mygpts.templates.emotional.desc":"Soutien émotionnel et bien‑être",
  "mygpts.templates.productivity.name":"Ma Productivité",
  "mygpts.templates.productivity.desc":"Optimisation et organisation",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"Recherche académique approfondie",
  "mygpts.templates.crypto.name":"CryptoActifs",
  "mygpts.templates.crypto.desc":"Analyse des cryptomonnaies et de la blockchain",
  "mygpts.templates.business.name":"Stratège d’Affaires",
  "mygpts.templates.business.desc":"Conseil et stratégie d’entreprise",
  "mygpts.sample.tutor.name":"Mon Tuteur Personnel",
  "mygpts.sample.tutor.desc":"Spécialisé dans l’explication simple de concepts complexes",
  "mygpts.sample.productivity.name":"Assistant Productivité",
  "mygpts.sample.productivity.desc":"Optimisation des tâches et gestion du temps",
  "mygpts.sample.emotional.name":"Mentor Émotionnel",
  "mygpts.sample.emotional.desc":"Soutien émotionnel et conseils de bien‑être mental",
  "mygpts.sample.tone.friendly":"amical",
  "mygpts.sample.tone.direct":"direct",
  "mygpts.sample.tone.empatic":"empathique",
  "mygpts.sample.depth.intermediate":"intermédiaire",
  "mygpts.sample.depth.practical":"pratique",
  "mygpts.sample.depth.deep":"profond",
  "mygpts.sample.style.conversational":"conversationnel",
  "mygpts.sample.style.structured":"structuré",
  "mygpts.sample.style.reflective":"réflexif",
  "projects.types.web.name":"Application Web",
  "projects.types.web.desc":"Frontend complet avec React, Vue ou Angular",
  "projects.types.api.name":"API Backend",
  "projects.types.api.desc":"Serveur et base de données avec Node.js ou Python",
  "projects.types.mobile.name":"Application Mobile",
  "projects.types.mobile.desc":"Application native ou hybride",
  "projects.types.fullstack.name":"Full Stack",
  "projects.types.fullstack.desc":"Projet complet frontend + backend",
  "projects.actions.download_zip":"Télécharger ZIP",
  "projects.actions.continue":"Continuer",
  "projects.actions.new_project":"Nouveau Projet",
  "projects.progress":"Avancement",
  "projects.created_on":"Créé",
  "projects.status.completed":"Terminé",
  "projects.status.in_progress":"En cours",
  "projects.status.generating":"Génération",
  "projects.status.generating_dots":"Génération...",
  "projects.actions.view":"Voir",
  "projects.detail.untitled":"Projet sans titre",
  "projects.detail.loading_desc":"Recherche des détails du projet…",
  "projects.detail.no_desc":"Sans description",
  "projects.detail.view":"Voir",
  "projects.detail.summary":"Résumé",
  "projects.detail.actions":"Actions rapides",
  "projects.detail.view_code":"Voir le code",
  "projects.detail.activity":"Activité",
  "projects.detail.activity_init":"Projet créé et mis en file de génération",
  "projects.detail.activity_ai":"IA préparant la structure et les dépendances",
  "projects.detail.activity_docs":"Documentation de base initialisée",
  "projects.detail.tech":"Technologies",
  "history.sample.1.title":"Comment améliorer ma productivité personnelle",
  "history.sample.1.preview":"J’ai besoin de conseils pour être plus productif au quotidien...",
  "history.sample.2.title":"Explication des algorithmes de tri",
  "history.sample.2.preview":"Pourriez‑vous expliquer les différents algorithmes de tri...",
  "history.sample.3.title":"Idées pour un projet React",
  "history.sample.3.preview":"Je cherche des idées innovantes pour un projet React...",
  "history.sample.4.title":"Conseils pour les entretiens d’embauche",
  "history.sample.4.preview":"J’ai un entretien important la semaine prochaine...",
  "history.sample.5.title":"Analyse du marché des cryptomonnaies",
  "history.sample.5.preview":"Que pensez‑vous des tendances actuelles du marché crypto...",
  "projects.mock.1.name":"Portfolio Personnel",
  "projects.mock.1.desc":"Site professionnel avec React et Tailwind CSS",
  "projects.mock.2.name":"Application de Tâches",
  "projects.mock.2.desc":"Application de gestion des tâches avec authentification",
  "projects.mock.3.name":"API REST E‑commerce",
  "projects.mock.3.desc":"Backend complet pour boutique en ligne",
  "tools.items.emotional-translator.name":"Traducteur IA Émotionnel",
  "tools.items.emotional-translator.description":"Traduire en préservant le ton et le contexte émotionnel",
  "tools.items.text-reformulator.name":"Reformulateur de Textes",
  "tools.items.text-reformulator.description":"Réécrit les textes en conservant le sens",
  "tools.items.voice-converter.name":"Convertisseur Texte en Voix",
  "tools.items.voice-converter.description":"Convertit le texte en audio naturel",
  "tools.items.prompt-creator.name":"Créateur de Prompts",
  "tools.items.prompt-creator.description":"Génère des prompts optimisés pour toute IA",
  "tools.items.viral-titles.name":"Générateur de Titres Viraux",
  "tools.items.viral-titles.description":"Crée des titres accrocheurs",
  "tools.items.audience-segmenter.name":"Segmenteur d’Audiences",
  "tools.items.audience-segmenter.description":"Analyse et segmente les audiences cibles",
  "tools.items.idea-repairer.name":"Réparateur d’Idées Incomplètes",
  "tools.items.idea-repairer.description":"Complète et améliore des idées partielles",
  "tools.items.copy-pulse.name":"CopyPulse – Copier, Améliorer et Lancer",
  "tools.items.copy-pulse.description":"Analyse, améliore et optimise tout contenu",
  "tools.items.file-converter.name":"Convertisseur de Fichiers Intelligent",
  "tools.items.file-converter.description":"Convertit des fichiers avec l’IA pour optimiser le contenu",
  "tools.items.arconte-ai.name":"Contact Arconte AI",
  "tools.items.arconte-ai.description":"Accès direct à l’IA la plus avancée",
  "tools.items.mass-control.name":"Contrôle Positif des Masses",
  "tools.items.mass-control.description":"Outils pour un impact social constructif",
  "pages.not_found.title":"Page Introuvable",
  "pages.not_found.body":"On dirait que cette page s'est perdue dans le multivers de l'intelligence artificielle. Nos 120 IA travaillent à la retrouver.",
  "pages.not_found.help_title":"Besoin d'aide ?",
  "pages.not_found.help_body":"Si vous pensez que c'est une erreur, vous pouvez nous contacter ou retourner à la page principale.",
  "pages.not_found.cta_home":"🏠 Retour à l'accueil",
  "pages.not_found.cta_tools":"🛠️ Explorer les outils",
  "pages.not_found.link_support":"📧 Support",
  "pages.not_found.link_home":"🏠 Accueil",
  "pages.not_found.link_plans":"💎 Plans",
  "user.panel_title":"Panneau Utilisateur",
  "user.security.change_password":"Changer le mot de passe",
  "user.security.change_password_prompt":"Nouveau mot de passe (minimum 8 caractères)",
  "user.security.password_changed":"Mot de passe mis à jour",
  "user.security.reset_password":"Envoyer le lien de réinitialisation",
  "user.security.reset_sent":"Nous vous avons envoyé un email pour réinitialiser votre mot de passe",
  "user.security.title":"Sécurité du Compte",
  "user.security.subtitle":"Gérez les identifiants et options de sécurité.",
  "user.security.password":"Mot de passe",
  "user.security.password_hint":"Utilisez un mot de passe long et unique. MFA bientôt disponible.",
  "user.security.email_hint":"Si vous changez votre email, vous devrez le vérifier avant de l'utiliser.",
  "user.security.password_error":"Impossible de mettre à jour le mot de passe",
  "user.security.password_placeholder":"Nouveau mot de passe sécurisé",
  "user.security.change_password_title":"Mettre à jour le mot de passe",
  "user.security.change_password_action":"Mettre à jour",
  "user.security.cancel":"Annuler",
  "user.security.password_min":"Minimum 8 caractères",
  "user.security.logout":"Se déconnecter",
  "user.security.delete_account_btn":"Supprimer le compte",
  "user.security.delete_account":"Supprimer le compte",
  "user.security.delete_account_desc":"Cette action est permanente. Vous perdrez vos projets, GPTs et données associées.",
  "user.security.delete_account_type":"Tapez SUPPRIMER pour confirmer :",
  "user.security.delete_account_confirm":"Supprimer définitivement",
  "user.security.delete_account_done":"Demande de suppression envoyée. Nous vous notifierons par email.",
  "user.security.delete_account_signout":"Session fermée. Pour terminer la suppression, configurez le webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL.",
  "trial.expired.title":"Votre Trial de 7 jours est terminé !",
  "trial.expired.body":"Vous avez experimenté toute la puissance d'IntelliVerseOne. Pour continuer à utiliser {{feature}}, choisissez votre plan.",
  "trial.expired.stats_title":"🎉 Pendant votre trial vous avez expérimenté :",
  "trial.expired.stat_ias":"IA consultées",
  "trial.expired.stat_functionality":"Fonctionnalité complète",
  "trial.expired.stat_projects":"Projets créés",
  "trial.expired.stat_costs":"Coûts cachés",
  "trial.expired.pro_plus_label":"🚀 Plan Pro+ - 9,79$/mois",
  "trial.expired.pro_plus_desc":"Fonctionnalité complète + priorité + multimédia IA",
  "trial.expired.pro_label":"⭐ Plan Pro - 5,79$/mois",
  "trial.expired.pro_desc":"Parfait pour un usage complet et professionnel",
  "trial.expired.free_option":"Ou continuez avec des fonctionnalités limitées :",
  "trial.expired.free_plan_title":"🆓 Plan Free (Limité) :",
  "trial.expired.free_blocked":"ACCÈS COMPLÈTEMENT BLOQUÉ",
  "trial.expired.free_no_ias":"Pas de consultations aux IA",
  "trial.expired.free_no_premium":"Pas de fonctions premium",
  "trial.expired.free_history_only":"Consultation de l'historique précédent uniquement",
  "trial.expired.continue_free":"Continuer avec le Plan Free",
  "trial.expired.benefits":"✨ Garantie 30 jours • 🔒 Annulez quand vous voulez • 💰 Prix justes",
  "notifications.welcome.activated":"🚀 IntelliVerseOne activé - plusieurs IA prêtes à consulter",
  "notifications.welcome.optimized":"🧠 Système Meta-IA optimisé pour une précision maximale",
  "notifications.welcome.new_features":"⚡ Nouvelles fonctionnalités disponibles - Explorez les outils",
  "chat.error.auth":"Non authentifié. Veuillez vous connecter pour continuer.",
  "chat.error.quota":"Limite de requêtes journalières atteint. Améliorez votre forfait.",
  "chat.error.timeout":"La requête a expiré. Veuillez réessayer.",
  "chat.error.server":"Erreur serveur. Veuillez réessayer plus tard.",
  "chat.error":"Une erreur est survenue. Veuillez réessayer.",
  "chat.placeholder.answer":"Réponse de l'IA...",
  "history.auto.title":"Conversation du {{date}}",
  "history.actions.confirm":"Supprimer cette conversation ?",
  "life_coach":{
    "common":{"select":"Sélectionner…","selected_count":"{{count}} sélectionnées","other":"Autre","other_ph":"Décrivez une autre option"},
    "hero":{"title":"Laissez-moi diriger votre vie","subtitle":"Un copilote émotionnel et stratégique pour vous accompagner au quotidien."},
    "stats":{"areas":"Domaines sélectionnés","habits":"Total des habitudes","remaining":"Actions restantes aujourd'hui"},
    "form":{"title":"Votre focus de vie","areas_label":"Domaines prioritaires","daily_time":"Temps quotidien disponible","emotions_label":"Comment vous sentez-vous globalement","emotions.low":"Bas","emotions.medium":"Moyen","emotions.high":"Élevé","motivation":"Qu'est-ce qui vous motive maintenant?","motivation_ph":"Décrivez votre motivation","routine":"Comment est votre routine?","routine_ph":"Décrivez brièvement","constraints":"Contraintes ou défis (optionnel)","sleep_hours":"Heures de sommeil","sleep":{"less6":"Moins de 6","6_7":"6-7","7_8":"7-8","more8":"Plus de 8"},"exercise_freq":"Fréquence d'exercice","exercise":{"never":"Jamais","1_2":"1-2 fois/semaine","3_4":"3-4 fois/semaine","more4":"Plus de 4/semaine"},"diet_focus":"Régime alimentaire","diet":{"balanced":"Équilibré","high_protein":"Riche en protéines","low_carb":"Faible en glucides","plant_based":"Végétal"},"stress_level":"Niveau de stress","level":{"low":"Faible","medium":"Moyen","high":"Élevé"},"productivity_peak":"Pic de productivité","daytime":{"morning":"Matin","afternoon":"Après-midi","evening":"Soir"},"reminder_time":"Heure de rappel préférée","distractions":"Principales distractions","learning_goal":"Objectif d'apprentissage","learning_goal_ph":"Que voulez-vous apprendre?","financial_goal":"Objectif financier","financial_goal_ph":"Ex.: épargner X, rembourser dette","relationship_goal":"Objectif relationnel","relationship_goal_ph":"Famille, partenaire, amis","weekend_routine":"Routine du week-end","weekend_routine_ph":"Activités typiques","accountability":{"label":"Responsabilité","solo":"Seul","buddy":"Avec un ami","coach":"Avec un coach"},"comm_style":"Style de communication","comm":{"concise":"Concis","detailed":"Détaillé","motivational":"Motivant"}},
    "area":{"health":"Santé","career":"Carrière","finance":"Finances","relationships":"Relations","personal":"Développement personnel"},
    "motivation":{"health":"Améliorer la santé","career":"Progresser professionnellement","balance":"Équilibre vie-travail","learn":"Apprendre une compétence","finance":"Améliorer les finances","emotional":"Bien-être émotionnel","consistency":"Être constant","project":"Projet personnel","exam":"Préparer un examen","stress":"Réduire le stress"},
    "routine":{"office":"Bureau 9-5","remote":"Télétravail flexible","student":"Étudiant","shift":"Équipe/rotation","entrepreneur":"Entrepreneur","caretaker":"Aidant","night":"Nuit","parent":"Parent avec enfants","variable":"Très variable"},
    "constraints":{"time":"Manque de temps","stress":"Stress/Anxiété","health":"Santé physique","finance":"Finances","family":"Famille/Soins","environment":"Environnement/Espace","sleep":"Sommeil irrégulier","motivation":"Faible motivation","tech":"Technologie/Équipement"},
    "distractions":{"social":"Réseaux sociaux","notifs":"Notifications","chat":"Messagerie","noise":"Bruit ambiant","multitask":"Multitâche","phone":"Téléphone","fatigue":"Fatigue","perfect":"Perfectionnisme","procrast":"Procrastination","family":"Interruptions familiales","tv":"TV/Jeux"},
    "learning":{"languages":"Langues","programming":"Programmation","dataai":"Données/IA","marketing":"Marketing","sales":"Ventes","personal_finance":"Finances personnelles","music":"Musique","design":"Art/Design","cert":"Examen/Certification","softskills":"Compétences douces"},
    "finance":{"emergency":"Fonds d'urgence","pay_debt":"Rembourser les dettes","cut_expenses":"Réduire les dépenses","increase_income":"Augmenter les revenus","invest":"Investir","buy_house":"Acheter maison/véhicule","save_trip":"Épargner voyage/études","credit_score":"Améliorer le crédit"},
    "relation":{"communication":"Améliorer la communication","family_time":"Plus de temps en famille","partner":"Renforcer la relation","friends":"Se faire de nouveaux amis","network":"Réseautage professionnel","conflict":"Résoudre un conflit","boundaries":"Établir des limites saines"},
    "weekend":{"rest":"Repos","family":"Famille","sport":"Sport/activité","social":"Socialisation","creative":"Créatif/hobby","chores":"Tâches ménagères","study":"Étude/projet","travel":"Voyage"},
    "cta":{"generate":"Générer le Plan","regenerate":"Régénérer","refine_area":"Affiner le domaine"},
    "plan":{"title":"Votre Plan de Vie","progress":"Progression","weekly_goals":"Objectifs hebdomadaires","monthly_goals":"Objectifs mensuels","habits":"Habitudes"},
    "module":{"reminders":"Rappels intelligents","feedback":"Retour hebdomadaire"},
    "reminders":{"active":"Vous recevrez des rappels quotidiens et hebdomadaires personnalisés.","locked":"Disponible en Pro+. Débloquez des rappels automatiques et personnalisés."},
    "feedback":{"active":"Vous recevrez une analyse hebdomadaire avec des recommandations personnalisées.","locked":"Disponible en Pro+. Obtenez un rapport hebdomadaire avec des améliorations suggérées."},
    "errors":{"areas":"Sélectionnez au moins un domaine.","limit":"Vous avez atteint votre limite quotidienne."},
    "copy":{"m1":"Je suis là pour vous aider à construire la meilleure version de vous-même.","m2":"Aujourd'hui, nous pouvons faire un pas de plus. Prêt?","m3":"Petits changements, grands résultats."},
    "mock":{"goal":{"week":"Complétez 3 sessions liées à {{area}}","month":"Atteignez un jalon clé dans {{area}}","learn":{"week":"Étudiez {{skill}} (3 x 20m)","month":"Complétez un module dans {{skill}}"},"finance":{"week":"Avancez vers: {{goal}}","month":"Atteignez l'objectif financier: {{goal}}"},"weekend":"Activité du week-end: {{w}}","refine":"Action affinée dans {{area}}"},"habit":{"1":"Habitude de 5 minutes dans {{area}}","2":"Écrivez une réflexion sur {{area}}","learn":"Apprenez {{skill}} (15m)","budget":"Révisez dépenses et budget (10m)","relation":"Contact significatif (message/appel)","sleep":"Hygiène du sommeil (10m)","exercise":{"start":"Marchez 10m","progress":"Session de 20m d'exercice","maintain":"Maintenir la forme 25m"},"diet":{"pb":"Ajoutez 1 portion de légumes en plus","hp":"Planifiez des protéines à chaque repas","lc":"Évitez les sucres raffinés"},"morning":"Bloc AM profond (20m) pour {{area}}","focus":"Session sans notifications (15m)","stress":"Technique de respiration 4-7-8","accountability":"Check-in avec ami/coach (5m)"}},
    "career":{"habit":{"focus":"Bloc de focus de {{m}}m"}},
    "remark":{"privacy":"Vos réponses sont sauvegardées en toute confidentialité."}
  },
  "stats.ias":"IA consultées",
  "stats.remaining":"Restants aujourd'hui",
  "stats.accuracy":"Précision",
  "prompt.actions.search":"Rechercher",
  "prompt.actions.voice":"Voix",
  "prompt.actions.suggest":"Suggérer",
  "prompt.actions.attach":"Joindre",
  "prompt.cta.consult_ias":"Consulter {{count}} IA",
  "prompt.remaining":"Restants",
  "prompt.placeholder.expired":"Essai expiré —",
  "prompt.placeholder.limit":"Limite atteint —",
  "prompt.trial.expired_msg":"Votre période d'essai a expiré. Choisissez un plan pour continuer.",
  "prompt.trial.choose_plan":"Choisir un plan",
  "prompt.search.active":"Mode recherche actif",
  "prompt.voice.no_mic":"Accès au microphone refusé",
  "prompt.limit.exceeded":"Limite de requêtes atteint",
  "prompt.trial.expired":"Essai expiré",
  "auth.logout":"Déconnexion",
  "mygpts.updated":"GPT mis à jour",
  "mygpts.created":"GPT créé avec succès",
  "mygpts.error.save":"Erreur lors de la sauvegarde",
  "mygpts.creator.title_new":"Créer un nouveau GPT",
  "mygpts.creator.title_edit":"Modifier le GPT",
  "tools.copy_empty":"Cet outil n'a pas de texte à copier",
  "tools.copy_ok":"Prompt copié dans le presse-papiers",
  "tools.copy_fail":"Impossible de copier. Réessayez.",
  "tools.copy_tooltip":"Copier le prompt dans le presse-papiers",
  "tools.run_tooltip":"Exécuter l'outil avec l'IA",
  "common.run":"Exécuter",
  "plans.paypal.error":"Une erreur de paiement s'est produite. Réessayez.",
  "plans.paypal.cancel":"Paiement annulé par l'utilisateur.",
  "plans.paypal.required":"Pour activer ce forfait, vous devez effectuer le paiement via PayPal.",
  "plans.cancel.confirm":"Êtes-vous sûr de vouloir annuler votre abonnement ? Vous conserverez l'accès jusqu'à la fin de la période payée.",
  "plans.cancel.no_auth":"Aucune session active. Veuillez vous reconnecter.",
  "plans.cancel.error":"Erreur lors de l'annulation. Réessayez ou contactez le support.",
  "plans.cancel.success":"Abonnement annulé ! Vous conserverez l'accès jusqu'au {{date}}.",
  "user.connections.title":"Connexions de compte",
  "user.connections.hint":"Liez des fournisseurs pour pouvoir vous connecter avec n'importe lequel d'entre eux.",
  "projects.generated_success":"Projet généré ! Vous pouvez maintenant télécharger le ZIP.",
  "projects.wizard.mvp_includes":"Votre projet MVP comprendra :",
  "projects.wizard.gen.structure_mvp":"Structure de base du projet",
  "projects.wizard.gen.starter":"Fichiers de démarrage fonctionnels",
  "projects.wizard.gen.readme":"README avec instructions",
  "projects.wizard.gen.config":"Configuration initiale",
  "projects.wizard.mvp_note":"Téléchargez le ZIP et personnalisez le code à votre guise",
  "projects.actions.generating":"Génération en cours...",
  "common.login_required":"Veuillez vous connecter pour continuer",
  "common.reset":"Réinitialiser",
  "share.copied":"Lien copié : ",
  "limits.share_pro":"Le partage nécessite un plan Pro ou supérieur.",
  "common.back":"Retour"
} };
const de = { translation: {
  "dashboard.hero.powered_by":"Lernen, erstellen und tiefer recherchieren mit mehreren KIs",
  "auth.promo.subscribe":"Kostenlos registrieren",
  "auth.promo.trial":"Plattform 7 Tage kostenlos testen",
  "auth.promo.nocard":"Keine Kreditkarte erforderlich",
  "dashboard.hero.rotating":[
    "Lerne, erstelle und recherchiere mit mehreren KIs."
  ],
  "plans.cards":{
    "trial":{"name":"Trial","price":"Kostenlos","period":"7-tägige Testversion","features":["15 Aktionen/Tag","Orchestrator mehrere KIs","Grundlegende Tools","Community-Support"],"limitations":["Eingeschränkte Funktionen","Keine Exporte","Kein Deep Research-Zugang","Endet nach 7 Tagen"]},
    "pro":{"name":"Pro","period":"pro Monat","features":["25 Fragen (lebenslang)","300 Aktionen/Tag","Zugriff auf mehrere KIs","Die meisten Tools freigeschaltet","Priorisierte Verarbeitung"],"limitations":["Begrenzter Deep Research","Keine unbegrenzten Aktionen"]},
    "pro_plus":{"name":"Pro+","period":"pro Monat","features":["50 Fragen (lebenslang)","Unbegrenzte Aktionen","Vollständige Deep Research","Alle Tools freigeschaltet","24/7 Prioritäts-Support"],"limitations":[]}
  },
  "plans.popular":"Am beliebtesten","plans.current":"Aktueller Plan","plans.select":"Plan auswählen","plans.paypal.success":"Abonnement erfolgreich! ID: ","plans.trial_active":"Trial aktiv",
  "dashboard.cta.life_director":"Persönlicher KI-Plan","dashboard.cta.study_tutor":"KI-Lerntutor","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"Nach Interessen verbinden","dashboard.cta.propose_ideas":"Ideen und Projekte","dashboard.cta.mass_control":"KI für Community Impact",
  "dashboard.desc.life_director":"Personalisertes KI‑Coaching","dashboard.desc.study_tutor":"Intelligentes adaptives Lernen","dashboard.desc.create_project":"Geführte Komplettentwicklung","dashboard.desc.deepweb":"Tiefgehende akademische Suche","dashboard.desc.connect_people":"Kooperatives Wissensnetzwerk","dashboard.desc.propose_ideas":"Chancen‑Generator","dashboard.desc.mass_control":"Konstruktive soziale Wirkung",
  "dashboard.quick.prompts.life_director":"Handle als mein persönlicher Lebenscoach...","dashboard.quick.prompts.study_tutor":"Werde mein persönlicher Tutor...","dashboard.quick.prompts.deepweb":"Greife auf tiefe akademische und rechtliche Infos zu...","dashboard.quick.prompts.connect_people":"Hilf mir, Menschen mit ähnlichen Interessen zu finden.","dashboard.quick.prompts.propose_ideas":"Erzeuge innovative Projekt‑/Business‑Ideen...",
  "dashboard.meta.title":"Meta‑Antwort von {{count}} KIs","dashboard.meta.confidence":"Vertrauen","dashboard.meta.queried_ais":"Abgefragte KIs:","dashboard.meta.more":"+{{count}} mehr...","dashboard.meta.specialized_ais":"{{count}} spezialisierte KIs","dashboard.meta.categories":"Kategorien","dashboard.meta.general":"Allgemein",
  "dashboard.welcome.title":"Willkommen, {{name}}!","dashboard.welcome.body":"Sie sind mit dem fortschrittlichsten KI‑Netzwerk verbunden...","dashboard.welcome.precision.title":"Präzision","dashboard.welcome.precision.desc":"Antworten von mehreren KIs verifiziert","dashboard.welcome.speed.title":"Geschwindigkeit","dashboard.welcome.speed.desc":"Parallele Verarbeitung für schnelle Antworten","dashboard.welcome.intelligence.title":"Intelligenz","dashboard.welcome.intelligence.desc":"Wissenssynthese aus mehreren Fachbereichen",
  "dashboard.trial.title":"Sie nutzen nur 8% der echten Leistung von IntelliVerseOne","dashboard.trial.body":"Schalten Sie vollen Zugriff auf mehrere KIs, Premium‑Tools und Funktionen frei.","dashboard.trial.view_plans":"Premium‑Pläne ansehen","dashboard.trial.continue":"Trial fortsetzen ({{days}} Tage)",
  "dashboard.stats.today":"Anfragen heute","dashboard.stats.accuracy":"Genauigkeit",
  "dashboard.quick_actions.title":"Schnellaktionen",
  "dashboard.quick_actions.subtitle":"Entdecke die Fähigkeiten von IntelliVerseOne",
  "dashboard.quick_actions.unlock_title":"Volles Potenzial freischalten",
  "dashboard.quick_actions.unlock_desc":"Zugriff auf alle Premium‑Tools und Funktionen",
  "prompt.suggestions.title":"💡 Intelligente Vorschläge:","prompt.suggestions.1":"Wie verbessere ich meine Produktivität?","prompt.suggestions.2":"Erkläre effiziente Sortieralgorithmen","prompt.suggestions.3":"Ideen für ein React‑Projekt","prompt.suggestions.4":"Digital‑Marketing‑Strategien 2024","prompt.suggestions.5":"Trends in der KI","prompt.suggestions.6":"Schritt‑für‑Schritt erfolgreiche Startup‑Gründung",
  "prompt.process.analyzing":"🔍 Anfrage wird analysiert...","prompt.process.selecting":"🧠 Spezialisierte KIs werden gewählt...","prompt.process.querying":"⚡ Netzwerk wird abgefragt...","prompt.process.synthesizing":"🔄 Antworten werden synthetisiert...","prompt.process.optimizing":"✨ Meta‑Antwort wird optimiert...",
  "prompt.placeholder.trial":"Stellen Sie Ihre Frage... (Heute übrig: 8/10)","prompt.placeholder.default":"Stellen Sie Ihre Frage an mehrere KIs...",
  "prompt.placeholder.search":"Nach spezifischen Informationen suchen...",
  "prompt.search.mode":"Suchmodus",
  "prompt.search.truncated":"Text gekürzt (Suchmodus-Limit).",
  "prompt.attach.limit_files":"Maximale Anzahl Dateien erreicht",
  "prompt.attach.file_too_big":"Datei zu groß (60KB max): ",
  "prompt.attach.total_too_big":"Gesamtgröße der Anhänge überschritten",
  "prompt.attach.unsupported_now":"Format bald unterstützt (Cloud-Modus erforderlich): ",
  "prompt.attach.unsupported":"Nicht unterstütztes Format: ",
  "prompt.attach.read_error":"Fehler beim Lesen: ",
  "prompt.attach.remove":"Anhang entfernen",
  "prompt.voice.recording":"Sprache wird aufgenommen... (max 60s)",
  "prompt.voice.unsupported":"Spracherkennung in diesem Browser nicht unterstützt.",
  "prompt.actions.Adjuntar archivo":"Datei anhängen","prompt.actions.Búsqueda avanzada":"Erweiterte Suche","prompt.actions.Voz a texto":"Sprache zu Text","prompt.actions.Prompt inteligente":"Intelligenter Prompt",
  "prompt.status.querying":"Abfrage...","prompt.status.optimizing":"Optimierung...","prompt.cta.consult_ais":"{{count}} KIs konsultieren","prompt.trial.info":"Kostenloser Plan: {{days}} Tage übrig •","prompt.trial.upgrade":"Für unbegrenzte Anfragen upgraden",
  "common.ok":"OK","common.sending":"Senden...","common.sent":"Gesendet","common.error":"Fehler","common.send":"Senden","common.close":"Schließen","common.cancel":"Abbrechen","common.loading":"Wird geladen...",
  "auth.login":"Anmelden","auth.signup":"Kostenlos registrieren","auth.password":"Passwort","auth.forgot":"Passwort vergessen?","auth.continue":"Weiter","auth.magic_short":"Magic link","auth.check_email":"Prüfen Sie Ihre E‑Mail, um Ihr Konto zu bestätigen","auth.reset":"Passwort zurücksetzen","auth.resend":"Erneut senden",
  "time.just_now":"Gerade eben","time.minutes_ago":"Vor {{count}} Minuten","time.hours_ago":"Vor {{count}} Stunden","time.days_ago":"Vor {{count}} Tagen",
  "auth.with.google":"Weiter mit Google","auth.with.apple":"Weiter mit Apple","auth.with.microsoft":"Weiter mit Microsoft","auth.with.facebook":"Weiter mit Facebook","auth.with.github":"Weiter mit GitHub","auth.with.linkedin":"Weiter mit LinkedIn","auth.or":"oder","auth.legal":"Mit dem Fortfahren akzeptierst du unsere","auth.terms":"Bedingungen","auth.and":"und","auth.privacy":"Datenschutz","auth.errors.social":"Anmeldung mit dem ausgewählten Anbieter nicht möglich","auth.protected_route":"Geschützte Seite: Bitte melden Sie sich an",
  "auth.email":"E-Mail","auth.remember_me":"Angemeldet bleiben","auth.magic.send":"Link senden","auth.magic.resend_btn":"Erneut senden","auth.magic.resend_in":"Erneut senden ({{s}})","auth.logged_in":"Angemeldet","auth.password.requirements_failed":"Passwort erfüllt die Anforderungen nicht","auth.reset.sent_conditional":"Falls es das Konto gibt, haben wir eine E-Mail geschickt.","auth.verification.unverified":"Ihre E-Mail ist nicht verifiziert.","auth.verification.resent":"Bestätigungs-E-Mail erneut gesendet.","auth.errors.login_failed":"Anmeldung fehlgeschlagen","auth.errors.signup_failed":"Registrierung fehlgeschlagen","auth.errors.magic_failed":"Link konnte nicht gesendet werden","auth.errors.resend_failed":"Erneutes Senden fehlgeschlagen",
  "auth.env.missing":"Supabase-Variablen nicht erkannt. Definieren Sie REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY oder VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY und starten Sie den Server neu.",
  "sidebar.dashboard":"Dashboard","sidebar.new_chat":"Neuer Chat","sidebar.new_project":"Neues Projekt","sidebar.history":"Verlauf","sidebar.tools":"Werkzeuge","sidebar.my_gpts":"Meine GPTs","sidebar.plans":"Pläne","sidebar.my_profile":"Mein Profil","sidebar.days_left":"{{count}} Tage übrig",
  "pages.plans.title":"Pläne & Preise","pages.plans.subtitle":"Wählen Sie den perfekten Plan für das volle Potenzial von IntelliVerseOne","pages.plans.stats.ais":"Verfügbare IAs","pages.plans.stats.tools":"Werkzeuge","pages.plans.stats.availability":"Verfügbarkeit","pages.plans.compare":"Detaillierter Vergleich","pages.plans.trial_expiring":"Ihre Testversion läuft in {{days}} Tagen ab","pages.plans.trial_expiring_hint":"Jetzt upgraden, um vollen Zugriff zu behalten","pages.plans.trial_expired_ago":"Ihre Testversion ist vor {{days}} Tagen abgelaufen","plans.cta.start_pro":"Pro-Plan starten","plans.cta.go_pro_plus":"Direkt zu Pro+","pages.plans.view_plans":"Pläne ansehen",
  "pages.faq.title":"Häufige Fragen","pages.faq.q.change_anytime":"Kann ich jederzeit den Plan ändern?","pages.faq.a.change_anytime":"Ja, Upgrade/Downgrade ist jederzeit möglich. Änderungen gelten sofort.","pages.faq.q.free_includes":"Was beinhaltet der Gratis-Plan?","pages.faq.a.free_includes":"Basiszugang zu 5 IAs, 10 tägliche Anfragen und grundlegende Tools für 7 Tage.","pages.faq.q.annual_discounts":"Gibt es Rabatte bei Jahreszahlung?","pages.faq.a.annual_discounts":"Ja, 2 Monate gratis bei Jahreszahlung.","pages.faq.q.payment_methods":"Welche Zahlungsmethoden akzeptieren Sie?","pages.faq.a.payment_methods":"Kredit-/Debitkarten, PayPal und Banküberweisungen.","pages.faq.q.cancel_anytime":"Kann ich jederzeit kündigen?","pages.faq.a.cancel_anytime":"Ja, Kündigung jederzeit ohne Strafen.","pages.faq.q.support":"Bieten Sie technischen Support an?","pages.faq.a.support":"Ja, alle Pläne beinhalten Support. Bezahlte Pläne haben 24/7 Prioritätssupport.",
  "pages.history.title":"Gesprächsverlauf","pages.history.subtitle":"Überprüfen und durchsuchen Sie Ihre früheren Gespräche",
  "pages.tools.title":"KI-Werkzeuge","pages.tools.subtitle":"Komplette Suite von KI-gestützten Werkzeugen","pages.tools.search_placeholder":"Werkzeuge suchen...","pages.tools.empty":"Keine Werkzeuge gefunden","pages.tools.empty_hint":"Versuchen Sie andere Suchbegriffe oder ändern Sie die Kategorie","pages.tools.more_coming":"Weitere Werkzeuge in Entwicklung","pages.tools.more_coming_desc":"Wir fügen ständig neue KI-Tools hinzu, um Ihre Produktivität zu steigern",
  "pages.projects.create_title":"Projekt erstellen","pages.projects.step1_title":"Welche Art von Projekt möchten Sie erstellen?","pages.projects.details_title":"Projektdetails","pages.projects.name_label":"Projektname","pages.projects.name_ph":"Z.B.: Mein persönliches Portfolio","pages.projects.desc_label":"Beschreibung","pages.projects.desc_ph":"Beschreiben Sie Ihr Projekt...","pages.projects.purpose_label":"Hauptzweck","pages.projects.purpose_ph":"Z.B.: Meine Entwicklerfähigkeiten zeigen","pages.projects.audience_label":"Zielgruppe","pages.projects.audience_ph":"Z.B.: Recruiter und Tech-Unternehmen","pages.projects.summary_title":"Projektübersicht","pages.projects.type":"Typ","pages.projects.purpose":"Zweck","pages.projects.audience":"Publikum","pages.projects.title":"Meine Projekte","pages.projects.subtitle":"Erstellen Sie vollständige Projekte mit KI","pages.projects.empty":"Sie haben noch keine Projekte","pages.projects.first_project":"Erstellen Sie Ihr erstes KI-Projekt","pages.projects.unlock_title":"Projekt-Erstellung freischalten","pages.projects.reached_limit":"Sie haben das Projektlimit Ihres Plans erreicht. Upgrade, um fortzufahren.","pages.projects.upgrade_benefits":"Erstellen Sie vollständige Projekte mit Pro und erhalten Sie erweiterte Exporte mit Pro+",
  "pages.cta.boost_productivity":"Bereit, Ihre Produktivität zu steigern?","pages.cta.join_many":"Schließen Sie sich Tausenden an, die die kollektive KI nutzen",
  "user.plan.current":"Aktueller Plan","user.plan.trial":"Test","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"Plan upgraden",
  "goodbye.title":"Ihr Konto wurde gelöscht","goodbye.subtitle":"Danke, dass Sie IntelliVerseOne ausprobiert haben.","goodbye.feedback":"Teilen Sie uns mit, warum Sie gehen – Ihr Feedback hilft uns.","goodbye.contact":"Support kontaktieren","goodbye.home":"Zur Startseite",
    "common.copy":"Kopieren","common.coming_soon":"Bald verfügbar","common.in_development":"In Entwicklung",
    "tools.categories.all":"Alle","tools.categories.content":"Inhalte","tools.categories.productivity":"Produktivität","tools.categories.analysis":"Analyse","tools.categories.social":"Soziales & Wirkung","tools.categories.development":"Entwicklung",
  "plans.limitations":"Einschränkungen:",
  "plans.table.available":"Verfügbare Pläne",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"Kostenlos",
  "plans.table.trial.features":"15 Aktionen/Tag • Orchestrator mehrere KIs",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/Monat",
  "plans.table.pro.features":"25 Fragen (lebenslang) • 300 Aktionen/Tag",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/Monat",
  "plans.table.pro_plus.features":"50 Fragen (lebenslang) • Unbegrenzte Aktionen • Vollständige Deep Research",
  "pages.history.search_placeholder":"In Gesprächen suchen...",
  "history.stats.conversations":"Unterhaltungen",
  "history.stats.total_responses":"Gesamtantworten",
  "history.stats.average_rating":"Durchschnittsbewertung",
  "history.stats.active_days":"Aktive Tage",
  "history.category.all":"Alle",
  "history.category.productivity":"Produktivität",
  "history.category.education":"Bildung",
  "history.category.development":"Entwicklung",
  "history.category.career":"Karriere",
  "history.category.finance":"Finanzen",
  "history.label.responses":"Antworten",
  "history.empty.title":"Keine Gespräche gefunden",
  "history.empty.hint_search":"Versuchen Sie andere Suchbegriffe",
  "history.empty.hint_empty":"Sie haben noch keine gespeicherten Gespräche",
  "history.empty.cta":"Neue Unterhaltung starten",
  "history.smart_search.title":"Intelligente semantische Suche",
  "history.smart_search.subtitle":"Bald: Suche nach Konzepten und Kontext, nicht nur nach Schlüsselwörtern",
  "history.smart_search.card.semantic_ai.title":"Semantische KI",
  "history.smart_search.card.semantic_ai.desc":"Finden Sie Gespräche nach Bedeutung",
  "history.smart_search.card.auto_tagging.title":"Automatische Verschlagwortung",
  "history.smart_search.card.auto_tagging.desc":"Intelligente automatische Kategorisierung",
  "history.smart_search.card.patterns.title":"Musterauswertung",
  "history.smart_search.card.patterns.desc":"Einblicke in Ihre Anfragen",
  "mygpts.title":"Meine GPTs",
  "mygpts.subtitle":"Erstellen und verwalten Sie Ihre individuellen KI‑Assistenten",
  "mygpts.create_new":"Neuen GPT erstellen",
  "mygpts.stats.created":"Erstellte GPTs",
  "mygpts.stats.uses":"Gesamtnutzungen",
  "mygpts.stats.limit":"GPT‑Limit",
  "mygpts.stats.templates":"Verfügbare Vorlagen",
  "mygpts.empty.title":"Sie haben noch keine GPTs",
  "mygpts.empty.subtitle":"Erstellen Sie Ihren ersten individuellen KI‑Assistenten",
  "mygpts.empty.cta":"Meinen ersten GPT erstellen",
  "mygpts.locked.title":"GPT‑Erstellung freischalten",
  "mygpts.locked.desc.hard":"Sie haben das GPT‑Limit Ihres Tarifs erreicht. Upgrade, um fortzufahren.",
  "mygpts.locked.desc.info":"Erstellen Sie bis zu 5 individuelle GPTs mit Pro, oder unbegrenzt mit Pro+",
  "mygpts.locked.cta":"Pläne ansehen",
  "mygpts.card.uses":"Nutzungen",
  "mygpts.card.created":"Erstellt",
  "mygpts.card.tone":"Ton",
  "mygpts.card.depth":"Tiefe",
  "mygpts.card.style":"Stil",
  "mygpts.card.use":"Verwenden",
  "mygpts.creator.title":"Neuen GPT erstellen",
  "mygpts.creator.step":"Schritt {{n}} von 4",
  "mygpts.creator.step1.title":"Basisvorlage auswählen",
  "mygpts.creator.step2.title":"GPT anpassen",
  "mygpts.creator.name.placeholder":"z. B. Mein persönlicher Assistent",
  "mygpts.creator.desc.placeholder":"Beschreiben Sie, was Ihr GPT tut und wie er hilft...",
  "mygpts.creator.icon":"Icon",
  "mygpts.creator.step3.title":"Persönlichkeit konfigurieren",
  "mygpts.creator.tone.label":"Kommunikationston",
  "mygpts.creator.tone.professional":"Professionell",
  "mygpts.creator.tone.friendly":"Freundlich",
  "mygpts.creator.tone.casual":"Locker",
  "mygpts.creator.tone.empatic":"Einfühlsam",
  "mygpts.creator.tone.direct":"Direkt",
  "mygpts.creator.depth.label":"Antworttiefe",
  "mygpts.creator.depth.basic":"Grundlegend",
  "mygpts.creator.depth.intermediate":"Mittel",
  "mygpts.creator.depth.advanced":"Fortgeschritten",
  "mygpts.creator.depth.expert":"Experte",
  "mygpts.creator.style.label":"Kommunikationsstil",
  "mygpts.creator.style.conversational":"Konversationell",
  "mygpts.creator.style.structured":"Strukturiert",
  "mygpts.creator.style.creative":"Kreativ",
  "mygpts.creator.style.analytical":"Analytisch",
  "mygpts.creator.style.reflective":"Reflektiert",
  "mygpts.creator.step4.title":"Vorschau Ihres GPT",
  "mygpts.creator.preview_hint":"Alles sieht gut aus? Sie können Ihren GPT später bearbeiten.",
  "mygpts.creator.create":"GPT erstellen",
  "mygpts.templates.tutor.name":"Mein Tutor",
  "mygpts.templates.tutor.desc":"Spezialisiert auf Lehre und Erklärungen",
  "mygpts.templates.emotional.name":"Emotionaler Mentor",
  "mygpts.templates.emotional.desc":"Emotionale Unterstützung und Wohlbefinden",
  "mygpts.templates.productivity.name":"Meine Produktivität",
  "mygpts.templates.productivity.desc":"Optimierung und Organisation",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"Tiefgehende akademische Recherche",
  "mygpts.templates.crypto.name":"Krypto‑Assets",
  "mygpts.templates.crypto.desc":"Analyse von Kryptowährungen und Blockchain",
  "mygpts.templates.business.name":"Business‑Stratege",
  "mygpts.templates.business.desc":"Unternehmensberatung und Strategie",
  "mygpts.sample.tutor.name":"Mein persönlicher Tutor",
  "mygpts.sample.tutor.desc":"Spezialisiert auf einfache Erklärung komplexer Konzepte",
  "mygpts.sample.productivity.name":"Produktivitäts‑Assistent",
  "mygpts.sample.productivity.desc":"Aufgabenoptimierung und Zeitmanagement",
  "mygpts.sample.emotional.name":"Emotionaler Mentor",
  "mygpts.sample.emotional.desc":"Emotionale Unterstützung und mentale Wohlfühltipps",
  "mygpts.sample.tone.friendly":"freundlich",
  "mygpts.sample.tone.direct":"direkt",
  "mygpts.sample.tone.empatic":"einfühlsam",
  "mygpts.sample.depth.intermediate":"mittel",
  "mygpts.sample.depth.practical":"praktisch",
  "mygpts.sample.depth.deep":"tief",
  "mygpts.sample.style.conversational":"konversationell",
  "mygpts.sample.style.structured":"strukturiert",
  "mygpts.sample.style.reflective":"reflektiert",
  "projects.types.web.name":"Webanwendung",
  "projects.types.web.desc":"Vollständiges Frontend mit React, Vue oder Angular",
  "projects.types.api.name":"API‑Backend",
  "projects.types.api.desc":"Server und Datenbank mit Node.js oder Python",
  "projects.types.mobile.name":"Mobile App",
  "projects.types.mobile.desc":"Native oder hybride Anwendung",
  "projects.types.fullstack.name":"Full‑Stack",
  "projects.types.fullstack.desc":"Komplettes Projekt: Frontend + Backend",
  "projects.actions.download_zip":"ZIP herunterladen",
  "projects.actions.continue":"Fortsetzen",
  "projects.actions.new_project":"Neues Projekt",
  "projects.progress":"Fortschritt",
  "projects.created_on":"Erstellt",
  "projects.status.completed":"Abgeschlossen",
  "projects.status.in_progress":"In Bearbeitung",
  "projects.status.generating":"Wird generiert",
  "projects.status.generating_dots":"Wird generiert...",
  "projects.actions.view":"Ansehen",
  "projects.detail.untitled":"Unbenanntes Projekt",
  "projects.detail.loading_desc":"Projektdetails werden geladen…",
  "projects.detail.no_desc":"Keine Beschreibung",
  "projects.detail.view":"Ansehen",
  "projects.detail.summary":"Zusammenfassung",
  "projects.detail.actions":"Schnellaktionen",
  "projects.detail.view_code":"Code ansehen",
  "projects.detail.activity":"Aktivität",
  "projects.detail.activity_init":"Projekt erstellt und zur Generierung eingereiht",
  "projects.detail.activity_ai":"KI bereitet Struktur und Abhängigkeiten vor",
  "projects.detail.activity_docs":"Basisdokumentation initialisiert",
  "projects.detail.tech":"Technologien",
  "history.sample.1.title":"Wie verbessere ich meine persönliche Produktivität",
  "history.sample.1.preview":"Ich brauche Tipps, um im Alltag produktiver zu sein...",
  "history.sample.2.title":"Erklärung von Sortieralgorithmen",
  "history.sample.2.preview":"Können Sie die verschiedenen Sortieralgorithmen erklären...",
  "history.sample.3.title":"Ideen für ein React‑Projekt",
  "history.sample.3.preview":"Ich suche innovative Ideen für ein React‑Projekt...",
  "history.sample.4.title":"Tipps für Vorstellungsgespräche",
  "history.sample.4.preview":"Nächste Woche habe ich ein wichtiges Vorstellungsgespräch...",
  "history.sample.5.title":"Analyse des Kryptowährungsmarkts",
  "history.sample.5.preview":"Was halten Sie von den aktuellen Kryptomarkt‑Trends...",
  "projects.mock.1.name":"Persönliches Portfolio",
  "projects.mock.1.desc":"Professionelle Website mit React und Tailwind CSS",
  "projects.mock.2.name":"Aufgaben‑App",
  "projects.mock.2.desc":"Aufgabenverwaltung mit Authentifizierung",
  "projects.mock.3.name":"E‑Commerce REST‑API",
  "projects.mock.3.desc":"Vollständiges Backend für Online‑Shop",
  "tools.items.emotional-translator.name":"Emotionaler KI‑Übersetzer",
  "tools.items.emotional-translator.description":"Übersetzt unter Wahrung von Ton und Kontext",
  "tools.items.text-reformulator.name":"Text‑Reformulator",
  "tools.items.text-reformulator.description":"Formuliert Texte unter Beibehaltung der Bedeutung um",
  "tools.items.voice-converter.name":"Text‑zu‑Sprache‑Konverter",
  "tools.items.voice-converter.description":"Wandelt Text in natürliche Sprache um",
  "tools.items.prompt-creator.name":"Prompt‑Ersteller",
  "tools.items.prompt-creator.description":"Erzeugt optimierte Prompts für jede KI",
  "tools.items.viral-titles.name":"Generator viraler Titel",
  "tools.items.viral-titles.description":"Erstellt aufmerksamkeitsstarke Titel",
  "tools.items.audience-segmenter.name":"Zielgruppen‑Segmentierer",
  "tools.items.audience-segmenter.description":"Analysiert und segmentiert Zielgruppen",
  "tools.items.idea-repairer.name":"Ideen‑Vervollständiger",
  "tools.items.idea-repairer.description":"Vervollständigt und verbessert unvollständige Ideen",
  "tools.items.copy-pulse.name":"CopyPulse – Kopieren, Verbessern und Starten",
  "tools.items.copy-pulse.description":"Analysiert, verbessert und optimiert Inhalte",
  "tools.items.file-converter.name":"Intelligenter Datei‑Konverter",
  "tools.items.file-converter.description":"Konvertiert Dateien mit KI zur Inhaltsoptimierung",
  "tools.items.arconte-ai.name":"Kontakt Arconte AI",
  "tools.items.arconte-ai.description":"Direkter Zugriff auf die fortschrittlichste KI",
  "tools.items.mass-control.name":"Positives Massen‑Management",
  "tools.items.mass-control.description":"Werkzeuge für konstruktiven sozialen Einfluss",
  "pages.not_found.title":"Seite Nicht Gefunden",
  "pages.not_found.body":"Es scheint, als hätte sich diese Seite im Multiversum der künstlichen Intelligenz verirrt. Unsere 120 KIs arbeiten daran, sie zu finden.",
  "pages.not_found.help_title":"Brauchst du Hilfe?",
  "pages.not_found.help_body":"Wenn du denkst, dass es ein Fehler ist, kannst du uns kontaktieren oder zur Hauptseite zurückkehren.",
  "pages.not_found.cta_home":"🏠 Zurück zur Startseite",
  "pages.not_found.cta_tools":"🛠️ Werkzeuge erkunden",
  "pages.not_found.link_support":"📧 Support",
  "pages.not_found.link_home":"🏠 Startseite",
  "pages.not_found.link_plans":"💎 Pläne",
  "user.panel_title":"Benutzerbereich",
  "user.security.change_password":"Passwort ändern",
  "user.security.change_password_prompt":"Neues Passwort (mindestens 8 Zeichen)",
  "user.security.password_changed":"Passwort aktualisiert",
  "user.security.reset_password":"Reset-Link senden",
  "user.security.reset_sent":"Wir haben dir eine E-Mail zum Zurücksetzen deines Passworts gesendet",
  "user.security.title":"Kontosicherheit",
  "user.security.subtitle":"Anmeldedaten und Sicherheitsoptionen verwalten.",
  "user.security.password":"Passwort",
  "user.security.password_hint":"Verwende ein langes, einzigartiges Passwort. MFA kommt bald.",
  "user.security.email_hint":"Wenn du deine E-Mail änderst, musst du sie vor der Nutzung verifizieren.",
  "user.security.password_error":"Passwort konnte nicht aktualisiert werden",
  "user.security.password_placeholder":"Neues sicheres Passwort",
  "user.security.change_password_title":"Passwort aktualisieren",
  "user.security.change_password_action":"Aktualisieren",
  "user.security.cancel":"Abbrechen",
  "user.security.password_min":"Mindestens 8 Zeichen",
  "user.security.logout":"Abmelden",
  "user.security.delete_account_btn":"Konto löschen",
  "user.security.delete_account":"Konto löschen",
  "user.security.delete_account_desc":"Diese Aktion ist dauerhaft. Du verlierst deine Projekte, GPTs und zugehörige Daten.",
  "user.security.delete_account_type":"Gib LÖSCHEN zur Bestätigung ein:",
  "user.security.delete_account_confirm":"Endgültig löschen",
  "user.security.delete_account_done":"Löschanfrage gesendet. Wir benachrichtigen dich per E-Mail.",
  "user.security.delete_account_signout":"Abgemeldet. Um die Löschung abzuschließen, konfiguriere den Webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL.",
  "trial.expired.title":"Dein 7-Tage-Trial ist beendet!",
  "trial.expired.body":"Du hast die volle Leistung von IntelliVerseOne erlebt. Um {{feature}} weiter zu nutzen, wähle deinen Plan.",
  "trial.expired.stats_title":"🎉 Während deines Trials hast du erlebt:",
  "trial.expired.stat_ias":"Befragte KIs",
  "trial.expired.stat_functionality":"Volle Funktionalität",
  "trial.expired.stat_projects":"Erstellte Projekte",
  "trial.expired.stat_costs":"Versteckte Kosten",
  "trial.expired.pro_plus_label":"🚀 Pro+ Plan - 9,79$/Monat",
  "trial.expired.pro_plus_desc":"Volle Funktionalität + Priorität + Multimedia-KI",
  "trial.expired.pro_label":"⭐ Pro Plan - 5,79$/Monat",
  "trial.expired.pro_desc":"Perfekt für den vollständigen und professionellen Einsatz",
  "trial.expired.free_option":"Oder fahre mit eingeschränkter Funktionalität fort:",
  "trial.expired.free_plan_title":"🆓 Free Plan (Eingeschränkt):",
  "trial.expired.free_blocked":"ZUGANG VOLLSTÄNDIG GESPERRT",
  "trial.expired.free_no_ias":"Keine KI-Anfragen",
  "trial.expired.free_no_premium":"Keine Premium-Funktionen",
  "trial.expired.free_history_only":"Nur Anzeige des vorherigen Verlaufs",
  "trial.expired.continue_free":"Mit Free Plan fortfahren",
  "trial.expired.benefits":"✨ 30-Tage-Garantie • 🔒 Jederzeit kündigen • 💰 Faire Preise",
  "notifications.welcome.activated":"🚀 IntelliVerseOne aktiviert - mehrere KIs bereit zur Beratung",
  "notifications.welcome.optimized":"🧠 Meta-KI-System für maximale Präzision optimiert",
  "notifications.welcome.new_features":"⚡ Neue Funktionen verfügbar - Erkunde die Werkzeuge",
  "chat.error.auth":"Nicht authentifiziert. Bitte melden Sie sich an.",
  "chat.error.quota":"Tägliches Anfragelimit erreicht. Upgrade Ihren Plan.",
  "chat.error.timeout":"Anfrage-Timeout. Bitte versuchen Sie es erneut.",
  "chat.error.server":"Serverfehler. Bitte versuchen Sie es später erneut.",
  "chat.error":"Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  "chat.placeholder.answer":"Antwort von der KI...",
  "history.auto.title":"Konversation {{date}}",
  "history.actions.confirm":"Diese Konversation löschen?",
  "life_coach":{
    "common":{"select":"Auswählen…","selected_count":"{{count}} ausgewählt","other":"Andere","other_ph":"Andere Option beschreiben"},
    "hero":{"title":"Persönlicher KI-Plan","subtitle":"Ein personalisierter Tagesplan für Prioritäten, Gewohnheiten und nächste Schritte."},
    "stats":{"areas":"Ausgewählte Bereiche","habits":"Gewohnheiten gesamt","remaining":"Heutige Aktionen verbleibend"},
    "form":{"title":"Ihr Lebensfokus","areas_label":"Prioritäre Bereiche","daily_time":"Tägliche verfügbare Zeit","emotions_label":"Wie fühlen Sie sich insgesamt","emotions.low":"Niedrig","emotions.medium":"Mittel","emotions.high":"Hoch","motivation":"Was motiviert Sie jetzt?","motivation_ph":"Beschreiben Sie Ihre Motivation","routine":"Wie ist Ihre Routine?","routine_ph":"Kurz beschreiben","constraints":"Einschränkungen oder Herausforderungen (optional)","sleep_hours":"Stunden Schlaf","sleep":{"less6":"Weniger als 6","6_7":"6-7","7_8":"7-8","more8":"Mehr als 8"},"exercise_freq":"Trainingsfrequenz","exercise":{"never":"Nie","1_2":"1-2 mal/Woche","3_4":"3-4 mal/Woche","more4":"Mehr als 4/Woche"},"diet_focus":"Ernährungsfokus","diet":{"balanced":"Ausgewogen","high_protein":"Proteinreich","low_carb":"Kohlenhydratarm","plant_based":"Pflanzlich"},"stress_level":"Stresslevel","level":{"low":"Niedrig","medium":"Mittel","high":"Hoch"},"productivity_peak":"Produktivitätsgipfel","daytime":{"morning":"Morgen","afternoon":"Nachmittag","evening":"Abend"},"reminder_time":"Bevorzugte Erinnerungszeit","distractions":"Hauptablenkungen","learning_goal":"Lernziel","learning_goal_ph":"Was möchten Sie lernen?","financial_goal":"Finanzziel","financial_goal_ph":"Z.B.: X sparen, Schulden tilgen","relationship_goal":"Beziehungsziel","relationship_goal_ph":"Familie, Partner, Freunde","weekend_routine":"Wochenend-Routine","weekend_routine_ph":"Typische Aktivitäten","accountability":{"label":"Verantwortlichkeit","solo":"Solo","buddy":"Mit Partner","coach":"Mit Coach"},"comm_style":"Kommunikationsstil","comm":{"concise":"Prägnant","detailed":"Detailliert","motivational":"Motivierend"}},
    "area":{"health":"Gesundheit","career":"Karriere","finance":"Finanzen","relationships":"Beziehungen","personal":"Persönliches Wachstum"},
    "motivation":{"health":"Gesundheit verbessern","career":"Beruflich wachsen","balance":"Work-Life-Balance","learn":"Fähigkeit erlernen","finance":"Finanzen verbessern","emotional":"Emotionales Wohlbefinden","consistency":"Konsequent sein","project":"Persönliches Projekt","exam":"Prüfung/Zertifizierung vorbereiten","stress":"Stress reduzieren"},
    "routine":{"office":"Büro 9-5","remote":"Flexibles Homeoffice","student":"Student","shift":"Schicht/Rotation","entrepreneur":"Unternehmer","caretaker":"Pflegeperson","night":"Nacht","parent":"Elternteil mit Kindern","variable":"Sehr variabel"},
    "constraints":{"time":"Zeitmangel","stress":"Stress/Angst","health":"Körperliche Gesundheit","finance":"Finanzen","family":"Familie/Pflege","environment":"Umgebung/Raum","sleep":"Unregulierter Schlaf","motivation":"Geringe Motivation","tech":"Technologie/Ausrüstung"},
    "distractions":{"social":"Soziale Medien","notifs":"Benachrichtigungen","chat":"Messaging","noise":"Umgebungslärm","multitask":"Multitasking","phone":"Telefon","fatigue":"Müdigkeit","perfect":"Perfektionismus","procrast":"Prokrastination","family":"Familienunterbrechungen","tv":"TV/Spiele"},
    "learning":{"languages":"Sprachen","programming":"Programmierung","dataai":"Daten/KI","marketing":"Marketing","sales":"Vertrieb","personal_finance":"Persönliche Finanzen","music":"Musik","design":"Kunst/Design","cert":"Prüfung/Zertifizierung","softskills":"Soft Skills"},
    "finance":{"emergency":"Notfallfonds","pay_debt":"Schulden tilgen","cut_expenses":"Ausgaben reduzieren","increase_income":"Einkommen erhöhen","invest":"Investieren","buy_house":"Haus/Fahrzeug kaufen","save_trip":"Für Reise/Studium sparen","credit_score":"Kreditwürdigkeit verbessern"},
    "relation":{"communication":"Kommunikation verbessern","family_time":"Mehr Zeit mit Familie","partner":"Beziehung stärken","friends":"Neue Freunde finden","network":"Professionelles Netzwerk","conflict":"Konflikt lösen","boundaries":"Gesunde Grenzen setzen"},
    "weekend":{"rest":"Ausruhen","family":"Familie","sport":"Sport/Aktivität","social":"Soziales","creative":"Kreativ/Hobby","chores":"Hausarbeiten","study":"Lernen/Projekt","travel":"Reisen"},
    "cta":{"generate":"Plan erstellen","regenerate":"Neu erstellen","refine_area":"Bereich verfeinern"},
    "plan":{"title":"Ihr Lebensplan","progress":"Fortschritt","weekly_goals":"Wöchentliche Ziele","monthly_goals":"Monatliche Ziele","habits":"Gewohnheiten"},
    "module":{"reminders":"Smarte Erinnerungen","feedback":"Wöchentliches Feedback"},
    "reminders":{"active":"Sie erhalten tägliche und wöchentliche personalisierte Erinnerungen.","locked":"Verfügbar in Pro+. Schalten Sie automatische Erinnerungen frei."},
    "feedback":{"active":"Sie erhalten eine wöchentliche Analyse mit Empfehlungen.","locked":"Verfügbar in Pro+. Wöchentlicher Bericht mit Verbesserungsvorschlägen."},
    "errors":{"areas":"Wählen Sie mindestens einen Bereich.","limit":"Sie haben Ihr Tageslimit erreicht."},
    "copy":{"m1":"Ich helfe Ihnen, die beste Version von sich selbst zu erschaffen.","m2":"Heute können wir einen weiteren Schritt machen. Bereit?","m3":"Kleine Veränderungen, große Ergebnisse."},
    "mock":{"goal":{"week":"3 Einheiten zu {{area}} abschließen","month":"Einen Meilenstein in {{area}} erreichen","learn":{"week":"{{skill}} üben (3 x 20m)","month":"Ein Modul in {{skill}} abschließen"},"finance":{"week":"Auf {{goal}} hinarbeiten","month":"Finanzmeilenstein erreichen: {{goal}}"},"weekend":"Wochenendaktivität: {{w}}","refine":"Verfeinerte Aktion in {{area}}"},"habit":{"1":"5-Minuten-Gewohnheit in {{area}}","2":"Reflexion über {{area}} schreiben","learn":"{{skill}} lernen (15m)","budget":"Ausgaben und Budget prüfen (10m)","relation":"Bedeutsamer Kontakt (Nachricht/Anruf)","sleep":"Schlafhygiene (10m)","exercise":{"start":"10m spazieren","progress":"20m Trainingseinheit","maintain":"Fitness halten 25m"},"diet":{"pb":"1 extra Gemüseportion hinzufügen","hp":"Protein bei jeder Mahlzeit planen","lc":"Raffinierten Zucker vermeiden"},"morning":"Tiefer AM-Block (20m) für {{area}}","focus":"Benachrichtigungsfreie Sitzung (15m)","stress":"4-7-8 Atemtechnik","accountability":"Check-in mit Partner/Coach (5m)"}},
    "career":{"habit":{"focus":"Fokusblock von {{m}}m"}},
    "remark":{"privacy":"Ihre Antworten werden privat gespeichert."}
  },
  "stats.ias":"Abgefragte KIs",
  "stats.remaining":"Verbleibend heute",
  "stats.accuracy":"Genauigkeit",
  "prompt.actions.search":"Suchen",
  "prompt.actions.voice":"Stimme",
  "prompt.actions.suggest":"Vorschlagen",
  "prompt.actions.attach":"Anhängen",
  "prompt.cta.consult_ias":"{{count}} KIs befragen",
  "prompt.remaining":"Verbleibend",
  "prompt.placeholder.expired":"Testversion abgelaufen —",
  "prompt.placeholder.limit":"Limit erreicht —",
  "prompt.trial.expired_msg":"Ihr Test ist abgelaufen. Wählen Sie einen Plan.",
  "prompt.trial.choose_plan":"Plan wählen",
  "prompt.search.active":"Suchmodus aktiv",
  "prompt.voice.no_mic":"Kein Mikrofonzugriff",
  "prompt.limit.exceeded":"Anfragelimit erreicht",
  "prompt.trial.expired":"Testversion abgelaufen",
  "auth.logout":"Abmelden",
  "mygpts.updated":"GPT aktualisiert",
  "mygpts.created":"GPT erfolgreich erstellt",
  "mygpts.error.save":"Fehler beim Speichern",
  "mygpts.creator.title_new":"Neuen GPT erstellen",
  "mygpts.creator.title_edit":"GPT bearbeiten",
  "tools.copy_empty":"Dieses Tool hat keinen Text zum Kopieren",
  "tools.copy_ok":"Prompt in Zwischenablage kopiert",
  "tools.copy_fail":"Kopieren fehlgeschlagen. Erneut versuchen.",
  "tools.copy_tooltip":"Prompt in Zwischenablage kopieren",
  "tools.run_tooltip":"Tool mit KI ausführen",
  "common.run":"Ausführen",
  "plans.paypal.error":"Ein Zahlungsfehler ist aufgetreten. Bitte erneut versuchen.",
  "plans.paypal.cancel":"Zahlung vom Benutzer abgebrochen.",
  "plans.paypal.required":"Um diesen Plan zu aktivieren, müssen Sie die Zahlung über PayPal abschließen.",
  "plans.cancel.confirm":"Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten? Sie behalten den Zugang bis zum Ende der bezahlten Periode.",
  "plans.cancel.no_auth":"Keine aktive Sitzung. Bitte erneut anmelden.",
  "plans.cancel.error":"Fehler beim Kündigen. Erneut versuchen oder Support kontaktieren.",
  "plans.cancel.success":"Abonnement gekündigt! Sie behalten den Zugang bis {{date}}.",
  "user.connections.title":"Kontoverbindungen",
  "user.connections.hint":"Verknüpfen Sie Anbieter, um sich mit jedem von ihnen anmelden zu können.",
  "projects.generated_success":"Projekt generiert! Sie können jetzt die ZIP herunterladen.",
  "projects.wizard.mvp_includes":"Ihr MVP-Projekt wird beinhalten:",
  "projects.wizard.gen.structure_mvp":"Basis-Projektstruktur",
  "projects.wizard.gen.starter":"Funktionsfähige Startdateien",
  "projects.wizard.gen.readme":"README mit Anweisungen",
  "projects.wizard.gen.config":"Anfangskonfiguration",
  "projects.wizard.mvp_note":"Laden Sie die ZIP herunter und passen Sie den Code nach Belieben an",
  "projects.actions.generating":"Generierung...",
  "common.login_required":"Bitte melden Sie sich an, um fortzufahren",
  "common.reset":"Zurücksetzen",
  "share.copied":"Link kopiert: ",
  "limits.share_pro":"Teilen erfordert Pro-Plan oder höher.",
  "common.back":"Zurück"
} };
const it = { translation: {
  "dashboard.hero.powered_by":"Impara, crea e ricerca con più intelligenze artificiali",
  "auth.promo.subscribe":"Registrati gratis",
  "auth.promo.trial":"Prova la piattaforma per 7 giorni",
  "auth.promo.nocard":"Senza carta di credito",
  "dashboard.hero.rotating":[
    "Impara, crea e fai ricerca con più intelligenze artificiali."
  ],
  "plans.cards":{
    "trial":{"name":"Trial","price":"Gratis","period":"Prova di 7 giorni","features":["15 azioni/giorno","Orchestratore IA multiple","Strumenti base","Supporto della community"],"limitations":["Funzionalità limitate","Nessuna esportazione","Nessun accesso Deep Research","Termina dopo 7 giorni"]},
    "pro":{"name":"Pro","period":"al mese","features":["25 domande (a vita)","300 azioni/giorno","Accesso a più IA","Molti strumenti sbloccati","Elaborazione prioritaria"],"limitations":["Deep Research limitata","Nessuna azione illimitata"]},
    "pro_plus":{"name":"Pro+","period":"al mese","features":["50 domande (a vita)","Azioni illimitate","Deep Research completo","Tutti gli strumenti sbloccati","Supporto prioritario 24/7"],"limitations":[]}
  },
  "plans.popular":"Più Popolare","plans.current":"Piano attuale","plans.select":"Seleziona Piano","plans.paypal.success":"Abbonamento riuscito! ID: ","plans.trial_active":"Trial attivo",
  "dashboard.cta.life_director":"Piano Personale IA","dashboard.cta.study_tutor":"Tutor di Studio IA","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"Connessioni per Interessi","dashboard.cta.propose_ideas":"Idee e Progetti","dashboard.cta.mass_control":"IA per Impatto Comunitario",
  "dashboard.desc.life_director":"Coaching personalizzato IA","dashboard.desc.study_tutor":"Apprendimento adattivo intelligente","dashboard.desc.create_project":"Sviluppo completo guidato","dashboard.desc.deepweb":"Ricerca accademica approfondita","dashboard.desc.connect_people":"Rete di conoscenza collaborativa","dashboard.desc.propose_ideas":"Generatore di opportunità","dashboard.desc.mass_control":"Impatto sociale costruttivo",
  "dashboard.quick.prompts.life_director":"Agisci come il mio coach personale di vita...","dashboard.quick.prompts.study_tutor":"Diventa il mio tutor personale...","dashboard.quick.prompts.deepweb":"Accedi a informazioni accademiche e legali approfondite...","dashboard.quick.prompts.connect_people":"Aiutami a trovare e connettere persone con interessi simili.","dashboard.quick.prompts.propose_ideas":"Genera idee innovative per progetti o business...",
  "dashboard.meta.title":"Meta‑risposta da {{count}} IA","dashboard.meta.confidence":"fiducia","dashboard.meta.queried_ais":"IA interrogate:","dashboard.meta.more":"+{{count}} altre...","dashboard.meta.specialized_ais":"{{count}} IA specializzate","dashboard.meta.categories":"Categorie","dashboard.meta.general":"Generale",
  "dashboard.welcome.title":"Benvenuto, {{name}}!","dashboard.welcome.body":"Sei connesso alla rete di IA più avanzata...","dashboard.welcome.precision.title":"Precisione","dashboard.welcome.precision.desc":"Risposte verificate da più IA","dashboard.welcome.speed.title":"Velocità","dashboard.welcome.speed.desc":"Elaborazione parallela per risposte rapide","dashboard.welcome.intelligence.title":"Intelligenza","dashboard.welcome.intelligence.desc":"Sintesi di conoscenze multi‑area",
  "dashboard.trial.title":"Stai usando solo l'8% della vera potenza di IntelliVerseOne","dashboard.trial.body":"Sblocca l’accesso completo a più IA, strumenti premium e funzioni avanzate.","dashboard.trial.view_plans":"Vedi Piani Premium","dashboard.trial.continue":"Continua la prova ({{days}} giorni)",
  "dashboard.stats.today":"Query di oggi","dashboard.stats.accuracy":"Accuratezza",
  "dashboard.quick_actions.title":"Azioni Rapide",
  "dashboard.quick_actions.subtitle":"Esplora le capacità di IntelliVerseOne",
  "dashboard.quick_actions.unlock_title":"Sblocca tutto il potenziale",
  "dashboard.quick_actions.unlock_desc":"Accedi a tutti gli strumenti e funzionalità premium",
  "prompt.suggestions.title":"💡 Suggerimenti intelligenti:","prompt.suggestions.1":"Come migliorare la mia produttività personale?","prompt.suggestions.2":"Spiega gli algoritmi di ordinamento più efficienti","prompt.suggestions.3":"Idee per un progetto React","prompt.suggestions.4":"Strategie di marketing digitale per il 2024","prompt.suggestions.5":"Tendenze nell’intelligenza artificiale","prompt.suggestions.6":"Come creare una startup di successo passo dopo passo",
  "prompt.process.analyzing":"🔍 Analisi della tua richiesta...","prompt.process.selecting":"🧠 Selezione di IA specializzate...","prompt.process.querying":"⚡ Interrogazione della rete...","prompt.process.synthesizing":"🔄 Sintesi delle risposte...","prompt.process.optimizing":"✨ Ottimizzazione della meta‑risposta...",
  "prompt.placeholder.trial":"Fai la tua domanda... (Rimaste oggi: 8/10)","prompt.placeholder.default":"Fai la tua domanda alle oltre 120 intelligenze artificiali...",
  "prompt.placeholder.search":"Cerca informazioni specifiche...",
  "prompt.search.mode":"Modalità ricerca",
  "prompt.search.truncated":"Testo troncato (limite modalità ricerca).",
  "prompt.attach.limit_files":"Numero massimo di file raggiunto",
  "prompt.attach.file_too_big":"File troppo grande (60KB max): ",
  "prompt.attach.total_too_big":"Dimensione totale allegati superata",
  "prompt.attach.unsupported_now":"Formato supportato a breve (richiede modalità cloud): ",
  "prompt.attach.unsupported":"Formato non supportato: ",
  "prompt.attach.read_error":"Errore di lettura: ",
  "prompt.attach.remove":"Rimuovere allegato",
  "prompt.voice.recording":"Registrazione in corso... (max 60s)",
  "prompt.voice.unsupported":"Riconoscimento vocale non supportato da questo browser.",
  "prompt.actions.Adjuntar archivo":"Allega file","prompt.actions.Búsqueda avanzada":"Ricerca avanzata","prompt.actions.Voz a texto":"Voce in testo","prompt.actions.Prompt inteligente":"Prompt intelligente",
  "prompt.status.querying":"Interrogazione...","prompt.status.optimizing":"Ottimizzazione...","prompt.cta.consult_ais":"Consulta {{count}} IA","prompt.trial.info":"Piano gratuito: {{days}} giorni rimanenti •","prompt.trial.upgrade":"Fai upgrade per richieste illimitate",
  "common.ok":"OK","common.sending":"Invio...","common.sent":"Inviato","common.error":"Errore","common.send":"Invia","common.close":"Chiudi","common.cancel":"Annulla","common.loading":"Caricamento...",
  "auth.login":"Accedi","auth.signup":"Registrati gratis","auth.password":"Password","auth.forgot":"Password dimenticata?","auth.continue":"Continua","auth.magic_short":"Magic link","auth.check_email":"Controlla l’e‑mail per confermare l’account","auth.reset":"Reimposta password","auth.resend":"Reinvia",
  "time.just_now":"Proprio ora","time.minutes_ago":"{{count}} minuti fa","time.hours_ago":"{{count}} ore fa","time.days_ago":"{{count}} giorni fa",
  "auth.with.google":"Continua con Google","auth.with.apple":"Continua con Apple","auth.with.microsoft":"Continua con Microsoft","auth.with.facebook":"Continua con Facebook","auth.with.github":"Continua con GitHub","auth.with.linkedin":"Continua con LinkedIn","auth.or":"o","auth.legal":"Continuando accetti i nostri","auth.terms":"Termini","auth.and":"e","auth.privacy":"Privacy","auth.errors.social":"Impossibile accedere con il provider selezionato","auth.protected_route":"Pagina protetta: accedi per continuare",
  "auth.email":"Email","auth.remember_me":"Ricordami","auth.magic.send":"Invia link","auth.magic.resend_btn":"Reinvia","auth.magic.resend_in":"Reinvia ({{s}})","auth.logged_in":"Accesso effettuato","auth.password.requirements_failed":"La password non soddisfa i requisiti","auth.reset.sent_conditional":"Se l’account esiste, abbiamo inviato un’email di reset.","auth.verification.unverified":"La tua email non è verificata.","auth.verification.resent":"Email di verifica reinviata.","auth.errors.login_failed":"Accesso non riuscito","auth.errors.signup_failed":"Registrazione non riuscita","auth.errors.magic_failed":"Impossibile inviare il link","auth.errors.resend_failed":"Impossibile reinviare",
  "auth.env.missing":"Variabili di Supabase non rilevate. Definisci REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY o VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY e riavvia il server.",
  "sidebar.dashboard":"Dashboard","sidebar.new_chat":"Nuova Chat","sidebar.new_project":"Nuovo Progetto","sidebar.history":"Cronologia","sidebar.tools":"Strumenti","sidebar.my_gpts":"I miei GPT","sidebar.plans":"Piani","sidebar.my_profile":"Il mio Profilo","sidebar.days_left":"{{count}} giorni rimanenti",
  "pages.plans.title":"Piani e Prezzi","pages.plans.subtitle":"Scegli il piano perfetto per sbloccare tutto il potenziale di IntelliVerseOne","pages.plans.stats.ais":"IA Disponibili","pages.plans.stats.tools":"Strumenti","pages.plans.stats.availability":"Disponibilità","pages.plans.compare":"Confronto dettagliato","pages.plans.trial_expiring":"La tua prova gratuita scade tra {{days}} giorni","pages.plans.trial_expiring_hint":"Fai upgrade ora per mantenere l’accesso completo","pages.plans.trial_expired_ago":"La tua prova gratuita è scaduta {{days}} giorni fa","plans.cta.start_pro":"Inizia Piano Pro","plans.cta.go_pro_plus":"Vai diretto a Pro+","pages.plans.view_plans":"Vedi Piani",
  "pages.faq.title":"Domande Frequenti","pages.faq.q.change_anytime":"Posso cambiare piano in qualsiasi momento?","pages.faq.a.change_anytime":"Sì, puoi aggiornare o effettuare il downgrade in qualsiasi momento. Le modifiche sono immediate.","pages.faq.q.free_includes":"Cosa include il piano gratuito?","pages.faq.a.free_includes":"Accesso di base a 5 IA, 10 richieste al giorno e strumenti essenziali per 7 giorni.","pages.faq.q.annual_discounts":"Ci sono sconti annuali?","pages.faq.a.annual_discounts":"Sì, 2 mesi gratis con pagamento annuale.","pages.faq.q.payment_methods":"Metodi di pagamento accettati?","pages.faq.a.payment_methods":"Carte, PayPal e bonifici.","pages.faq.q.cancel_anytime":"Posso cancellare in qualsiasi momento?","pages.faq.a.cancel_anytime":"Sì, puoi annullare senza penali.","pages.faq.q.support":"Offrite supporto tecnico?","pages.faq.a.support":"Sì, tutti i piani includono supporto. Quelli a pagamento hanno supporto prioritario 24/7.",
  "pages.history.title":"Cronologia Conversazioni","pages.history.subtitle":"Rivedi e cerca le tue conversazioni passate",
  "pages.tools.title":"Strumenti IA","pages.tools.subtitle":"Suite completa di strumenti potenziati dall’IA","pages.tools.search_placeholder":"Cerca strumenti...","pages.tools.empty":"Nessuno strumento trovato","pages.tools.empty_hint":"Prova altri termini o cambia categoria","pages.tools.more_coming":"Altri strumenti in sviluppo","pages.tools.more_coming_desc":"Aggiungiamo costantemente nuovi strumenti IA per aumentare la produttività",
  "pages.projects.create_title":"Crea Progetto","pages.projects.step1_title":"Che tipo di progetto vuoi creare?","pages.projects.details_title":"Dettagli del progetto","pages.projects.name_label":"Nome del progetto","pages.projects.name_ph":"Es.: Il mio Portfolio Personale","pages.projects.desc_label":"Descrizione","pages.projects.desc_ph":"Descrivi il tuo progetto...","pages.projects.purpose_label":"Scopo principale","pages.projects.purpose_ph":"Es.: Mostrare le mie capacità","pages.projects.audience_label":"Pubblico di riferimento","pages.projects.audience_ph":"Es.: Recruiter e aziende tech","pages.projects.summary_title":"Riepilogo progetto","pages.projects.type":"Tipo","pages.projects.purpose":"Scopo","pages.projects.audience":"Pubblico","pages.projects.title":"I miei Progetti","pages.projects.subtitle":"Crea progetti completi con l’IA","pages.projects.empty":"Non hai ancora progetti","pages.projects.first_project":"Crea il tuo primo progetto con l’IA","pages.projects.unlock_title":"Sblocca la Creazione di Progetti","pages.projects.reached_limit":"Hai raggiunto il limite di progetti del tuo piano. Effettua l’upgrade per continuare.","pages.projects.upgrade_benefits":"Genera progetti completi con il piano Pro ed esportazioni avanzate con Pro+",
  "pages.cta.boost_productivity":"Pronto a potenziare la tua produttività?","pages.cta.join_many":"Unisciti a migliaia che sfruttano la potenza dell’IA collettiva",
  "user.plan.current":"Piano attuale","user.plan.trial":"Prova","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"Aggiorna Piano",
  "goodbye.title":"Il tuo account è stato eliminato","goodbye.subtitle":"Grazie per aver provato IntelliVerseOne.","goodbye.feedback":"Se vuoi dirci perché vai via, il tuo feedback ci aiuta a migliorare.","goodbye.contact":"Contatta il supporto","goodbye.home":"Torna alla home",
    "common.copy":"Copia","common.coming_soon":"In arrivo","common.in_development":"In sviluppo",
    "tools.categories.all":"Tutte","tools.categories.content":"Contenuti","tools.categories.productivity":"Produttività","tools.categories.analysis":"Analisi","tools.categories.social":"Social & Impatto","tools.categories.development":"Sviluppo",
  "plans.limitations":"Limitazioni:",
  "plans.table.available":"Piani disponibili",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"Gratis",
  "plans.table.trial.features":"15 azioni/giorno • Orchestratore IA multiple",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/mese",
  "plans.table.pro.features":"25 domande (a vita) • 300 azioni/giorno",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/mese",
  "plans.table.pro_plus.features":"50 domande (a vita) • Azioni illimitate • Deep Research completo",
  "pages.history.search_placeholder":"Cerca nelle conversazioni...",
  "history.stats.conversations":"Conversazioni",
  "history.stats.total_responses":"Risposte totali",
  "history.stats.average_rating":"Valutazione media",
  "history.stats.active_days":"Giorni attivi",
  "history.category.all":"Tutte",
  "history.category.productivity":"Produttività",
  "history.category.education":"Educazione",
  "history.category.development":"Sviluppo",
  "history.category.career":"Carriera",
  "history.category.finance":"Finanza",
  "history.label.responses":"risposte",
  "history.empty.title":"Nessuna conversazione trovata",
  "history.empty.hint_search":"Prova altri termini di ricerca",
  "history.empty.hint_empty":"Non hai ancora conversazioni salvate",
  "history.empty.cta":"Avvia Nuova Conversazione",
  "history.smart_search.title":"Ricerca Semantica Intelligente",
  "history.smart_search.subtitle":"In arrivo: ricerca per concetti e contesto, non solo parole chiave",
  "history.smart_search.card.semantic_ai.title":"IA Semantica",
  "history.smart_search.card.semantic_ai.desc":"Trova conversazioni per significato",
  "history.smart_search.card.auto_tagging.title":"Auto-etichettatura",
  "history.smart_search.card.auto_tagging.desc":"Categorizzazione automatica intelligente",
  "history.smart_search.card.patterns.title":"Analisi dei Pattern",
  "history.smart_search.card.patterns.desc":"Insight sulle tue richieste",
  "mygpts.title":"I miei GPT",
  "mygpts.subtitle":"Crea e gestisci i tuoi assistenti IA personalizzati",
  "mygpts.create_new":"Crea Nuovo GPT",
  "mygpts.stats.created":"GPT creati",
  "mygpts.stats.uses":"Utilizzi totali",
  "mygpts.stats.limit":"Limite GPT",
  "mygpts.stats.templates":"Modelli disponibili",
  "mygpts.empty.title":"Non hai ancora GPT",
  "mygpts.empty.subtitle":"Crea il tuo primo assistente IA personalizzato",
  "mygpts.empty.cta":"Crea il mio primo GPT",
  "mygpts.locked.title":"Sblocca la creazione di GPT",
  "mygpts.locked.desc.hard":"Hai raggiunto il limite di GPT del tuo piano. Effettua l’upgrade per continuare.",
  "mygpts.locked.desc.info":"Crea fino a 5 GPT personalizzati con Pro, oppure illimitati con Pro+",
  "mygpts.locked.cta":"Vedi Piani",
  "mygpts.card.uses":"utilizzi",
  "mygpts.card.created":"Creato",
  "mygpts.card.tone":"Tono",
  "mygpts.card.depth":"Profondità",
  "mygpts.card.style":"Stile",
  "mygpts.card.use":"Usa",
  "mygpts.creator.title":"Crea Nuovo GPT",
  "mygpts.creator.step":"Passo {{n}} di 4",
  "mygpts.creator.step1.title":"Seleziona un modello base",
  "mygpts.creator.step2.title":"Personalizza il tuo GPT",
  "mygpts.creator.name.placeholder":"es.: Il mio assistente personale",
  "mygpts.creator.desc.placeholder":"Descrivi cosa fa il tuo GPT e come aiuta...",
  "mygpts.creator.icon":"Icona",
  "mygpts.creator.step3.title":"Configurazione della personalità",
  "mygpts.creator.tone.label":"Tono di comunicazione",
  "mygpts.creator.tone.professional":"Professionale",
  "mygpts.creator.tone.friendly":"Amichevole",
  "mygpts.creator.tone.casual":"Informale",
  "mygpts.creator.tone.empatic":"Empatico",
  "mygpts.creator.tone.direct":"Diretto",
  "mygpts.creator.depth.label":"Profondità delle risposte",
  "mygpts.creator.depth.basic":"Base",
  "mygpts.creator.depth.intermediate":"Intermedio",
  "mygpts.creator.depth.advanced":"Avanzato",
  "mygpts.creator.depth.expert":"Esperto",
  "mygpts.creator.style.label":"Stile di comunicazione",
  "mygpts.creator.style.conversational":"Conversazionale",
  "mygpts.creator.style.structured":"Strutturato",
  "mygpts.creator.style.creative":"Creativo",
  "mygpts.creator.style.analytical":"Analitico",
  "mygpts.creator.style.reflective":"Riflessivo",
  "mygpts.creator.step4.title":"Anteprima del tuo GPT",
  "mygpts.creator.preview_hint":"Tutto a posto? Potrai modificare il GPT più tardi.",
  "mygpts.creator.create":"Crea GPT",
  "mygpts.templates.tutor.name":"Il mio Tutor",
  "mygpts.templates.tutor.desc":"Specializzato in insegnamento e spiegazioni",
  "mygpts.templates.emotional.name":"Mentore Emotivo",
  "mygpts.templates.emotional.desc":"Supporto emotivo e benessere",
  "mygpts.templates.productivity.name":"La mia Produttività",
  "mygpts.templates.productivity.desc":"Ottimizzazione e organizzazione",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"Ricerca accademica approfondita",
  "mygpts.templates.crypto.name":"CriptoAttivi",
  "mygpts.templates.crypto.desc":"Analisi di criptovalute e blockchain",
  "mygpts.templates.business.name":"Stratega Aziendale",
  "mygpts.templates.business.desc":"Consulenza e strategia aziendale",
  "mygpts.sample.tutor.name":"Il mio Tutor Personale",
  "mygpts.sample.tutor.desc":"Specializzato nello spiegare concetti complessi in modo semplice",
  "mygpts.sample.productivity.name":"Assistente Produttività",
  "mygpts.sample.productivity.desc":"Ottimizzazione delle attività e gestione del tempo",
  "mygpts.sample.emotional.name":"Mentore Emotivo",
  "mygpts.sample.emotional.desc":"Supporto emotivo e consigli per il benessere mentale",
  "mygpts.sample.tone.friendly":"amichevole",
  "mygpts.sample.tone.direct":"diretto",
  "mygpts.sample.tone.empatic":"empatico",
  "mygpts.sample.depth.intermediate":"intermedio",
  "mygpts.sample.depth.practical":"pratico",
  "mygpts.sample.depth.deep":"profondo",
  "mygpts.sample.style.conversational":"conversazionale",
  "mygpts.sample.style.structured":"strutturato",
  "mygpts.sample.style.reflective":"riflessivo",
  "projects.types.web.name":"Applicazione Web",
  "projects.types.web.desc":"Frontend completo con React, Vue o Angular",
  "projects.types.api.name":"API Backend",
  "projects.types.api.desc":"Server e database con Node.js o Python",
  "projects.types.mobile.name":"App Mobile",
  "projects.types.mobile.desc":"Applicazione nativa o ibrida",
  "projects.types.fullstack.name":"Full Stack",
  "projects.types.fullstack.desc":"Progetto completo frontend + backend",
  "projects.actions.download_zip":"Scarica ZIP",
  "projects.actions.continue":"Continua",
  "projects.actions.new_project":"Nuovo Progetto",
  "projects.progress":"Progresso",
  "projects.created_on":"Creato",
  "projects.status.completed":"Completato",
  "projects.status.in_progress":"In corso",
  "projects.status.generating":"In generazione",
  "projects.status.generating_dots":"In generazione...",
  "projects.actions.view":"Vedi",
  "projects.detail.untitled":"Progetto senza titolo",
  "projects.detail.loading_desc":"Recupero dei dettagli del progetto…",
  "projects.detail.no_desc":"Senza descrizione",
  "projects.detail.view":"Vedi",
  "projects.detail.summary":"Riepilogo",
  "projects.detail.actions":"Azioni rapide",
  "projects.detail.view_code":"Vedi codice",
  "projects.detail.activity":"Attività",
  "projects.detail.activity_init":"Progetto creato e messo in coda per la generazione",
  "projects.detail.activity_ai":"L’IA sta preparando struttura e dipendenze",
  "projects.detail.activity_docs":"Documentazione di base inizializzata",
  "projects.detail.tech":"Tecnologie",
  "history.sample.1.title":"Come migliorare la mia produttività personale",
  "history.sample.1.preview":"Mi servono consigli per essere più produttivo nel lavoro quotidiano...",
  "history.sample.2.title":"Spiegazione degli algoritmi di ordinamento",
  "history.sample.2.preview":"Potresti spiegare i diversi algoritmi di ordinamento...",
  "history.sample.3.title":"Idee per un progetto React",
  "history.sample.3.preview":"Cerco idee innovative per un progetto in React...",
  "history.sample.4.title":"Consigli per i colloqui di lavoro",
  "history.sample.4.preview":"Ho un colloquio importante la prossima settimana...",
  "history.sample.5.title":"Analisi del mercato delle criptovalute",
  "history.sample.5.preview":"Cosa ne pensi delle tendenze attuali del mercato crypto...",
  "projects.mock.1.name":"Portfolio Personale",
  "projects.mock.1.desc":"Sito professionale con React e Tailwind CSS",
  "projects.mock.2.name":"App Attività",
  "projects.mock.2.desc":"Gestione delle attività con autenticazione",
  "projects.mock.3.name":"API REST E‑commerce",
  "projects.mock.3.desc":"Backend completo per negozio online",
  "tools.items.emotional-translator.name":"Traduttore IA Emotivo",
  "tools.items.emotional-translator.description":"Traduce preservando tono e contesto emotivo",
  "tools.items.text-reformulator.name":"Riformulatore di Testi",
  "tools.items.text-reformulator.description":"Riscrive i testi mantenendo il significato",
  "tools.items.voice-converter.name":"Convertitore Testo‑Voce",
  "tools.items.voice-converter.description":"Converte il testo in audio naturale",
  "tools.items.prompt-creator.name":"Creatore di Prompt",
  "tools.items.prompt-creator.description":"Genera prompt ottimizzati per qualsiasi IA",
  "tools.items.viral-titles.name":"Generatore di Titoli Virali",
  "tools.items.viral-titles.description":"Crea titoli accattivanti",
  "tools.items.audience-segmenter.name":"Segmentatore di Pubblico",
  "tools.items.audience-segmenter.description":"Analizza e segmenta il pubblico target",
  "tools.items.idea-repairer.name":"Riparatore di Idee Incomplete",
  "tools.items.idea-repairer.description":"Completa e migliora idee parziali",
  "tools.items.copy-pulse.name":"CopyPulse – Copia, Migliora e Lancia",
  "tools.items.copy-pulse.description":"Analizza, migliora e ottimizza qualsiasi contenuto",
  "tools.items.file-converter.name":"Convertitore Intelligente di File",
  "tools.items.file-converter.description":"Converte file con IA per ottimizzare i contenuti",
  "tools.items.arconte-ai.name":"Contatto Arconte AI",
  "tools.items.arconte-ai.description":"Accesso diretto all’IA più avanzata",
  "tools.items.mass-control.name":"Controllo Positivo delle Masse",
  "tools.items.mass-control.description":"Strumenti per un impatto sociale costruttivo",
  "pages.not_found.title":"Pagina Non Trovata",
  "pages.not_found.body":"Sembra che questa pagina si sia persa nel multiverso dell'intelligenza artificiale. Le nostre 120 IA stanno lavorando per trovarla.",
  "pages.not_found.help_title":"Hai bisogno di aiuto?",
  "pages.not_found.help_body":"Se pensi che sia un errore, puoi contattarci o tornare alla pagina principale.",
  "pages.not_found.cta_home":"🏠 Torna all'inizio",
  "pages.not_found.cta_tools":"🛠️ Esplora gli strumenti",
  "pages.not_found.link_support":"📧 Supporto",
  "pages.not_found.link_home":"🏠 Inizio",
  "pages.not_found.link_plans":"💎 Piani",
  "user.panel_title":"Pannello Utente",
  "user.security.change_password":"Cambia password",
  "user.security.change_password_prompt":"Nuova password (minimo 8 caratteri)",
  "user.security.password_changed":"Password aggiornata",
  "user.security.reset_password":"Invia link di reimpostazione",
  "user.security.reset_sent":"Ti abbiamo inviato un'email per reimpostare la tua password",
  "user.security.title":"Sicurezza dell'Account",
  "user.security.subtitle":"Gestisci credenziali e opzioni di sicurezza.",
  "user.security.password":"Password",
  "user.security.password_hint":"Usa una password lunga e unica. MFA in arrivo.",
  "user.security.email_hint":"Se cambi la tua email dovrai verificarla prima di usarla.",
  "user.security.password_error":"Impossibile aggiornare la password",
  "user.security.password_placeholder":"Nuova password sicura",
  "user.security.change_password_title":"Aggiorna Password",
  "user.security.change_password_action":"Aggiorna",
  "user.security.cancel":"Annulla",
  "user.security.password_min":"Minimo 8 caratteri",
  "user.security.logout":"Esci",
  "user.security.delete_account_btn":"Elimina account",
  "user.security.delete_account":"Elimina account",
  "user.security.delete_account_desc":"Questa azione è permanente. Perderai i tuoi progetti, GPT e dati associati.",
  "user.security.delete_account_type":"Scrivi ELIMINA per confermare:",
  "user.security.delete_account_confirm":"Elimina definitivamente",
  "user.security.delete_account_done":"Richiesta di eliminazione inviata. Ti notificheremo via email.",
  "user.security.delete_account_signout":"Sessione chiusa. Per completare l'eliminazione, configura il webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL.",
  "trial.expired.title":"Il tuo Trial di 7 giorni è terminato!",
  "trial.expired.body":"Hai sperimentato la piena potenza di IntelliVerseOne. Per continuare a usare {{feature}}, scegli il tuo piano.",
  "trial.expired.stats_title":"🎉 Durante il tuo trial hai sperimentato:",
  "trial.expired.stat_ias":"IA consultate",
  "trial.expired.stat_functionality":"Funzionalità completa",
  "trial.expired.stat_projects":"Progetti creati",
  "trial.expired.stat_costs":"Costi nascosti",
  "trial.expired.pro_plus_label":"🚀 Piano Pro+ - $9,79/mese",
  "trial.expired.pro_plus_desc":"Funzionalità completa + priorità + multimedia IA",
  "trial.expired.pro_label":"⭐ Piano Pro - $5,79/mese",
  "trial.expired.pro_desc":"Perfetto per un uso completo e professionale",
  "trial.expired.free_option":"O continua con funzionalità limitate:",
  "trial.expired.free_plan_title":"🆓 Piano Free (Limitato):",
  "trial.expired.free_blocked":"ACCESSO COMPLETAMENTE BLOCCATO",
  "trial.expired.free_no_ias":"Nessuna consultazione alle IA",
  "trial.expired.free_no_premium":"Nessuna funzione premium",
  "trial.expired.free_history_only":"Solo visualizzazione della cronologia precedente",
  "trial.expired.continue_free":"Continua con il Piano Free",
  "trial.expired.benefits":"✨ Garanzia di 30 giorni • 🔒 Annulla quando vuoi • 💰 Prezzi equi",
  "notifications.welcome.activated":"🚀 IntelliVerseOne attivato - più IA pronte per la consultazione",
  "notifications.welcome.optimized":"🧠 Sistema Meta-IA ottimizzato per la massima precisione",
  "notifications.welcome.new_features":"⚡ Nuove funzioni disponibili - Esplora gli strumenti",
  "chat.error.auth":"Non autenticato. Accedi per continuare.",
  "chat.error.quota":"Limite giornaliero di query raggiunto. Aggiorna il piano.",
  "chat.error.timeout":"Timeout della richiesta. Riprova.",
  "chat.error.server":"Errore del server. Riprova più tardi.",
  "chat.error":"Si è verificato un errore. Riprova.",
  "chat.placeholder.answer":"Risposta dell'IA...",
  "history.auto.title":"Conversazione {{date}}",
  "history.actions.confirm":"Eliminare questa conversazione?",
  "life_coach":{
    "common":{"select":"Seleziona…","selected_count":"{{count}} selezionate","other":"Altro","other_ph":"Descrivi un'altra opzione"},
    "hero":{"title":"Piano Personale IA","subtitle":"Un piano quotidiano personalizzato per priorità, abitudini e prossimi passi."},
    "stats":{"areas":"Aree selezionate","habits":"Abitudini totali","remaining":"Azioni rimanenti oggi"},
    "form":{"title":"Il tuo focus di vita","areas_label":"Aree prioritarie","daily_time":"Tempo giornaliero disponibile","emotions_label":"Come ti senti in generale","emotions.low":"Basso","emotions.medium":"Medio","emotions.high":"Alto","motivation":"Cosa ti motiva adesso?","motivation_ph":"Descrivi la tua motivazione","routine":"Com'è la tua routine?","routine_ph":"Descrivi brevemente","constraints":"Vincoli o sfide (opzionale)","sleep_hours":"Ore di sonno","sleep":{"less6":"Meno di 6","6_7":"6-7","7_8":"7-8","more8":"Più di 8"},"exercise_freq":"Frequenza di esercizio","exercise":{"never":"Mai","1_2":"1-2 volte/settimana","3_4":"3-4 volte/settimana","more4":"Più di 4/settimana"},"diet_focus":"Focus alimentare","diet":{"balanced":"Equilibrato","high_protein":"Alto in proteine","low_carb":"Basso in carboidrati","plant_based":"Vegetale"},"stress_level":"Livello di stress","level":{"low":"Basso","medium":"Medio","high":"Alto"},"productivity_peak":"Picco di produttività","daytime":{"morning":"Mattina","afternoon":"Pomeriggio","evening":"Sera"},"reminder_time":"Orario promemoria preferito","distractions":"Principali distrazioni","learning_goal":"Obiettivo di apprendimento","learning_goal_ph":"Cosa vuoi imparare?","financial_goal":"Obiettivo finanziario","financial_goal_ph":"Es.: risparmiare X, saldare debito","relationship_goal":"Obiettivo relazionale","relationship_goal_ph":"Famiglia, partner, amici","weekend_routine":"Routine del weekend","weekend_routine_ph":"Attività tipiche","accountability":{"label":"Responsabilità","solo":"Solo","buddy":"Con un amico","coach":"Con un coach"},"comm_style":"Stile di comunicazione","comm":{"concise":"Conciso","detailed":"Dettagliato","motivational":"Motivante"}},
    "area":{"health":"Salute","career":"Carriera","finance":"Finanze","relationships":"Relazioni","personal":"Crescita personale"},
    "motivation":{"health":"Migliorare la salute","career":"Crescere professionalmente","balance":"Equilibrio vita-lavoro","learn":"Imparare una competenza","finance":"Migliorare le finanze","emotional":"Benessere emotivo","consistency":"Essere costante","project":"Progetto personale","exam":"Prepararsi per un esame","stress":"Ridurre lo stress"},
    "routine":{"office":"Ufficio 9-5","remote":"Remoto flessibile","student":"Studente","shift":"Turni/rotazione","entrepreneur":"Imprenditore","caretaker":"Caregiver","night":"Notturno","parent":"Genitore con figli","variable":"Molto variabile"},
    "constraints":{"time":"Mancanza di tempo","stress":"Stress/Ansia","health":"Salute fisica","finance":"Finanze","family":"Famiglia/Cura","environment":"Ambiente/Spazio","sleep":"Sonno irregolare","motivation":"Bassa motivazione","tech":"Tecnologia/Attrezzatura"},
    "distractions":{"social":"Social media","notifs":"Notifiche","chat":"Messaggistica","noise":"Rumore ambientale","multitask":"Multitasking","phone":"Telefono","fatigue":"Stanchezza","perfect":"Perfezionismo","procrast":"Procrastinazione","family":"Interruzioni familiari","tv":"TV/Giochi"},
    "learning":{"languages":"Lingue","programming":"Programmazione","dataai":"Dati/IA","marketing":"Marketing","sales":"Vendite","personal_finance":"Finanze personali","music":"Musica","design":"Arte/Design","cert":"Esame/Certificazione","softskills":"Soft skill"},
    "finance":{"emergency":"Fondo di emergenza","pay_debt":"Saldare i debiti","cut_expenses":"Ridurre le spese","increase_income":"Aumentare le entrate","invest":"Investire","buy_house":"Comprare casa/veicolo","save_trip":"Risparmiare per viaggio/studio","credit_score":"Migliorare il credito"},
    "relation":{"communication":"Migliorare la comunicazione","family_time":"Più tempo in famiglia","partner":"Rafforzare la relazione","friends":"Fare nuove amicizie","network":"Networking professionale","conflict":"Risolvere un conflitto","boundaries":"Stabilire limiti sani"},
    "weekend":{"rest":"Riposo","family":"Famiglia","sport":"Sport/attività","social":"Socialità","creative":"Creativo/hobby","chores":"Faccende domestiche","study":"Studio/progetto","travel":"Viaggio"},
    "cta":{"generate":"Genera Piano","regenerate":"Rigenera","refine_area":"Affina area"},
    "plan":{"title":"Il Tuo Piano di Vita","progress":"Progresso","weekly_goals":"Obiettivi Settimanali","monthly_goals":"Obiettivi Mensili","habits":"Abitudini"},
    "module":{"reminders":"Promemoria intelligenti","feedback":"Feedback settimanale"},
    "reminders":{"active":"Riceverai promemoria giornalieri e settimanali personalizzati.","locked":"Disponibile in Pro+. Sblocca promemoria automatici e personalizzati."},
    "feedback":{"active":"Riceverai un'analisi settimanale con raccomandazioni personalizzate.","locked":"Disponibile in Pro+. Report settimanale con miglioramenti suggeriti."},
    "errors":{"areas":"Seleziona almeno un'area.","limit":"Hai raggiunto il limite giornaliero."},
    "copy":{"m1":"Sono qui per aiutarti a costruire la versione migliore di te stesso.","m2":"Oggi possiamo fare un altro passo. Pronto?","m3":"Piccoli cambiamenti, grandi risultati."},
    "mock":{"goal":{"week":"Completa 3 sessioni legate a {{area}}","month":"Raggiungi un traguardo chiave in {{area}}","learn":{"week":"Studia {{skill}} (3 x 20m)","month":"Completa un modulo in {{skill}}"},"finance":{"week":"Avanza verso: {{goal}}","month":"Raggiungi l'obiettivo finanziario: {{goal}}"},"weekend":"Attività del weekend: {{w}}","refine":"Azione rifinita in {{area}}"},"habit":{"1":"Abitudine di 5 minuti in {{area}}","2":"Scrivi una riflessione su {{area}}","learn":"Impara {{skill}} (15m)","budget":"Rivedi spese e budget (10m)","relation":"Contatto significativo (messaggio/chiamata)","sleep":"Igiene del sonno (10m)","exercise":{"start":"Cammina 10m","progress":"Sessione di 20m di esercizio","maintain":"Mantenere la forma 25m"},"diet":{"pb":"Aggiungi 1 porzione extra di verdure","hp":"Pianifica proteine in ogni pasto","lc":"Evita zuccheri raffinati"},"morning":"Blocco AM profondo (20m) per {{area}}","focus":"Sessione senza notifiche (15m)","stress":"Tecnica respiratoria 4-7-8","accountability":"Check-in con amico/coach (5m)"}},
    "career":{"habit":{"focus":"Blocco di focus di {{m}}m"}},
    "remark":{"privacy":"Le tue risposte vengono salvate privatamente."}
  },
  "stats.ias":"IA consultate",
  "stats.remaining":"Rimanenti oggi",
  "stats.accuracy":"Precisione",
  "prompt.actions.search":"Cerca",
  "prompt.actions.voice":"Voce",
  "prompt.actions.suggest":"Suggerisci",
  "prompt.actions.attach":"Allega",
  "prompt.cta.consult_ias":"Consulta {{count}} IA",
  "prompt.remaining":"Rimanenti",
  "prompt.placeholder.expired":"Trial scaduto —",
  "prompt.placeholder.limit":"Limite raggiunto —",
  "prompt.trial.expired_msg":"Il tuo periodo di prova è scaduto. Scegli un piano.",
  "prompt.trial.choose_plan":"Scegli un piano",
  "prompt.search.active":"Modalità ricerca attiva",
  "prompt.voice.no_mic":"Accesso microfono non disponibile",
  "prompt.limit.exceeded":"Limite di query raggiunto",
  "prompt.trial.expired":"Trial scaduto",
  "auth.logout":"Esci",
  "mygpts.updated":"GPT aggiornato",
  "mygpts.created":"GPT creato con successo",
  "mygpts.error.save":"Errore nel salvataggio",
  "mygpts.creator.title_new":"Crea Nuovo GPT",
  "mygpts.creator.title_edit":"Modifica GPT",
  "tools.copy_empty":"Questo strumento non ha testo da copiare",
  "tools.copy_ok":"Prompt copiato negli appunti",
  "tools.copy_fail":"Impossibile copiare. Riprova.",
  "tools.copy_tooltip":"Copia prompt negli appunti",
  "tools.run_tooltip":"Esegui strumento con IA",
  "common.run":"Esegui",
  "plans.paypal.error":"Si è verificato un errore di pagamento. Riprova.",
  "plans.paypal.cancel":"Pagamento annullato dall'utente.",
  "plans.paypal.required":"Per attivare questo piano, devi completare il pagamento tramite PayPal.",
  "plans.cancel.confirm":"Sei sicuro di voler cancellare la tua iscrizione? Manterrai l'accesso fino alla fine del periodo pagato.",
  "plans.cancel.no_auth":"Nessuna sessione attiva. Effettua nuovamente il login.",
  "plans.cancel.error":"Errore durante la cancellazione. Riprova o contatta il supporto.",
  "plans.cancel.success":"Abbonamento cancellato! Manterrai l'accesso fino al {{date}}.",
  "user.connections.title":"Connessioni account",
  "user.connections.hint":"Collega i provider per poter accedere con uno qualsiasi di essi.",
  "projects.generated_success":"Progetto generato! Puoi ora scaricare il ZIP.",
  "projects.wizard.mvp_includes":"Il tuo progetto MVP includerà:",
  "projects.wizard.gen.structure_mvp":"Struttura base del progetto",
  "projects.wizard.gen.starter":"File di avvio funzionali",
  "projects.wizard.gen.readme":"README con istruzioni",
  "projects.wizard.gen.config":"Configurazione iniziale",
  "projects.wizard.mvp_note":"Scarica il ZIP e personalizza il codice come preferisci",
  "projects.actions.generating":"Generazione in corso...",
  "common.login_required":"Accedi per continuare",
  "common.reset":"Reimposta",
  "share.copied":"Link copiato: ",
  "limits.share_pro":"La condivisione richiede il piano Pro o superiore.",
  "common.back":"Indietro"
} };
const zh = { translation: {
  "dashboard.hero.powered_by":"用多种人工智能学习、创作和研究",
  "auth.promo.subscribe":"免费注册",
  "auth.promo.trial":"免费试用平台7天",
  "auth.promo.nocard":"无需信用卡",
  "dashboard.hero.rotating":[
    "用多种人工智能学习、创作和研究。"
  ],
  "plans.cards":{
    "trial":{"name":"试用","price":"免费","period":"7 天试用","features":["每日 15 次操作","Orchestrator 多个 AI","基础工具","社区支持"],"limitations":["功能受限","无导出","无 Deep Research 访问","7 天后结束"]},
    "pro":{"name":"Pro","period":"每月","features":["终身 25 个问题","每日 300 次操作","访问 多个 AI","大部分工具解锁","优先处理"],"limitations":["Deep Research 受限","无无限操作"]},
    "pro_plus":{"name":"Pro+","period":"每月","features":["终身 50 个问题","无限操作","完整 Deep Research","全部工具解锁","24/7 优先支持"],"limitations":[]}
  },
  "plans.popular":"最受欢迎","plans.current":"当前套餐","plans.select":"选择套餐","plans.paypal.success":"订阅成功！ID: ","plans.trial_active":"试用已激活",
  "dashboard.cta.life_director":"个人 AI 计划","dashboard.cta.study_tutor":"AI 学习导师","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"按兴趣连接","dashboard.cta.propose_ideas":"想法与项目","dashboard.cta.mass_control":"社区影响 AI",
  "dashboard.desc.life_director":"个性化AI教练","dashboard.desc.study_tutor":"智能自适应学习","dashboard.desc.create_project":"完整的引导式开发","dashboard.desc.deepweb":"深度学术检索","dashboard.desc.connect_people":"协作式知识网络","dashboard.desc.propose_ideas":"机会生成器","dashboard.desc.mass_control":"建设性的社会影响",
  "dashboard.quick.prompts.life_director":"充当我的个人生活教练...","dashboard.quick.prompts.study_tutor":"成为我的私人导师...","dashboard.quick.prompts.deepweb":"访问深度的学术与法律信息...","dashboard.quick.prompts.connect_people":"帮我寻找并连接兴趣相近的人。","dashboard.quick.prompts.propose_ideas":"生成创新的项目或商业创意...",
  "dashboard.meta.title":"来自 {{count}} 个AI的元回答","dashboard.meta.confidence":"置信度","dashboard.meta.queried_ais":"已查询AI：","dashboard.meta.more":"+{{count}} 更多...","dashboard.meta.specialized_ais":"{{count}} 个专用AI","dashboard.meta.categories":"分类","dashboard.meta.general":"通用",
  "dashboard.welcome.title":"欢迎，{{name}}！","dashboard.welcome.body":"你已连接到最先进的AI网络...","dashboard.welcome.precision.title":"精准","dashboard.welcome.precision.desc":"由多路AI交叉验证的答案","dashboard.welcome.speed.title":"速度","dashboard.welcome.speed.desc":"并行处理以获得快速响应","dashboard.welcome.intelligence.title":"智能","dashboard.welcome.intelligence.desc":"多领域知识综合",
  "dashboard.trial.title":"你只在使用 IntelliVerseOne 真正实力的 8%","dashboard.trial.body":"解锁对 multiple AIs、精品工具和高级功能的完整访问。","dashboard.trial.view_plans":"查看高级套餐","dashboard.trial.continue":"继续试用（{{days}} 天）",
  "dashboard.stats.today":"今日查询","dashboard.stats.accuracy":"准确率",
  "dashboard.quick_actions.title":"快速操作",
  "dashboard.quick_actions.subtitle":"探索 IntelliVerseOne 的能力",
  "dashboard.quick_actions.unlock_title":"解锁全部潜能",
  "dashboard.quick_actions.unlock_desc":"访问所有高级工具和功能",
  "prompt.suggestions.title":"💡 智能建议：","prompt.suggestions.1":"如何提升我的个人效率？","prompt.suggestions.2":"解释最有效的排序算法","prompt.suggestions.3":"React 项目创意","prompt.suggestions.4":"2024 年数字营销策略","prompt.suggestions.5":"人工智能的趋势","prompt.suggestions.6":"如何一步步创建一家成功的初创公司",
  "prompt.process.analyzing":"🔍 正在分析你的问题...","prompt.process.selecting":"🧠 正在选择专业AI...","prompt.process.querying":"⚡ 正在查询网络...","prompt.process.synthesizing":"🔄 正在综合答案...","prompt.process.optimizing":"✨ 正在优化元回答...",
  "prompt.placeholder.trial":"提出你的问题...（今日剩余：8/10）","prompt.placeholder.default":"用 AI 提问、研究或创作...",
  "prompt.placeholder.search":"搜索特定信息...",
  "prompt.search.mode":"搜索模式",
  "prompt.search.truncated":"文本已截断（搜索模式限制）",
  "prompt.attach.limit_files":"已达到最大文件数",
  "prompt.attach.file_too_big":"文件过大 (最大 60KB)：",
  "prompt.attach.total_too_big":"附件总大小超限",
  "prompt.attach.unsupported_now":"格式即将支持（需云模式）：",
  "prompt.attach.unsupported":"不支持的格式：",
  "prompt.attach.read_error":"读取错误：",
  "prompt.attach.remove":"移除附件",
  "prompt.voice.recording":"正在录音...（最多 60 秒）",
  "prompt.voice.unsupported":"此浏览器不支持语音识别。",
  "prompt.actions.Adjuntar archivo":"附加文件","prompt.actions.Búsqueda avanzada":"高级搜索","prompt.actions.Voz a texto":"语音转文字","prompt.actions.Prompt inteligente":"智能提示",
  "prompt.status.querying":"查询中...","prompt.status.optimizing":"优化中...","prompt.cta.consult_ais":"咨询 {{count}} 个AI","prompt.trial.info":"免费计划：剩余 {{days}} 天 •","prompt.trial.upgrade":"升级以获得无限查询",
  "common.ok":"OK","common.sending":"发送中...","common.sent":"已发送","common.error":"错误","common.send":"发送","common.close":"关闭","common.cancel":"取消","common.loading":"加载中...",
  "auth.login":"登录","auth.signup":"免费注册","auth.password":"密码","auth.forgot":"忘记密码？","auth.continue":"继续","auth.magic_short":"魔法链接","auth.check_email":"请检查邮箱以确认账户","auth.reset":"重置密码","auth.resend":"重新发送",
  "time.just_now":"刚刚","time.minutes_ago":"{{count}} 分钟前","time.hours_ago":"{{count}} 小时前","time.days_ago":"{{count}} 天前",
  "auth.with.google":"使用 Google 继续","auth.with.apple":"使用 Apple 继续","auth.with.microsoft":"使用 Microsoft 继续","auth.with.facebook":"使用 Facebook 继续","auth.with.github":"使用 GitHub 继续","auth.with.linkedin":"使用 LinkedIn 继续","auth.or":"或","auth.legal":"继续即表示同意我们的","auth.terms":"条款","auth.and":"和","auth.privacy":"隐私","auth.errors.social":"无法使用所选提供商登录","auth.protected_route":"受保护页面：请先登录",
  "auth.email":"邮箱","auth.remember_me":"记住我","auth.magic.send":"发送链接","auth.magic.resend_btn":"重新发送","auth.magic.resend_in":"重新发送 ({{s}})","auth.logged_in":"已登录","auth.password.requirements_failed":"密码不符合要求","auth.reset.sent_conditional":"若账户存在，我们已发送重置邮件。","auth.verification.unverified":"您的邮箱尚未验证。","auth.verification.resent":"验证邮件已重新发送。","auth.errors.login_failed":"登录失败","auth.errors.signup_failed":"注册失败","auth.errors.magic_failed":"无法发送链接","auth.errors.resend_failed":"无法重新发送",
  "auth.env.missing":"未检测到 Supabase 变量。请设置 REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY 或 VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY 并重启服务器。",
  "sidebar.dashboard":"仪表板","sidebar.new_chat":"新建聊天","sidebar.new_project":"新建项目","sidebar.history":"历史记录","sidebar.tools":"工具","sidebar.my_gpts":"我的 GPTs","sidebar.plans":"套餐","sidebar.my_profile":"我的资料","sidebar.days_left":"剩余 {{count}} 天",
  "pages.plans.title":"套餐与价格","pages.plans.subtitle":"选择合适的套餐，释放 IntelliVerseOne 的全部潜力","pages.plans.stats.ais":"可用 AI","pages.plans.stats.tools":"工具","pages.plans.stats.availability":"可用性","pages.plans.compare":"详细对比","pages.plans.trial_expiring":"您的免费试用将在 {{days}} 天后到期","pages.plans.trial_expiring_hint":"立即升级以保持完整访问","pages.plans.trial_expired_ago":"您的免费试用已于 {{days}} 天前到期","plans.cta.start_pro":"开始 Pro 套餐","plans.cta.go_pro_plus":"直达 Pro+","pages.plans.view_plans":"查看套餐",
  "pages.faq.title":"常见问题","pages.faq.q.change_anytime":"我可以随时更改套餐吗？","pages.faq.a.change_anytime":"可以，随时升级或降级，立即生效。","pages.faq.q.free_includes":"免费套餐包含什么？","pages.faq.a.free_includes":"基础访问：5 个 AI、每日 10 次查询、部分工具，持续 7 天。","pages.faq.q.annual_discounts":"是否有年付优惠？","pages.faq.a.annual_discounts":"有，年付赠送 2 个月。","pages.faq.q.payment_methods":"支持哪些支付方式？","pages.faq.a.payment_methods":"信用/借记卡、PayPal、银行转账。","pages.faq.q.cancel_anytime":"随时可以取消吗？","pages.faq.a.cancel_anytime":"可以，随时取消，无罚金。","pages.faq.q.support":"是否提供技术支持？","pages.faq.a.support":"是的，所有套餐均含支持，付费套餐享受 24/7 优先支持。",
  "pages.history.title":"对话历史","pages.history.subtitle":"查看并搜索您之前的对话",
  "pages.tools.title":"AI 工具","pages.tools.subtitle":"完整的人工智能工具套件","pages.tools.search_placeholder":"搜索工具...","pages.tools.empty":"未找到工具","pages.tools.empty_hint":"尝试其他搜索词或更换分类","pages.tools.more_coming":"更多工具开发中","pages.tools.more_coming_desc":"我们持续添加新的 AI 工具以提升生产力",
  "pages.projects.create_title":"创建项目","pages.projects.step1_title":"您想创建哪种类型的项目？","pages.projects.details_title":"项目详情","pages.projects.name_label":"项目名称","pages.projects.name_ph":"例：我的个人作品集","pages.projects.desc_label":"描述","pages.projects.desc_ph":"描述您的项目...","pages.projects.purpose_label":"主要目的","pages.projects.purpose_ph":"例：展示我的开发能力","pages.projects.audience_label":"目标受众","pages.projects.audience_ph":"例：招聘人员和科技公司","pages.projects.summary_title":"项目摘要","pages.projects.type":"类型","pages.projects.purpose":"目的","pages.projects.audience":"受众","pages.projects.title":"我的项目","pages.projects.subtitle":"用 AI 创建完整项目","pages.projects.empty":"你还没有项目","pages.projects.first_project":"创建你的第一个 AI 项目","pages.projects.unlock_title":"解锁项目创建","pages.projects.reached_limit":"已达到套餐项目上限。升级以继续。","pages.projects.upgrade_benefits":"使用 Pro 生成完整项目，Pro+ 获得高级导出",
  "pages.cta.boost_productivity":"准备好提升生产力了吗？","pages.cta.join_many":"加入数千名正在利用集体AI力量的用户",
  "user.plan.current":"当前套餐","user.plan.trial":"试用","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"升级套餐",
  "goodbye.title":"你的账户已被删除","goodbye.subtitle":"感谢试用 IntelliVerseOne。","goodbye.feedback":"如果愿意，请告诉我们离开的原因，您的反馈会帮助我们改进。","goodbye.contact":"联系支持","goodbye.home":"返回首页",
    "common.copy":"复制","common.coming_soon":"即将推出","common.in_development":"开发中",
    "tools.categories.all":"全部","tools.categories.content":"内容","tools.categories.productivity":"效率","tools.categories.analysis":"分析","tools.categories.social":"社会与影响","tools.categories.development":"开发",
  "plans.limitations":"限制：",
  "plans.table.available":"可用套餐",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"免费",
  "plans.table.trial.features":"每日 15 次操作 • Orchestrator 多个 AI",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/月",
  "plans.table.pro.features":"终身 25 个问题 • 每日 300 次操作",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/月",
  "plans.table.pro_plus.features":"终身 50 个问题 • 操作不限 • 完整 Deep Research",
  "pages.history.search_placeholder":"在对话中搜索...",
  "history.stats.conversations":"会话",
  "history.stats.total_responses":"总回复数",
  "history.stats.average_rating":"平均评分",
  "history.stats.active_days":"活跃天数",
  "history.category.all":"全部",
  "history.category.productivity":"效率",
  "history.category.education":"教育",
  "history.category.development":"开发",
  "history.category.career":"职业",
  "history.category.finance":"金融",
  "history.label.responses":"条回复",
  "history.empty.title":"未找到对话",
  "history.empty.hint_search":"尝试其他搜索词",
  "history.empty.hint_empty":"你还没有已保存的对话",
  "history.empty.cta":"开始新对话",
  "history.smart_search.title":"智能语义搜索",
  "history.smart_search.subtitle":"即将推出：按概念和上下文搜索，而不仅是关键词",
  "history.smart_search.card.semantic_ai.title":"语义AI",
  "history.smart_search.card.semantic_ai.desc":"按含义查找对话",
  "history.smart_search.card.auto_tagging.title":"自动标签",
  "history.smart_search.card.auto_tagging.desc":"智能自动分类",
  "history.smart_search.card.patterns.title":"模式分析",
  "history.smart_search.card.patterns.desc":"关于你查询的洞察",
  "mygpts.title":"我的 GPTs",
  "mygpts.subtitle":"创建并管理你的自定义 AI 助手",
  "mygpts.create_new":"创建新的 GPT",
  "mygpts.stats.created":"已创建 GPTs",
  "mygpts.stats.uses":"总使用次数",
  "mygpts.stats.limit":"GPTs 上限",
  "mygpts.stats.templates":"可用模板",
  "mygpts.empty.title":"你还没有任何 GPT",
  "mygpts.empty.subtitle":"创建你的第一个自定义 AI 助手",
  "mygpts.empty.cta":"创建我的第一个 GPT",
  "mygpts.locked.title":"解锁 GPT 创建",
  "mygpts.locked.desc.hard":"你已达到套餐的 GPT 上限。升级以继续。",
  "mygpts.locked.desc.info":"Pro 计划可创建最多 5 个自定义 GPT；Pro+ 为无限",
  "mygpts.locked.cta":"查看套餐",
  "mygpts.card.uses":"次",
  "mygpts.card.created":"创建于",
  "mygpts.card.tone":"语气",
  "mygpts.card.depth":"深度",
  "mygpts.card.style":"风格",
  "mygpts.card.use":"使用",
  "mygpts.creator.title":"创建新的 GPT",
  "mygpts.creator.step":"第 {{n}} 步，共 4 步",
  "mygpts.creator.step1.title":"选择一个基础模板",
  "mygpts.creator.step2.title":"自定义你的 GPT",
  "mygpts.creator.name.placeholder":"例如：我的个人助手",
  "mygpts.creator.desc.placeholder":"描述你的 GPT 做什么以及如何帮助...",
  "mygpts.creator.icon":"图标",
  "mygpts.creator.step3.title":"个性设置",
  "mygpts.creator.tone.label":"沟通语气",
  "mygpts.creator.tone.professional":"专业",
  "mygpts.creator.tone.friendly":"友好",
  "mygpts.creator.tone.casual":"随意",
  "mygpts.creator.tone.empatic":"富有同理心",
  "mygpts.creator.tone.direct":"直接",
  "mygpts.creator.depth.label":"回答深度",
  "mygpts.creator.depth.basic":"基础",
  "mygpts.creator.depth.intermediate":"中等",
  "mygpts.creator.depth.advanced":"高级",
  "mygpts.creator.depth.expert":"专家",
  "mygpts.creator.style.label":"沟通风格",
  "mygpts.creator.style.conversational":"对话式",
  "mygpts.creator.style.structured":"结构化",
  "mygpts.creator.style.creative":"创意",
  "mygpts.creator.style.analytical":"分析型",
  "mygpts.creator.style.reflective":"反思型",
  "mygpts.creator.step4.title":"你的 GPT 预览",
  "mygpts.creator.preview_hint":"一切都正确吗？你稍后可以编辑你的 GPT。",
  "mygpts.creator.create":"创建 GPT",
  "mygpts.templates.tutor.name":"我的导师",
  "mygpts.templates.tutor.desc":"专注教学与解释",
  "mygpts.templates.emotional.name":"情感导师",
  "mygpts.templates.emotional.desc":"情感支持与身心健康",
  "mygpts.templates.productivity.name":"我的效率",
  "mygpts.templates.productivity.desc":"优化与组织",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"深度学术研究",
  "mygpts.templates.crypto.name":"加密资产",
  "mygpts.templates.crypto.desc":"加密货币与区块链分析",
  "mygpts.templates.business.name":"商业战略家",
  "mygpts.templates.business.desc":"商业咨询与战略",
  "mygpts.sample.tutor.name":"我的私人导师",
  "mygpts.sample.tutor.desc":"专长于将复杂概念简单解释",
  "mygpts.sample.productivity.name":"效率助手",
  "mygpts.sample.productivity.desc":"任务优化与时间管理",
  "mygpts.sample.emotional.name":"情感导师",
  "mygpts.sample.emotional.desc":"情感支持与心理健康提示",
  "mygpts.sample.tone.friendly":"友好",
  "mygpts.sample.tone.direct":"直接",
  "mygpts.sample.tone.empatic":"有同理心",
  "mygpts.sample.depth.intermediate":"中等",
  "mygpts.sample.depth.practical":"实用",
  "mygpts.sample.depth.deep":"深入",
  "mygpts.sample.style.conversational":"对话式",
  "mygpts.sample.style.structured":"结构化",
  "mygpts.sample.style.reflective":"反思型",
  "projects.types.web.name":"Web 应用",
  "projects.types.web.desc":"使用 React、Vue 或 Angular 的完整前端",
  "projects.types.api.name":"API 后端",
  "projects.types.api.desc":"使用 Node.js 或 Python 的服务器与数据库",
  "projects.types.mobile.name":"移动应用",
  "projects.types.mobile.desc":"原生或混合应用",
  "projects.types.fullstack.name":"全栈",
  "projects.types.fullstack.desc":"端到端项目：前端 + 后端",
  "projects.actions.download_zip":"下载 ZIP",
  "projects.actions.continue":"继续",
  "projects.actions.new_project":"新建项目",
  "projects.progress":"进度",
  "projects.created_on":"创建于",
  "projects.status.completed":"已完成",
  "projects.status.in_progress":"进行中",
  "projects.status.generating":"生成中",
  "projects.status.generating_dots":"生成中...",
  "projects.actions.view":"查看",
  "projects.detail.untitled":"未命名项目",
  "projects.detail.loading_desc":"正在获取项目详情…",
  "projects.detail.no_desc":"无描述",
  "projects.detail.view":"查看",
  "projects.detail.summary":"摘要",
  "projects.detail.actions":"快速操作",
  "projects.detail.view_code":"查看代码",
  "projects.detail.activity":"活动",
  "projects.detail.activity_init":"项目已创建并排队生成",
  "projects.detail.activity_ai":"AI 正在准备结构和依赖",
  "projects.detail.activity_docs":"基础文档已初始化",
  "projects.detail.tech":"技术",
  "history.sample.1.title":"如何提升我的个人效率",
  "history.sample.1.preview":"我需要一些建议来让日常工作更高效...",
  "history.sample.2.title":"排序算法的讲解",
  "history.sample.2.preview":"能否讲解几种常见的排序算法...",
  "history.sample.3.title":"React 项目创意",
  "history.sample.3.preview":"我在寻找创新的 React 项目点子...",
  "history.sample.4.title":"求职面试技巧",
  "history.sample.4.preview":"我下周有一场很重要的面试...",
  "history.sample.5.title":"加密货币市场分析",
  "history.sample.5.preview":"你如何看待当前的加密市场趋势...",
  "projects.mock.1.name":"个人作品集",
  "projects.mock.1.desc":"基于 React 和 Tailwind CSS 的专业网站",
  "projects.mock.2.name":"任务应用",
  "projects.mock.2.desc":"带身份验证的任务管理应用",
  "projects.mock.3.name":"电商 REST API",
  "projects.mock.3.desc":"完整的网店后端",
  "tools.items.emotional-translator.name":"情感保留翻译器",
  "tools.items.emotional-translator.description":"在保持情感语气与语境下进行翻译",
  "tools.items.text-reformulator.name":"文本重写器",
  "tools.items.text-reformulator.description":"在不改变含义的情况下改写文本",
  "tools.items.voice-converter.name":"文本转语音转换器",
  "tools.items.voice-converter.description":"将文本转换为自然语音",
  "tools.items.prompt-creator.name":"提示词生成器",
  "tools.items.prompt-creator.description":"为任意 AI 生成优化的提示词",
  "tools.items.viral-titles.name":"爆款标题生成器",
  "tools.items.viral-titles.description":"创建吸睛标题",
  "tools.items.audience-segmenter.name":"受众细分工具",
  "tools.items.audience-segmenter.description":"分析并细分目标受众",
  "tools.items.idea-repairer.name":"创意修复器",
  "tools.items.idea-repairer.description":"补全并完善不完整的想法",
  "tools.items.copy-pulse.name":"CopyPulse – 复制、改进与发布",
  "tools.items.copy-pulse.description":"分析、改进并优化任何内容",
  "tools.items.file-converter.name":"智能文件转换器",
  "tools.items.file-converter.description":"利用 AI 转换文件以优化内容",
  "tools.items.arconte-ai.name":"Arconte AI 联系",
  "tools.items.arconte-ai.description":"直达最先进的 AI",
  "tools.items.mass-control.name":"积极的群体影响",
  "tools.items.mass-control.description":"用于建设性社会影响的工具",
  "pages.not_found.title":"页面未找到",
  "pages.not_found.body":"看来这个页面在人工智能的多元宇宙中迷路了。我们的1200个AI正在努力寻找它。",
  "pages.not_found.help_title":"需要帮助？",
  "pages.not_found.help_body":"如果您认为这是个错误，可以联系我们或返回主页。",
  "pages.not_found.cta_home":"🏠 返回主页",
  "pages.not_found.cta_tools":"🛠️ 探索工具",
  "pages.not_found.link_support":"📧 支持",
  "pages.not_found.link_home":"🏠 主页",
  "pages.not_found.link_plans":"💎 套餐",
  "user.panel_title":"用户面板",
  "user.security.change_password":"修改密码",
  "user.security.change_password_prompt":"新密码（最少8个字符）",
  "user.security.password_changed":"密码已更新",
  "user.security.reset_password":"发送重置链接",
  "user.security.reset_sent":"我们已发送邮件帮您重置密码",
  "user.security.title":"账户安全",
  "user.security.subtitle":"管理凭据和安全选项。",
  "user.security.password":"密码",
  "user.security.password_hint":"请使用长且唯一的密码。MFA即将推出。",
  "user.security.email_hint":"如果更改邮箱，使用前需先验证。",
  "user.security.password_error":"无法更新密码",
  "user.security.password_placeholder":"新安全密码",
  "user.security.change_password_title":"更新密码",
  "user.security.change_password_action":"更新",
  "user.security.cancel":"取消",
  "user.security.password_min":"最少8个字符",
  "user.security.logout":"退出登录",
  "user.security.delete_account_btn":"删除账号",
  "user.security.delete_account":"删除账号",
  "user.security.delete_account_desc":"此操作是永久性的。您将失去您的项目、GPT和相关数据。",
  "user.security.delete_account_type":"输入 删除 以确认：",
  "user.security.delete_account_confirm":"永久删除",
  "user.security.delete_account_done":"删除请求已发送。我们将通过电子邮件通知您。",
  "user.security.delete_account_signout":"已退出。要完成删除，请配置 webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL。",
  "trial.expired.title":"您的7天试用已结束！",
  "trial.expired.body":"您已体验了IntelliVerseOne的完整功能。要继续使用{{feature}}，请选择您的套餐。",
  "trial.expired.stats_title":"🎉 在试用期间您体验了：",
  "trial.expired.stat_ias":"咋询的AI",
  "trial.expired.stat_functionality":"完整功能",
  "trial.expired.stat_projects":"创建的项目",
  "trial.expired.stat_costs":"隐藏费用",
  "trial.expired.pro_plus_label":"🚀 Pro+套餐 - $9.79/月",
  "trial.expired.pro_plus_desc":"完整功能 + 优先级 + 多媒体AI",
  "trial.expired.pro_label":"⭐ Pro套餐 - $5.79/月",
  "trial.expired.pro_desc":"完整专业使用的完美选择",
  "trial.expired.free_option":"或继续使用有限功能：",
  "trial.expired.free_plan_title":"🆓 免费套餐（有限）：",
  "trial.expired.free_blocked":"访问完全封锁",
  "trial.expired.free_no_ias":"无AI查询",
  "trial.expired.free_no_premium":"无高级功能",
  "trial.expired.free_history_only":"仅查看历史记录",
  "trial.expired.continue_free":"继续使用免费套餐",
  "trial.expired.benefits":"✨ 30天保证 • 🔒 随时取消 • 💰 公平定价",
  "notifications.welcome.activated":"🚀 IntelliVerseOne已激活 - 多个 AI准备咋询",
  "notifications.welcome.optimized":"🧠 元AI系统已针对最高精度优化",
  "notifications.welcome.new_features":"⚡ 新功能可用 - 探索工具",
  "chat.error.auth":"未认证。请登录以继续。",
  "chat.error.quota":"每日查询限额已达。升级您的套餐以获得更多。",
  "chat.error.timeout":"请求超时。请重试。",
  "chat.error.server":"服务器错误。请稍后重试。",
  "chat.error":"发生了错误。请重试。",
  "chat.placeholder.answer":"AI回答...",
  "history.auto.title":"对话 {{date}}",
  "history.actions.confirm":"删除此对话？",
  "life_coach":{
    "common":{"select":"选择…","selected_count":"已选 {{count}} 项","other":"其他","other_ph":"描述其他选项"},
    "hero":{"title":"让我指导您的生活","subtitle":"一个情感与战略并重的每日小帮手。"},
    "stats":{"areas":"已选区域","habits":"总习惯","remaining":"今日剩余行动"},
    "form":{"title":"您的生活重心","areas_label":"优先区域","daily_time":"每日可用时间","emotions_label":"您总体感觉如何","emotions.low":"低","emotions.medium":"中","emotions.high":"高","motivation":"现在什么激励您？","motivation_ph":"描述您的动力","routine":"您的日常是怎样的？","routine_ph":"简要描述","constraints":"限制或挑战（可选）","sleep_hours":"睡眠小时","sleep":{"less6":"少6小时","6_7":"6-7","7_8":"7-8","more8":"聨8小时"},"exercise_freq":"锻炼频率","exercise":{"never":"从不","1_2":"每周 1-2 次","3_4":"每周 3-4 次","more4":"每周 4 次以上"},"diet_focus":"饮食重点","diet":{"balanced":"均衡","high_protein":"高蛋白","low_carb":"低碳","plant_based":"植物性"},"stress_level":"压力等级","level":{"low":"低","medium":"中","high":"高"},"productivity_peak":"高效峰値","daytime":{"morning":"早晨","afternoon":"下午","evening":"晚上"},"reminder_time":"首选提醒时间","distractions":"主要分心因素","learning_goal":"学习目标","learning_goal_ph":"您想学什么？","financial_goal":"财务目标","financial_goal_ph":"如：储蓄 X、还清负债","relationship_goal":"人际目标","relationship_goal_ph":"家庭、伴侣、朋友","weekend_routine":"周末日常","weekend_routine_ph":"典型活动","accountability":{"label":"责任心","solo":"独自","buddy":"搭档","coach":"有教练"},"comm_style":"沟通风格","comm":{"concise":"简洁","detailed":"详细","motivational":"激励式"}},
    "area":{"health":"健康","career":"职业","finance":"财务","relationships":"人际关系","personal":"个人成长"},
    "motivation":{"health":"改善健康","career":"职业成长","balance":"工作生活平衡","learn":"学习技能","finance":"改善财务","emotional":"心理健康","consistency":"坚持一致","project":"个人项目","exam":"备考证书","stress":"减少压力"},
    "routine":{"office":"朝亙平日上班","remote":"灵活远程","student":"学生","shift":"轮班","entrepreneur":"创业者","caretaker":"照护者","night":"夜班","parent":"带孩家长","variable":"极不规律"},
    "constraints":{"time":"时间不足","stress":"压力/焦虑","health":"身体健康","finance":"财务","family":"家庭/照料","environment":"环境/空间","sleep":"睡眠不规律","motivation":"动力不足","tech":"技术/设备"},
    "distractions":{"social":"社交媒体","notifs":"通知","chat":"消息","noise":"环境噪音","multitask":"多任务","phone":"手机","fatigue":"疲劳","perfect":"完美主义","procrast":"拖延","family":"家庭干扰","tv":"电视/游戏"},
    "learning":{"languages":"语言","programming":"编程","dataai":"数据/AI","marketing":"市场营销","sales":"销售","personal_finance":"个人理财","music":"音乐","design":"艺术/设计","cert":"考试/证书","softskills":"软技能"},
    "finance":{"emergency":"紧急备用金","pay_debt":"还清负债","cut_expenses":"节缩开支","increase_income":"增加收入","invest":"投资","buy_house":"购房/车","save_trip":"旅行/学习存款","credit_score":"改善信用"},
    "relation":{"communication":"改善沟通","family_time":"更多家庭时光","partner":"巩固感情","friends":"结交新朋友","network":"职业社交","conflict":"解决冲突","boundaries":"建立健康边界"},
    "weekend":{"rest":"休息","family":"家庭","sport":"运动/活动","social":"社交","creative":"创意/爱好","chores":"家务","study":"学习/项目","travel":"旅行"},
    "cta":{"generate":"生成计划","regenerate":"重新生成","refine_area":"精细区域"},
    "plan":{"title":"您的生活计划","progress":"进度","weekly_goals":"每周目标","monthly_goals":"每月目标","habits":"习惯"},
    "module":{"reminders":"智能提醒","feedback":"每周反馈"},
    "reminders":{"active":"您将每日和每周收到个性化提醒。","locked":"在 Pro+ 中可用。解锁自动个性化提醒。"},
    "feedback":{"active":"您将每周收到个性化建议的分析。","locked":"在 Pro+ 中可用。获取含改进建议的周报。"},
    "errors":{"areas":"请至少选择一个区域。","limit":"您已达到今日限额。"},
    "copy":{"m1":"我在这里帮您打造最好的自己。","m2":"今天我们可以再进一步。准备好了吗？","m3":"小改变，大成果。"},
    "mock":{"goal":{"week":"完成 3 个与 {{area}} 相关的环节","month":"在 {{area}} 中达到关键里程碑","learn":{"week":"学习 {{skill}} (3 x 20分钟)","month":"完成 {{skill}} 中的一个模块"},"finance":{"week":"朝着 {{goal}} 进领","month":"达到财务里程碑：{{goal}}"},"weekend":"周末活动：{{w}}","refine":"在 {{area}} 中精化行动"},"habit":{"1":"{{area}} 5 分钟习惯","2":"写一篇关于 {{area}} 的反思","learn":"学习 {{skill}} (15分钟)","budget":"回顾开支和预算 (10分钟)","relation":"有意义的联系（消息/通话）","sleep":"睡眠卫生 (10分钟)","exercise":{"start":"散步 10 分钟","progress":"20 分钟运动","maintain":"保持健身 25 分钟"},"diet":{"pb":"额外添加 1 份过","hp":"每餐包含蛋白质","lc":"避免精制糖"},"morning":"深度早展块 (20分钟) 为 {{area}}","focus":"关钉通知专注会 (15分钟)","stress":"4-7-8 呼吸法","accountability":"搭档/教练 检入 (5分钟)"}},
    "career":{"habit":{"focus":"{{m}} 分钟专注块"}},
    "remark":{"privacy":"您的回答将私密保存。"}
  },
  "stats.ias":"已咨询AI数",
  "stats.remaining":"今日剩余",
  "stats.accuracy":"精准度",
  "prompt.actions.search":"搜索",
  "prompt.actions.voice":"语音",
  "prompt.actions.suggest":"建议",
  "prompt.actions.attach":"附件",
  "prompt.cta.consult_ias":"咨询 {{count}} 个AI",
  "prompt.remaining":"剩余",
  "prompt.placeholder.expired":"试用已过期 —",
  "prompt.placeholder.limit":"已达上限 —",
  "prompt.trial.expired_msg":"您的试用期已到期。请选择套餐继续使用。",
  "prompt.trial.choose_plan":"选择套餐",
  "prompt.search.active":"搜索模式已激活",
  "prompt.voice.no_mic":"无法访问麦克风",
  "prompt.limit.exceeded":"查询已达上限",
  "prompt.trial.expired":"试用已过期",
  "auth.logout":"退出登录",
  "mygpts.updated":"GPT已更新",
  "mygpts.created":"GPT创建成功",
  "mygpts.error.save":"保存时出错",
  "mygpts.creator.title_new":"创建新的 GPT",
  "mygpts.creator.title_edit":"编辑 GPT",
  "tools.copy_empty":"此工具没有可复制的文本",
  "tools.copy_ok":"提示词已复制到剪贴板",
  "tools.copy_fail":"复制失败，请重试。",
  "tools.copy_tooltip":"复制提示词到剪贴板",
  "tools.run_tooltip":"使用 AI 运行工具",
  "common.run":"运行",
  "plans.paypal.error":"付款时发生错误，请重试。",
  "plans.paypal.cancel":"用户取消了付款。",
  "plans.paypal.required":"要激活此套餐，您需要通过 PayPal 完成付款。",
  "plans.cancel.confirm":"您确定要取消订阅吗？您将在付费期结束前保留访问权限。",
  "plans.cancel.no_auth":"没有活跃的会话。请重新登录。",
  "plans.cancel.error":"取消时出错。请重试或联系客服。",
  "plans.cancel.success":"订阅已取消！您将保留到 {{date}} 的访问权限。",
  "user.connections.title":"账户连接",
  "user.connections.hint":"绑定提供商以便使用任意一个登录。",
  "projects.generated_success":"项目已生成！您现在可以下载 ZIP。",
  "projects.wizard.mvp_includes":"您的 MVP 项目将包含：",
  "projects.wizard.gen.structure_mvp":"项目基础结构",
  "projects.wizard.gen.starter":"功能性起始文件",
  "projects.wizard.gen.readme":"带说明的 README",
  "projects.wizard.gen.config":"初始配置",
  "projects.wizard.mvp_note":"下载 ZIP 并按需自定义代码",
  "projects.actions.generating":"生成中...",
  "common.login_required":"请登录以继续",
  "common.reset":"重置",
  "share.copied":"链接已复制：",
  "limits.share_pro":"分享需要 Pro 计划或更高级别。",
  "common.back":"返回"
} };
const ja = { translation: {
  "dashboard.hero.powered_by":"120以上の人工知能により実現",
  "auth.promo.subscribe":"無料で登録する",
  "auth.promo.trial":"プラットフォームを7日間無料で試す",
  "auth.promo.nocard":"クレジットカード不要",
  "dashboard.hero.rotating":[
    "複数の人工知能で学び、作り、調べる。"
  ],
  "plans.cards":{
    "trial":{"name":"トライアル","price":"無料","period":"7日間の試用","features":["1日15アクション","オーケストレーター複数のAI","基本ツール","コミュニティサポート"],"limitations":["機能が制限されます","エクスポートなし","Deep Researchアクセスなし","7日後に終了"]},
    "pro":{"name":"Pro","period":"月額","features":["生涯 25 質問","1日300アクション","複数のAIにアクセス","ほとんどのツールが解放","優先処理"],"limitations":["Deep Research は限定","無制限アクションなし"]},
    "pro_plus":{"name":"Pro+","period":"月額","features":["生涯 50 質問","無制限アクション","フル Deep Research","全ツール解放","24/7 優先サポート"],"limitations":[]}
  },
  "plans.popular":"一番人気","plans.current":"現在のプラン","plans.select":"プランを選択","plans.paypal.success":"購読に成功しました！ID: ","plans.trial_active":"トライアル有効",
  "dashboard.cta.life_director":"パーソナルAIプラン","dashboard.cta.study_tutor":"AI学習チューター","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"興味でつながる","dashboard.cta.propose_ideas":"アイデアとプロジェクト","dashboard.cta.mass_control":"コミュニティ貢献AI",
  "dashboard.desc.life_director":"パーソナライズドAIコーチ","dashboard.desc.study_tutor":"インテリジェント適応学習","dashboard.desc.create_project":"ガイド付きフル開発","dashboard.desc.deepweb":"深い学術検索","dashboard.desc.connect_people":"協調知識ネットワーク","dashboard.desc.propose_ideas":"チャンスジェネレーター","dashboard.desc.mass_control":"建設的な社会的インパクト",
  "dashboard.quick.prompts.life_director":"私のパーソナルライフコーチとして振る舞って...","dashboard.quick.prompts.study_tutor":"私の個人チューターになって...","dashboard.quick.prompts.deepweb":"学術・法律の深い情報にアクセスして...","dashboard.quick.prompts.connect_people":"似た興味の人を見つけてつないで。","dashboard.quick.prompts.propose_ideas":"革新的なプロジェクト/ビジネスのアイデアを生み出して...",
  "dashboard.meta.title":"{{count}} 個のAIによるメタ回答","dashboard.meta.confidence":"確信度","dashboard.meta.queried_ais":"照会したAI:","dashboard.meta.more":"+{{count}} さらに...","dashboard.meta.specialized_ais":"特化AI {{count}}","dashboard.meta.categories":"カテゴリ","dashboard.meta.general":"一般",
  "dashboard.welcome.title":"ようこそ、{{name}} さん！","dashboard.welcome.body":"最先端のAIネットワークに接続されました...","dashboard.welcome.precision.title":"精度","dashboard.welcome.precision.desc":"複数AIで検証された回答","dashboard.welcome.speed.title":"速度","dashboard.welcome.speed.desc":"高速応答のための並列処理","dashboard.welcome.intelligence.title":"知性","dashboard.welcome.intelligence.desc":"マルチドメイン知識の統合",
  "dashboard.trial.title":"IntelliVerseOne の真の力のわずか8%しか使っていません","dashboard.trial.body":"プレミアムツールと高度なAI機能へのフルアクセスを解放。","dashboard.trial.view_plans":"プレミアムプランを見る","dashboard.trial.continue":"トライアルを続行（{{days}} 日）",
  "dashboard.stats.today":"本日のクエリ","dashboard.stats.accuracy":"正確性",
  "dashboard.quick_actions.title":"クイックアクション",
  "dashboard.quick_actions.subtitle":"IntelliVerseOne の機能を探索",
  "dashboard.quick_actions.unlock_title":"すべての可能性を解放",
  "dashboard.quick_actions.unlock_desc":"すべてのプレミアムツールと機能にアクセス",
  "prompt.suggestions.title":"💡 スマートな提案:","prompt.suggestions.1":"個人の生産性を高めるには？","prompt.suggestions.2":"最も効率的なソートアルゴリズムを説明","prompt.suggestions.3":"React プロジェクトのアイデア","prompt.suggestions.4":"2024年のデジタルマーケ戦略","prompt.suggestions.5":"AIのトレンド","prompt.suggestions.6":"成功するスタートアップの作り方（手順）",
  "prompt.process.analyzing":"🔍 質問を分析中...","prompt.process.selecting":"🧠 特化AIを選定中...","prompt.process.querying":"⚡ ネットワークに照会中...","prompt.process.synthesizing":"🔄 回答を統合中...","prompt.process.optimizing":"✨ メタ回答を最適化中...",
  "prompt.placeholder.trial":"質問してください...（今日の残り：8/10）","prompt.placeholder.default":"120以上の人工知能へ質問をどうぞ...",
  "prompt.placeholder.search":"特定の情報を検索...",
  "prompt.search.mode":"検索モード",
  "prompt.search.truncated":"テキストを切り詰めました（検索モード上限）。",
  "prompt.attach.limit_files":"ファイル数の上限に達しました",
  "prompt.attach.file_too_big":"ファイルが大きすぎます (最大60KB): ",
  "prompt.attach.total_too_big":"添付ファイルの合計サイズを超えました",
  "prompt.attach.unsupported_now":"まもなく対応予定の形式（クラウドモード必要）：",
  "prompt.attach.unsupported":"未対応の形式: ",
  "prompt.attach.read_error":"読み取りエラー: ",
  "prompt.attach.remove":"添付を削除",
  "prompt.voice.recording":"録音中... (最大60秒)",
  "prompt.voice.unsupported":"このブラウザは音声認識をサポートしていません。",
  "prompt.actions.Adjuntar archivo":"ファイルを添付","prompt.actions.Búsqueda avanzada":"高度な検索","prompt.actions.Voz a texto":"音声からテキスト","prompt.actions.Prompt inteligente":"スマートプロンプト",
  "prompt.status.querying":"照会中...","prompt.status.optimizing":"最適化中...","prompt.cta.consult_ais":"{{count}} 個のAIに相談","prompt.trial.info":"無料プラン：残り {{days}} 日 •","prompt.trial.upgrade":"無制限クエリのためにアップグレード",
  "common.ok":"OK","common.sending":"送信中...","common.sent":"送信済み","common.error":"エラー","common.send":"送信","common.close":"閉じる","common.cancel":"キャンセル","common.loading":"読み込み中...",
  "auth.login":"ログイン","auth.signup":"無料登録","auth.password":"パスワード","auth.forgot":"パスワードをお忘れですか？","auth.continue":"続行","auth.magic_short":"マジックリンク","auth.check_email":"アカウント確認のためメールをご確認ください","auth.reset":"パスワードをリセット","auth.resend":"再送",
  "time.just_now":"たった今","time.minutes_ago":"{{count}} 分前","time.hours_ago":"{{count}} 時間前","time.days_ago":"{{count}} 日前",
  "auth.with.google":"Googleで続行","auth.with.apple":"Appleで続行","auth.with.microsoft":"Microsoftで続行","auth.with.facebook":"Facebookで続行","auth.with.github":"GitHubで続行","auth.with.linkedin":"LinkedInで続行","auth.or":"または","auth.legal":"続行すると、次に同意したことになります：","auth.terms":"利用規約","auth.and":"および","auth.privacy":"プライバシー","auth.errors.social":"選択したプロバイダーでサインインできませんでした","auth.protected_route":"保護されたページ：ログインしてください",
  "auth.email":"メール","auth.remember_me":"記憶する","auth.magic.send":"リンク送信","auth.magic.resend_btn":"再送","auth.magic.resend_in":"再送 ({{s}})","auth.logged_in":"サインインしました","auth.password.requirements_failed":"パスワードが要件を満たしていません","auth.reset.sent_conditional":"アカウントが存在する場合、リセット用メールを送信しました。","auth.verification.unverified":"メールが未確認です。","auth.verification.resent":"確認メールを再送しました。","auth.errors.login_failed":"ログインに失敗しました","auth.errors.signup_failed":"サインアップに失敗しました","auth.errors.magic_failed":"リンクを送信できませんでした","auth.errors.resend_failed":"再送できませんでした",
  "auth.env.missing":"Supabase の環境変数が検出されませんでした。REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY または VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY を設定し、サーバーを再起動してください。",
  "sidebar.dashboard":"ダッシュボード","sidebar.new_chat":"新規チャット","sidebar.new_project":"新規プロジェクト","sidebar.history":"履歴","sidebar.tools":"ツール","sidebar.my_gpts":"マイ GPTs","sidebar.plans":"プラン","sidebar.my_profile":"マイプロフィール","sidebar.days_left":"残り {{count}} 日",
  "pages.plans.title":"プランと価格","pages.plans.subtitle":"IntelliVerseOne の可能性を最大限に引き出すプランを選択","pages.plans.stats.ais":"利用可能なAI","pages.plans.stats.tools":"ツール","pages.plans.stats.availability":"可用性","pages.plans.compare":"詳細比較","pages.plans.trial_expiring":"無料トライアルは {{days}} 日で終了します","pages.plans.trial_expiring_hint":"今すぐアップグレードしてすべての機能を利用","pages.plans.trial_expired_ago":"無料トライアルは {{days}} 日前に終了しました","plans.cta.start_pro":"Proプランを開始","plans.cta.go_pro_plus":"Pro+へ","pages.plans.view_plans":"プランを見る",
  "pages.faq.title":"よくある質問","pages.faq.q.change_anytime":"いつでもプラン変更できますか？","pages.faq.a.change_anytime":"可能です。アップグレード/ダウングレードは即時適用されます。","pages.faq.q.free_includes":"無料プランに含まれるものは？","pages.faq.a.free_includes":"5つのAI、1日10回のクエリ、7日間の基本ツールアクセス。","pages.faq.q.annual_discounts":"年払いの割引はありますか？","pages.faq.a.annual_discounts":"はい、年払いで2ヶ月無料です。","pages.faq.q.payment_methods":"支払い方法は？","pages.faq.a.payment_methods":"クレカ/デビット、PayPal、銀行振込。","pages.faq.q.cancel_anytime":"いつでも解約できますか？","pages.faq.a.cancel_anytime":"はい、ペナルティなしでいつでも解約できます。","pages.faq.q.support":"技術サポートはありますか？","pages.faq.a.support":"はい、すべてのプランにサポートが含まれます。有料は24/7優先サポート。",
  "pages.history.title":"会話履歴","pages.history.subtitle":"過去の会話を確認・検索",
  "pages.tools.title":"AI ツール","pages.tools.subtitle":"AI 搭載の完全なツールスイート","pages.tools.search_placeholder":"ツールを検索...","pages.tools.empty":"ツールが見つかりません","pages.tools.empty_hint":"別のキーワードやカテゴリを試してください","pages.tools.more_coming":"さらなるツールを開発中","pages.tools.more_coming_desc":"生産性向上のため新ツールを継続的に追加しています",
  "pages.projects.create_title":"プロジェクトを作成","pages.projects.step1_title":"どんな種類のプロジェクトを作成しますか？","pages.projects.details_title":"プロジェクト詳細","pages.projects.name_label":"プロジェクト名","pages.projects.name_ph":"例：マイポートフォリオ","pages.projects.desc_label":"説明","pages.projects.desc_ph":"プロジェクトの内容を説明...","pages.projects.purpose_label":"主な目的","pages.projects.purpose_ph":"例：スキルのアピール","pages.projects.audience_label":"対象ユーザー","pages.projects.audience_ph":"例：採用担当やIT企業","pages.projects.summary_title":"プロジェクト概要","pages.projects.type":"タイプ","pages.projects.purpose":"目的","pages.projects.audience":"対象","pages.projects.title":"マイプロジェクト","pages.projects.subtitle":"AIで完全なプロジェクトを作成","pages.projects.empty":"まだプロジェクトがありません","pages.projects.first_project":"最初のAIプロジェクトを作成","pages.projects.unlock_title":"プロジェクト作成を解放","pages.projects.reached_limit":"プランのプロジェクト上限に達しました。アップグレードしてください。","pages.projects.upgrade_benefits":"Proで完全なプロジェクト、Pro+で高度なエクスポート",
  "pages.cta.boost_productivity":"生産性を高める準備はできましたか？","pages.cta.join_many":"集合知AIを活用する何千人ものユーザーに参加しましょう",
  "user.plan.current":"現在のプラン","user.plan.trial":"トライアル","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"プランをアップグレード",
  "goodbye.title":"アカウントは削除されました","goodbye.subtitle":"IntelliVerseOne をお試しいただきありがとうございます。","goodbye.feedback":"退会理由を教えていただけると改善に役立ちます。","goodbye.contact":"サポートに連絡","goodbye.home":"ホームへ戻る",
    "common.copy":"コピー","common.coming_soon":"近日公開","common.in_development":"開発中",
    "tools.categories.all":"すべて","tools.categories.content":"コンテンツ","tools.categories.productivity":"生産性","tools.categories.analysis":"分析","tools.categories.social":"社会・インパクト","tools.categories.development":"開発",
  "plans.limitations":"制限:",
  "plans.table.available":"利用可能なプラン",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"無料",
  "plans.table.trial.features":"1日15アクション • オーケストレーター複数のAI",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/月",
  "plans.table.pro.features":"生涯 25 質問 • 1日300アクション",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/月",
  "plans.table.pro_plus.features":"生涯 50 質問 • 無制限アクション • フル Deep Research",
  "pages.history.search_placeholder":"会話を検索...",
  "history.stats.conversations":"会話",
  "history.stats.total_responses":"合計返信",
  "history.stats.average_rating":"平均評価",
  "history.stats.active_days":"アクティブ日数",
  "history.category.all":"すべて",
  "history.category.productivity":"生産性",
  "history.category.education":"教育",
  "history.category.development":"開発",
  "history.category.career":"キャリア",
  "history.category.finance":"金融",
  "history.label.responses":"件の返信",
  "history.empty.title":"会話が見つかりません",
  "history.empty.hint_search":"別の検索語を試してください",
  "history.empty.hint_empty":"保存された会話はまだありません",
  "history.empty.cta":"新しい会話を開始",
  "history.smart_search.title":"スマートセマンティック検索",
  "history.smart_search.subtitle":"近日公開：キーワードだけでなく概念や文脈で検索",
  "history.smart_search.card.semantic_ai.title":"セマンティックAI",
  "history.smart_search.card.semantic_ai.desc":"意味で会話を見つける",
  "history.smart_search.card.auto_tagging.title":"自動タグ付け",
  "history.smart_search.card.auto_tagging.desc":"インテリジェントな自動分類",
  "history.smart_search.card.patterns.title":"パターン分析",
  "history.smart_search.card.patterns.desc":"あなたのクエリに関するインサイト",
  "mygpts.title":"マイ GPTs",
  "mygpts.subtitle":"カスタムAIアシスタントを作成・管理",
  "mygpts.create_new":"新しい GPT を作成",
  "mygpts.stats.created":"作成済み GPTs",
  "mygpts.stats.uses":"総使用回数",
  "mygpts.stats.limit":"GPT 上限",
  "mygpts.stats.templates":"利用可能なテンプレート",
  "mygpts.empty.title":"まだGPTがありません",
  "mygpts.empty.subtitle":"最初のカスタムAIアシスタントを作成しましょう",
  "mygpts.empty.cta":"最初の GPT を作成",
  "mygpts.locked.title":"GPT 作成を解除",
  "mygpts.locked.desc.hard":"プランの GPT 上限に達しました。続行するにはアップグレードしてください。",
  "mygpts.locked.desc.info":"Pro で最大5つ、Pro+ で無制限のカスタム GPT を作成",
  "mygpts.locked.cta":"プランを見る",
  "mygpts.card.uses":"回",
  "mygpts.card.created":"作成日",
  "mygpts.card.tone":"トーン",
  "mygpts.card.depth":"深さ",
  "mygpts.card.style":"スタイル",
  "mygpts.card.use":"使う",
  "mygpts.creator.title":"新しい GPT を作成",
  "mygpts.creator.step":"全4ステップ中 {{n}}",
  "mygpts.creator.step1.title":"ベースのテンプレートを選択",
  "mygpts.creator.step2.title":"GPT をカスタマイズ",
  "mygpts.creator.name.placeholder":"例：マイパーソナルアシスタント",
  "mygpts.creator.desc.placeholder":"GPT の役割と支援内容を記述...",
  "mygpts.creator.icon":"アイコン",
  "mygpts.creator.step3.title":"パーソナリティ設定",
  "mygpts.creator.tone.label":"コミュニケーショントーン",
  "mygpts.creator.tone.professional":"プロフェッショナル",
  "mygpts.creator.tone.friendly":"フレンドリー",
  "mygpts.creator.tone.casual":"カジュアル",
  "mygpts.creator.tone.empatic":"共感的",
  "mygpts.creator.tone.direct":"ダイレクト",
  "mygpts.creator.depth.label":"回答の深さ",
  "mygpts.creator.depth.basic":"基本",
  "mygpts.creator.depth.intermediate":"中級",
  "mygpts.creator.depth.advanced":"上級",
  "mygpts.creator.depth.expert":"エキスパート",
  "mygpts.creator.style.label":"コミュニケーションスタイル",
  "mygpts.creator.style.conversational":"会話型",
  "mygpts.creator.style.structured":"構造化",
  "mygpts.creator.style.creative":"クリエイティブ",
  "mygpts.creator.style.analytical":"分析的",
  "mygpts.creator.style.reflective":"内省的",
  "mygpts.creator.step4.title":"GPT プレビュー",
  "mygpts.creator.preview_hint":"問題なければ、後から編集も可能です。",
  "mygpts.creator.create":"GPT を作成",
  "mygpts.templates.tutor.name":"マイチューター",
  "mygpts.templates.tutor.desc":"教育と解説に特化",
  "mygpts.templates.emotional.name":"エモーショナルメンター",
  "mygpts.templates.emotional.desc":"感情的サポートとウェルビーイング",
  "mygpts.templates.productivity.name":"マイプロダクティビティ",
  "mygpts.templates.productivity.desc":"最適化と整理",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"深い学術リサーチ",
  "mygpts.templates.crypto.name":"クリプトアセット",
  "mygpts.templates.crypto.desc":"暗号資産とブロックチェーン分析",
  "mygpts.templates.business.name":"ビジネスストラテジスト",
  "mygpts.templates.business.desc":"ビジネスコンサルと戦略",
  "mygpts.sample.tutor.name":"マイパーソナルチューター",
  "mygpts.sample.tutor.desc":"複雑な概念をやさしく説明するのが得意",
  "mygpts.sample.productivity.name":"プロダクティビティアシスタント",
  "mygpts.sample.productivity.desc":"タスク最適化と時間管理",
  "mygpts.sample.emotional.name":"エモーショナルメンター",
  "mygpts.sample.emotional.desc":"感情サポートとメンタルウェルビーイングのヒント",
  "mygpts.sample.tone.friendly":"フレンドリー",
  "mygpts.sample.tone.direct":"ダイレクト",
  "mygpts.sample.tone.empatic":"共感的",
  "mygpts.sample.depth.intermediate":"中級",
  "mygpts.sample.depth.practical":"実践的",
  "mygpts.sample.depth.deep":"深い",
  "mygpts.sample.style.conversational":"会話型",
  "mygpts.sample.style.structured":"構造化",
  "mygpts.sample.style.reflective":"内省的",
  "projects.types.web.name":"Web アプリ",
  "projects.types.web.desc":"React・Vue・Angular で構築するフロントエンド",
  "projects.types.api.name":"API バックエンド",
  "projects.types.api.desc":"Node.js または Python のサーバーとデータベース",
  "projects.types.mobile.name":"モバイルアプリ",
  "projects.types.mobile.desc":"ネイティブまたはハイブリッドアプリ",
  "projects.types.fullstack.name":"フルスタック",
  "projects.types.fullstack.desc":"エンドツーエンド（フロント + バックエンド）",
  "projects.actions.download_zip":"ZIP をダウンロード",
  "projects.actions.continue":"続行",
  "projects.actions.new_project":"新規プロジェクト",
  "projects.progress":"進捗",
  "projects.created_on":"作成日",
  "projects.status.completed":"完了",
  "projects.status.in_progress":"進行中",
  "projects.status.generating":"生成中",
  "projects.status.generating_dots":"生成中...",
  "projects.actions.view":"表示",
  "projects.detail.untitled":"無題のプロジェクト",
  "projects.detail.loading_desc":"プロジェクト詳細を取得中…",
  "projects.detail.no_desc":"説明なし",
  "projects.detail.view":"表示",
  "projects.detail.summary":"概要",
  "projects.detail.actions":"クイックアクション",
  "projects.detail.view_code":"コードを表示",
  "projects.detail.activity":"アクティビティ",
  "projects.detail.activity_init":"プロジェクトが作成され、生成待ちに追加",
  "projects.detail.activity_ai":"AI が構成と依存関係を準備中",
  "projects.detail.activity_docs":"基本ドキュメントを初期化",
  "projects.detail.tech":"技術",
  "history.sample.1.title":"個人の生産性を高めるには",
  "history.sample.1.preview":"日々の仕事でより生産的になるコツが知りたい...",
  "history.sample.2.title":"ソートアルゴリズムの解説",
  "history.sample.2.preview":"代表的なソートアルゴリズムを説明してくれませんか...",
  "history.sample.3.title":"React プロジェクトのアイデア",
  "history.sample.3.preview":"React プロジェクトの斬新なアイデアを探しています...",
  "history.sample.4.title":"就職面接のコツ",
  "history.sample.4.preview":"来週、大事な面接があります...",
  "history.sample.5.title":"暗号資産市場の分析",
  "history.sample.5.preview":"最近の暗号資産市場の動向をどう見ますか...",
  "projects.mock.1.name":"個人ポートフォリオ",
  "projects.mock.1.desc":"React と Tailwind CSS を用いたプロフェッショナルなサイト",
  "projects.mock.2.name":"タスクアプリ",
  "projects.mock.2.desc":"認証機能付きタスク管理アプリ",
  "projects.mock.3.name":"EC 向け REST API",
  "projects.mock.3.desc":"オンラインストア向けフルバックエンド",
  "tools.items.emotional-translator.name":"感情保持翻訳",
  "tools.items.emotional-translator.description":"感情のトーンと文脈を保ったまま翻訳",
  "tools.items.text-reformulator.name":"テキストリライター",
  "tools.items.text-reformulator.description":"意味を変えずに文章を言い換え",
  "tools.items.voice-converter.name":"テキスト読み上げ",
  "tools.items.voice-converter.description":"テキストを自然な音声へ変換",
  "tools.items.prompt-creator.name":"プロンプトメーカー",
  "tools.items.prompt-creator.description":"あらゆる AI 用に最適化されたプロンプトを生成",
  "tools.items.viral-titles.name":"バズタイトル生成",
  "tools.items.viral-titles.description":"注目を集めるタイトルを作成",
  "tools.items.audience-segmenter.name":"オーディエンスセグメンター",
  "tools.items.audience-segmenter.description":"ターゲット受 audience を分析・分類",
  "tools.items.idea-repairer.name":"アイデア補完",
  "tools.items.idea-repairer.description":"不完全なアイデアを補完・改善",
  "tools.items.copy-pulse.name":"CopyPulse – コピー・改善・公開",
  "tools.items.copy-pulse.description":"あらゆるコンテンツを分析・改善・最適化",
  "tools.items.file-converter.name":"スマートファイルコンバーター",
  "tools.items.file-converter.description":"AI でファイルを変換しコンテンツを最適化",
  "tools.items.arconte-ai.name":"Arconte AI 連絡",
  "tools.items.arconte-ai.description":"最先端の AI へダイレクトアクセス",
  "tools.items.mass-control.name":"ポジティブな大衆影響",
  "tools.items.mass-control.description":"建設的な社会的影響のためのツール",
  "pages.not_found.title":"ページが見つかりません",
  "pages.not_found.body":"このページは人工知能のマルチバースで迷子になったようです。120のAIが見つけるために取り組んでいます。",
  "pages.not_found.help_title":"お困りですか？",
  "pages.not_found.help_body":"エラーだと思われる場合は、お問い合わせいただくか、メインページに戻ってください。",
  "pages.not_found.cta_home":"🏠 ホームに戻る",
  "pages.not_found.cta_tools":"🛠️ ツールを探す",
  "pages.not_found.link_support":"📧 サポート",
  "pages.not_found.link_home":"🏠 ホーム",
  "pages.not_found.link_plans":"💎 プラン",
  "user.panel_title":"ユーザーパネル",
  "user.security.change_password":"パスワードを変更",
  "user.security.change_password_prompt":"新しいパスワード（最低8文字）",
  "user.security.password_changed":"パスワードが更新されました",
  "user.security.reset_password":"リセットリンクを送信",
  "user.security.reset_sent":"パスワードをリセットするメールをお送りしました",
  "user.security.title":"アカウントセキュリティ",
  "user.security.subtitle":"認証情報とセキュリティオプションを管理します。",
  "user.security.password":"パスワード",
  "user.security.password_hint":"長くユニークなパスワードを使用してください。MFAは近日追加予定。",
  "user.security.email_hint":"メールアドレスを変更した場合、使用前に確認が必要です。",
  "user.security.password_error":"パスワードを更新できませんでした",
  "user.security.password_placeholder":"新しい安全なパスワード",
  "user.security.change_password_title":"パスワードを更新",
  "user.security.change_password_action":"更新",
  "user.security.cancel":"キャンセル",
  "user.security.password_min":"最低8文字",
  "user.security.logout":"ログアウト",
  "user.security.delete_account_btn":"アカウントを削除",
  "user.security.delete_account":"アカウントを削除",
  "user.security.delete_account_desc":"この操作は永続的です。プロジェクト、GPT、関連データが失われます。",
  "user.security.delete_account_type":"削除と入力して確認してください：",
  "user.security.delete_account_confirm":"完全に削除",
  "user.security.delete_account_done":"削除リクエストが送信されました。メールでお知らせします。",
  "user.security.delete_account_signout":"ログアウトしました。削除を完了するには、webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL を設定してください。",
  "trial.expired.title":"7日間のトライアルが終了しました！",
  "trial.expired.body":"IntelliVerseOneのフルパワーを体験しました。{{feature}}を使い続けるには、プランを選択してください。",
  "trial.expired.stats_title":"🎉 トライアル中に体験したこと：",
  "trial.expired.stat_ias":"相談したAI",
  "trial.expired.stat_functionality":"完全な機能",
  "trial.expired.stat_projects":"作成したプロジェクト",
  "trial.expired.stat_costs":"隠れたコスト",
  "trial.expired.pro_plus_label":"🚀 Pro+プラン - $9.79/月",
  "trial.expired.pro_plus_desc":"完全な機能 + 優先度 + マルチメディアAI",
  "trial.expired.pro_label":"⭐ Proプラン - $5.79/月",
  "trial.expired.pro_desc":"完全かつプロフェッショナルな使用に最適",
  "trial.expired.free_option":"または制限付き機能で続ける：",
  "trial.expired.free_plan_title":"🆓 Freeプラン（制限付き）：",
  "trial.expired.free_blocked":"アクセスが完全にブロックされています",
  "trial.expired.free_no_ias":"AIへの相談なし",
  "trial.expired.free_no_premium":"プレミアム機能なし",
  "trial.expired.free_history_only":"以前の履歴の表示のみ",
  "trial.expired.continue_free":"Freeプランで続ける",
  "trial.expired.benefits":"✨ 30日間保証 • 🔒 いつでもキャンセル • 💰 公正な価格",
  "notifications.welcome.activated":"🚀 IntelliVerseOne起動 - 複数のAIが相談可能",
  "notifications.welcome.optimized":"🧠 メタAIシステムが最高精度に最適化",
  "notifications.welcome.new_features":"⚡ 新機能が利用可能 - ツールを探索",
  "chat.error.auth":"未認証です。続けるにはログインしてください。",
  "chat.error.quota":"クエリの日次制限に達しました。プランをアップグレードしてください。",
  "chat.error.timeout":"リクエストがタイムアウトしました。再試行してください。",
  "chat.error.server":"サーバーエラー。後ほど再試行してください。",
  "chat.error":"エラーが発生しました。再試行してください。",
  "chat.placeholder.answer":"AIからの回答...",
  "history.auto.title":"会話 {{date}}",
  "history.actions.confirm":"この会話を削除しますか？",
  "stats.ias":"照会したAI数",
  "stats.remaining":"今日の残り",
  "stats.accuracy":"精度",
  "prompt.actions.search":"検索",
  "prompt.actions.voice":"音声",
  "prompt.actions.suggest":"提案",
  "prompt.actions.attach":"添付",
  "prompt.cta.consult_ias":"{{count}}件のAIに照会",
  "prompt.remaining":"残り",
  "prompt.placeholder.expired":"トライアル終了 —",
  "prompt.placeholder.limit":"制限に達しました —",
  "prompt.trial.expired_msg":"体験期間が終了しました。プランを選択してください。",
  "prompt.trial.choose_plan":"プランを選ぶ",
  "prompt.search.active":"検索モードアクティブ",
  "prompt.voice.no_mic":"マイクにアクセスできません",
  "prompt.limit.exceeded":"クエリ制限に達しました",
  "prompt.trial.expired":"体験期間終了",
  "auth.logout":"ログアウト",
  "mygpts.updated":"GPTを更新しました",
  "mygpts.created":"GPTを正常に作成しました",
  "mygpts.error.save":"保存エラー",
  "mygpts.creator.title_new":"新しい GPT を作成",
  "mygpts.creator.title_edit":"GPT を編集",
  "tools.copy_empty":"このツールにはコピーするテキストがありません",
  "tools.copy_ok":"プロンプトをクリップボードにコピーしました",
  "tools.copy_fail":"コピーできませんでした。再試してください。",
  "tools.copy_tooltip":"プロンプトをクリップボードにコピー",
  "tools.run_tooltip":"AIでツールを実行",
  "common.run":"実行",
  "plans.paypal.error":"支払いエラーが発生しました。もう一度お試しください。",
  "plans.paypal.cancel":"ユーザーによって支払いがキャンセルされました。",
  "plans.paypal.required":"このプランを有効にするには、PayPalでのお支払いを完了してください。",
  "plans.cancel.confirm":"サブスクリプションをキャンセルしてもよいですか？支払い期間終了まではアクセスを維持できます。",
  "plans.cancel.no_auth":"アクティブなセッションがありません。再度ログインしてください。",
  "plans.cancel.error":"キャンセル中にエラーが発生しました。再試行するか、サポートに連絡してください。",
  "plans.cancel.success":"サブスクリプションがキャンセルされました！{{date}}までアクセスを維持できます。",
  "user.connections.title":"アカウント接続",
  "user.connections.hint":"プロバイダーを連携して、どれでもログインに使用できるようにしましょう。",
  "projects.generated_success":"プロジェクトが生成されました！ZIPをダウンロードできます。",
  "projects.wizard.mvp_includes":"MVPプロジェクトには以下が含まれます：",
  "projects.wizard.gen.structure_mvp":"プロジェクトの基本構造",
  "projects.wizard.gen.starter":"機能的なスターターファイル",
  "projects.wizard.gen.readme":"手順付きREADME",
  "projects.wizard.gen.config":"初期設定",
  "projects.wizard.mvp_note":"ZIPをダウンロードして自由にコードをカスタマイズしてください",
  "projects.actions.generating":"生成中...",
  "common.login_required":"続行するにはログインしてください",
  "common.reset":"リセット",
  "share.copied":"リンクをコピー：",
  "limits.share_pro":"共有にはProプラン以上が必要です。",
  "life_coach":{
    "common":{"select":"選択…","selected_count":"{{count}} 件選択","other":"その他","other_ph":"他のオプションを説明"},
    "hero":{"title":"あなたの人生を導きます","subtitle":"毎日に寄り添う感情的・戦略的コパイロット。"},
    "stats":{"areas":"選択したエリア","habits":"総習慣数","remaining":"今日残りのアクション"},
    "form":{"title":"あなたの人生の焦点","areas_label":"優先エリア","daily_time":"1日に使える時間","emotions_label":"全体的な気分","emotions.low":"低い","emotions.medium":"普通","emotions.high":"高い","motivation":"今あなたを動かすものは?","motivation_ph":"モチベーションを説明","routine":"日課はどんなものですか?","routine_ph":"簡単に説明","constraints":"制約や課題（任意）","sleep_hours":"睡眠時間","sleep":{"less6":"6時間未満","6_7":"6-7時間","7_8":"7-8時間","more8":"8時間以上"},"exercise_freq":"運動頻度","exercise":{"never":"しない","1_2":"週1-2回","3_4":"週3-4回","more4":"週4回以上"},"diet_focus":"食事のこだわり","diet":{"balanced":"バランス","high_protein":"高タンパク","low_carb":"低糖質","plant_based":"植物性"},"stress_level":"ストレスレベル","level":{"low":"低い","medium":"普通","high":"高い"},"productivity_peak":"生産性のピーク","daytime":{"morning":"朝","afternoon":"午後","evening":"夜"},"reminder_time":"リマインダーの希望時間","distractions":"主な気晴らし","learning_goal":"学習目標","learning_goal_ph":"何を学びたいですか?","financial_goal":"財務目標","financial_goal_ph":"例：X円貯める、借金を返す","relationship_goal":"人間関係の目標","relationship_goal_ph":"家族、パートナー、友人","weekend_routine":"週末のルーティン","weekend_routine_ph":"典型的な活動","accountability":{"label":"アカウンタビリティ","solo":"一人で","buddy":"仲間と","coach":"コーチと"},"comm_style":"コミュニケーションスタイル","comm":{"concise":"簡潔","detailed":"詳細","motivational":"動機付け"}},
    "area":{"health":"健康","career":"キャリア","finance":"財務","relationships":"人間関係","personal":"個人の成長"},
    "motivation":{"health":"健康改善","career":"プロとして成長","balance":"ワークライフバランス","learn":"スキルを学ぶ","finance":"財務改善","emotional":"感情的な健康","consistency":"継続する","project":"個人プロジェクト","exam":"試験/資格の準備","stress":"ストレス軽減"},
    "routine":{"office":"オフィス9-5","remote":"フレックスリモート","student":"学生","shift":"シフト/交代","entrepreneur":"起業家","caretaker":"介護者","night":"夜間","parent":"子どもがいる親","variable":"非常に変動的"},
    "constraints":{"time":"時間不足","stress":"ストレス/不安","health":"身体の健康","finance":"財務","family":"家族/ケア","environment":"環境/スペース","sleep":"不規則な睡眠","motivation":"低モチベーション","tech":"技術/機器"},
    "distractions":{"social":"ソーシャルメディア","notifs":"通知","chat":"メッセージ","noise":"周囲の騒音","multitask":"マルチタスク","phone":"スマホ","fatigue":"疲労","perfect":"完璧主義","procrast":"先延ばし","family":"家族の割り込み","tv":"TV/ゲーム"},
    "learning":{"languages":"言語","programming":"プログラミング","dataai":"データ/AI","marketing":"マーケティング","sales":"営業","personal_finance":"個人財務","music":"音楽","design":"アート/デザイン","cert":"試験/資格","softskills":"ソフトスキル"},
    "finance":{"emergency":"緊急資金","pay_debt":"借金返済","cut_expenses":"支出削減","increase_income":"収入増加","invest":"投資","buy_house":"住宅/車購入","save_trip":"旅行/学習のための貯金","credit_score":"信用スコア改善"},
    "relation":{"communication":"コミュニケーション改善","family_time":"家族との時間を増やす","partner":"関係強化","friends":"新しい友人を作る","network":"プロネットワーキング","conflict":"紛争解決","boundaries":"健全な境界設定"},
    "weekend":{"rest":"休息","family":"家族","sport":"スポーツ/活動","social":"社交","creative":"創造/趣味","chores":"家事","study":"勉強/プロジェクト","travel":"旅行"},
    "cta":{"generate":"プランを生成","regenerate":"再生成","refine_area":"エリアを絞り込む"},
    "plan":{"title":"あなたの人生プラン","progress":"進捗","weekly_goals":"週次目標","monthly_goals":"月次目標","habits":"習慣"},
    "module":{"reminders":"スマートリマインダー","feedback":"週次フィードバック"},
    "reminders":{"active":"毎日・毎週のパーソナライズされたリマインダーを受信します。","locked":"Pro+で利用可能。自動でパーソナライズされたリマインダーをアンロック。"},
    "feedback":{"active":"週次分析とカスタマイズされた推奨事項を受信します。","locked":"Pro+で利用可能。改善提案付きの週次レポートを受け取る。"},
    "errors":{"areas":"少なくとも1つのエリアを選択してください。","limit":"1日の制限に達しました。"},
    "copy":{"m1":"あなたが最高の自分を構築できるよう、ここにいます。","m2":"今日も一歩前進しましょう。準備はいいですか?","m3":"小さな変化、大きな結果。"},
    "mock":{"goal":{"week":"{{area}}に関連する3セッションを完了","month":"{{area}}の重要なマイルストーンを達成","learn":{"week":"{{skill}}を学ぶ（3×20分）","month":"{{skill}}のモジュールを完了"},"finance":{"week":"{{goal}}に向けて進む","month":"財務マイルストーン達成：{{goal}}"},"weekend":"週末の活動：{{w}}","refine":"{{area}}の精製アクション"},"habit":{"1":"{{area}}の5分ハビット","2":"{{area}}についての短い振り返りを書く","learn":"{{skill}}を学ぶ（15分）","budget":"支出と予算を見直す（10分）","relation":"意味のある連絡（メッセージ/通話）","sleep":"睡眠衛生（10分ルーティン）","exercise":{"start":"10分歩く","progress":"20分の運動セッション","maintain":"25分のフィットネス維持"},"diet":{"pb":"野菜を1サービング追加","hp":"すべての食事にタンパク質を計画","lc":"精製糖を避ける"},"morning":"{{area}}のためのAMディープブロック（20分）","focus":"通知なしセッション（15分）","stress":"4-7-8呼吸法","accountability":"仲間/コーチとのチェックイン（5分）"}},
    "career":{"habit":{"focus":"{{m}}分のフォーカスブロック"}},
    "remark":{"privacy":"あなたの回答はプライベートに保存されます。"}
  },
  "common.back":"戻る"
} };
const ko = { translation: {
  "dashboard.hero.powered_by":"여러 인공지능으로 배우고, 만들고, 연구하세요",
  "auth.promo.subscribe":"무료 가입",
  "auth.promo.trial":"7일 플랫폼 무료 체험",
  "auth.promo.nocard":"신용카드 불필요",
  "dashboard.hero.rotating":[
    "여러 인공지능으로 배우고, 만들고, 연구하세요."
  ],
  "plans.cards":{
    "trial":{"name":"체험","price":"무료","period":"7일 체험","features":["하루 15회 액션","오케스트레이터 multiple AIs","기본 도구","커뮤니티 지원"],"limitations":["기능 제한","내보내기 불가","Deep Research 접근 불가","7일 후 종료"]},
    "pro":{"name":"Pro","period":"월별","features":["평생 25개 질문","하루 300회 액션","multiple AIs 접근","대부분 도구 해제","우선 처리"],"limitations":["Deep Research 제한","무제한 액션 아님"]},
    "pro_plus":{"name":"Pro+","period":"월별","features":["평생 50개 질문","무제한 액션","전체 Deep Research","모든 도구 해제","24/7 우선 지원"],"limitations":[]}
  },
  "plans.popular":"가장 인기","plans.current":"현재 요금제","plans.select":"요금제 선택","plans.paypal.success":"구독 성공! ID: ","plans.trial_active":"체험 활성화",
  "dashboard.cta.life_director":"개인 AI 플랜","dashboard.cta.study_tutor":"AI 학습 튜터","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"관심사로 연결","dashboard.cta.propose_ideas":"아이디어와 프로젝트","dashboard.cta.mass_control":"커뮤니티 임팩트 AI",
  "dashboard.desc.life_director":"맞춤형 AI 코칭","dashboard.desc.study_tutor":"지능형 적응 학습","dashboard.desc.create_project":"가이드형 풀 개발","dashboard.desc.deepweb":"심층 학술 검색","dashboard.desc.connect_people":"협업 지식 네트워크","dashboard.desc.propose_ideas":"기회 생성기","dashboard.desc.mass_control":"건설적 사회 임팩트",
  "dashboard.quick.prompts.life_director":"내 개인 라이프 코치처럼 행동해줘...","dashboard.quick.prompts.study_tutor":"내 개인 튜터가 되어줘...","dashboard.quick.prompts.deepweb":"심층 학술 및 법률 정보를 찾아줘...","dashboard.quick.prompts.connect_people":"비슷한 관심을 가진 사람들을 찾아 연결해줘.","dashboard.quick.prompts.propose_ideas":"혁신적인 프로젝트/비즈니스 아이디어를 만들어줘...",
  "dashboard.meta.title":"{{count}}개의 AI 메타‑응답","dashboard.meta.confidence":"신뢰도","dashboard.meta.queried_ais":"조회한 AI:","dashboard.meta.more":"+{{count}} 더...","dashboard.meta.specialized_ais":"전문 AI {{count}}","dashboard.meta.categories":"카테고리","dashboard.meta.general":"일반",
  "dashboard.welcome.title":"환영합니다, {{name}}님!","dashboard.welcome.body":"가장 진보된 AI 네트워크에 연결되었습니다...","dashboard.welcome.precision.title":"정밀도","dashboard.welcome.precision.desc":"여러 AI가 교차 검증한 답변","dashboard.welcome.speed.title":"속도","dashboard.welcome.speed.desc":"빠른 응답을 위한 병렬 처리","dashboard.welcome.intelligence.title":"지능","dashboard.welcome.intelligence.desc":"멀티 도메인 지식 합성",
  "dashboard.trial.title":"지금 IntelliVerseOne의 진짜 파워 중 8%만 쓰고 있어요","dashboard.trial.body":"multiple AIs, 프리미엄 도구, 고급 기능에 대한 전체 액세스를 해제하세요.","dashboard.trial.view_plans":"프리미엄 요금제 보기","dashboard.trial.continue":"체험 계속하기 ({{days}}일)",
  "dashboard.stats.today":"오늘의 쿼리","dashboard.stats.accuracy":"정확도",
  "dashboard.quick_actions.title":"빠른 작업",
  "dashboard.quick_actions.subtitle":"IntelliVerseOne의 기능을 탐색하세요",
  "dashboard.quick_actions.unlock_title":"전체 잠재력 해제",
  "dashboard.quick_actions.unlock_desc":"모든 프리미엄 도구와 기능에 접근",
  "prompt.suggestions.title":"💡 스마트 제안:","prompt.suggestions.1":"개인 생산성을 높이려면?","prompt.suggestions.2":"가장 효율적인 정렬 알고리즘 설명","prompt.suggestions.3":"React 프로젝트 아이디어","prompt.suggestions.4":"2024 디지털 마케팅 전략","prompt.suggestions.5":"인공지능 트렌드","prompt.suggestions.6":"성공적인 스타트업 만드는 법 단계별",
  "prompt.process.analyzing":"🔍 질문 분석 중...","prompt.process.selecting":"🧠 전문 AI 선택 중...","prompt.process.querying":"⚡ 네트워크 조회 중...","prompt.process.synthesizing":"🔄 답변 통합 중...","prompt.process.optimizing":"✨ 메타‑응답 최적화 중...",
  "prompt.placeholder.trial":"질문을 입력하세요... (오늘 남은 횟수: 8/10)","prompt.placeholder.default":"AI로 질문하고, 연구하고, 만들어보세요...",
  "prompt.placeholder.search":"특정 정보를 검색...",
  "prompt.search.mode":"검색 모드",
  "prompt.search.truncated":"텍스트가 잘렸습니다 (검색 모드 제한).",
  "prompt.attach.limit_files":"파일 최대 개수에 도달",
  "prompt.attach.file_too_big":"파일이 너무 큽니다 (최대 60KB): ",
  "prompt.attach.total_too_big":"첨부 총 용량 초과",
  "prompt.attach.unsupported_now":"형식은 곧 지원 예정 (클라우드 모드 필요): ",
  "prompt.attach.unsupported":"지원하지 않는 형식: ",
  "prompt.attach.read_error":"읽기 오류: ",
  "prompt.attach.remove":"첨부 제거",
  "prompt.voice.recording":"음성 녹음 중... (최대 60초)",
  "prompt.voice.unsupported":"이 브라우저는 음성 인식을 지원하지 않습니다.",
  "prompt.actions.Adjuntar archivo":"파일 첨부","prompt.actions.Búsqueda avanzada":"고급 검색","prompt.actions.Voz a texto":"음성을 텍스트로","prompt.actions.Prompt inteligente":"스마트 프롬프트",
  "prompt.status.querying":"조회 중...","prompt.status.optimizing":"최적화 중...","prompt.cta.consult_ais":"{{count}}개 AI에 상담","prompt.trial.info":"무료 요금제: {{days}}일 남음 •","prompt.trial.upgrade":"무제한 쿼리를 위해 업그레이드",
  "common.ok":"OK","common.sending":"전송 중...","common.sent":"전송됨","common.error":"오류","common.send":"보내기","common.close":"닫기","common.cancel":"취소","common.loading":"로딩 중...",
  "auth.login":"로그인","auth.signup":"무료 가입","auth.password":"비밀번호","auth.forgot":"비밀번호를 잊으셨나요?","auth.continue":"계속","auth.magic_short":"매직 링크","auth.check_email":"계정 확인을 위해 이메일을 확인하세요","auth.reset":"비밀번호 재설정","auth.resend":"재전송",
  "time.just_now":"방금","time.minutes_ago":"{{count}}분 전","time.hours_ago":"{{count}}시간 전","time.days_ago":"{{count}}일 전",
  "auth.with.google":"Google로 계속","auth.with.apple":"Apple로 계속","auth.with.microsoft":"Microsoft로 계속","auth.with.facebook":"Facebook으로 계속","auth.with.github":"GitHub로 계속","auth.with.linkedin":"LinkedIn으로 계속","auth.or":"또는","auth.legal":"계속하면 다음에 동의하는 것입니다:","auth.terms":"이용 약관","auth.and":"및","auth.privacy":"개인정보","auth.errors.social":"선택한 제공업체로 로그인할 수 없습니다","auth.protected_route":"보호된 페이지: 로그인하세요",
  "auth.email":"이메일","auth.remember_me":"기억하기","auth.magic.send":"링크 보내기","auth.magic.resend_btn":"재전송","auth.magic.resend_in":"재전송 ({{s}})","auth.logged_in":"로그인됨","auth.password.requirements_failed":"비밀번호가 요구 사항을 충족하지 않습니다","auth.reset.sent_conditional":"계정이 존재하면 재설정 메일을 보냈습니다.","auth.verification.unverified":"이메일이 확인되지 않았습니다.","auth.verification.resent":"확인 메일이 재전송되었습니다.","auth.errors.login_failed":"로그인에 실패했습니다","auth.errors.signup_failed":"가입에 실패했습니다","auth.errors.magic_failed":"링크를 보낼 수 없습니다","auth.errors.resend_failed":"재전송할 수 없습니다",
  "auth.env.missing":"Supabase 변수가 감지되지 않았습니다. REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY 또는 VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY 를 설정하고 서버를 재시작하세요.",
  "sidebar.dashboard":"대시보드","sidebar.new_chat":"새 채팅","sidebar.new_project":"새 프로젝트","sidebar.history":"히스토리","sidebar.tools":"도구","sidebar.my_gpts":"내 GPTs","sidebar.plans":"요금제","sidebar.my_profile":"내 프로필","sidebar.days_left":"{{count}}일 남음",
  "pages.plans.title":"요금제 및 가격","pages.plans.subtitle":"IntelliVerseOne의 잠재력을 최대화할 요금제를 선택하세요","pages.plans.stats.ais":"사용 가능한 AI","pages.plans.stats.tools":"도구","pages.plans.stats.availability":"가용성","pages.plans.compare":"상세 비교","pages.plans.trial_expiring":"무료 체험이 {{days}}일 후 종료됩니다","pages.plans.trial_expiring_hint":"지금 업그레이드하여 모든 기능을 유지하세요","pages.plans.trial_expired_ago":"무료 체험이 {{days}}일 전에 종료되었습니다","plans.cta.start_pro":"Pro 요금제 시작","plans.cta.go_pro_plus":"바로 Pro+","pages.plans.view_plans":"요금제 보기",
  "pages.faq.title":"자주 묻는 질문","pages.faq.q.change_anytime":"언제든 요금제 변경이 가능한가요?","pages.faq.a.change_anytime":"네, 언제든 업/다운그레이드 가능합니다. 즉시 적용됩니다.","pages.faq.q.free_includes":"무료 요금제는 무엇이 포함되나요?","pages.faq.a.free_includes":"5개 AI, 일 10회 쿼리, 7일간 기본 도구 이용.","pages.faq.q.annual_discounts":"연간 결제 할인 있나요?","pages.faq.a.annual_discounts":"예, 연간 결제 시 2개월 무료.","pages.faq.q.payment_methods":"결제 수단은?","pages.faq.a.payment_methods":"신용/직불카드, PayPal, 은행이체.","pages.faq.q.cancel_anytime":"언제든 해지 가능한가요?","pages.faq.a.cancel_anytime":"네, 페널티 없이 언제든 해지할 수 있습니다.","pages.faq.q.support":"기술 지원이 제공되나요?","pages.faq.a.support":"예, 모든 요금제에 지원 포함. 유료는 24/7 우선 지원.",
  "pages.history.title":"대화 기록","pages.history.subtitle":"이전 대화를 확인하고 검색하세요",
  "pages.tools.title":"AI 도구","pages.tools.subtitle":"AI로 강화된 완전한 도구 모음","pages.tools.search_placeholder":"도구 검색...","pages.tools.empty":"도구를 찾을 수 없습니다","pages.tools.empty_hint":"다른 검색어나 카테고리를 시도하세요","pages.tools.more_coming":"더 많은 도구 개발 중","pages.tools.more_coming_desc":"생산성 향상을 위해 지속적으로 신규 AI 도구를 추가하고 있습니다",
  "pages.projects.create_title":"프로젝트 생성","pages.projects.step1_title":"어떤 유형의 프로젝트를 생성하시겠습니까?","pages.projects.details_title":"프로젝트 상세","pages.projects.name_label":"프로젝트명","pages.projects.name_ph":"예: 내 포트폴리오","pages.projects.desc_label":"설명","pages.projects.desc_ph":"프로젝트 설명...","pages.projects.purpose_label":"주요 목적","pages.projects.purpose_ph":"예: 개발 역량 보여주기","pages.projects.audience_label":"대상","pages.projects.audience_ph":"예: 리크루터 및 테크 기업","pages.projects.summary_title":"프로젝트 요약","pages.projects.type":"유형","pages.projects.purpose":"목적","pages.projects.audience":"대상","pages.projects.title":"내 프로젝트","pages.projects.subtitle":"AI로 완전한 프로젝트 생성","pages.projects.empty":"아직 프로젝트가 없습니다","pages.projects.first_project":"첫 AI 프로젝트 만들기","pages.projects.unlock_title":"프로젝트 생성 잠금 해제","pages.projects.reached_limit":"요금제 프로젝트 한도에 도달했습니다. 업그레이드하세요.","pages.projects.upgrade_benefits":"Pro로 완전한 프로젝트, Pro+로 고급 내보내기",
  "pages.cta.boost_productivity":"생산성을 높일 준비가 되셨나요?","pages.cta.join_many":"집단 지능 AI의 힘을 활용하는 수천 명에 합류하세요",
  "user.plan.current":"현재 요금제","user.plan.trial":"체험","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"요금제 업그레이드",
  "goodbye.title":"계정이 삭제되었습니다","goodbye.subtitle":"IntelliVerseOne을 이용해 주셔서 감사합니다.","goodbye.feedback":"떠나는 이유를 알려주시면 개선에 도움이 됩니다.","goodbye.contact":"지원 문의","goodbye.home":"홈으로",
    "common.copy":"복사","common.coming_soon":"곧 제공","common.in_development":"개발 중",
    "tools.categories.all":"전체","tools.categories.content":"콘텐츠","tools.categories.productivity":"생산성","tools.categories.analysis":"분석","tools.categories.social":"사회 & 임팩트","tools.categories.development":"개발",
  "plans.limitations":"제한사항:",
  "plans.table.available":"이용 가능한 요금제",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"무료",
  "plans.table.trial.features":"하루 15회 액션 • 오케스트레이터 multiple AIs",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/월",
  "plans.table.pro.features":"평생 25개 질문 • 하루 300회 액션",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/월",
  "plans.table.pro_plus.features":"평생 50개 질문 • 무제한 액션 • 전체 Deep Research",
  "pages.history.search_placeholder":"대화에서 검색...",
  "history.stats.conversations":"대화",
  "history.stats.total_responses":"총 응답",
  "history.stats.average_rating":"평균 평점",
  "history.stats.active_days":"활성 일수",
  "history.category.all":"전체",
  "history.category.productivity":"생산성",
  "history.category.education":"교육",
  "history.category.development":"개발",
  "history.category.career":"커리어",
  "history.category.finance":"금융",
  "history.label.responses":"개의 응답",
  "history.empty.title":"대화를 찾을 수 없습니다",
  "history.empty.hint_search":"다른 검색어를 시도하세요",
  "history.empty.hint_empty":"저장된 대화가 아직 없습니다",
  "history.empty.cta":"새 대화 시작",
  "history.smart_search.title":"스마트 시맨틱 검색",
  "history.smart_search.subtitle":"곧 제공: 키워드뿐 아니라 개념과 문맥으로 검색",
  "history.smart_search.card.semantic_ai.title":"시맨틱 AI",
  "history.smart_search.card.semantic_ai.desc":"의미로 대화를 찾기",
  "history.smart_search.card.auto_tagging.title":"자동 태깅",
  "history.smart_search.card.auto_tagging.desc":"지능형 자동 분류",
  "history.smart_search.card.patterns.title":"패턴 분석",
  "history.smart_search.card.patterns.desc":"질의에 대한 인사이트",
  "mygpts.title":"내 GPTs",
  "mygpts.subtitle":"맞춤형 AI 어시스턴트를 만들고 관리하세요",
  "mygpts.create_new":"새 GPT 만들기",
  "mygpts.stats.created":"생성된 GPTs",
  "mygpts.stats.uses":"총 사용 수",
  "mygpts.stats.limit":"GPT 한도",
  "mygpts.stats.templates":"사용 가능한 템플릿",
  "mygpts.empty.title":"아직 GPT가 없습니다",
  "mygpts.empty.subtitle":"첫 맞춤형 AI 어시스턴트를 만들어보세요",
  "mygpts.empty.cta":"내 첫 GPT 만들기",
  "mygpts.locked.title":"GPT 생성 잠금 해제",
  "mygpts.locked.desc.hard":"요금제의 GPT 한도에 도달했습니다. 계속하려면 업그레이드하세요.",
  "mygpts.locked.desc.info":"Pro에서는 최대 5개, Pro+에서는 무제한의 맞춤형 GPT 생성",
  "mygpts.locked.cta":"요금제 보기",
  "mygpts.card.uses":"회",
  "mygpts.card.created":"생성됨",
  "mygpts.card.tone":"톤",
  "mygpts.card.depth":"깊이",
  "mygpts.card.style":"스타일",
  "mygpts.card.use":"사용",
  "mygpts.creator.title":"새 GPT 만들기",
  "mygpts.creator.step":"4단계 중 {{n}}단계",
  "mygpts.creator.step1.title":"기본 템플릿 선택",
  "mygpts.creator.step2.title":"GPT 사용자 지정",
  "mygpts.creator.name.placeholder":"예: 내 개인 비서",
  "mygpts.creator.desc.placeholder":"GPT가 무엇을 하고 어떻게 도움을 주는지 설명...",
  "mygpts.creator.icon":"아이콘",
  "mygpts.creator.step3.title":"성격 설정",
  "mygpts.creator.tone.label":"의사소통 톤",
  "mygpts.creator.tone.professional":"전문적",
  "mygpts.creator.tone.friendly":"친근함",
  "mygpts.creator.tone.casual":"캐주얼",
  "mygpts.creator.tone.empatic":"공감적",
  "mygpts.creator.tone.direct":"직설적",
  "mygpts.creator.depth.label":"응답 깊이",
  "mygpts.creator.depth.basic":"기본",
  "mygpts.creator.depth.intermediate":"중간",
  "mygpts.creator.depth.advanced":"고급",
  "mygpts.creator.depth.expert":"전문가",
  "mygpts.creator.style.label":"의사소통 스타일",
  "mygpts.creator.style.conversational":"대화형",
  "mygpts.creator.style.structured":"구조화",
  "mygpts.creator.style.creative":"창의적",
  "mygpts.creator.style.analytical":"분석적",
  "mygpts.creator.style.reflective":"성찰적",
  "mygpts.creator.step4.title":"GPT 미리보기",
  "mygpts.creator.preview_hint":"괜찮나요? 나중에 편집할 수 있습니다.",
  "mygpts.creator.create":"GPT 만들기",
  "mygpts.templates.tutor.name":"내 튜터",
  "mygpts.templates.tutor.desc":"교육과 설명 전문",
  "mygpts.templates.emotional.name":"감정 멘토",
  "mygpts.templates.emotional.desc":"정서적 지원 및 웰빙",
  "mygpts.templates.productivity.name":"내 생산성",
  "mygpts.templates.productivity.desc":"최적화 및 조직",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"심층 학술 연구",
  "mygpts.templates.crypto.name":"크립토 자산",
  "mygpts.templates.crypto.desc":"암호화폐 및 블록체인 분석",
  "mygpts.templates.business.name":"비즈니스 전략가",
  "mygpts.templates.business.desc":"비즈니스 컨설팅 및 전략",
  "mygpts.sample.tutor.name":"내 개인 튜터",
  "mygpts.sample.tutor.desc":"복잡한 개념을 쉽게 설명하는 데 특화",
  "mygpts.sample.productivity.name":"생산성 어시스턴트",
  "mygpts.sample.productivity.desc":"작업 최적화 및 시간 관리",
  "mygpts.sample.emotional.name":"감정 멘토",
  "mygpts.sample.emotional.desc":"정서적 지원 및 멘탈 웰빙 팁",
  "mygpts.sample.tone.friendly":"친근함",
  "mygpts.sample.tone.direct":"직설적",
  "mygpts.sample.tone.empatic":"공감적",
  "mygpts.sample.depth.intermediate":"중간",
  "mygpts.sample.depth.practical":"실용적",
  "mygpts.sample.depth.deep":"깊은",
  "mygpts.sample.style.conversational":"대화형",
  "mygpts.sample.style.structured":"구조화",
  "mygpts.sample.style.reflective":"성찰적",
  "projects.types.web.name":"웹 애플리케이션",
  "projects.types.web.desc":"React/Vue/Angular로 구성된 전체 프론트엔드",
  "projects.types.api.name":"API 백엔드",
  "projects.types.api.desc":"Node.js 또는 Python 기반 서버와 데이터베이스",
  "projects.types.mobile.name":"모바일 앱",
  "projects.types.mobile.desc":"네이티브 또는 하이브리드 앱",
  "projects.types.fullstack.name":"풀스택",
  "projects.types.fullstack.desc":"엔드투엔드 프로젝트: 프론트엔드 + 백엔드",
  "projects.actions.download_zip":"ZIP 다운로드",
  "projects.actions.continue":"계속",
  "projects.actions.new_project":"새 프로젝트",
  "projects.progress":"진행도",
  "projects.created_on":"생성됨",
  "projects.status.completed":"완료",
  "projects.status.in_progress":"진행 중",
  "projects.status.generating":"생성 중",
  "projects.status.generating_dots":"생성 중...",
  "projects.actions.view":"보기",
  "projects.detail.untitled":"제목 없는 프로젝트",
  "projects.detail.loading_desc":"프로젝트 세부정보 불러오는 중…",
  "projects.detail.no_desc":"설명 없음",
  "projects.detail.view":"보기",
  "projects.detail.summary":"요약",
  "projects.detail.actions":"빠른 작업",
  "projects.detail.view_code":"코드 보기",
  "projects.detail.activity":"활동",
  "projects.detail.activity_init":"프로젝트가 생성되어 생성 대기열에 추가됨",
  "projects.detail.activity_ai":"AI가 구조와 종속성을 준비 중",
  "projects.detail.activity_docs":"기본 문서가 초기화됨",
  "projects.detail.tech":"기술",
  "history.sample.1.title":"개인 생산성을 높이는 방법",
  "history.sample.1.preview":"일상 업무에서 더 생산적으로 일하는 팁이 필요해요...",
  "history.sample.2.title":"정렬 알고리즘 설명",
  "history.sample.2.preview":"여러 정렬 알고리즘에 대해 설명해 줄 수 있나요...",
  "history.sample.3.title":"React 프로젝트 아이디어",
  "history.sample.3.preview":"React 프로젝트를 위한 참신한 아이디어를 찾고 있어요...",
  "history.sample.4.title":"면접 팁",
  "history.sample.4.preview":"다음 주에 중요한 면접이 있어요...",
  "history.sample.5.title":"가상자산 시장 분석",
  "history.sample.5.preview":"현재 크립토 시장 트렌드에 대해 어떻게 생각하나요...",
  "projects.mock.1.name":"개인 포트폴리오",
  "projects.mock.1.desc":"React와 Tailwind CSS로 만든 전문 웹사이트",
  "projects.mock.2.name":"할 일 앱",
  "projects.mock.2.desc":"인증이 포함된 작업 관리 앱",
  "projects.mock.3.name":"이커머스 REST API",
  "projects.mock.3.desc":"온라인 스토어용 전체 백엔드",
  "tools.items.emotional-translator.name":"감정 보존 번역기",
  "tools.items.emotional-translator.description":"감정 톤과 문맥을 유지하며 번역",
  "tools.items.text-reformulator.name":"텍스트 리라이팅",
  "tools.items.text-reformulator.description":"의미를 유지하면서 문장을 재작성",
  "tools.items.voice-converter.name":"텍스트‑음성 변환",
  "tools.items.voice-converter.description":"텍스트를 자연스러운 음성으로 변환",
  "tools.items.prompt-creator.name":"프롬프트 생성기",
  "tools.items.prompt-creator.description":"모든 AI를 위한 최적화된 프롬프트 생성",
  "tools.items.viral-titles.name":"바이럴 제목 생성기",
  "tools.items.viral-titles.description":"시선을 끄는 제목 생성",
  "tools.items.audience-segmenter.name":"오디언스 세그멘터",
  "tools.items.audience-segmenter.description":"타깃 오디언스를 분석 및 분류",
  "tools.items.idea-repairer.name":"아이디어 보완기",
  "tools.items.idea-repairer.description":"불완전한 아이디어를 보완 및 개선",
  "tools.items.copy-pulse.name":"CopyPulse – 복사, 개선 및 출시",
  "tools.items.copy-pulse.description":"모든 콘텐츠를 분석·개선·최적화",
  "tools.items.file-converter.name":"지능형 파일 변환기",
  "tools.items.file-converter.description":"AI로 파일을 변환하여 콘텐츠 최적화",
  "tools.items.arconte-ai.name":"Arconte AI 연락",
  "tools.items.arconte-ai.description":"가장 진보된 AI에 직접 접근",
  "tools.items.mass-control.name":"긍정적 대중 영향",
  "tools.items.mass-control.description":"건설적 사회 영향 도구",
  "pages.not_found.title":"페이지를 찾을 수 없습니다",
  "pages.not_found.body":"이 페이지가 인공지능 멀티버스에서 길을 잃은 것 같습니다. 120개의 AI가 찾고 있습니다.",
  "pages.not_found.help_title":"도움이 필요하신가요?",
  "pages.not_found.help_body":"오류라고 생각되시면 저희에게 연락하거나 메인 페이지로 돌아가세요.",
  "pages.not_found.cta_home":"🏠 홈으로 돌아가기",
  "pages.not_found.cta_tools":"🛠️ 도구 탐색",
  "pages.not_found.link_support":"📧 지원",
  "pages.not_found.link_home":"🏠 홈",
  "pages.not_found.link_plans":"💎 요금제",
  "user.panel_title":"사용자 패널",
  "user.security.change_password":"비밀번호 변경",
  "user.security.change_password_prompt":"새 비밀번호 (최소 8자)",
  "user.security.password_changed":"비밀번호가 업데이트되었습니다",
  "user.security.reset_password":"재설정 링크 보내기",
  "user.security.reset_sent":"비밀번호 재설정을 위한 이메일을 보냈습니다",
  "user.security.title":"계정 보안",
  "user.security.subtitle":"자격 증명 및 보안 옵션을 관리합니다.",
  "user.security.password":"비밀번호",
  "user.security.password_hint":"길고 고유한 비밀번호를 사용하세요. MFA 곧 추가 예정.",
  "user.security.email_hint":"이메일을 변경하면 사용 전에 인증해야 합니다.",
  "user.security.password_error":"비밀번호를 업데이트할 수 없습니다",
  "user.security.password_placeholder":"새 보안 비밀번호",
  "user.security.change_password_title":"비밀번호 업데이트",
  "user.security.change_password_action":"업데이트",
  "user.security.cancel":"취소",
  "user.security.password_min":"최소 8자",
  "user.security.logout":"로그아웃",
  "user.security.delete_account_btn":"계정 삭제",
  "user.security.delete_account":"계정 삭제",
  "user.security.delete_account_desc":"이 작업은 영구적입니다. 프로젝트, GPT 및 관련 데이터가 삭제됩니다.",
  "user.security.delete_account_type":"삭제를 입력하여 확인하세요:",
  "user.security.delete_account_confirm":"영구 삭제",
  "user.security.delete_account_done":"삭제 요청이 전송되었습니다. 이메일로 알려드리겠습니다.",
  "user.security.delete_account_signout":"로그아웃되었습니다. 삭제를 완료하려면 webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL을 설정하세요.",
  "trial.expired.title":"7일 체험판이 종료되었습니다!",
  "trial.expired.body":"IntelliVerseOne의 완전한 기능을 경험하셨습니다. {{feature}} 사용을 계속하려면 요금제를 선택하세요.",
  "trial.expired.stats_title":"🎉 체험판 기간 동안 경험한 것들:",
  "trial.expired.stat_ias":"상담한 AI",
  "trial.expired.stat_functionality":"완전한 기능",
  "trial.expired.stat_projects":"생성한 프로젝트",
  "trial.expired.stat_costs":"숨겨진 비용",
  "trial.expired.pro_plus_label":"🚀 Pro+ 요금제 - $9.79/월",
  "trial.expired.pro_plus_desc":"완전한 기능 + 우선순위 + 멀티미디어 AI",
  "trial.expired.pro_label":"⭐ Pro 요금제 - $5.79/월",
  "trial.expired.pro_desc":"완전하고 전문적인 사용에 완벽",
  "trial.expired.free_option":"또는 제한된 기능으로 계속:",
  "trial.expired.free_plan_title":"🆓 Free 요금제 (제한됨):",
  "trial.expired.free_blocked":"액세스 완전히 차단됨",
  "trial.expired.free_no_ias":"AI 쿼리 없음",
  "trial.expired.free_no_premium":"프리미엄 기능 없음",
  "trial.expired.free_history_only":"이전 기록만 보기",
  "trial.expired.continue_free":"Free 요금제로 계속",
  "trial.expired.benefits":"✨ 30일 보장 • 🔒 언제든지 취소 • 💰 공정한 가격",
  "notifications.welcome.activated":"🚀 IntelliVerseOne 활성화됨 - multiple AIs 상담 준비 완료",
  "notifications.welcome.optimized":"🧠 최고 정밀도를 위해 메타 AI 시스템 최적화됨",
  "notifications.welcome.new_features":"⚡ 새 기능 이용 가능 - 도구 탐색",
  "chat.error.auth":"인증되지 않았습니다. 계속하려면 로그인하세요.",
  "chat.error.quota":"일일 쿼리 한도에 도달했습니다. 플랜을 업그레이드하세요.",
  "chat.error.timeout":"요청 시간이 초과되었습니다. 다시 시도하세요.",
  "chat.error.server":"서버 오류. 나중에 다시 시도하세요.",
  "chat.error":"오류가 발생했습니다. 다시 시도하세요.",
  "chat.placeholder.answer":"AI 답변...",
  "history.auto.title":"대화 {{date}}",
  "history.actions.confirm":"이 대화를 삭제하시겠습니까?",
  "stats.ias":"조회된 AI",
  "stats.remaining":"오늘 남은 횟수",
  "stats.accuracy":"정확도",
  "prompt.actions.search":"검색",
  "prompt.actions.voice":"음성",
  "prompt.actions.suggest":"제안",
  "prompt.actions.attach":"첨부",
  "prompt.cta.consult_ias":"{{count}}개 AI 조회",
  "prompt.remaining":"남은 횟수",
  "prompt.placeholder.expired":"체험 만료 —",
  "prompt.placeholder.limit":"한도 초과 —",
  "prompt.trial.expired_msg":"체험 기간이 만료되었습니다. 플랜을 선택하세요.",
  "prompt.trial.choose_plan":"플랜 선택",
  "prompt.search.active":"검색 모드 활성",
  "prompt.voice.no_mic":"마이크 접근 불가",
  "prompt.limit.exceeded":"쿼리 한도 초과",
  "prompt.trial.expired":"체험 만료",
  "auth.logout":"로그아웃",
  "mygpts.updated":"GPT 업데이트됨",
  "mygpts.created":"GPT가 성공적으로 생성되었습니다",
  "mygpts.error.save":"저장 중 오류가 발생했습니다",
  "mygpts.creator.title_new":"새 GPT 만들기",
  "mygpts.creator.title_edit":"GPT 편집",
  "tools.copy_empty":"이 도구에는 복사할 텍스트가 없습니다",
  "tools.copy_ok":"프롬프트가 클립보드에 복사되었습니다",
  "tools.copy_fail":"복사할 수 없습니다. 다시 시도하세요.",
  "tools.copy_tooltip":"프롬프트를 클립보드에 복사",
  "tools.run_tooltip":"AI로 도구 실행",
  "common.run":"실행",
  "plans.paypal.error":"결제 오류가 발생했습니다. 다시 시도해 주세요.",
  "plans.paypal.cancel":"사용자가 결제를 취소했습니다.",
  "plans.paypal.required":"이 플랜을 활성화하려면 PayPal로 결제를 완료해야 합니다.",
  "plans.cancel.confirm":"정말로 구독을 취소하시겠습니까? 유료 기간이 끝날 때까지 접근이 유지됩니다.",
  "plans.cancel.no_auth":"활성 세션이 없습니다. 다시 로그인해 주세요.",
  "plans.cancel.error":"취소 중 오류가 발생했습니다. 다시 시도하거나 지원팀에 문의하세요.",
  "plans.cancel.success":"구독이 취소되었습니다! {{date}}까지 접근이 유지됩니다.",
  "user.connections.title":"계정 연결",
  "user.connections.hint":"제공업체를 연결하여 그 중 하나로 로그인할 수 있습니다.",
  "projects.generated_success":"프로젝트가 생성되었습니다! 이제 ZIP을 다운로드할 수 있습니다.",
  "projects.wizard.mvp_includes":"MVP 프로젝트에는 다음이 포함됩니다:",
  "projects.wizard.gen.structure_mvp":"프로젝트 기본 구조",
  "projects.wizard.gen.starter":"기능적 스타터 파일",
  "projects.wizard.gen.readme":"안내가 포함된 README",
  "projects.wizard.gen.config":"초기 설정",
  "projects.wizard.mvp_note":"ZIP을 다운로드하고 원하는 대로 코드를 커스텀하세요",
  "projects.actions.generating":"생성 중...",
  "common.login_required":"계속하려면 로그인하세요",
  "common.reset":"초기화",
  "share.copied":"링크 복사됨: ",
  "limits.share_pro":"공유하려면 Pro 플랜 이상이 필요합니다.",
  "life_coach":{
    "common":{"select":"선택…","selected_count":"{{count}}개 선택됨","other":"기타","other_ph":"다른 옵션 설명"},
    "hero":{"title":"당신의 삶을 이끌겠습니다","subtitle":"매일 함께하는 감성적·전략적 코파일럿."},
    "stats":{"areas":"선택한 영역","habits":"총 습관 수","remaining":"오늘 남은 행동"},
    "form":{"title":"당신의 삶의 초점","areas_label":"우선순위 영역","daily_time":"하루 가용 시간","emotions_label":"전반적인 기분","emotions.low":"낮음","emotions.medium":"보통","emotions.high":"높음","motivation":"지금 당신을 동기부여하는 것은?","motivation_ph":"동기를 설명하세요","routine":"일상은 어떤가요?","routine_ph":"간단히 설명하세요","constraints":"제약이나 도전 과제 (선택)","sleep_hours":"수면 시간","sleep":{"less6":"6시간 미만","6_7":"6-7시간","7_8":"7-8시간","more8":"8시간 이상"},"exercise_freq":"운동 빈도","exercise":{"never":"안 함","1_2":"주 1-2회","3_4":"주 3-4회","more4":"주 4회 이상"},"diet_focus":"식단 초점","diet":{"balanced":"균형","high_protein":"고단백","low_carb":"저탄수화물","plant_based":"식물성"},"stress_level":"스트레스 수준","level":{"low":"낮음","medium":"보통","high":"높음"},"productivity_peak":"생산성 최고조","daytime":{"morning":"아침","afternoon":"오후","evening":"저녁"},"reminder_time":"선호 알림 시간","distractions":"주요 방해 요소","learning_goal":"학습 목표","learning_goal_ph":"무엇을 배우고 싶으세요?","financial_goal":"재정 목표","financial_goal_ph":"예: X 저축, 부채 상환","relationship_goal":"관계 목표","relationship_goal_ph":"가족, 파트너, 친구","weekend_routine":"주말 루틴","weekend_routine_ph":"일반적인 활동","accountability":{"label":"책임감","solo":"혼자","buddy":"친구와","coach":"코치와"},"comm_style":"소통 스타일","comm":{"concise":"간결","detailed":"상세","motivational":"동기부여"}},
    "area":{"health":"건강","career":"커리어","finance":"재정","relationships":"관계","personal":"개인 성장"},
    "motivation":{"health":"건강 개선","career":"전문적으로 성장","balance":"일-생활 균형","learn":"기술 배우기","finance":"재정 개선","emotional":"정서적 웰빙","consistency":"일관성 유지","project":"개인 프로젝트","exam":"시험/자격증 준비","stress":"스트레스 감소"},
    "routine":{"office":"사무실 9-5","remote":"유연 재택","student":"학생","shift":"교대 근무","entrepreneur":"기업가","caretaker":"돌봄 제공자","night":"야간","parent":"자녀가 있는 부모","variable":"매우 가변적"},
    "constraints":{"time":"시간 부족","stress":"스트레스/불안","health":"신체 건강","finance":"재정","family":"가족/돌봄","environment":"환경/공간","sleep":"불규칙한 수면","motivation":"낮은 동기","tech":"기술/장비"},
    "distractions":{"social":"소셜 미디어","notifs":"알림","chat":"메시지","noise":"주변 소음","multitask":"멀티태스킹","phone":"스마트폰","fatigue":"피로","perfect":"완벽주의","procrast":"미루기","family":"가족 방해","tv":"TV/게임"},
    "learning":{"languages":"언어","programming":"프로그래밍","dataai":"데이터/AI","marketing":"마케팅","sales":"영업","personal_finance":"개인 재정","music":"음악","design":"아트/디자인","cert":"시험/자격증","softskills":"소프트 스킬"},
    "finance":{"emergency":"비상 자금","pay_debt":"부채 상환","cut_expenses":"지출 삭감","increase_income":"수입 증가","invest":"투자","buy_house":"주택/차량 구입","save_trip":"여행/학습을 위한 저축","credit_score":"신용 점수 개선"},
    "relation":{"communication":"소통 개선","family_time":"더 많은 가족 시간","partner":"관계 강화","friends":"새 친구 사귀기","network":"전문 네트워킹","conflict":"갈등 해결","boundaries":"건강한 경계 설정"},
    "weekend":{"rest":"휴식","family":"가족","sport":"스포츠/활동","social":"사교","creative":"창의적/취미","chores":"집안일","study":"공부/프로젝트","travel":"여행"},
    "cta":{"generate":"플랜 생성","regenerate":"재생성","refine_area":"영역 세분화"},
    "plan":{"title":"나의 인생 플랜","progress":"진행상황","weekly_goals":"주간 목표","monthly_goals":"월간 목표","habits":"습관"},
    "module":{"reminders":"스마트 알림","feedback":"주간 피드백"},
    "reminders":{"active":"매일·매주 맞춤 알림을 받게 됩니다.","locked":"Pro+에서 이용 가능. 자동 맞춤 알림을 잠금 해제하세요."},
    "feedback":{"active":"맞춤 권장 사항이 포함된 주간 분석을 받게 됩니다.","locked":"Pro+에서 이용 가능. 개선 제안이 포함된 주간 보고서를 받으세요."},
    "errors":{"areas":"최소 하나의 영역을 선택하세요.","limit":"일일 한도에 도달했습니다."},
    "copy":{"m1":"최고의 자신을 만들 수 있도록 도와드리겠습니다.","m2":"오늘도 한 걸음 나아갑시다. 준비됐나요?","m3":"작은 변화, 큰 결과."},
    "mock":{"goal":{"week":"{{area}} 관련 세션 3개 완료","month":"{{area}}의 주요 마일스톤 달성","learn":{"week":"{{skill}} 공부 (3×20분)","month":"{{skill}} 모듈 완료"},"finance":{"week":"{{goal}}을 향해 전진","month":"재정 마일스톤 달성: {{goal}}"},"weekend":"주말 활동: {{w}}","refine":"{{area}}의 정제된 행동"},"habit":{"1":"{{area}}의 5분 습관","2":"{{area}}에 대한 짧은 성찰 작성","learn":"{{skill}} 학습 (15분)","budget":"지출 및 예산 검토 (10분)","relation":"의미 있는 연락 (메시지/통화)","sleep":"수면 위생 (10분 루틴)","exercise":{"start":"10분 걷기","progress":"20분 운동 세션","maintain":"25분 체력 유지"},"diet":{"pb":"채소 1인분 추가","hp":"모든 식사에 단백질 계획","lc":"정제당 피하기"},"morning":"{{area}}를 위한 AM 딥 블록 (20분)","focus":"알림 없는 세션 (15분)","stress":"4-7-8 호흡 기법","accountability":"친구/코치와 체크인 (5분)"}},
    "career":{"habit":{"focus":"{{m}}분 집중 블록"}},
    "remark":{"privacy":"답변은 비공개로 저장됩니다."}
  },
  "common.back":"뒤로"
} };
const ar = { translation: {
  "dashboard.hero.powered_by":"تعلّم وأنشئ وابحث باستخدام عدة أنظمة ذكاء اصطناعي",
  "auth.promo.subscribe":"سجل مجاناً",
  "auth.promo.trial":"جرب المنصة 7 أيام",
  "auth.promo.nocard":"بدون بطاقة ائتمان",
  "dashboard.hero.rotating":[
    "تعلّم وأنشئ وابحث باستخدام عدة أنظمة ذكاء اصطناعي."
  ],
  "plans.cards":{
    "trial":{"name":"تجريبي","price":"مجاني","period":"تجربة 7 أيام","features":["15 إجراء/يوم","تنسيق عدة أنظمة ذكاء اصطناعي","أدوات أساسية","دعم المجتمع"],"limitations":["ميزات محدودة","لا تصدير","لا وصول إلى Deep Research","تنتهي بعد 7 أيام"]},
    "pro":{"name":"Pro","period":"شهريًا","features":["25 سؤال (مدى الحياة)","300 إجراء/يوم","وصول إلى عدة أنظمة ذكاء اصطناعي","معظم الأدوات مفتوحة","معالجة أولوية"],"limitations":["Deep Research محدود","لا إجراءات غير محدودة"]},
    "pro_plus":{"name":"Pro+","period":"شهريًا","features":["50 سؤال (مدى الحياة)","إجراءات غير محدودة","Deep Research كاملة","كل الأدوات مفتوحة","دعم أولوية 24/7"],"limitations":[]}
  },
  "plans.popular":"الأكثر شعبية","plans.current":"الخطة الحالية","plans.select":"اختر الخطة","plans.paypal.success":"اكتملت الاشتراك! المعرّف: ","plans.trial_active":"تجريبي مُفعل",
  "dashboard.cta.life_director":"خطة شخصية بالذكاء الاصطناعي","dashboard.cta.study_tutor":"مدرس دراسة بالذكاء الاصطناعي","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"تواصل حسب الاهتمامات","dashboard.cta.propose_ideas":"أفكار ومشاريع","dashboard.cta.mass_control":"ذكاء اصطناعي للأثر المجتمعي",
  "dashboard.desc.life_director":"تدريب شخصي بالذكاء الاصطناعي","dashboard.desc.study_tutor":"تعلم تكيفي ذكي","dashboard.desc.create_project":"تطوير كامل مُوجّه","dashboard.desc.deepweb":"بحث أكاديمي عميق","dashboard.desc.connect_people":"شبكة معرفة تعاونية","dashboard.desc.propose_ideas":"مولّد فرص","dashboard.desc.mass_control":"أثر اجتماعي بنّاء",
  "dashboard.quick.prompts.life_director":"تصرّف كمدرّب حياة شخصي لي...","dashboard.quick.prompts.study_tutor":"كن مُعلّمي الشخصي...","dashboard.quick.prompts.deepweb":"وصّلني بمعلومات أكاديمية وقانونية عميقة...","dashboard.quick.prompts.connect_people":"ساعدني في العثور على أشخاص يشاركونني الاهتمامات والتواصل معهم.","dashboard.quick.prompts.propose_ideas":"ولّد أفكارًا مبتكرة لمشاريع أو أعمال...",
  "dashboard.meta.title":"استجابة ميتا من {{count}} ذكاءات","dashboard.meta.confidence":"ثقة","dashboard.meta.queried_ais":"الذكاءات المستعلَمة:","dashboard.meta.more":"+{{count}} المزيد...","dashboard.meta.specialized_ais":"{{count}} ذكاءات متخصصة","dashboard.meta.categories":"الفئات","dashboard.meta.general":"عام",
  "dashboard.welcome.title":"مرحبًا، {{name}}!","dashboard.welcome.body":"أنت متصل بأكثر شبكة ذكاء اصطناعي تقدمًا...","dashboard.welcome.precision.title":"الدقة","dashboard.welcome.precision.desc":"إجابات مُتحقَّقة من عدة ذكاءات","dashboard.welcome.speed.title":"السرعة","dashboard.welcome.speed.desc":"معالجة متوازية لإجابات سريعة","dashboard.welcome.intelligence.title":"الذكاء","dashboard.welcome.intelligence.desc":"تركيب معرفة متعدد المجالات",
  "dashboard.trial.title":"أنت تستخدم 8% فقط من القوة الحقيقية لـ IntelliVerseOne","dashboard.trial.body":"افتح وصولًا كاملًا إلى أدوات مميزة وميزات ذكاء اصطناعي متقدمة.","dashboard.trial.view_plans":"عرض الخطط المميزة","dashboard.trial.continue":"متابعة التجربة ({{days}} يومًا)",
  "dashboard.stats.today":"استفسارات اليوم","dashboard.stats.accuracy":"الدقة",
  "dashboard.quick_actions.title":"إجراءات سريعة",
  "dashboard.quick_actions.subtitle":"استكشف قدرات IntelliVerseOne",
  "dashboard.quick_actions.unlock_title":"افتح كامل الإمكانات",
  "dashboard.quick_actions.unlock_desc":"الوصول إلى جميع الأدوات والميزات المميزة",
  "prompt.suggestions.title":"💡 اقتراحات ذكية:","prompt.suggestions.1":"كيف أحسن إنتاجيتي الشخصية؟","prompt.suggestions.2":"اشرح أكثر خوارزميات الفرز كفاءة","prompt.suggestions.3":"أفكار لمشروع React","prompt.suggestions.4":"استراتيجيات التسويق الرقمي لعام 2024","prompt.suggestions.5":"اتجاهات الذكاء الاصطناعي","prompt.suggestions.6":"كيف أبني شركة ناشئة ناجحة خطوة بخطوة",
  "prompt.process.analyzing":"🔍 تحليل طلبك...","prompt.process.selecting":"🧠 اختيار ذكاءات متخصصة...","prompt.process.querying":"⚡ استعلام الشبكة...","prompt.process.synthesizing":"🔄 تركيب الإجابات...","prompt.process.optimizing":"✨ تحسين الاستجابة الميتا...",
  "prompt.placeholder.trial":"اطرح سؤالك... (المتبقي اليوم: 8/10)","prompt.placeholder.default":"اطرح سؤالك على أكثر من 120 ذكاءً اصطناعيًا...",
  "prompt.placeholder.search":"ابحث عن معلومات محددة...",
  "prompt.search.mode":"وضع البحث",
  "prompt.search.truncated":"تم اقتطاع النص (حد وضع البحث)",
  "prompt.attach.limit_files":"تم بلوغ الحد الأقصى للملفات",
  "prompt.attach.file_too_big":"ملف كبير جداً (60KB حد أقصى): ",
  "prompt.attach.total_too_big":"تجاوز الحد الإجمالي للمرفقات",
  "prompt.attach.unsupported_now":"صيغة ستُدعم قريباً (تتطلب وضع السحابة): ",
  "prompt.attach.unsupported":"صيغة غير مدعومة: ",
  "prompt.attach.read_error":"خطأ في القراءة: ",
  "prompt.attach.remove":"إزالة المرفق",
  "prompt.voice.recording":"جارٍ تسجيل الصوت... (60 ثانية كحد أقصى)",
  "prompt.voice.unsupported":"هذا المتصفح لا يدعم التعرف على الصوت.",
  "prompt.actions.Adjuntar archivo":"إرفاق ملف","prompt.actions.Búsqueda avanzada":"بحث متقدم","prompt.actions.Voz a texto":"صوت إلى نص","prompt.actions.Prompt inteligente":"مِحفّز ذكي",
  "prompt.status.querying":"جارٍ الاستعلام...","prompt.status.optimizing":"جارٍ التحسين...","prompt.cta.consult_ais":"استشر {{count}} ذكاءات","prompt.trial.info":"الخطة المجانية: {{days}} يومًا متبقيًا •","prompt.trial.upgrade":"قم بالترقية لاستفسارات غير محدودة",
  "common.ok":"حسنًا","common.sending":"جارٍ الإرسال...","common.sent":"تم الإرسال","common.error":"خطأ","common.send":"إرسال","common.close":"إغلاق","common.cancel":"إلغاء","common.loading":"جارٍ التحميل...",
  "auth.login":"تسجيل الدخول","auth.signup":"إنشاء حساب مجاني","auth.password":"كلمة المرور","auth.forgot":"هل نسيت كلمة المرور؟","auth.continue":"متابعة","auth.magic_short":"رابط سحري","auth.check_email":"تحقق من بريدك لتأكيد حسابك","auth.reset":"إعادة تعيين كلمة المرور","auth.resend":"إعادة الإرسال",
  "time.just_now":"الآن","time.minutes_ago":"قبل {{count}} دقيقة","time.hours_ago":"قبل {{count}} ساعة","time.days_ago":"قبل {{count}} يوم",
  "auth.with.google":"تابع باستخدام Google","auth.with.apple":"تابع باستخدام Apple","auth.with.microsoft":"تابع باستخدام Microsoft","auth.with.facebook":"تابع باستخدام Facebook","auth.with.github":"تابع باستخدام GitHub","auth.with.linkedin":"تابع باستخدام LinkedIn","auth.or":"أو","auth.legal":"بالمتابعة فإنك توافق على","auth.terms":"الشروط","auth.and":"و","auth.privacy":"الخصوصية","auth.errors.social":"تعذر تسجيل الدخول عبر المزود المحدد","auth.protected_route":"صفحة محمية: يرجى تسجيل الدخول",
  "auth.email":"البريد الإلكتروني","auth.remember_me":"تذكرني","auth.magic.send":"إرسال الرابط","auth.magic.resend_btn":"إعادة الإرسال","auth.magic.resend_in":"إعادة الإرسال ({{s}})","auth.logged_in":"تم تسجيل الدخول","auth.password.requirements_failed":"كلمة المرور لا تستوفي المتطلبات","auth.reset.sent_conditional":"إذا كان الحساب موجودًا فقد أرسلنا رسالة لإعادة التعيين.","auth.verification.unverified":"بريدك غير مُؤكد.","auth.verification.resent":"أُعيد إرسال رسالة التأكيد.","auth.errors.login_failed":"فشل تسجيل الدخول","auth.errors.signup_failed":"فشل التسجيل","auth.errors.magic_failed":"تعذّر إرسال الرابط","auth.errors.resend_failed":"تعذّرت إعادة الإرسال",
  "auth.env.missing":"لم يتم اكتشاف متغيرات Supabase. عرّف REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY أو VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY ثم أعد تشغيل الخادم.",
  "sidebar.dashboard":"لوحة التحكم","sidebar.new_chat":"دردشة جديدة","sidebar.new_project":"مشروع جديد","sidebar.history":"السجل","sidebar.tools":"الأدوات","sidebar.my_gpts":"نماذجي GPT","sidebar.plans":"الخطط","sidebar.my_profile":"ملفي الشخصي","sidebar.days_left":"{{count}} يومًا متبقيًا",
  "pages.plans.title":"الخطط والأسعار","pages.plans.subtitle":"اختر الخطة المناسبة لاستخدام كامل إمكانات IntelliVerseOne","pages.plans.stats.ais":"الذكاء الاصطناعي المتاح","pages.plans.stats.tools":"الأدوات","pages.plans.stats.availability":"التوفر","pages.plans.compare":"مقارنة تفصيلية","pages.plans.trial_expiring":"تنتهي الفترة التجريبية خلال {{days}} يومًا","pages.plans.trial_expiring_hint":"قم بالترقية الآن للحفاظ على الوصول الكامل","pages.plans.trial_expired_ago":"انتهت الفترة التجريبية منذ {{days}} يومًا","plans.cta.start_pro":"بدء خطة Pro","plans.cta.go_pro_plus":"الانتقال إلى Pro+","pages.plans.view_plans":"عرض الخطط",
  "pages.faq.title":"الأسئلة الشائعة","pages.faq.q.change_anytime":"هل يمكنني تغيير الخطة في أي وقت؟","pages.faq.a.change_anytime":"نعم، يمكنك الترقية أو التخفيض في أي وقت وتُطبق التغييرات فورًا.","pages.faq.q.free_includes":"ماذا تتضمن الخطة المجانية؟","pages.faq.a.free_includes":"وصول أساسي إلى 5 ذكاءات، و10 استفسارات يوميًا، وأدوات أساسية لمدة 7 أيام.","pages.faq.q.annual_discounts":"هل توجد خصومات للدفع السنوي؟","pages.faq.a.annual_discounts":"نعم، شهران مجانًا عند الدفع السنوي.","pages.faq.q.payment_methods":"ما طرق الدفع المقبولة؟","pages.faq.a.payment_methods":"البطاقات وPayPal والتحويلات البنكية.","pages.faq.q.cancel_anytime":"هل يمكنني الإلغاء في أي وقت؟","pages.faq.a.cancel_anytime":"نعم، يمكنك الإلغاء دون عقوبات.","pages.faq.q.support":"هل تقدمون دعمًا فنيًا؟","pages.faq.a.support":"نعم، جميع الخطط تتضمن دعمًا، والمدفوعة لها دعم أولوية 24/7.",
  "pages.history.title":"سجل المحادثات","pages.history.subtitle":"راجع وابحث في محادثاتك السابقة",
  "pages.tools.title":"أدوات الذكاء الاصطناعي","pages.tools.subtitle":"مجموعة أدوات متكاملة مدعومة بالذكاء الاصطناعي","pages.tools.search_placeholder":"ابحث عن الأدوات...","pages.tools.empty":"لم يتم العثور على أدوات","pages.tools.empty_hint":"جرّب كلمات أخرى أو غيّر الفئة","pages.tools.more_coming":"المزيد من الأدوات قيد التطوير","pages.tools.more_coming_desc":"نضيف باستمرار أدوات جديدة لزيادة إنتاجيتك",
  "pages.projects.create_title":"إنشاء مشروع","pages.projects.step1_title":"ما نوع المشروع الذي تريد إنشاؤه؟","pages.projects.details_title":"تفاصيل المشروع","pages.projects.name_label":"اسم المشروع","pages.projects.name_ph":"مثال: ملفي الشخصي","pages.projects.desc_label":"الوصف","pages.projects.desc_ph":"صف مشروعك...","pages.projects.purpose_label":"الغرض الرئيسي","pages.projects.purpose_ph":"مثال: عرض مهاراتي","pages.projects.audience_label":"الجمهور المستهدف","pages.projects.audience_ph":"مثال: مجندو وشركات تقنية","pages.projects.summary_title":"ملخص المشروع","pages.projects.type":"النوع","pages.projects.purpose":"الغرض","pages.projects.audience":"الجمهور","pages.projects.title":"مشاريعي","pages.projects.subtitle":"أنشئ مشروعات كاملة بالذكاء الاصطناعي","pages.projects.empty":"لا توجد مشاريع بعد","pages.projects.first_project":"أنشئ أول مشروع لك بالذكاء الاصطناعي","pages.projects.unlock_title":"افتح إنشاء المشاريع","pages.projects.reached_limit":"لقد وصلت إلى حد المشاريع في خطتك. قم بالترقية للمتابعة.","pages.projects.upgrade_benefits":"أنشئ مشاريع كاملة مع Pro واحصل على تصدير متقدم مع Pro+",
  "pages.cta.boost_productivity":"هل أنت مستعد لزيادة إنتاجيتك؟","pages.cta.join_many":"انضم إلى الآلاف الذين يستفيدون من قوة الذكاء الجماعي",
  "user.plan.current":"الخطة الحالية","user.plan.trial":"تجريبي","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"ترقية الخطة",
  "goodbye.title":"تم حذف حسابك","goodbye.subtitle":"شكرًا لتجربة IntelliVerseOne.","goodbye.feedback":"إذا أردت إخبارنا بسبب المغادرة، يساعدنا ذلك على التحسين.","goodbye.contact":"اتصل بالدعم","goodbye.home":"عودة للرئيسية",
    "common.copy":"نسخ","common.coming_soon":"قريبًا","common.in_development":"قيد التطوير",
    "tools.categories.all":"الكل","tools.categories.content":"المحتوى","tools.categories.productivity":"الإنتاجية","tools.categories.analysis":"التحليل","tools.categories.social":"اجتماعي وتأثير","tools.categories.development":"التطوير",
  "plans.limitations":"القيود:",
  "plans.table.available":"الخطط المتاحة",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"مجاني",
  "plans.table.trial.features":"15 إجراء/يوم • تنسيق عدة أنظمة ذكاء اصطناعي",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/شهر",
  "plans.table.pro.features":"25 سؤال (مدى الحياة) • 300 إجراء/يوم",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/شهر",
  "plans.table.pro_plus.features":"50 سؤال (مدى الحياة) • إجراءات غير محدودة • Deep Research كاملة",
  "pages.history.search_placeholder":"ابحث في المحادثات...",
  "history.stats.conversations":"المحادثات",
  "history.stats.total_responses":"إجمالي الردود",
  "history.stats.average_rating":"التقييم المتوسط",
  "history.stats.active_days":"الأيام النشطة",
  "history.category.all":"الكل",
  "history.category.productivity":"الإنتاجية",
  "history.category.education":"التعليم",
  "history.category.development":"التطوير",
  "history.category.career":"المسار المهني",
  "history.category.finance":"التمويل",
  "history.label.responses":"ردود",
  "history.empty.title":"لم يتم العثور على محادثات",
  "history.empty.hint_search":"جرّب مصطلحات بحث أخرى",
  "history.empty.hint_empty":"ليس لديك محادثات محفوظة بعد",
  "history.empty.cta":"بدء محادثة جديدة",
  "history.smart_search.title":"بحث دلالي ذكي",
  "history.smart_search.subtitle":"قريبًا: ابحث حسب المفاهيم والسياق وليس فقط الكلمات المفتاحية",
  "history.smart_search.card.semantic_ai.title":"ذكاء اصطناعي دلالي",
  "history.smart_search.card.semantic_ai.desc":"اعثر على المحادثات حسب المعنى",
  "history.smart_search.card.auto_tagging.title":"الوسم التلقائي",
  "history.smart_search.card.auto_tagging.desc":"تصنيف تلقائي ذكي",
  "history.smart_search.card.patterns.title":"تحليل الأنماط",
  "history.smart_search.card.patterns.desc":"رؤى حول استفساراتك",
  "mygpts.title":"نماذجي GPT",
  "mygpts.subtitle":"أنشئ وأدر مساعديك الذكيين المخصصين",
  "mygpts.create_new":"إنشاء GPT جديد",
  "mygpts.stats.created":"GPTs المنشأة",
  "mygpts.stats.uses":"إجمالي الاستخدامات",
  "mygpts.stats.limit":"حد GPTs",
  "mygpts.stats.templates":"القوالب المتاحة",
  "mygpts.empty.title":"ليس لديك أي GPT بعد",
  "mygpts.empty.subtitle":"أنشئ أول مساعد ذكاء اصطناعي مخصص لك",
  "mygpts.empty.cta":"إنشاء أول GPT لي",
  "mygpts.locked.title":"افتح إنشاء GPT",
  "mygpts.locked.desc.hard":"لقد وصلت إلى حد GPT في خطتك. قم بالترقية للمتابعة.",
  "mygpts.locked.desc.info":"أنشئ ما يصل إلى 5 GPTs مخصصة مع Pro، أو غير محدود مع Pro+",
  "mygpts.locked.cta":"عرض الخطط",
  "mygpts.card.uses":"استخدامات",
  "mygpts.card.created":"تم الإنشاء",
  "mygpts.card.tone":"النبرة",
  "mygpts.card.depth":"العمق",
  "mygpts.card.style":"الأسلوب",
  "mygpts.card.use":"استخدم",
  "mygpts.creator.title":"إنشاء GPT جديد",
  "mygpts.creator.step":"الخطوة {{n}} من 4",
  "mygpts.creator.step1.title":"اختر قالبًا أساسيًا",
  "mygpts.creator.step2.title":"خصص GPT الخاص بك",
  "mygpts.creator.name.placeholder":"مثال: مساعدي الشخصي",
  "mygpts.creator.desc.placeholder":"صف ما يفعله GPT وكيف يساعد...",
  "mygpts.creator.icon":"أيقونة",
  "mygpts.creator.step3.title":"إعداد الشخصية",
  "mygpts.creator.tone.label":"نبرة التواصل",
  "mygpts.creator.tone.professional":"مهني",
  "mygpts.creator.tone.friendly":"ودود",
  "mygpts.creator.tone.casual":"غير رسمي",
  "mygpts.creator.tone.empatic":"متعاطف",
  "mygpts.creator.tone.direct":"مباشر",
  "mygpts.creator.depth.label":"عمق الإجابات",
  "mygpts.creator.depth.basic":"أساسي",
  "mygpts.creator.depth.intermediate":"متوسط",
  "mygpts.creator.depth.advanced":"متقدم",
  "mygpts.creator.depth.expert":"خبير",
  "mygpts.creator.style.label":"أسلوب التواصل",
  "mygpts.creator.style.conversational":"حواري",
  "mygpts.creator.style.structured":"منظم",
  "mygpts.creator.style.creative":"إبداعي",
  "mygpts.creator.style.analytical":"تحليلي",
  "mygpts.creator.style.reflective":"تأملي",
  "mygpts.creator.step4.title":"معاينة GPT الخاص بك",
  "mygpts.creator.preview_hint":"هل كل شيء مناسب؟ يمكنك تعديله لاحقًا.",
  "mygpts.creator.create":"إنشاء GPT",
  "mygpts.templates.tutor.name":"معلمي",
  "mygpts.templates.tutor.desc":"متخصص في التعليم والشرح",
  "mygpts.templates.emotional.name":"مرشد عاطفي",
  "mygpts.templates.emotional.desc":"دعم عاطفي ورفاه",
  "mygpts.templates.productivity.name":"إنتاجيتي",
  "mygpts.templates.productivity.desc":"تحسين وتنظيم",
  "mygpts.templates.deepweb.name":"الويب العميق",
  "mygpts.templates.deepweb.desc":"بحث أكاديمي عميق",
  "mygpts.templates.crypto.name":"أصول التشفير",
  "mygpts.templates.crypto.desc":"تحليل العملات المشفرة والبلوك تشين",
  "mygpts.templates.business.name":"استراتيجي أعمال",
  "mygpts.templates.business.desc":"استشارات واستراتيجية أعمال",
  "mygpts.sample.tutor.name":"معلمي الشخصي",
  "mygpts.sample.tutor.desc":"متخصص في تبسيط المفاهيم المعقدة",
  "mygpts.sample.productivity.name":"مساعد الإنتاجية",
  "mygpts.sample.productivity.desc":"تحسين المهام وإدارة الوقت",
  "mygpts.sample.emotional.name":"مرشد عاطفي",
  "mygpts.sample.emotional.desc":"دعم عاطفي ونصائح للصحة النفسية",
  "mygpts.sample.tone.friendly":"ودود",
  "mygpts.sample.tone.direct":"مباشر",
  "mygpts.sample.tone.empatic":"متعاطف",
  "mygpts.sample.depth.intermediate":"متوسط",
  "mygpts.sample.depth.practical":"عملي",
  "mygpts.sample.depth.deep":"عميق",
  "mygpts.sample.style.conversational":"حواري",
  "mygpts.sample.style.structured":"منظم",
  "mygpts.sample.style.reflective":"تأملي",
  "projects.types.web.name":"تطبيق ويب",
  "projects.types.web.desc":"واجهة أمامية كاملة بـ React أو Vue أو Angular",
  "projects.types.api.name":"واجهة برمجة تطبيقات (Backend)",
  "projects.types.api.desc":"خادم وقاعدة بيانات بـ Node.js أو Python",
  "projects.types.mobile.name":"تطبيق جوّال",
  "projects.types.mobile.desc":"تطبيق أصلي أو هجين",
  "projects.types.fullstack.name":"فل ستاك",
  "projects.types.fullstack.desc":"مشروع متكامل: الواجهة الأمامية + الخلفية",
  "projects.actions.download_zip":"تنزيل ZIP",
  "projects.actions.continue":"متابعة",
  "projects.actions.new_project":"مشروع جديد",
  "projects.progress":"التقدم",
  "projects.created_on":"تم الإنشاء",
  "projects.status.completed":"مكتمل",
  "projects.status.in_progress":"قيد التنفيذ",
  "projects.status.generating":"جارٍ التوليد",
  "projects.status.generating_dots":"جارٍ التوليد...",
  "projects.actions.view":"عرض",
  "projects.detail.untitled":"مشروع بدون عنوان",
  "projects.detail.loading_desc":"جارٍ جلب تفاصيل المشروع…",
  "projects.detail.no_desc":"بدون وصف",
  "projects.detail.view":"عرض",
  "projects.detail.summary":"الملخص",
  "projects.detail.actions":"إجراءات سريعة",
  "projects.detail.view_code":"عرض الكود",
  "projects.detail.activity":"النشاط",
  "projects.detail.activity_init":"تم إنشاء المشروع ووضعه في قائمة الانتظار للتوليد",
  "projects.detail.activity_ai":"يجري الذكاء الاصطناعي إعداد البنية والاعتمادات",
  "projects.detail.activity_docs":"تم تهيئة الوثائق الأساسية",
  "projects.detail.tech":"التقنيات",
  "history.sample.1.title":"كيف أحسّن إنتاجيتي الشخصية",
  "history.sample.1.preview":"أحتاج نصائح لأكون أكثر إنتاجية في عملي اليومي...",
  "history.sample.2.title":"شرح خوارزميات الفرز",
  "history.sample.2.preview":"هل يمكنك شرح خوارزميات الفرز المختلفة...",
  "history.sample.3.title":"أفكار لمشروع React",
  "history.sample.3.preview":"أبحث عن أفكار مبتكرة لمشروع React...",
  "history.sample.4.title":"نصائح لمقابلات العمل",
  "history.sample.4.preview":"لدي مقابلة مهمة الأسبوع المقبل...",
  "history.sample.5.title":"تحليل سوق العملات المشفرة",
  "history.sample.5.preview":"ما رأيك باتجاهات سوق الكريبتو الحالية...",
  "projects.mock.1.name":"ملف شخصي",
  "projects.mock.1.desc":"موقع احترافي باستخدام React وTailwind CSS",
  "projects.mock.2.name":"تطبيق المهام",
  "projects.mock.2.desc":"تطبيق لإدارة المهام مع المصادقة",
  "projects.mock.3.name":"واجهة REST للتجارة الإلكترونية",
  "projects.mock.3.desc":"خلفية كاملة لمتجر إلكتروني",
  "tools.items.emotional-translator.name":"مترجم عاطفي بالذكاء الاصطناعي",
  "tools.items.emotional-translator.description":"يترجم مع الحفاظ على النبرة والسياق العاطفي",
  "tools.items.text-reformulator.name":"معيد صياغة النصوص",
  "tools.items.text-reformulator.description":"يعيد كتابة النص مع الحفاظ على المعنى",
  "tools.items.voice-converter.name":"محول نص إلى صوت",
  "tools.items.voice-converter.description":"يحوّل النص إلى صوت طبيعي",
  "tools.items.prompt-creator.name":"منشئ المطالبات",
  "tools.items.prompt-creator.description":"ينشئ مطالبات محسّنة لأي ذكاء اصطناعي",
  "tools.items.viral-titles.name":"مولّد عناوين رائجة",
  "tools.items.viral-titles.description":"ينشئ عناوين لافتة للانتباه",
  "tools.items.audience-segmenter.name":"مجزئ الجماهير",
  "tools.items.audience-segmenter.description":"يحلّل ويجزّئ الجماهير المستهدفة",
  "tools.items.idea-repairer.name":"مكمّل الأفكار الناقصة",
  "tools.items.idea-repairer.description":"يكمل ويحسن الأفكار الجزئية",
  "tools.items.copy-pulse.name":"CopyPulse – انسخ، حسّن واطلق",
  "tools.items.copy-pulse.description":"يحلل ويحسن ويُحسّن أي محتوى",
  "tools.items.file-converter.name":"محول ملفات ذكي",
  "tools.items.file-converter.description":"يحوّل الملفات بالذكاء الاصطناعي لتحسين المحتوى",
  "tools.items.arconte-ai.name":"اتصال Arconte AI",
  "tools.items.arconte-ai.description":"وصول مباشر لأكثر الذكاءات تقدمًا",
  "tools.items.mass-control.name":"تأثير جماهيري إيجابي",
  "tools.items.mass-control.description":"أدوات للتأثير الاجتماعي البنّاء",
  "pages.not_found.title":"الصفحة غير موجودة",
  "pages.not_found.body":"يبدو أن هذه الصفحة ضاعت في متعدد الأكوان للذكاء الاصطناعي. إن 120 ذكاءً اصطناعياً تعمل على إيجادها.",
  "pages.not_found.help_title":"هل تحتاج مساعدة؟",
  "pages.not_found.help_body":"إذا كنت تعتقد أن هذا خطأ، يمكنك الاتصال بنا أو العودة إلى الصفحة الرئيسية.",
  "pages.not_found.cta_home":"🏠 العودة إلى الرئيسية",
  "pages.not_found.cta_tools":"🛠️ استكشاف الأدوات",
  "pages.not_found.link_support":"📧 الدعم",
  "pages.not_found.link_home":"🏠 الرئيسية",
  "pages.not_found.link_plans":"💎 الخطط",
  "user.panel_title":"لوحة المستخدم",
  "user.security.change_password":"تغيير كلمة المرور",
  "user.security.change_password_prompt":"كلمة مرور جديدة (8 أحرف على الأقل)",
  "user.security.password_changed":"تم تحديث كلمة المرور",
  "user.security.reset_password":"إرسال رابط إعادة التعيين",
  "user.security.reset_sent":"أرسلنا لك بريدًا إلكترونيًا لإعادة تعيين كلمة المرور",
  "user.security.title":"أمان الحساب",
  "user.security.subtitle":"إدارة بيانات الاعتماد وخيارات الأمان.",
  "user.security.password":"كلمة المرور",
  "user.security.password_hint":"استخدم كلمة مرور طويلة وفريدة. المصادقة الثنائية قادمة قريبًا.",
  "user.security.email_hint":"إذا غيّرت بريدك الإلكتروني، يجب التحقق منه قبل الاستخدام.",
  "user.security.password_error":"تعذّر تحديث كلمة المرور",
  "user.security.password_placeholder":"كلمة مرور جديدة آمنة",
  "user.security.change_password_title":"تحديث كلمة المرور",
  "user.security.change_password_action":"تحديث",
  "user.security.cancel":"إلغاء",
  "user.security.password_min":"8 أحرف على الأقل",
  "user.security.logout":"تسجيل الخروج",
  "user.security.delete_account_btn":"حذف الحساب",
  "user.security.delete_account":"حذف الحساب",
  "user.security.delete_account_desc":"هذا الإجراء دائم. ستفقد مشاريعك وGPTs والبيانات المرتبطة.",
  "user.security.delete_account_type":"اكتب حذف للتأكيد:",
  "user.security.delete_account_confirm":"حذف نهائياً",
  "user.security.delete_account_done":"تم إرسال طلب الحذف. سنخطرك عبر البريد الإلكتروني.",
  "user.security.delete_account_signout":"تم تسجيل الخروج. لإتمام الحذف، قم بتهيئة الـ webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL.",
  "trial.expired.title":"انتهت فترة تجربتك المجانية لمدة 7 أيام!",
  "trial.expired.body":"لقد جربت القوة الكاملة لـ IntelliVerseOne. للاستمرار في استخدام {{feature}}، اختر خطتك.",
  "trial.expired.stats_title":"🎉 خلال فترة التجربة جربت:",
  "trial.expired.stat_ias":"ذكاءات اصطناعية استشرتها",
  "trial.expired.stat_functionality":"وظائف كاملة",
  "trial.expired.stat_projects":"مشاريع أنشأتها",
  "trial.expired.stat_costs":"تكاليف مخفية",
  "trial.expired.pro_plus_label":"🚀 خطة Pro+ - 9.79$/شهر",
  "trial.expired.pro_plus_desc":"وظائف كاملة + أولوية + وسائط متعددة بالذكاء الاصطناعي",
  "trial.expired.pro_label":"⭐ خطة Pro - 5.79$/شهر",
  "trial.expired.pro_desc":"مثالية للاستخدام الكامل والمهني",
  "trial.expired.free_option":"أو استمر بوظائف محدودة:",
  "trial.expired.free_plan_title":"🆓 الخطة المجانية (محدودة):",
  "trial.expired.free_blocked":"الوصول محظور بالكامل",
  "trial.expired.free_no_ias":"لا استشارات للذكاء الاصطناعي",
  "trial.expired.free_no_premium":"لا وظائف مميزة",
  "trial.expired.free_history_only":"عرض السجل السابق فقط",
  "trial.expired.continue_free":"الاستمرار بالخطة المجانية",
  "trial.expired.benefits":"✨ ضمان 30 يوماً • 🔒 إلغاء في أي وقت • 💰 أسعار عادلة",
  "notifications.welcome.activated":"🚀 تم تفعيل IntelliVerseOne - أكثر من 120 ذكاءً اصطناعياً جاهز للاستشارة",
  "notifications.welcome.optimized":"🧠 نظام Meta-AI مُحسَّن لأقصى دقة",
  "notifications.welcome.new_features":"⚡ ميزات جديدة متاحة - استكشف الأدوات",
  "chat.error.auth":"غير مصادق عليه. يرجى تسجيل الدخول للمتابعة.",
  "chat.error.quota":"تم الوصول إلى الحد اليومي للاستعلامات. قم بترقية خطتك.",
  "chat.error.timeout":"انتهت مهلة الطلب. يرجى المحاولة مجدداً.",
  "chat.error.server":"خطأ في الخادم. يرجى المحاولة لاحقاً.",
  "chat.error":"حدث خطأ. يرجى المحاولة مجدداً.",
  "chat.placeholder.answer":"إجابة الذكاء الاصطناعي...",
  "history.auto.title":"محادثة {{date}}",
  "history.actions.confirm":"حذف هذه المحادثة?",
  "stats.ias":"الذكاء الاصطناعي المستشار",
  "stats.remaining":"المتبقي اليوم",
  "stats.accuracy":"الدقة",
  "prompt.actions.search":"بحث",
  "prompt.actions.voice":"صوت",
  "prompt.actions.suggest":"اقترح",
  "prompt.actions.attach":"إرفاق",
  "prompt.cta.consult_ias":"استشر {{count}} ذكاءات",
  "prompt.remaining":"المتبقي",
  "prompt.placeholder.expired":"انتهت الفترة التجريبية —",
  "prompt.placeholder.limit":"تم الوصول للحد —",
  "prompt.trial.expired_msg":"انتهت فترتك التجريبية. اختر خطة للمتابعة.",
  "prompt.trial.choose_plan":"اختر خطة",
  "prompt.search.active":"وضع البحث نشط",
  "prompt.voice.no_mic":"لا يمكن الوصول للميكروفون",
  "prompt.limit.exceeded":"تم الوصول لحد الاستعلامات",
  "prompt.trial.expired":"انتهت الفترة التجريبية",
  "auth.logout":"تسجيل الخروج",
  "mygpts.updated":"تم تحديث GPT",
  "mygpts.created":"تم إنشاء GPT بنجاح",
  "mygpts.error.save":"خطأ في الحفظ",
  "mygpts.creator.title_new":"إنشاء GPT جديد",
  "mygpts.creator.title_edit":"تعديل GPT",
  "tools.copy_empty":"هذا الأداة ليس لديها نص للنسخ",
  "tools.copy_ok":"تم نسخ الطلب إلى الحافظة",
  "tools.copy_fail":"تعذر النسخ. حاول مرة أخرى.",
  "tools.copy_tooltip":"نسخ الطلب إلى الحافظة",
  "tools.run_tooltip":"تشغيل الأداة بالذكاء الاصطناعي",
  "common.run":"تشغيل",
  "plans.paypal.error":"حدث خطأ في الدفع. حاول مجدداً.",
  "plans.paypal.cancel":"تم إلغاء الدفع من قِبَل المستخدم.",
  "plans.paypal.required":"لتفعيل هذه الخطة، يجب إتمام الدفع عبر PayPal.",
  "plans.cancel.confirm":"هل أنت متأكد من رغبتك في إلغاء اشتراكك؟ ستحتفظ بالوصول حتى نهاية الفترة المدفوعة.",
  "plans.cancel.no_auth":"لا توجد جلسة نشطة. يرجى تسجيل الدخول مجدداً.",
  "plans.cancel.error":"خطأ في الإلغاء. حاول مجدداً أو تواصل مع الدعم.",
  "plans.cancel.success":"تم إلغاء الاشتراك! ستحتفظ بالوصول حتى {{date}}.",
  "user.connections.title":"اتصالات الحساب",
  "user.connections.hint":"اربط مزودي الخدمة لتتمكن من تسجيل الدخول بأي منهم.",
  "projects.generated_success":"تم إنشاء المشروع! يمكنك الآن تنزيل ZIP.",
  "projects.wizard.mvp_includes":"سيتضمن مشروع MVP الخاص بك:",
  "projects.wizard.gen.structure_mvp":"هيكل المشروع الأساسي",
  "projects.wizard.gen.starter":"ملفات بداية وظيفية",
  "projects.wizard.gen.readme":"README مع تعليمات",
  "projects.wizard.gen.config":"الإعداد الأولي",
  "projects.wizard.mvp_note":"قم بتنزيل ZIP وتخصيص الكود حسب رغبتك",
  "projects.actions.generating":"جارِ الإنشاء...",
  "common.login_required":"يرجى تسجيل الدخول للمتابعة",
  "common.reset":"إعادة تعيين",
  "share.copied":"تم نسخ الرابط: ",
  "limits.share_pro":"المشاركة تتطلب خطة Pro أو أعلى.",
  "life_coach":{
    "common":{"select":"اختر…","selected_count":"{{count}} محددة","other":"أخرى","other_ph":"صف خياراً آخر"},
    "hero":{"title":"خطة شخصية بالذكاء الاصطناعي","subtitle":"خطة يومية مخصصة لتنظيم الأولويات والعادات والخطوات التالية."},
    "stats":{"areas":"المجالات المختارة","habits":"إجمالي العادات","remaining":"إجراءات متبقية اليوم"},
    "form":{"title":"تركيزك في الحياة","areas_label":"المجالات ذات الأولوية","daily_time":"الوقت اليومي المتاح","emotions_label":"كيف تشعر بشكل عام","emotions.low":"منخفض","emotions.medium":"متوسط","emotions.high":"عالٍ","motivation":"ما الذي يحفزك الآن؟","motivation_ph":"صف دوافعك","routine":"كيف هو روتينك؟","routine_ph":"صفه باختصار","constraints":"قيود أو تحديات (اختياري)","sleep_hours":"ساعات النوم","sleep":{"less6":"أقل من 6","6_7":"6-7","7_8":"7-8","more8":"أكثر من 8"},"exercise_freq":"تكرار التمرين","exercise":{"never":"لا شيء","1_2":"1-2 مرات/أسبوع","3_4":"3-4 مرات/أسبوع","more4":"أكثر من 4/أسبوع"},"diet_focus":"التركيز الغذائي","diet":{"balanced":"متوازن","high_protein":"بروتين عالٍ","low_carb":"منخفض الكربوهيدرات","plant_based":"نباتي"},"stress_level":"مستوى التوتر","level":{"low":"منخفض","medium":"متوسط","high":"عالٍ"},"productivity_peak":"ذروة الإنتاجية","daytime":{"morning":"الصباح","afternoon":"بعد الظهر","evening":"المساء"},"reminder_time":"وقت التذكير المفضل","distractions":"المشتتات الرئيسية","learning_goal":"هدف التعلم","learning_goal_ph":"ماذا تريد أن تتعلم؟","financial_goal":"الهدف المالي","financial_goal_ph":"مثلاً: توفير X، سداد ديون","relationship_goal":"هدف العلاقات","relationship_goal_ph":"عائلة، شريك، أصدقاء","weekend_routine":"روتين عطلة نهاية الأسبوع","weekend_routine_ph":"الأنشطة المعتادة","accountability":{"label":"المسؤولية","solo":"بمفردي","buddy":"مع رفيق","coach":"مع مدرب"},"comm_style":"أسلوب التواصل","comm":{"concise":"موجز","detailed":"مفصّل","motivational":"تحفيزي"}},
    "area":{"health":"الصحة","career":"المهنة","finance":"المال","relationships":"العلاقات","personal":"النمو الشخصي"},
    "motivation":{"health":"تحسين الصحة","career":"النمو المهني","balance":"توازن العمل والحياة","learn":"تعلم مهارة","finance":"تحسين الوضع المالي","emotional":"الرفاه العاطفي","consistency":"الاتساق","project":"مشروع شخصي","exam":"التحضير لامتحان/شهادة","stress":"تخفيف التوتر"},
    "routine":{"office":"مكتب 9-5","remote":"عن بُعد مرن","student":"طالب","shift":"وردية/متناوبة","entrepreneur":"رائد أعمال","caretaker":"مقدم رعاية","night":"ليلي","parent":"والد/والدة مع أطفال","variable":"متغير جداً"},
    "constraints":{"time":"نقص الوقت","stress":"التوتر/القلق","health":"الصحة الجسدية","finance":"الماليات","family":"الأسرة/الرعاية","environment":"البيئة/المساحة","sleep":"نوم غير منتظم","motivation":"دوافع منخفضة","tech":"التقنية/المعدات"},
    "distractions":{"social":"وسائل التواصل الاجتماعي","notifs":"الإشعارات","chat":"المراسلة","noise":"الضوضاء المحيطة","multitask":"تعدد المهام","phone":"الهاتف","fatigue":"الإرهاق","perfect":"الكمالية","procrast":"التسويف","family":"مقاطعات الأسرة","tv":"التلفزيون/الألعاب"},
    "learning":{"languages":"اللغات","programming":"البرمجة","dataai":"البيانات/الذكاء الاصطناعي","marketing":"التسويق","sales":"المبيعات","personal_finance":"التمويل الشخصي","music":"الموسيقى","design":"الفن/التصميم","cert":"الامتحانات/الشهادات","softskills":"المهارات الناعمة"},
    "finance":{"emergency":"صندوق الطوارئ","pay_debt":"سداد الديون","cut_expenses":"خفض النفقات","increase_income":"زيادة الدخل","invest":"الاستثمار","buy_house":"شراء منزل/سيارة","save_trip":"الادخار للسفر/الدراسة","credit_score":"تحسين التصنيف الائتماني"},
    "relation":{"communication":"تحسين التواصل","family_time":"مزيد من وقت العائلة","partner":"تقوية العلاقة","friends":"إيجاد أصدقاء جدد","network":"التواصل المهني","conflict":"حل النزاع","boundaries":"وضع حدود صحية"},
    "weekend":{"rest":"راحة","family":"عائلة","sport":"رياضة/نشاط","social":"اجتماعي","creative":"إبداعي/هواية","chores":"أعمال منزلية","study":"دراسة/مشروع","travel":"سفر"},
    "cta":{"generate":"إنشاء الخطة","regenerate":"إعادة الإنشاء","refine_area":"تحسين المجال"},
    "plan":{"title":"خطتك في الحياة","progress":"التقدم","weekly_goals":"الأهداف الأسبوعية","monthly_goals":"الأهداف الشهرية","habits":"العادات"},
    "module":{"reminders":"تذكيرات ذكية","feedback":"تقييم أسبوعي"},
    "reminders":{"active":"ستتلقى تذكيرات يومية وأسبوعية مخصصة.","locked":"متاح في Pro+. افتح التذكيرات التلقائية والمخصصة."},
    "feedback":{"active":"ستتلقى تحليلاً أسبوعياً مع توصيات مخصصة.","locked":"متاح في Pro+. احصل على تقرير أسبوعي مع اقتراحات التحسين."},
    "errors":{"areas":"اختر مجالاً واحداً على الأقل.","limit":"لقد وصلت إلى حدك اليومي."},
    "copy":{"m1":"أنا هنا لمساعدتك في بناء أفضل نسخة منك.","m2":"اليوم يمكننا أن نخطو خطوة أخرى. مستعد؟","m3":"تغييرات صغيرة، نتائج كبيرة."},
    "mock":{"goal":{"week":"أكمل 3 جلسات متعلقة بـ {{area}}","month":"حقق مرحلة رئيسية في {{area}}","learn":{"week":"ادرس {{skill}} (3 × 20 دقيقة)","month":"أكمل وحدة في {{skill}}"},"finance":{"week":"تقدم نحو: {{goal}}","month":"حقق الهدف المالي: {{goal}}"},"weekend":"نشاط عطلة نهاية الأسبوع: {{w}}","refine":"إجراء محسّن في {{area}}"},"habit":{"1":"عادة 5 دقائق في {{area}}","2":"اكتب تأملاً قصيراً عن {{area}}","learn":"تعلم {{skill}} (15 دقيقة)","budget":"راجع النفقات والميزانية (10 دقائق)","relation":"تواصل مؤثر (رسالة/مكالمة)","sleep":"نظافة النوم (روتين 10 دقائق)","exercise":{"start":"امشِ 10 دقائق","progress":"جلسة تمرين 20 دقيقة","maintain":"الحفاظ على اللياقة 25 دقيقة"},"diet":{"pb":"أضف حصة إضافية من الخضروات","hp":"خطط للبروتين في كل وجبة","lc":"تجنب السكريات المكررة"},"morning":"كتلة AM عميقة (20 دقيقة) لـ {{area}}","focus":"جلسة بدون إشعارات (15 دقيقة)","stress":"تقنية التنفس 4-7-8","accountability":"تواصل مع رفيق/مدرب (5 دقائق)"}},
    "career":{"habit":{"focus":"كتلة تركيز {{m}} دقيقة"}},
    "remark":{"privacy":"إجاباتك تُحفظ بشكل خاص."}
  },
  "common.back":"رجوع"
} };
const hi = { translation: {
  "dashboard.hero.powered_by":"कई कृत्रिम बुद्धिमत्ता प्रणालियों के साथ सीखें, बनाएँ और शोध करें",
  "auth.promo.subscribe":"मुफ़्त में साइन अप करें",
  "auth.promo.trial":"7 दिन मुफ़्त में प्लेटफ़ॉर्म आज़माएं",
  "auth.promo.nocard":"क्रेडिट कार्ड आवश्यक नहीं",
  "dashboard.hero.rotating":[
    "कई कृत्रिम बुद्धिमत्ता प्रणालियों के साथ सीखें, बनाएँ और शोध करें।"
  ],
  "plans.cards":{
    "trial":{"name":"ट्रायल","price":"नि:शुल्क","period":"7-दिवसीय ट्रायल","features":["15 क्रियाएँ/दिन","Orchestrator multiple AIs","बेसिक टूल्स","कम्युनिटी सपोर्ट"],"limitations":["सीमित सुविधाएँ","एक्सपोर्ट नहीं","Deep Research एक्सेस नहीं","7 दिनों बाद समाप्त"]},
    "pro":{"name":"Pro","period":"प्रति माह","features":["25 प्रश्न (आजीवन)","प्रतिदिन 300 क्रियाएँ","multiple AIs की पहुँच","अधिकांश टूल्स अनलॉक","प्राथमिकता प्रोसेसिंग"],"limitations":["Deep Research सीमित","अनलिमिटेड क्रियाएँ नहीं"]},
    "pro_plus":{"name":"Pro+","period":"प्रति माह","features":["50 प्रश्न (आजीवन)","असीमित क्रियाएँ","पूर्ण Deep Research","सभी टूल्स अनलॉक","24/7 प्राथमिकता सपोर्ट"],"limitations":[]}
  },
  "common.ok":"ठीक है","common.sending":"भेजा जा रहा है...","common.sent":"भेज दिया","common.error":"त्रुटि","common.send":"भेजें","common.close":"बंद करें","common.cancel":"रद्द करें","common.loading":"लोड हो रहा है...",
  "auth.login":"साइन इन करें","auth.signup":"मुफ़्त साइन अप करें","auth.password":"पासवर्ड","auth.forgot":"पासवर्ड भूल गए?","auth.continue":"जारी रखें","auth.magic_short":"मैजिक लिंक","auth.check_email":"अपना खाता पुष्टि करने के लिए ईमेल देखें","auth.reset":"पासवर्ड रीसेट करें","auth.resend":"फिर से भेजें",
  "time.just_now":"अभी","time.minutes_ago":"{{count}} मिनट पहले","time.hours_ago":"{{count}} घंटे पहले","time.days_ago":"{{count}} दिन पहले",
  "auth.with.google":"Google से जारी रखें","auth.with.apple":"Apple से जारी रखें","auth.with.microsoft":"Microsoft से जारी रखें","auth.with.facebook":"Facebook से जारी रखें","auth.with.github":"GitHub से जारी रखें","auth.with.linkedin":"LinkedIn से जारी रखें","auth.or":"या","auth.legal":"जारी रखने पर आप हमारी","auth.terms":"शर्तों","auth.and":"और","auth.privacy":"गोपनीयता","auth.errors.social":"चयनित प्रदाता से साइन इन नहीं हो सका","auth.protected_route":"सुरक्षित पेज: आगे बढ़ने के लिए साइन इन करें",
  "auth.email":"ईमेल","auth.remember_me":"मुझे याद रखें","auth.magic.send":"लिंक भेजें","auth.magic.resend_btn":"दोबारा भेजें","auth.magic.resend_in":"दोबारा भेजें ({{s}})","auth.logged_in":"साइन इन हुआ","auth.password.requirements_failed":"पासवर्ड आवश्यकताओं को पूरा नहीं करता","auth.reset.sent_conditional":"यदि खाता मौजूद है तो हमने रीसेट ईमेल भेज दिया है।","auth.verification.unverified":"आपका ईमेल सत्यापित नहीं है।","auth.verification.resent":"सत्यापन ईमेल फिर से भेजा गया।","auth.errors.login_failed":"साइन इन विफल","auth.errors.signup_failed":"साइन अप विफल","auth.errors.magic_failed":"लिंक भेजा नहीं जा सका","auth.errors.resend_failed":"दोबारा भेजा नहीं जा सका",
  "auth.env.missing":"Supabase वेरिएबल नहीं मिले। REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY या VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY सेट करें और सर्वर को रीस्टार्ट करें।",
  "sidebar.dashboard":"डैशबोर्ड","sidebar.new_chat":"नया चैट","sidebar.new_project":"नया प्रोजेक्ट","sidebar.history":"इतिहास","sidebar.tools":"टूल्स","sidebar.my_gpts":"मेरे GPTs","sidebar.plans":"प्लान","sidebar.my_profile":"मेरा प्रोफ़ाइल","sidebar.days_left":"{{count}} दिन शेष",
  "pages.plans.title":"प्लान और मूल्य","pages.plans.subtitle":"IntelliVerseOne की पूरी क्षमता अनलॉक करने के लिए सही प्लान चुनें","pages.plans.stats.ais":"उपलब्ध AI","pages.plans.stats.tools":"टूल्स","pages.plans.stats.availability":"उपलब्धता","pages.plans.compare":"विस्तृत तुलना","pages.plans.trial_expiring":"आपका मुफ्त ट्रायल {{days}} दिनों में समाप्त होगा","pages.plans.trial_expiring_hint":"पूरी पहुँच बनाए रखने के लिए अभी अपग्रेड करें","pages.plans.trial_expired_ago":"आपका मुफ्त ट्रायल {{days}} दिन पहले समाप्त हो गया","plans.cta.start_pro":"Pro प्लान शुरू करें","plans.cta.go_pro_plus":"सीधे Pro+ पर जाएँ","pages.plans.view_plans":"प्लान देखें",
  "pages.faq.title":"अक्सर पूछे जाने वाले प्रश्न","pages.faq.q.change_anytime":"क्या मैं कभी भी प्लान बदल सकता हूँ?","pages.faq.a.change_anytime":"हाँ, आप कभी भी अपग्रेड/डाउनग्रेड कर सकते हैं। बदलाव तुरंत लागू होते हैं।","pages.faq.q.free_includes":"फ्री प्लान में क्या शामिल है?","pages.faq.a.free_includes":"5 AI, 10 दैनिक क्वेरी और 7 दिनों तक आवश्यक टूल्स।","pages.faq.q.annual_discounts":"क्या वार्षिक भुगतान पर छूट है?","pages.faq.a.annual_discounts":"हाँ, वार्षिक भुगतान पर 2 महीने मुफ्त।","pages.faq.q.payment_methods":"आप कौन से भुगतान तरीके स्वीकार करते हैं?","pages.faq.a.payment_methods":"कार्ड, PayPal और बैंक ट्रांसफर।","pages.faq.q.cancel_anytime":"क्या मैं किसी भी समय रद्द कर सकता हूँ?","pages.faq.a.cancel_anytime":"हाँ, बिना पेनल्टी के कभी भी।","pages.faq.q.support":"क्या आप तकनीकी सपोर्ट देते हैं?","pages.faq.a.support":"हाँ, सभी प्लान में सपोर्ट शामिल है। भुगतान वाले प्लान में 24/7 प्राथमिकता सपोर्ट।",
  "dashboard.cta.life_director":"व्यक्तिगत AI योजना","dashboard.cta.study_tutor":"AI अध्ययन ट्यूटर","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"रुचियों से जुड़ें","dashboard.cta.propose_ideas":"विचार और परियोजनाएँ","dashboard.cta.mass_control":"सामुदायिक प्रभाव AI",
  "dashboard.desc.life_director":"व्यक्तिगत AI कोचिंग","dashboard.desc.study_tutor":"स्मार्ट अनुकूली सीख","dashboard.desc.create_project":"मार्गदर्शित पूर्ण विकास","dashboard.desc.deepweb":"गहन अकादमिक खोज","dashboard.desc.connect_people":"सहयोगी ज्ञान नेटवर्क","dashboard.desc.propose_ideas":"अवसर जनरेटर","dashboard.desc.mass_control":"रचनात्मक सामाजिक प्रभाव",
  "dashboard.quick.prompts.life_director":"मेरे पर्सनल लाइफ कोच की तरह कार्य करो...","dashboard.quick.prompts.study_tutor":"मेरा निजी ट्यूटर बनो...","dashboard.quick.prompts.deepweb":"गहरी अकादमिक व कानूनी जानकारी तक पहुँचो...","dashboard.quick.prompts.connect_people":"मिलते-जुलते रुचि वाले लोगों को ढूँढकर जोड़ो।","dashboard.quick.prompts.propose_ideas":"नवोन्मेषी प्रोजेक्ट/बिज़नेस आइडिया जनरेट करो...",
  "dashboard.meta.title":"{{count}} AI की मेटा‑प्रतिक्रिया","dashboard.meta.confidence":"विश्वास","dashboard.meta.queried_ais":"पूछे गए AI:","dashboard.meta.more":"+{{count}} और...","dashboard.meta.specialized_ais":"{{count}} विशिष्ट AI","dashboard.meta.categories":"श्रेणियाँ","dashboard.meta.general":"सामान्य",
  "dashboard.welcome.title":"स्वागत है, {{name}}!","dashboard.welcome.body":"आप सबसे उन्नत AI नेटवर्क से जुड़े हैं...","dashboard.welcome.precision.title":"सटीकता","dashboard.welcome.precision.desc":"कई AI द्वारा सत्यापित उत्तर","dashboard.welcome.speed.title":"गति","dashboard.welcome.speed.desc":"तेज़ उत्तरों के लिए समानांतर प्रोसेसिंग","dashboard.welcome.intelligence.title":"बुद्धिमत्ता","dashboard.welcome.intelligence.desc":"मल्टी‑डोमेन ज्ञान संश्लेषण",
  "dashboard.trial.title":"आप IntelliVerseOne की वास्तविक शक्ति का केवल 8% उपयोग कर रहे हैं","dashboard.trial.body":"multiple AIs, प्रीमियम टूल्स और उन्नत फीचर्स तक पूर्ण एक्सेस अनलॉक करें।","dashboard.trial.view_plans":"प्रीमियम प्लान देखें","dashboard.trial.continue":"ट्रायल जारी रखें ({{days}} दिन)",
  "dashboard.stats.today":"आज की क्वेरी","dashboard.stats.accuracy":"शुद्धता",
  "dashboard.quick_actions.title":"त्वरित क्रियाएँ",
  "dashboard.quick_actions.subtitle":"IntelliVerseOne की क्षमताएँ खोजें",
  "dashboard.quick_actions.unlock_title":"पूर्ण क्षमता अनलॉक करें",
  "dashboard.quick_actions.unlock_desc":"सभी प्रीमियम टूल्स और फीचर्स तक पहुँच",
  "prompt.suggestions.title":"💡 स्मार्ट सुझाव:","prompt.suggestions.1":"मैं अपनी व्यक्तिगत उत्पादकता कैसे बढ़ाऊँ?","prompt.suggestions.2":"सबसे कुशल सॉर्टिंग एल्गोरिद्म समझाएँ","prompt.suggestions.3":"React प्रोजेक्ट के आइडिया","prompt.suggestions.4":"2024 के लिए डिजिटल मार्केटिंग रणनीतियाँ","prompt.suggestions.5":"कृत्रिम बुद्धिमत्ता की प्रवृत्तियाँ","prompt.suggestions.6":"एक सफल स्टार्टअप बनाने के चरण",
  "prompt.process.analyzing":"🔍 आपके प्रश्न का विश्लेषण हो रहा है...","prompt.process.selecting":"🧠 विशिष्ट AI चुने जा रहे हैं...","prompt.process.querying":"⚡ नेटवर्क से क्वेरी हो रही है...","prompt.process.synthesizing":"🔄 उत्तरों का संश्लेषण...","prompt.process.optimizing":"✨ मेटा‑प्रतिक्रिया का अनुकूलन...",
  "prompt.placeholder.trial":"अपना सवाल पूछें... (आज शेष: 8/10)","prompt.placeholder.default":"AI से पूछें, शोध करें या बनाएँ...",
  "prompt.placeholder.search":"विशिष्ट जानकारी खोजें...",
  "prompt.search.mode":"खोज मोड",
  "prompt.search.truncated":"पाठ काटा गया (खोज मोड सीमा)।",
  "prompt.attach.limit_files":"अधिकतम फ़ाइल संख्या पहुँची",
  "prompt.attach.file_too_big":"फ़ाइल बहुत बड़ी (अधिकतम 60KB): ",
  "prompt.attach.total_too_big":"संलग्नकों का कुल आकार सीमा से अधिक",
  "prompt.attach.unsupported_now":"प्रारूप शीघ्र समर्थित होगा (क्लाउड मोड आवश्यक): ",
  "prompt.attach.unsupported":"असमर्थित प्रारूप: ",
  "prompt.attach.read_error":"पढ़ने में त्रुटि: ",
  "prompt.attach.remove":"संलग्नक हटाएँ",
  "prompt.voice.recording":"रिकॉर्डिंग जारी... (अधिकतम 60 सेकेंड)",
  "prompt.voice.unsupported":"यह ब्राउज़र वॉइस रिकग्निशन को सपोर्ट नहीं करता।",
  "prompt.actions.Adjuntar archivo":"फ़ाइल संलग्न करें","prompt.actions.Búsqueda avanzada":"उन्नत खोज","prompt.actions.Voz a texto":"वॉयस टू टेक्स्ट","prompt.actions.Prompt inteligente":"स्मार्ट प्रॉम्प्ट",
  "prompt.status.querying":"क्वेरी हो रही है...","prompt.status.optimizing":"अनुकूलन हो रहा है...","prompt.cta.consult_ais":"{{count}} AI से पूछें","prompt.trial.info":"फ्री प्लान: {{days}} दिन शेष •","prompt.trial.upgrade":"अनलिमिटेड क्वेरी के लिए अपग्रेड करें",
  "pages.history.title":"वार्तालाप इतिहास","pages.history.subtitle":"अपनी पिछली वार्ताओं की समीक्षा और खोज करें",
  "pages.tools.title":"AI टूल्स","pages.tools.subtitle":"कृत्रिम बुद्धिमत्ता द्वारा संचालित पूर्ण टूल सूट","pages.tools.search_placeholder":"टूल्स खोजें...","pages.tools.empty":"कोई टूल नहीं मिला","pages.tools.empty_hint":"अन्य खोज शब्द आज़माएँ या श्रेणी बदलें","pages.tools.more_coming":"और टूल्स विकासाधीन","pages.tools.more_coming_desc":"हम आपकी उत्पादकता बढ़ाने के लिए नए AI टूल्स जोड़ते रहते हैं",
  "pages.projects.create_title":"प्रोजेक्ट बनाएँ","pages.projects.step1_title":"आप किस प्रकार का प्रोजेक्ट बनाना चाहते हैं?","pages.projects.details_title":"प्रोजेक्ट विवरण","pages.projects.name_label":"प्रोजेक्ट नाम","pages.projects.name_ph":"उदा.: मेरा पर्सनल पोर्टफोलियो","pages.projects.desc_label":"विवरण","pages.projects.desc_ph":"अपने प्रोजेक्ट का वर्णन करें...","pages.projects.purpose_label":"मुख्य उद्देश्य","pages.projects.purpose_ph":"उदा.: मेरी स्किल्स दिखाना","pages.projects.audience_label":"लक्षित दर्शक","pages.projects.audience_ph":"उदा.: रिक्रूटर्स और टेक कंपनियाँ","pages.projects.summary_title":"प्रोजेक्ट सारांश","pages.projects.type":"प्रकार","pages.projects.purpose":"उद्देश्य","pages.projects.audience":"दर्शक","pages.projects.title":"मेरे प्रोजेक्ट्स","pages.projects.subtitle":"AI के साथ पूर्ण प्रोजेक्ट्स बनाएँ","pages.projects.empty":"अभी आपके कोई प्रोजेक्ट नहीं हैं","pages.projects.first_project":"अपना पहला AI प्रोजेक्ट बनाएँ","pages.projects.unlock_title":"प्रोजेक्ट निर्माण अनलॉक करें","pages.projects.reached_limit":"आप अपने प्लान की प्रोजेक्ट सीमा तक पहुँच चुके हैं। जारी रखने के लिए अपग्रेड करें।","pages.projects.upgrade_benefits":"Pro के साथ पूर्ण प्रोजेक्ट्स, Pro+ के साथ उन्नत एक्सपोर्ट",
  "pages.cta.boost_productivity":"क्या आप अपनी उत्पादकता बढ़ाने के लिए तैयार हैं?","pages.cta.join_many":"उन हजारों लोगों से जुड़ें जो सामूहिक AI का लाभ उठा रहे हैं",
  "user.plan.current":"वर्तमान प्लान","user.plan.trial":"ट्रायल","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"प्लान अपग्रेड करें",
  "goodbye.title":"आपका खाता हटा दिया गया है","goodbye.subtitle":"IntelliVerseOne आज़माने के लिए धन्यवाद।","goodbye.feedback":"यदि आप बताना चाहें कि आप क्यों जा रहे हैं, तो आपका फीडबैक हमें बेहतर बनाने में मदद करता है।","goodbye.contact":"सपोर्ट से संपर्क करें","goodbye.home":"होम पर वापस जाएँ",
    "common.copy":"कॉपी","common.coming_soon":"जल्द आ रहा है","common.in_development":"विकासाधीन",
    "tools.categories.all":"सभी","tools.categories.content":"सामग्री","tools.categories.productivity":"उत्पादकता","tools.categories.analysis":"विश्लेषण","tools.categories.social":"सामाजिक एवं प्रभाव","tools.categories.development":"डेवलपमेंट",
  "plans.limitations":"सीमाएँ:",
  "plans.table.available":"उपलब्ध प्लान",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"निःशुल्क",
  "plans.table.trial.features":"15 क्रियाएँ/दिन • Orchestrator multiple AIs",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/माह",
  "plans.table.pro.features":"25 प्रश्न (आजीवन) • प्रतिदिन 300 क्रियाएँ",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/माह",
  "plans.table.pro_plus.features":"50 प्रश्न (आजीवन) • असीमित क्रियाएँ • पूर्ण Deep Research",
  "pages.history.search_placeholder":"वार्तालापों में खोजें...",
  "history.stats.conversations":"वार्तालाप",
  "history.stats.total_responses":"कुल प्रतिक्रियाएँ",
  "history.stats.average_rating":"औसत रेटिंग",
  "history.stats.active_days":"सक्रिय दिन",
  "history.category.all":"सभी",
  "history.category.productivity":"उत्पादकता",
  "history.category.education":"शिक्षा",
  "history.category.development":"डेवलपमेंट",
  "history.category.career":"कैरियर",
  "history.category.finance":"वित्त",
  "history.label.responses":"प्रतिक्रियाएँ",
  "history.empty.title":"कोई वार्तालाप नहीं मिला",
  "history.empty.hint_search":"अन्य खोज शब्द आज़माएँ",
  "history.empty.hint_empty":"आपके पास अभी कोई सहेजी हुई वार्तालाप नहीं है",
  "history.empty.cta":"नई बातचीत शुरू करें",
  "history.smart_search.title":"स्मार्ट सिमैंटिक खोज",
  "history.smart_search.subtitle":"जल्द आ रहा है: केवल कीवर्ड नहीं, अवधारणाओं और संदर्भ से खोजें",
  "history.smart_search.card.semantic_ai.title":"सिमैंटिक AI",
  "history.smart_search.card.semantic_ai.desc":"अर्थ के आधार पर वार्तालाप खोजें",
  "history.smart_search.card.auto_tagging.title":"ऑटो-टैगिंग",
  "history.smart_search.card.auto_tagging.desc":"बुद्धिमान स्वचालित वर्गीकरण",
  "history.smart_search.card.patterns.title":"पैटर्न विश्लेषण",
  "plans.popular":"सबसे लोकप्रिय","plans.current":"वर्तमान प्लान","plans.select":"प्लान चुनें","plans.paypal.success":"सदस्यता सफल! ID: ","plans.trial_active":"ट्रायल सक्रिय",
  "history.smart_search.card.patterns.desc":"आपकी क्वेरीज़ पर इनसाइट्स",
  "mygpts.title":"मेरे GPTs",
  "mygpts.subtitle":"अपने कस्टम AI असिस्टेंट बनाएँ और प्रबंधित करें",
  "mygpts.create_new":"नया GPT बनाएँ",
  "mygpts.stats.created":"बनाए गए GPTs",
  "mygpts.stats.uses":"कुल उपयोग",
  "mygpts.stats.limit":"GPTs सीमा",
  "mygpts.stats.templates":"उपलब्ध टेम्पलेट्स",
  "mygpts.empty.title":"आपके पास अभी कोई GPT नहीं है",
  "mygpts.empty.subtitle":"अपना पहला कस्टम AI असिस्टेंट बनाएँ",
  "mygpts.empty.cta":"मेरा पहला GPT बनाएँ",
  "mygpts.locked.title":"GPT निर्माण अनलॉक करें",
  "mygpts.locked.desc.hard":"आप अपने प्लान की GPT सीमा तक पहुँच चुके हैं। जारी रखने के लिए अपग्रेड करें।",
  "mygpts.locked.desc.info":"Pro के साथ 5 तक कस्टम GPT बनाएँ, Pro+ के साथ असीमित",
  "mygpts.locked.cta":"प्लान देखें",
  "mygpts.card.uses":"उपयोग",
  "mygpts.card.created":"बनाया गया",
  "mygpts.card.tone":"स्वर",
  "mygpts.card.depth":"गहराई",
  "mygpts.card.style":"शैली",
  "mygpts.card.use":"उपयोग करें",
  "mygpts.creator.title":"नया GPT बनाएँ",
  "mygpts.creator.step":"4 में से चरण {{n}}",
  "mygpts.creator.step1.title":"एक बेस टेम्पलेट चुनें",
  "mygpts.creator.step2.title":"अपने GPT को कस्टमाइज़ करें",
  "mygpts.creator.name.placeholder":"उदा.: मेरा पर्सनल असिस्टेंट",
  "mygpts.creator.desc.placeholder":"बताएँ आपका GPT क्या करता है और कैसे मदद करता है...",
  "mygpts.creator.icon":"आइकन",
  "mygpts.creator.step3.title":"पर्सनैलिटी कॉन्फ़िगरेशन",
  "mygpts.creator.tone.label":"संचार का स्वर",
  "mygpts.creator.tone.professional":"प्रोफेशनल",
  "mygpts.creator.tone.friendly":"दोस्ताना",
  "mygpts.creator.tone.casual":"अनौपचारिक",
  "mygpts.creator.tone.empatic":"सहानुभूतिपूर्ण",
  "mygpts.creator.tone.direct":"सीधा",
  "mygpts.creator.depth.label":"उत्तर की गहराई",
  "mygpts.creator.depth.basic":"बेसिक",
  "mygpts.creator.depth.intermediate":"मध्यम",
  "mygpts.creator.depth.advanced":"उन्नत",
  "mygpts.creator.depth.expert":"विशेषज्ञ",
  "mygpts.creator.style.label":"संचार शैली",
  "mygpts.creator.style.conversational":"संवादी",
  "mygpts.creator.style.structured":"स्ट्रक्चर्ड",
  "mygpts.creator.style.creative":"रचनात्मक",
  "mygpts.creator.style.analytical":"विश्लेषणात्मक",
  "mygpts.creator.style.reflective":"चिंतनशील",
  "mygpts.creator.step4.title":"आपका GPT पूर्वावलोकन",
  "mygpts.creator.preview_hint":"सब ठीक है? आप बाद में भी GPT संपादित कर सकते हैं।",
  "mygpts.creator.create":"GPT बनाएँ",
  "mygpts.templates.tutor.name":"मेरा ट्यूटर",
  "mygpts.templates.tutor.desc":"शिक्षण और व्याख्या में विशेषज्ञ",
  "mygpts.templates.emotional.name":"भावनात्मक मार्गदर्शक",
  "mygpts.templates.emotional.desc":"भावनात्मक समर्थन और स्वास्थ्य",
  "mygpts.templates.productivity.name":"मेरी उत्पादकता",
  "mygpts.templates.productivity.desc":"सुधार और संगठन",
  "mygpts.templates.deepweb.name":"डीपवेब",
  "mygpts.templates.deepweb.desc":"गहन अकादमिक शोध",
  "mygpts.templates.crypto.name":"क्रिप्टो एसेट्स",
  "mygpts.templates.crypto.desc":"क्रिप्टोकरेंसी और ब्लॉकचेन विश्लेषण",
  "mygpts.templates.business.name":"व्यवसाय रणनीतिकार",
  "mygpts.templates.business.desc":"व्यवसाय परामर्श और रणनीति",
  "mygpts.sample.tutor.name":"मेरा निजी ट्यूटर",
  "mygpts.sample.tutor.desc":"जटिल अवधारणाओं को सरलता से समझाने में विशेषज्ञ",
  "mygpts.sample.productivity.name":"उत्पादकता सहायक",
  "mygpts.sample.productivity.desc":"कार्य अनुकूलन और समय प्रबंधन",
  "mygpts.sample.emotional.name":"भावनात्मक मार्गदर्शक",
  "mygpts.sample.emotional.desc":"भावनात्मक समर्थन और मानसिक स्वास्थ्य टिप्स",
  "mygpts.sample.tone.friendly":"दोस्ताना",
  "mygpts.sample.tone.direct":"सीधा",
  "mygpts.sample.tone.empatic":"सहानुभूतिपूर्ण",
  "mygpts.sample.depth.intermediate":"मध्यम",
  "mygpts.sample.depth.practical":"व्यावहारिक",
  "mygpts.sample.depth.deep":"गहरा",
  "mygpts.sample.style.conversational":"संवादी",
  "mygpts.sample.style.structured":"स्ट्रक्चर्ड",
  "mygpts.sample.style.reflective":"चिंतनशील",
  "projects.types.web.name":"वेब एप्लिकेशन",
  "projects.types.web.desc":"React, Vue या Angular के साथ पूरा फ्रंटएंड",
  "projects.types.api.name":"API बैकएंड",
  "projects.types.api.desc":"Node.js या Python से सर्वर और डेटाबेस",
  "projects.types.mobile.name":"मोबाइल ऐप",
  "projects.types.mobile.desc":"नेेटिव या हाइब्रिड ऐप",
  "projects.types.fullstack.name":"फुल‑स्टैक",
  "projects.types.fullstack.desc":"एंड‑टू‑एंड प्रोजेक्ट: फ्रंटएंड + बैकएंड",
  "projects.actions.download_zip":"ZIP डाउनलोड करें",
  "projects.actions.continue":"जारी रखें",
  "projects.actions.new_project":"नया प्रोजेक्ट",
  "projects.progress":"प्रगति",
  "projects.created_on":"निर्मित",
  "projects.status.completed":"पूर्ण",
  "projects.status.in_progress":"प्रगति पर",
  "projects.status.generating":"जनरेट हो रहा है",
  "projects.status.generating_dots":"जनरेट हो रहा है...",
  "projects.actions.view":"देखें",
  "projects.detail.untitled":"बिना शीर्षक का प्रोजेक्ट",
  "projects.detail.loading_desc":"प्रोजेक्ट विवरण लाए जा रहे हैं…",
  "projects.detail.no_desc":"विवरण नहीं",
  "projects.detail.view":"देखें",
  "projects.detail.summary":"सारांश",
  "projects.detail.actions":"त्वरित क्रियाएँ",
  "projects.detail.view_code":"कोड देखें",
  "projects.detail.activity":"गतिविधि",
  "projects.detail.activity_init":"प्रोजेक्ट बनाया गया और जेनरेशन के लिए कतारबद्ध",
  "projects.detail.activity_ai":"AI संरचना और निर्भरताएँ तैयार कर रहा है",
  "projects.detail.activity_docs":"बेस डॉक्यूमेंटेशन प्रारंभ किया गया",
  "projects.detail.tech":"प्रौद्योगिकियाँ",
  "history.sample.1.title":"अपनी व्यक्तिगत उत्पादकता कैसे बढ़ाऊं",
  "history.sample.1.preview":"दैनिक काम में अधिक उत्पादक बनने के लिए सुझाव चाहिए...",
  "history.sample.2.title":"सॉर्टिंग एल्गोरिदम की व्याख्या",
  "history.sample.2.preview":"क्या आप अलग‑अलग सॉर्टिंग एल्गोरिदम समझा सकते हैं...",
  "history.sample.3.title":"React प्रोजेक्ट के लिए आइडियाज़",
  "history.sample.3.preview":"मैं React प्रोजेक्ट के लिए नए आइडियाज़ ढूंढ रहा/रही हूँ...",
  "history.sample.4.title":"जॉब इंटरव्यू के लिए टिप्स",
  "history.sample.4.preview":"अगले सप्ताह मेरा एक महत्वपूर्ण इंटरव्यू है...",
  "history.sample.5.title":"क्रिप्टोकरेंसी बाज़ार विश्लेषण",
  "history.sample.5.preview":"मौजूदा क्रिप्टो बाजार रुझानों पर आपकी क्या राय है...",
  "projects.mock.1.name":"पर्सनल पोर्टफोलियो",
  "projects.mock.1.desc":"React और Tailwind CSS के साथ पेशेवर वेबसाइट",
  "projects.mock.2.name":"टास्क ऐप",
  "projects.mock.2.desc":"प्रमाणीकरण के साथ टास्क मैनेजमेंट ऐप",
  "projects.mock.3.name":"ई‑कॉमर्स REST API",
  "projects.mock.3.desc":"ऑनलाइन स्टोर के लिए पूर्ण बैकएंड",
  "tools.items.emotional-translator.name":"भावनात्मक अनुवादक (AI)",
  "tools.items.emotional-translator.description":"स्वर और भावनात्मक संदर्भ को बनाए रखते हुए अनुवाद",
  "tools.items.text-reformulator.name":"टेक्स्ट रिफॉर्मुलेटर",
  "tools.items.text-reformulator.description":"अर्थ बनाए रखते हुए पाठ को फिर से लिखे",
  "tools.items.voice-converter.name":"टेक्स्ट‑टू‑स्पीच कन्वर्टर",
  "tools.items.voice-converter.description":"पाठ को प्राकृतिक आवाज़ में बदलें",
  "tools.items.prompt-creator.name":"प्रॉम्प्ट क्रिएटर",
  "tools.items.prompt-creator.description":"किसी भी AI के लिए अनुकूलित प्रॉम्प्ट बनाएं",
  "tools.items.viral-titles.name":"वायरल शीर्षक जनरेटर",
  "tools.items.viral-titles.description":"ध्यान खींचने वाले शीर्षक बनाएं",
  "tools.items.audience-segmenter.name":"ऑडियंस सेगमेंटर",
  "tools.items.audience-segmenter.description":"लक्षित दर्शकों का विश्लेषण और विभाजन",
  "tools.items.idea-repairer.name":"आइडिया रिपेयरर",
  "tools.items.idea-repairer.description":"अधूरी विचारों को पूरा और बेहतर करें",
  "tools.items.copy-pulse.name":"CopyPulse – कॉपी, सुधारें और लॉन्च करें",
  "tools.items.copy-pulse.description":"किसी भी सामग्री का विश्लेषण, सुधार और अनुकूलन",
  "tools.items.file-converter.name":"स्मार्ट फाइल कन्वर्टर",
  "tools.items.file-converter.description":"AI के साथ फाइलें बदलें और सामग्री अनुकूलित करें",
  "tools.items.arconte-ai.name":"Arconte AI संपर्क",
  "tools.items.arconte-ai.description":"सबसे उन्नत AI तक सीधा पहुंच",
  "tools.items.mass-control.name":"सकारात्मक जन‑प्रभाव",
  "tools.items.mass-control.description":"रचनात्मक सामाजिक प्रभाव के लिए उपकरण",
  "pages.not_found.title":"पृष्ठ नहीं मिला",
  "pages.not_found.body":"लगता है यह पृष्ठ आर्टिफिशियल इंटेलिजेंस के मल्टीवर्स में खो गया। हमारे 120 AI इसे खोजने में लगे हैं।",
  "pages.not_found.help_title":"मदद चाहिए?",
  "pages.not_found.help_body":"अगर आपको लगता है यह एक गलती है, तो आप हमसे संपर्क कर सकते हैं या मुख्य पृष्ठ पर वापस जा सकते हैं।",
  "pages.not_found.cta_home":"🏠 होम पर वापस जाएं",
  "pages.not_found.cta_tools":"🛠️ टूल्स एक्सप्लोर करें",
  "pages.not_found.link_support":"📧 सहायता",
  "pages.not_found.link_home":"🏠 होम",
  "pages.not_found.link_plans":"💎 प्लान",
  "user.panel_title":"उपयोगकर्ता पैनल",
  "user.security.change_password":"पासवर्ड बदलें",
  "user.security.change_password_prompt":"नया पासवर्ड (न्यूनतम 8 अक्षर)",
  "user.security.password_changed":"पासवर्ड अपडेट हो गया",
  "user.security.reset_password":"रीसेट लिंक भेजें",
  "user.security.reset_sent":"हमने आपको पासवर्ड रीसेट करने के लिए ईमेल भेजा है",
  "user.security.title":"खाता सुरक्षा",
  "user.security.subtitle":"क्रेडेंशियल और सुरक्षा विकल्प प्रबंधित करें।",
  "user.security.password":"पासवर्ड",
  "user.security.password_hint":"लंबा और अनूठा पासवर्ड उपयोग करें। MFA जल्द आ रहा है।",
  "user.security.email_hint":"यदि आप अपना ईमेल बदलते हैं तो उपयोग से पहले उसे सत्यापित करना होगा।",
  "user.security.password_error":"पासवर्ड अपडेट नहीं हो सका",
  "user.security.password_placeholder":"नया सुरक्षित पासवर्ड",
  "user.security.change_password_title":"पासवर्ड अपडेट करें",
  "user.security.change_password_action":"अपडेट करें",
  "user.security.cancel":"रद्द करें",
  "user.security.password_min":"न्यूनतम 8 अक्षर",
  "user.security.logout":"लॉग आउट",
  "user.security.delete_account_btn":"खाता हटाएं",
  "user.security.delete_account":"खाता हटाएं",
  "user.security.delete_account_desc":"यह क्रिया स्थायी है। आप अपने प्रोजेक्ट, GPT और संबंधित डेटा खो देंगे।",
  "user.security.delete_account_type":"पुष्टि के लिए DELETE टाइप करें:",
  "user.security.delete_account_confirm":"स्थायी रूप से हटाएं",
  "user.security.delete_account_done":"हटाने का अनुरोध भेज दिया गया। हम आपको ईमेल से सूचित करेंगे।",
  "user.security.delete_account_signout":"लॉग आउट हो गए। हटाने को पूरा करने के लिए webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL कॉन्फ़िगर करें।",
  "trial.expired.title":"आपका 7-दिन का ट्रायल समाप्त हो गया!",
  "trial.expired.body":"आपने IntelliVerseOne की पूरी शक्ति का अनुभव किया है। {{feature}} का उपयोग जारी रखने के लिए, अपना प्लान चुनें।",
  "trial.expired.stats_title":"🎉 ट्रायल के दौरान आपने अनुभव किया:",
  "trial.expired.stat_ias":"परामर्श किए AI",
  "trial.expired.stat_functionality":"पूर्ण कार्यक्षमता",
  "trial.expired.stat_projects":"बनाए गए प्रोजेक्ट",
  "trial.expired.stat_costs":"छुपी हुई लागत",
  "trial.expired.pro_plus_label":"🚀 Pro+ प्लान - $9.79/माह",
  "trial.expired.pro_plus_desc":"पूर्ण कार्यक्षमता + प्राथमिकता + मल्टीमीडिया AI",
  "trial.expired.pro_label":"⭐ Pro प्लान - $5.79/माह",
  "trial.expired.pro_desc":"पूर्ण और पेशेवर उपयोग के लिए परफेक्ट",
  "trial.expired.free_option":"या सीमित कार्यक्षमता के साथ जारी रखें:",
  "trial.expired.free_plan_title":"🆓 Free प्लान (सीमित):",
  "trial.expired.free_blocked":"पहुंच पूरी तरह अवरुद्ध",
  "trial.expired.free_no_ias":"AI से कोई परामर्श नहीं",
  "trial.expired.free_no_premium":"कोई प्रीमियम सुविधाएं नहीं",
  "trial.expired.free_history_only":"केवल पिछला इतिहास देखें",
  "trial.expired.continue_free":"Free प्लान के साथ जारी रखें",
  "trial.expired.benefits":"✨ 30 दिन की गारंटी • 🔒 कभी भी रद्द करें • 💰 उचित कीमतें",
  "notifications.welcome.activated":"🚀 IntelliVerseOne सक्रिय - multiple AIs परामर्श के लिए तैयार",
  "notifications.welcome.optimized":"🧠 अधिकतम सटीकता के लिए Meta-AI सिस्टम अनुकूलित",
  "notifications.welcome.new_features":"⚡ नई सुविधाएं उपलब्ध - टूल्स एक्सप्लोर करें",
  "chat.error.auth":"प्रमाणित नहीं। जारी रखने के लिए लॉग इन करें।",
  "chat.error.quota":"दैनिक क्वेरी सीमा पूरी। अधिक के लिए अपना प्लान अपग्रेड करें।",
  "chat.error.timeout":"अनुरोध टाइमआउट। कृपया पुनः प्रयास करें।",
  "chat.error.server":"सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें।",
  "chat.error":"एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
  "chat.placeholder.answer":"AI का जवाब...",
  "history.auto.title":"बातचीत {{date}}",
  "history.actions.confirm":"इस बातचीत को हटाएं?",
  "stats.ias":"परामर्श किए AI",
  "stats.remaining":"आज शेष",
  "stats.accuracy":"सटीकता",
  "prompt.actions.search":"खोजें",
  "prompt.actions.voice":"आवाज़",
  "prompt.actions.suggest":"सुझाव",
  "prompt.actions.attach":"संलग्न",
  "prompt.cta.consult_ias":"{{count}} AI से पूछें",
  "prompt.remaining":"शेष",
  "prompt.placeholder.expired":"ट्रायल समाप्त —",
  "prompt.placeholder.limit":"सीमा पूरी —",
  "prompt.trial.expired_msg":"आपका ट्रायल समाप्त हो गया। जारी रखने के लिए प्लान चुनें।",
  "prompt.trial.choose_plan":"प्लान चुनें",
  "prompt.search.active":"खोज मोड सक्रिय",
  "prompt.voice.no_mic":"माइक्रोफ़ोन उपलब्ध नहीं",
  "prompt.limit.exceeded":"क्वेरी सीमा पूरी",
  "prompt.trial.expired":"ट्रायल समाप्त",
  "auth.logout":"साइन आउट",
  "mygpts.updated":"GPT अपडेट हो गया",
  "mygpts.created":"GPT सफलतापूर्वक बनाया गया",
  "mygpts.error.save":"सहेजने में त्रुटि",
  "mygpts.creator.title_new":"नया GPT बनाएं",
  "mygpts.creator.title_edit":"GPT संपादित करें",
  "tools.copy_empty":"इस टूल में कॉपी करने के लिए कोई टेक्स्ट नहीं है",
  "tools.copy_ok":"प्रॉम्प्ट क्लिपबोर्ड में कॉपी हो गया",
  "tools.copy_fail":"कॉपी नहीं हो सकी। पुनः प्रयास करें।",
  "tools.copy_tooltip":"प्रॉम्प्ट को क्लिपबोर्ड में कॉपी करें",
  "tools.run_tooltip":"AI से टूल चलाएं",
  "common.run":"चलाएं",
  "plans.paypal.error":"भुगतान में त्रुटि हुई। पुनः प्रयास करें।",
  "plans.paypal.cancel":"उपयोगकर्ता द्वारा भुगतान रद्द किया गया।",
  "plans.paypal.required":"इस प्लान को सक्रिय करने के लिए PayPal से भुगतान पूरा करें।",
  "plans.cancel.confirm":"क्या आप वाकई अपनी सदस्यता रद्द करना चाहते हैं? आप भुगतान की गई अवधि के अंत तक पहुंच बनाए रखेंगे।",
  "plans.cancel.no_auth":"कोई सक्रिय सत्र नहीं है। पुनः लॉगइन करें।",
  "plans.cancel.error":"रद्द करने में त्रुटि। पुनः प्रयास करें या सहायता से संपर्क करें।",
  "plans.cancel.success":"सदस्यता रद्द! आप {{date}} तक पहुंच बनाए रखेंगे।",
  "user.connections.title":"खाता कनेक्शन",
  "user.connections.hint":"किसी भी प्रदाता से लॉगइन करने के लिए उन्हें लिंक करें।",
  "projects.generated_success":"प्रोजेक्ट जनरेट हो गया! अब आप ZIP डाउनलोड कर सकते हैं।",
  "projects.wizard.mvp_includes":"आपके MVP प्रोजेक्ट में शामिल होगा:",
  "projects.wizard.gen.structure_mvp":"प्रोजेक्ट की बेस संरचना",
  "projects.wizard.gen.starter":"कार्यात्मक स्टार्टर फ़ाइलें",
  "projects.wizard.gen.readme":"निर्देशों सहित README",
  "projects.wizard.gen.config":"प्रारंभिक कॉन्फ़िगरेशन",
  "projects.wizard.mvp_note":"ZIP डाउनलोड करें और अपनी इच्छानुसार कोड कस्टमाइज़ करें",
  "projects.actions.generating":"जनरेट हो रहा है...",
  "common.login_required":"जारी रखने के लिए लॉगइन करें",
  "common.reset":"रीसेट",
  "share.copied":"लिंक कॉपी हुआ: ",
  "limits.share_pro":"शेयर करने के लिए Pro प्लान या उससे उंचे की आवश्यकता है।",
  "life_coach":{
    "common":{"select":"चुनें…","selected_count":"{{count}} चुना गया","other":"अन्य","other_ph":"दूसरा विकल्प बताएं"},
    "hero":{"title":"मैं आपकी जिंदगी को दिशा दूंगा","subtitle":"एक भावनात्मक और रणनीतिक सहयोगी जो आपके साथ हर दिन रहेगा।"},
    "stats":{"areas":"चयनित क्षेत्र","habits":"कुल आदतें","remaining":"आज के बाकी कार्य"},
    "form":{"title":"आपका जीवन फोकस","areas_label":"प्राथमिकता क्षेत्र","daily_time":"दैनिक उपलब्ध समय","emotions_label":"आप सामान्यतः कैसा महसूस करते हैं","emotions.low":"कम","emotions.medium":"मध्यम","emotions.high":"उच्च","motivation":"आपको अभी क्या प्रेरित करता है?","motivation_ph":"अपनी प्रेरणा बताएं","routine":"आपकी दिनचर्या कैसी है?","routine_ph":"संक्षेप में बताएं","constraints":"बाधाएं या चुनौतियां (वैकल्पिक)","sleep_hours":"नींद के घंटे","sleep":{"less6":"6 से कम","6_7":"6-7","7_8":"7-8","more8":"8 से अधिक"},"exercise_freq":"व्यायाम की आवृत्ति","exercise":{"never":"कभी नहीं","1_2":"सप्ताह में 1-2 बार","3_4":"सप्ताह में 3-4 बार","more4":"सप्ताह में 4 से अधिक"},"diet_focus":"आहार फोकस","diet":{"balanced":"संतुलित","high_protein":"उच्च प्रोटीन","low_carb":"कम कार्ब","plant_based":"पौधा-आधारित"},"stress_level":"तनाव स्तर","level":{"low":"कम","medium":"मध्यम","high":"उच्च"},"productivity_peak":"उत्पादकता का चरम","daytime":{"morning":"सुबह","afternoon":"दोपहर","evening":"शाम"},"reminder_time":"पसंदीदा अनुस्मारक समय","distractions":"मुख्य विकर्षण","learning_goal":"सीखने का लक्ष्य","learning_goal_ph":"आप क्या सीखना चाहते हैं?","financial_goal":"वित्तीय लक्ष्य","financial_goal_ph":"जैसे: X बचाएं, कर्ज चुकाएं","relationship_goal":"रिश्ते का लक्ष्य","relationship_goal_ph":"परिवार, साथी, दोस्त","weekend_routine":"सप्ताहांत की दिनचर्या","weekend_routine_ph":"सामान्य गतिविधियां","accountability":{"label":"जवाबदेही","solo":"अकेला","buddy":"साथी के साथ","coach":"कोच के साथ"},"comm_style":"संचार शैली","comm":{"concise":"संक्षिप्त","detailed":"विस्तृत","motivational":"प्रेरक"}},
    "area":{"health":"स्वास्थ्य","career":"करियर","finance":"वित्त","relationships":"रिश्ते","personal":"व्यक्तिगत विकास"},
    "motivation":{"health":"स्वास्थ्य सुधारें","career":"पेशेवर रूप से बढ़ें","balance":"काम-जीवन संतुलन","learn":"कौशल सीखें","finance":"वित्त सुधारें","emotional":"भावनात्मक स्वास्थ्य","consistency":"निरंतरता बनाए रखें","project":"व्यक्तिगत परियोजना","exam":"परीक्षा/प्रमाणन की तैयारी","stress":"तनाव कम करें"},
    "routine":{"office":"कार्यालय 9-5","remote":"लचीला रिमोट","student":"छात्र","shift":"शिफ्ट/रोटेटिंग","entrepreneur":"उद्यमी","caretaker":"देखभालकर्ता","night":"रात्रिकालीन","parent":"बच्चों वाले माता-पिता","variable":"बहुत परिवर्तनशील"},
    "constraints":{"time":"समय की कमी","stress":"तनाव/चिंता","health":"शारीरिक स्वास्थ्य","finance":"वित्त","family":"परिवार/देखभाल","environment":"वातावरण/स्थान","sleep":"अनियमित नींद","motivation":"कम प्रेरणा","tech":"प्रौद्योगिकी/उपकरण"},
    "distractions":{"social":"सोशल मीडिया","notifs":"सूचनाएं","chat":"संदेश","noise":"परिवेश शोर","multitask":"मल्टीटास्किंग","phone":"फोन","fatigue":"थकान","perfect":"पूर्णतावाद","procrast":"टालमटोल","family":"पारिवारिक व्यवधान","tv":"टीवी/गेम्स"},
    "learning":{"languages":"भाषाएं","programming":"प्रोग्रामिंग","dataai":"डेटा/AI","marketing":"मार्केटिंग","sales":"बिक्री","personal_finance":"व्यक्तिगत वित्त","music":"संगीत","design":"कला/डिजाइन","cert":"परीक्षा/प्रमाणन","softskills":"सॉफ्ट स्किल्स"},
    "finance":{"emergency":"आपातकालीन निधि","pay_debt":"कर्ज चुकाएं","cut_expenses":"खर्च कम करें","increase_income":"आय बढ़ाएं","invest":"निवेश करें","buy_house":"घर/वाहन खरीदें","save_trip":"यात्रा/अध्ययन के लिए बचत","credit_score":"क्रेडिट स्कोर सुधारें"},
    "relation":{"communication":"संचार सुधारें","family_time":"अधिक पारिवारिक समय","partner":"रिश्ता मजबूत करें","friends":"नए दोस्त बनाएं","network":"पेशेवर नेटवर्किंग","conflict":"विवाद सुलझाएं","boundaries":"स्वस्थ सीमाएं निर्धारित करें"},
    "weekend":{"rest":"आराम","family":"परिवार","sport":"खेल/गतिविधि","social":"सामाजिक","creative":"रचनात्मक/शौक","chores":"घर के काम","study":"अध्ययन/परियोजना","travel":"यात्रा"},
    "cta":{"generate":"योजना बनाएं","regenerate":"पुनर्जनन","refine_area":"क्षेत्र परिष्कृत करें"},
    "plan":{"title":"आपकी जीवन योजना","progress":"प्रगति","weekly_goals":"साप्ताहिक लक्ष्य","monthly_goals":"मासिक लक्ष्य","habits":"आदतें"},
    "module":{"reminders":"स्मार्ट अनुस्मारक","feedback":"साप्ताहिक प्रतिक्रिया"},
    "reminders":{"active":"आपको व्यक्तिगत दैनिक और साप्ताहिक अनुस्मारक मिलेंगे।","locked":"Pro+ में उपलब्ध। स्वचालित और व्यक्तिगत अनुस्मारक अनलॉक करें।"},
    "feedback":{"active":"आपको अनुकूलित सिफारिशों के साथ साप्ताहिक विश्लेषण मिलेगा।","locked":"Pro+ में उपलब्ध। सुधार सुझावों के साथ साप्ताहिक रिपोर्ट प्राप्त करें।"},
    "errors":{"areas":"कम से कम एक क्षेत्र चुनें।","limit":"आप अपनी दैनिक सीमा तक पहुंच गए हैं।"},
    "copy":{"m1":"मैं आपको अपना सर्वश्रेष्ठ संस्करण बनाने में मदद करने के लिए यहां हूं।","m2":"आज हम एक और कदम उठा सकते हैं। तैयार हैं?","m3":"छोटे बदलाव, बड़े परिणाम।"},
    "mock":{"goal":{"week":"{{area}} से संबंधित 3 सत्र पूरे करें","month":"{{area}} में एक महत्वपूर्ण मील का पत्थर प्राप्त करें","learn":{"week":"{{skill}} का अध्ययन करें (3×20 मिनट)","month":"{{skill}} में एक मॉड्यूल पूरा करें"},"finance":{"week":"{{goal}} की ओर आगे बढ़ें","month":"वित्तीय लक्ष्य प्राप्त करें: {{goal}}"},"weekend":"सप्ताहांत गतिविधि: {{w}}","refine":"{{area}} में परिष्कृत कार्य"},"habit":{"1":"{{area}} में 5 मिनट की आदत","2":"{{area}} के बारे में एक छोटी प्रतिबिंब लिखें","learn":"{{skill}} सीखें (15 मिनट)","budget":"खर्च और बजट की समीक्षा करें (10 मिनट)","relation":"अर्थपूर्ण संपर्क (संदेश/कॉल)","sleep":"नींद स्वच्छता (10 मिनट की दिनचर्या)","exercise":{"start":"10 मिनट चलें","progress":"20 मिनट व्यायाम सत्र","maintain":"25 मिनट फिटनेस बनाए रखें"},"diet":{"pb":"1 अतिरिक्त सब्जी सर्विंग जोड़ें","hp":"हर भोजन में प्रोटीन की योजना बनाएं","lc":"परिष्कृत शर्करा से बचें"},"morning":"{{area}} के लिए AM डीप ब्लॉक (20 मिनट)","focus":"बिना सूचनाओं के सत्र (15 मिनट)","stress":"4-7-8 श्वास तकनीक","accountability":"साथी/कोच के साथ चेक-इन (5 मिनट)"}},
    "career":{"habit":{"focus":"{{m}} मिनट फोकस ब्लॉक"}},
    "remark":{"privacy":"आपके उत्तर निजी रूप से सहेजे जाते हैं।"}
  },
  "common.back":"वापस"
} };
const ru = { translation: {
  "dashboard.hero.powered_by":"Учитесь, создавайте и исследуйте с несколькими ИИ",
  "auth.promo.subscribe":"Зарегистрируйтесь бесплатно",
  "auth.promo.trial":"Попробуйте платформу 7 дней",
  "auth.promo.nocard":"Без кредитной карты",
  "dashboard.hero.rotating":[
    "Учитесь, создавайте и исследуйте с несколькими ИИ."
  ],
  "plans.cards":{
    "trial":{"name":"Триал","price":"Бесплатно","period":"7-дневный триал","features":["15 действий/день","Оркестрация нескольких ИИ","Базовые инструменты","Поддержка сообщества"],"limitations":["Ограниченные возможности","Без экспорта","Нет доступа к Deep Research","Завершается через 7 дней"]},
    "pro":{"name":"Pro","period":"в месяц","features":["25 вопросов (пожизненно)","300 действий/день","Доступ к нескольким ИИ","Большинство инструментов разблокировано","Приоритетная обработка"],"limitations":["Ограниченный Deep Research","Нет безлимитных действий"]},
    "pro_plus":{"name":"Pro+","period":"в месяц","features":["50 вопросов (пожизненно)","Неограниченные действия","Полная Deep Research","Все инструменты разблокированы","Приоритетная поддержка 24/7"],"limitations":[]}
  },
  "plans.popular":"Самый популярный","plans.current":"Текущий тариф","plans.select":"Выбрать тариф","plans.paypal.success":"Подписка успешна! ID: ","plans.trial_active":"Триал активен",
  "dashboard.cta.life_director":"Личный AI-план","dashboard.cta.study_tutor":"AI-репетитор","dashboard.cta.create_project":"CodeProject AI","dashboard.cta.deepweb":"Deep Research","dashboard.cta.connect_people":"Связи по интересам","dashboard.cta.propose_ideas":"Идеи и проекты","dashboard.cta.mass_control":"AI для пользы сообщества",
  "dashboard.desc.life_director":"Персональный ИИ‑коучинг","dashboard.desc.study_tutor":"Интеллектуальное адаптивное обучение","dashboard.desc.create_project":"Полное развитие с гидом","dashboard.desc.deepweb":"Глубокий академический поиск","dashboard.desc.connect_people":"Сетевое сотрудничество знаний","dashboard.desc.propose_ideas":"Генератор возможностей","dashboard.desc.mass_control":"Конструктивное социальное воздействие",
  "dashboard.quick.prompts.life_director":"Выступай как мой личный лайф‑коуч...","dashboard.quick.prompts.study_tutor":"Стань моим личным наставником...","dashboard.quick.prompts.deepweb":"Достань глубокую академическую и юридическую информацию...","dashboard.quick.prompts.connect_people":"Помоги найти и связаться с людьми со схожими интересами.","dashboard.quick.prompts.propose_ideas":"Сгенерируй инновационные идеи проектов или бизнеса...",
  "dashboard.meta.title":"Мета‑ответ от {{count}} ИИ","dashboard.meta.confidence":"доверие","dashboard.meta.queried_ais":"Запрошенные ИИ:","dashboard.meta.more":"+{{count}} ещё...","dashboard.meta.specialized_ais":"{{count}} специализированных ИИ","dashboard.meta.categories":"Категории","dashboard.meta.general":"Общее",
  "dashboard.welcome.title":"Добро пожаловать, {{name}}!","dashboard.welcome.body":"Вы подключены к самой продвинутой сети ИИ...","dashboard.welcome.precision.title":"Точность","dashboard.welcome.precision.desc":"Ответы проверены несколькими ИИ","dashboard.welcome.speed.title":"Скорость","dashboard.welcome.speed.desc":"Параллельная обработка для быстрых ответов","dashboard.welcome.intelligence.title":"Интеллект","dashboard.welcome.intelligence.desc":"Синтез знаний из разных областей",
  "dashboard.trial.title":"Вы используете лишь 8% реальной мощности IntelliVerseOne","dashboard.trial.body":"Откройте полный доступ к премиум-инструментам и расширенным функциям ИИ.","dashboard.trial.view_plans":"Смотреть премиум‑тарифы","dashboard.trial.continue":"Продолжить триал ({{days}} дн.)",
  "dashboard.stats.today":"Запросов сегодня","dashboard.stats.accuracy":"Точность",
  "dashboard.quick_actions.title":"Быстрые действия",
  "dashboard.quick_actions.subtitle":"Исследуйте возможности IntelliVerseOne",
  "dashboard.quick_actions.unlock_title":"Откройте весь потенциал",
  "dashboard.quick_actions.unlock_desc":"Доступ ко всем премиум‑инструментам и функциям",
  "prompt.suggestions.title":"💡 Умные предложения:","prompt.suggestions.1":"Как повысить мою личную продуктивность?","prompt.suggestions.2":"Объясните самые эффективные алгоритмы сортировки","prompt.suggestions.3":"Идеи для проекта на React","prompt.suggestions.4":"Стратегии цифрового маркетинга на 2024","prompt.suggestions.5":"Тренды искусственного интеллекта","prompt.suggestions.6":"Как шаг за шагом создать успешный стартап",
  "prompt.process.analyzing":"🔍 Анализируем ваш запрос...","prompt.process.selecting":"🧠 Выбираем специализированные ИИ...","prompt.process.querying":"⚡ Запрашиваем сеть...","prompt.process.synthesizing":"🔄 Синтезируем ответы...","prompt.process.optimizing":"✨ Оптимизируем мета‑ответ...",
  "prompt.placeholder.trial":"Задайте свой вопрос... (Сегодня осталось: 8/10)","prompt.placeholder.default":"Задавайте вопросы нескольким ИИ...",
  "prompt.placeholder.search":"Искать конкретную информацию...",
  "prompt.search.mode":"Режим поиска",
  "prompt.search.truncated":"Текст обрезан (лимит режима поиска).",
  "prompt.attach.limit_files":"Достигнут максимум файлов",
  "prompt.attach.file_too_big":"Слишком большой файл (макс 60KB): ",
  "prompt.attach.total_too_big":"Превышен общий размер вложений",
  "prompt.attach.unsupported_now":"Формат скоро будет поддерживаться (нужен облачный режим): ",
  "prompt.attach.unsupported":"Неподдерживаемый формат: ",
  "prompt.attach.read_error":"Ошибка чтения: ",
  "prompt.attach.remove":"Удалить вложение",
  "prompt.voice.recording":"Идёт запись... (макс 60с)",
  "prompt.voice.unsupported":"Этот браузер не поддерживает распознавание речи.",
  "prompt.actions.Adjuntar archivo":"Прикрепить файл","prompt.actions.Búsqueda avanzada":"Расширенный поиск","prompt.actions.Voz a texto":"Речь в текст","prompt.actions.Prompt inteligente":"Умный промпт",
  "prompt.status.querying":"Запрашиваем...","prompt.status.optimizing":"Оптимизация...","prompt.cta.consult_ais":"Консультироваться с {{count}} ИИ","prompt.trial.info":"Бесплатный тариф: осталось {{days}} дней •","prompt.trial.upgrade":"Обновите тариф для безлимитных запросов",
  "common.ok":"OK","common.sending":"Отправка...","common.sent":"Отправлено","common.error":"Ошибка","common.send":"Отправить","common.close":"Закрыть","common.cancel":"Отмена","common.loading":"Загрузка...",
  "auth.login":"Войти","auth.signup":"Зарегистрироваться бесплатно","auth.password":"Пароль","auth.forgot":"Забыли пароль?","auth.continue":"Продолжить","auth.magic_short":"Магическая ссылка","auth.check_email":"Проверьте email, чтобы подтвердить аккаунт","auth.reset":"Сбросить пароль","auth.resend":"Отправить снова",
  "time.just_now":"Только что","time.minutes_ago":"{{count}} минут назад","time.hours_ago":"{{count}} часов назад","time.days_ago":"{{count}} дней назад",
  "auth.with.google":"Продолжить с Google","auth.with.apple":"Продолжить с Apple","auth.with.microsoft":"Продолжить с Microsoft","auth.with.facebook":"Продолжить с Facebook","auth.with.github":"Продолжить с GitHub","auth.with.linkedin":"Продолжить с LinkedIn","auth.or":"или","auth.legal":"Продолжая, вы принимаете наши","auth.terms":"Условия","auth.and":"и","auth.privacy":"Конфиденциальность","auth.errors.social":"Не удалось войти через выбранного провайдера","auth.protected_route":"Защищенная страница: войдите, чтобы продолжить",
  "auth.email":"Email","auth.remember_me":"Запомнить меня","auth.magic.send":"Отправить ссылку","auth.magic.resend_btn":"Повторно","auth.magic.resend_in":"Повторно ({{s}})","auth.logged_in":"Вход выполнен","auth.password.requirements_failed":"Пароль не соответствует требованиям","auth.reset.sent_conditional":"Если аккаунт существует, мы отправили письмо для сброса.","auth.verification.unverified":"Ваш email не подтверждён.","auth.verification.resent":"Письмо подтверждения отправлено повторно.","auth.errors.login_failed":"Не удалось войти","auth.errors.signup_failed":"Не удалось зарегистрироваться","auth.errors.magic_failed":"Не удалось отправить ссылку","auth.errors.resend_failed":"Не удалось повторно отправить",
  "auth.env.missing":"Переменные Supabase не обнаружены. Укажите REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY или VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY и перезапустите сервер.",
  "sidebar.dashboard":"Панель","sidebar.new_chat":"Новый чат","sidebar.new_project":"Новый проект","sidebar.history":"История","sidebar.tools":"Инструменты","sidebar.my_gpts":"Мои GPTs","sidebar.plans":"Тарифы","sidebar.my_profile":"Профиль","sidebar.days_left":"Осталось {{count}} дней",
  "pages.plans.title":"Тарифы и цены","pages.plans.subtitle":"Выберите идеальный тариф, чтобы раскрыть весь потенциал IntelliVerseOne","pages.plans.stats.ais":"Доступные ИИ","pages.plans.stats.tools":"Инструменты","pages.plans.stats.availability":"Доступность","pages.plans.compare":"Подробное сравнение","pages.plans.trial_expiring":"Бесплатный период истекает через {{days}} дней","pages.plans.trial_expiring_hint":"Обновите тариф сейчас, чтобы сохранить полный доступ","pages.plans.trial_expired_ago":"Бесплатный период истёк {{days}} дней назад","plans.cta.start_pro":"Начать тариф Pro","plans.cta.go_pro_plus":"Перейти на Pro+","pages.plans.view_plans":"Смотреть тарифы",
  "pages.faq.title":"Частые вопросы","pages.faq.q.change_anytime":"Могу ли я менять тариф в любое время?","pages.faq.a.change_anytime":"Да, вы можете повысить/понизить тариф в любое время. Изменения применяются сразу.","pages.faq.q.free_includes":"Что входит в бесплатный тариф?","pages.faq.a.free_includes":"Базовый доступ к 5 ИИ, 10 запросов в день и базовые инструменты на 7 дней.","pages.faq.q.annual_discounts":"Есть ли скидки при оплате за год?","pages.faq.a.annual_discounts":"Да, при оплате за год — 2 месяца бесплатно.","pages.faq.q.payment_methods":"Какие способы оплаты вы принимаете?","pages.faq.a.payment_methods":"Карты, PayPal и банковские переводы.","pages.faq.q.cancel_anytime":"Можно ли отменить в любое время?","pages.faq.a.cancel_anytime":"Да, можно отменить подписку без штрафов.","pages.faq.q.support":"Есть ли техническая поддержка?","pages.faq.a.support":"Да, поддержка включена во все тарифы. В платных — приоритет 24/7.",
  "pages.history.title":"История бесед","pages.history.subtitle":"Просматривайте и ищите прошлые беседы",
  "pages.tools.title":"Инструменты ИИ","pages.tools.subtitle":"Полный набор инструментов на базе ИИ","pages.tools.search_placeholder":"Искать инструменты...","pages.tools.empty":"Инструменты не найдены","pages.tools.empty_hint":"Попробуйте другие запросы или смените категорию","pages.tools.more_coming":"Готовятся новые инструменты","pages.tools.more_coming_desc":"Мы регулярно добавляем новые инструменты ИИ для повышения продуктивности",
  "pages.projects.create_title":"Создать проект","pages.projects.step1_title":"Какой тип проекта вы хотите создать?","pages.projects.details_title":"Детали проекта","pages.projects.name_label":"Название проекта","pages.projects.name_ph":"Напр.: Мое портфолио","pages.projects.desc_label":"Описание","pages.projects.desc_ph":"Опишите ваш проект...","pages.projects.purpose_label":"Основная цель","pages.projects.purpose_ph":"Напр.: Показать мои навыки","pages.projects.audience_label":"Целевая аудитория","pages.projects.audience_ph":"Напр.: Рекрутеры и тех. компании","pages.projects.summary_title":"Сводка проекта","pages.projects.type":"Тип","pages.projects.purpose":"Цель","pages.projects.audience":"Аудитория","pages.projects.title":"Мои проекты","pages.projects.subtitle":"Создавайте полноценные проекты с ИИ","pages.projects.empty":"У вас пока нет проектов","pages.projects.first_project":"Создайте свой первый ИИ‑проект","pages.projects.unlock_title":"Разблокировать создание проектов","pages.projects.reached_limit":"Достигнут лимит проектов по вашему тарифу. Обновите тариф, чтобы продолжить.","pages.projects.upgrade_benefits":"Создавайте проекты с Pro, продвинутый экспорт с Pro+",
  "pages.cta.boost_productivity":"Готовы повысить свою продуктивность?","pages.cta.join_many":"Присоединяйтесь к тысячам, кто уже использует коллективный ИИ",
  "user.plan.current":"Текущий тариф","user.plan.trial":"Триал","user.plan.pro":"Pro","user.plan.pro_plus":"Pro+","user.plan.upgrade":"Обновить тариф",
  "goodbye.title":"Ваш аккаунт удален","goodbye.subtitle":"Спасибо, что попробовали IntelliVerseOne.","goodbye.feedback":"Если хотите, расскажите, почему уходите — это поможет нам стать лучше.","goodbye.contact":"Связаться с поддержкой","goodbye.home":"На главную",
    "common.copy":"Копировать","common.coming_soon":"Скоро","common.in_development":"В разработке",
    "tools.categories.all":"Все","tools.categories.content":"Контент","tools.categories.productivity":"Продуктивность","tools.categories.analysis":"Аналитика","tools.categories.social":"Соц. и влияние","tools.categories.development":"Разработка",
  "plans.limitations":"Ограничения:",
  "plans.table.available":"Доступные тарифы",
  "plans.table.trial.name":"Trial",
  "plans.table.trial.price":"Бесплатно",
  "plans.table.trial.features":"15 действий/день • Оркестрация нескольких ИИ",
  "plans.table.pro.name":"Pro",
  "plans.table.pro.price":"$5.79/мес",
  "plans.table.pro.features":"25 вопросов (пожизненно) • 300 действий/день",
  "plans.table.pro_plus.name":"Pro+",
  "plans.table.pro_plus.price":"$9.79/мес",
  "plans.table.pro_plus.features":"50 вопросов (пожизненно) • Неограниченные действия • Полная Deep Research",
  "pages.history.search_placeholder":"Поиск по разговорам...",
  "history.stats.conversations":"Беседы",
  "history.stats.total_responses":"Всего ответов",
  "history.stats.average_rating":"Средняя оценка",
  "history.stats.active_days":"Активные дни",
  "history.category.all":"Все",
  "history.category.productivity":"Продуктивность",
  "history.category.education":"Образование",
  "history.category.development":"Разработка",
  "history.category.career":"Карьера",
  "history.category.finance":"Финансы",
  "history.label.responses":"ответов",
  "history.empty.title":"Разговоры не найдены",
  "history.empty.hint_search":"Попробуйте другие поисковые запросы",
  "history.empty.hint_empty":"У вас еще нет сохраненных разговоров",
  "history.empty.cta":"Начать новый разговор",
  "history.smart_search.title":"Умный семантический поиск",
  "history.smart_search.subtitle":"Скоро: поиск по понятиям и контексту, а не только по ключевым словам",
  "history.smart_search.card.semantic_ai.title":"Семантический ИИ",
  "history.smart_search.card.semantic_ai.desc":"Находите разговоры по смыслу",
  "history.smart_search.card.auto_tagging.title":"Автотегирование",
  "history.smart_search.card.auto_tagging.desc":"Интеллектуальная автоматическая категоризация",
  "history.smart_search.card.patterns.title":"Анализ шаблонов",
  "history.smart_search.card.patterns.desc":"Инсайты по вашим запросам",
  "mygpts.title":"Мои GPTs",
  "mygpts.subtitle":"Создавайте и управляйте своими настраиваемыми ИИ‑ассистентами",
  "mygpts.create_new":"Создать новый GPT",
  "mygpts.stats.created":"Создано GPTs",
  "mygpts.stats.uses":"Всего использований",
  "mygpts.stats.limit":"Лимит GPTs",
  "mygpts.stats.templates":"Доступные шаблоны",
  "mygpts.empty.title":"У вас пока нет GPT",
  "mygpts.empty.subtitle":"Создайте своего первого настраиваемого ИИ‑ассистента",
  "mygpts.empty.cta":"Создать мой первый GPT",
  "mygpts.locked.title":"Разблокировать создание GPT",
  "mygpts.locked.desc.hard":"Вы достигли лимита GPT по тарифу. Обновите тариф, чтобы продолжить.",
  "mygpts.locked.desc.info":"Создавайте до 5 настраиваемых GPT с Pro или безлимитно с Pro+",
  "mygpts.locked.cta":"Смотреть тарифы",
  "mygpts.card.uses":"исп.",
  "mygpts.card.created":"Создан",
  "mygpts.card.tone":"Тон",
  "mygpts.card.depth":"Глубина",
  "mygpts.card.style":"Стиль",
  "mygpts.card.use":"Использовать",
  "mygpts.creator.title":"Создать новый GPT",
  "mygpts.creator.step":"Шаг {{n}} из 4",
  "mygpts.creator.step1.title":"Выберите базовый шаблон",
  "mygpts.creator.step2.title":"Настройте ваш GPT",
  "mygpts.creator.name.placeholder":"например: Мой личный ассистент",
  "mygpts.creator.desc.placeholder":"Опишите, что делает ваш GPT и как он помогает...",
  "mygpts.creator.icon":"Иконка",
  "mygpts.creator.step3.title":"Настройки личности",
  "mygpts.creator.tone.label":"Тон общения",
  "mygpts.creator.tone.professional":"Профессиональный",
  "mygpts.creator.tone.friendly":"Дружелюбный",
  "mygpts.creator.tone.casual":"Неформальный",
  "mygpts.creator.tone.empatic":"Эмпатичный",
  "mygpts.creator.tone.direct":"Прямой",
  "mygpts.creator.depth.label":"Глубина ответа",
  "mygpts.creator.depth.basic":"Базовый",
  "mygpts.creator.depth.intermediate":"Средний",
  "mygpts.creator.depth.advanced":"Продвинутый",
  "mygpts.creator.depth.expert":"Эксперт",
  "mygpts.creator.style.label":"Стиль общения",
  "mygpts.creator.style.conversational":"Разговорный",
  "mygpts.creator.style.structured":"Структурированный",
  "mygpts.creator.style.creative":"Креативный",
  "mygpts.creator.style.analytical":"Аналитический",
  "mygpts.creator.style.reflective":"Рефлексивный",
  "mygpts.creator.step4.title":"Предпросмотр вашего GPT",
  "mygpts.creator.preview_hint":"Всё верно? Вы сможете отредактировать GPT позже.",
  "mygpts.creator.create":"Создать GPT",
  "mygpts.templates.tutor.name":"Мой Тьютор",
  "mygpts.templates.tutor.desc":"Специалист по обучению и объяснениям",
  "mygpts.templates.emotional.name":"Эмоциональный Наставник",
  "mygpts.templates.emotional.desc":"Эмоциональная поддержка и благополучие",
  "mygpts.templates.productivity.name":"Моя Продуктивность",
  "mygpts.templates.productivity.desc":"Оптимизация и организация",
  "mygpts.templates.deepweb.name":"Deep Research",
  "mygpts.templates.deepweb.desc":"Глубокие академические исследования",
  "mygpts.templates.crypto.name":"Криптоактивы",
  "mygpts.templates.crypto.desc":"Анализ криптовалют и блокчейна",
  "mygpts.templates.business.name":"Бизнес‑стратег",
  "mygpts.templates.business.desc":"Бизнес‑консалтинг и стратегия",
  "mygpts.sample.tutor.name":"Мой персональный тьютор",
  "mygpts.sample.tutor.desc":"Специалист по простому объяснению сложных концепций",
  "mygpts.sample.productivity.name":"Ассистент продуктивности",
  "mygpts.sample.productivity.desc":"Оптимизация задач и тайм‑менеджмент",
  "mygpts.sample.emotional.name":"Эмоциональный наставник",
  "mygpts.sample.emotional.desc":"Эмоциональная поддержка и советы по ментальному здоровью",
  "mygpts.sample.tone.friendly":"дружелюбный",
  "mygpts.sample.tone.direct":"прямой",
  "mygpts.sample.tone.empatic":"эмпатичный",
  "mygpts.sample.depth.intermediate":"средний",
  "mygpts.sample.depth.practical":"практичный",
  "mygpts.sample.depth.deep":"глубокий",
  "mygpts.sample.style.conversational":"разговорный",
  "mygpts.sample.style.structured":"структурированный",
  "mygpts.sample.style.reflective":"рефлексивный",
  "projects.types.web.name":"Веб‑приложение",
  "projects.types.web.desc":"Полный фронтенд на React/Vue/Angular",
  "projects.types.api.name":"API‑бэкенд",
  "projects.types.api.desc":"Сервер и база данных на Node.js или Python",
  "projects.types.mobile.name":"Мобильное приложение",
  "projects.types.mobile.desc":"Нативное или гибридное приложение",
  "projects.types.fullstack.name":"Фулстек",
  "projects.types.fullstack.desc":"Проект под ключ: фронтенд + бэкенд",
  "projects.actions.download_zip":"Скачать ZIP",
  "projects.actions.continue":"Продолжить",
  "projects.actions.new_project":"Новый проект",
  "projects.progress":"Прогресс",
  "projects.created_on":"Создан",
  "projects.status.completed":"Завершено",
  "projects.status.in_progress":"В процессе",
  "projects.status.generating":"Генерация",
  "projects.status.generating_dots":"Генерация...",
  "projects.actions.view":"Посмотреть",
  "projects.detail.untitled":"Проект без названия",
  "projects.detail.loading_desc":"Загружаем детали проекта…",
  "projects.detail.no_desc":"Без описания",
  "projects.detail.view":"Просмотр",
  "projects.detail.summary":"Сводка",
  "projects.detail.actions":"Быстрые действия",
  "projects.detail.view_code":"Посмотреть код",
  "projects.detail.activity":"Активность",
  "projects.detail.activity_init":"Проект создан и поставлен в очередь на генерацию",
  "projects.detail.activity_ai":"ИИ подготавливает структуру и зависимости",
  "projects.detail.activity_docs":"Базовая документация инициализирована",
  "projects.detail.tech":"Технологии",
  "history.sample.1.title":"Как повысить мою личную продуктивность",
  "history.sample.1.preview":"Нужны советы, как быть продуктивнее в повседневной работе...",
  "history.sample.2.title":"Объяснение алгоритмов сортировки",
  "history.sample.2.preview":"Не могли бы вы объяснить разные алгоритмы сортировки...",
  "history.sample.3.title":"Идеи для проекта на React",
  "history.sample.3.preview":"Ищу инновационные идеи для проекта на React...",
  "history.sample.4.title":"Советы для собеседований",
  "history.sample.4.preview":"На следующей неделе у меня важное собеседование...",
  "history.sample.5.title":"Анализ рынка криптовалют",
  "history.sample.5.preview":"Что вы думаете о текущих трендах крипторынка...",
  "projects.mock.1.name":"Личное портфолио",
  "projects.mock.1.desc":"Профессиональный сайт на React и Tailwind CSS",
  "projects.mock.2.name":"Приложение задач",
  "projects.mock.2.desc":"Управление задачами с аутентификацией",
  "projects.mock.3.name":"REST API для e‑commerce",
  "projects.mock.3.desc":"Полный бэкенд для интернет‑магазина",
  "tools.items.emotional-translator.name":"Эмоциональный ИИ‑переводчик",
  "tools.items.emotional-translator.description":"Перевод с сохранением тона и эмоционального контекста",
  "tools.items.text-reformulator.name":"Реформулятор текста",
  "tools.items.text-reformulator.description":"Переписывает текст, сохраняя смысл",
  "tools.items.voice-converter.name":"Преобразователь текста в речь",
  "tools.items.voice-converter.description":"Преобразует текст в естественную речь",
  "tools.items.prompt-creator.name":"Создатель промптов",
  "tools.items.prompt-creator.description":"Генерирует оптимизированные промпты для любой ИИ",
  "tools.items.viral-titles.name":"Генератор вирусных заголовков",
  "tools.items.viral-titles.description":"Создаёт привлекающие внимание заголовки",
  "tools.items.audience-segmenter.name":"Сегментатор аудитории",
  "tools.items.audience-segmenter.description":"Анализ и сегментация целевых аудиторий",
  "tools.items.idea-repairer.name":"Доработчик идей",
  "tools.items.idea-repairer.description":"Дополняет и улучшает незавершённые идеи",
  "tools.items.copy-pulse.name":"CopyPulse – Копируй, Улучшай и Запускай",
  "tools.items.copy-pulse.description":"Анализирует, улучшает и оптимизирует любой контент",
  "tools.items.file-converter.name":"Умный конвертер файлов",
  "tools.items.file-converter.description":"Конвертирует файлы с помощью ИИ для оптимизации контента",
  "tools.items.arconte-ai.name":"Контакт Arconte AI",
  "tools.items.arconte-ai.description":"Прямой доступ к самой передовой ИИ",
  "tools.items.mass-control.name":"AI для пользы сообщества",
  "tools.items.mass-control.description":"Инструменты для конструктивного социального воздействия",
  "pages.not_found.title":"Страница не найдена",
  "pages.not_found.body":"Похоже, эта страница потерялась в мультивселенной искусственного интеллекта. 120 ИИ работают над тем, чтобы её найти.",
  "pages.not_found.help_title":"Нужна помощь?",
  "pages.not_found.help_body":"Если вы считаете, что это ошибка, вы можете связаться с нами или вернуться на главную страницу.",
  "pages.not_found.cta_home":"🏠 На главную",
  "pages.not_found.cta_tools":"🛠️ Изучить инструменты",
  "pages.not_found.link_support":"📧 Поддержка",
  "pages.not_found.link_home":"🏠 Главная",
  "pages.not_found.link_plans":"💎 Тарифы",
  "user.panel_title":"Панель пользователя",
  "user.security.change_password":"Изменить пароль",
  "user.security.change_password_prompt":"Новый пароль (минимум 8 символов)",
  "user.security.password_changed":"Пароль обновлён",
  "user.security.reset_password":"Отправить ссылку для сброса",
  "user.security.reset_sent":"Мы отправили вам письмо для сброса пароля",
  "user.security.title":"Безопасность аккаунта",
  "user.security.subtitle":"Управление учётными данными и параметрами безопасности.",
  "user.security.password":"Пароль",
  "user.security.password_hint":"Используйте длинный уникальный пароль. MFA скоро появится.",
  "user.security.email_hint":"При смене email его нужно подтвердить перед использованием.",
  "user.security.password_error":"Не удалось обновить пароль",
  "user.security.password_placeholder":"Новый надёжный пароль",
  "user.security.change_password_title":"Обновить пароль",
  "user.security.change_password_action":"Обновить",
  "user.security.cancel":"Отмена",
  "user.security.password_min":"Минимум 8 символов",
  "user.security.logout":"Выйти",
  "user.security.delete_account_btn":"Удалить аккаунт",
  "user.security.delete_account":"Удалить аккаунт",
  "user.security.delete_account_desc":"Это действие необратимо. Вы потеряете свои проекты, GPT и связанные данные.",
  "user.security.delete_account_type":"Введите УДАЛИТЬ для подтверждения:",
  "user.security.delete_account_confirm":"Удалить навсегда",
  "user.security.delete_account_done":"Запрос на удаление отправлен. Мы уведомим вас по электронной почте.",
  "user.security.delete_account_signout":"Вы вышли из системы. Для завершения удаления настройте webhook REACT_APP_DELETE_ACCOUNT_WEBHOOK_URL.",
  "trial.expired.title":"Ваш 7-дневный пробный период завершён!",
  "trial.expired.body":"Вы испытали полную мощь IntelliVerseOne. Чтобы продолжить использование {{feature}}, выберите тариф.",
  "trial.expired.stats_title":"🎉 За время пробного периода вы испытали:",
  "trial.expired.stat_ias":"Запрошено ИИ",
  "trial.expired.stat_functionality":"Полная функциональность",
  "trial.expired.stat_projects":"Созданных проектов",
  "trial.expired.stat_costs":"Скрытых расходов",
  "trial.expired.pro_plus_label":"🚀 Тариф Pro+ - $9,79/мес",
  "trial.expired.pro_plus_desc":"Полная функциональность + приоритет + мультимедиа ИИ",
  "trial.expired.pro_label":"⭐ Тариф Pro - $5,79/мес",
  "trial.expired.pro_desc":"Идеально для полного и профессионального использования",
  "trial.expired.free_option":"Или продолжите с ограниченным функционалом:",
  "trial.expired.free_plan_title":"🆓 Бесплатный тариф (Ограниченный):",
  "trial.expired.free_blocked":"ДОСТУП ПОЛНОСТЬЮ ЗАБЛОКИРОВАН",
  "trial.expired.free_no_ias":"Нет запросов к ИИ",
  "trial.expired.free_no_premium":"Нет премиум-функций",
  "trial.expired.free_history_only":"Только просмотр предыдущей истории",
  "trial.expired.continue_free":"Продолжить с бесплатным тарифом",
  "trial.expired.benefits":"✨ 30-дневная гарантия • 🔒 Отмена в любое время • 💰 Справедливые цены",
  "notifications.welcome.activated":"🚀 IntelliVerseOne активирован - более 120 ИИ готовы к консультациям",
  "notifications.welcome.optimized":"🧠 Система Meta-ИИ оптимизирована для максимальной точности",
  "notifications.welcome.new_features":"⚡ Доступны новые функции - Исследуйте инструменты",
  "chat.error.auth":"Не аутентифицирован. Войдите для продолжения.",
  "chat.error.quota":"Дневной лимит запросов достигнут. Обновите план.",
  "chat.error.timeout":"Запрос истёк. Попробуйте снова.",
  "chat.error.server":"Ошибка сервера. Попробуйте позже.",
  "chat.error":"Произошла ошибка. Попробуйте снова.",
  "chat.placeholder.answer":"Ответ ИИ...",
  "history.auto.title":"Разговор {{date}}",
  "history.actions.confirm":"Удалить этот разговор?",
  "stats.ias":"Запрошено ИИ",
  "stats.remaining":"Осталось сегодня",
  "stats.accuracy":"Точность",
  "prompt.actions.search":"Поиск",
  "prompt.actions.voice":"Голос",
  "prompt.actions.suggest":"Предложить",
  "prompt.actions.attach":"Вложить",
  "prompt.cta.consult_ias":"Спросить {{count}} ИИ",
  "prompt.remaining":"Осталось",
  "prompt.placeholder.expired":"Пробный период истёк —",
  "prompt.placeholder.limit":"Лимит достигнут —",
  "prompt.trial.expired_msg":"Ваш пробный период истёк. Выберите план.",
  "prompt.trial.choose_plan":"Выбрать план",
  "prompt.search.active":"Режим поиска активен",
  "prompt.voice.no_mic":"Нет доступа к микрофону",
  "prompt.limit.exceeded":"Лимит запросов достигнут",
  "prompt.trial.expired":"Пробный период истёк",
  "auth.logout":"Выйти",
  "mygpts.updated":"GPT обновлён",
  "mygpts.created":"GPT успешно создан",
  "mygpts.error.save":"Ошибка при сохранении",
  "mygpts.creator.title_new":"Создать новый GPT",
  "mygpts.creator.title_edit":"Редактировать GPT",
  "tools.copy_empty":"У этого инструмента нет текста для копирования",
  "tools.copy_ok":"Промпт скопирован в буфер обмена",
  "tools.copy_fail":"Не удалось скопировать. Повторите.",
  "tools.copy_tooltip":"Скопировать промпт в буфер обмена",
  "tools.run_tooltip":"Запустить инструмент с ИИ",
  "common.run":"Запустить",
  "plans.paypal.error":"Произошла ошибка оплаты. Попробуйте снова.",
  "plans.paypal.cancel":"Платёж отменён пользователем.",
  "plans.paypal.required":"Чтобы активировать этот тариф, вам нужно завершить оплату через PayPal.",
  "plans.cancel.confirm":"Вы уверены, что хотите отменить подписку? Вы сохраните доступ до конца оплаченного периода.",
  "plans.cancel.no_auth":"Нет активного сеанса. Пожалуйста, войдите снова.",
  "plans.cancel.error":"Ошибка при отмене. Попробуйте снова или обратитесь в поддержку.",
  "plans.cancel.success":"Подписка отменена! Вы сохраните доступ до {{date}}.",
  "user.connections.title":"Подключения аккаунта",
  "user.connections.hint":"Привяжите провайдеров, чтобы входить через любого из них.",
  "projects.generated_success":"Проект сгенерирован! Теперь вы можете скачать ZIP.",
  "projects.wizard.mvp_includes":"Ваш MVP-проект будет включать:",
  "projects.wizard.gen.structure_mvp":"Базовая структура проекта",
  "projects.wizard.gen.starter":"Функциональные стартовые файлы",
  "projects.wizard.gen.readme":"README с инструкциями",
  "projects.wizard.gen.config":"Начальная конфигурация",
  "projects.wizard.mvp_note":"Скачайте ZIP и настройте код по своему желанию",
  "projects.actions.generating":"Генерация...",
  "common.login_required":"Пожалуйста, войдите, чтобы продолжить",
  "common.reset":"Сбросить",
  "share.copied":"Ссылка скопирована: ",
  "limits.share_pro":"Для публикации необходим план Pro или выше.",
  "life_coach":{
    "common":{"select":"Выберите…","selected_count":"{{count}} выбрано","other":"Другое","other_ph":"Опишите другой вариант"},
    "hero":{"title":"Позвольте мне направить вашу жизнь","subtitle":"Эмоциональный и стратегический копилот, сопровождающий вас каждый день."},
    "stats":{"areas":"Выбранные области","habits":"Всего привычек","remaining":"Действий осталось сегодня"},
    "form":{"title":"Ваш жизненный фокус","areas_label":"Приоритетные области","daily_time":"Доступное ежедневное время","emotions_label":"Как вы себя чувствуете в целом","emotions.low":"Низкий","emotions.medium":"Средний","emotions.high":"Высокий","motivation":"Что мотивирует вас сейчас?","motivation_ph":"Опишите свою мотивацию","routine":"Каков ваш распорядок дня?","routine_ph":"Опишите кратко","constraints":"Ограничения или вызовы (необязательно)","sleep_hours":"Часы сна","sleep":{"less6":"Менее 6","6_7":"6-7","7_8":"7-8","more8":"Более 8"},"exercise_freq":"Частота упражнений","exercise":{"never":"Никогда","1_2":"1-2 раза/неделю","3_4":"3-4 раза/неделю","more4":"Более 4/неделю"},"diet_focus":"Фокус питания","diet":{"balanced":"Сбалансированное","high_protein":"Высокий белок","low_carb":"Низкоуглеводное","plant_based":"Растительное"},"stress_level":"Уровень стресса","level":{"low":"Низкий","medium":"Средний","high":"Высокий"},"productivity_peak":"Пик продуктивности","daytime":{"morning":"Утро","afternoon":"День","evening":"Вечер"},"reminder_time":"Предпочтительное время напоминания","distractions":"Основные отвлечения","learning_goal":"Цель обучения","learning_goal_ph":"Чему вы хотите научиться?","financial_goal":"Финансовая цель","financial_goal_ph":"Например, сэкономить X, погасить долг","relationship_goal":"Цель в отношениях","relationship_goal_ph":"Семья, партнёр, друзья","weekend_routine":"Распорядок выходного дня","weekend_routine_ph":"Типичные занятия","accountability":{"label":"Подотчётность","solo":"Самостоятельно","buddy":"С партнёром","coach":"С коучем"},"comm_style":"Стиль общения","comm":{"concise":"Лаконичный","detailed":"Детальный","motivational":"Мотивирующий"}},
    "area":{"health":"Здоровье","career":"Карьера","finance":"Финансы","relationships":"Отношения","personal":"Личностный рост"},
    "motivation":{"health":"Улучшить здоровье","career":"Профессиональный рост","balance":"Баланс работы и жизни","learn":"Освоить навык","finance":"Улучшить финансы","emotional":"Эмоциональное благополучие","consistency":"Быть последовательным","project":"Личный проект","exam":"Подготовка к экзамену/сертификации","stress":"Снизить стресс"},
    "routine":{"office":"Офис 9-5","remote":"Гибкая удалёнка","student":"Студент","shift":"Посменно/вахта","entrepreneur":"Предприниматель","caretaker":"Опекун","night":"Ночная смена","parent":"Родитель с детьми","variable":"Очень изменчивый"},
    "constraints":{"time":"Нехватка времени","stress":"Стресс/тревога","health":"Физическое здоровье","finance":"Финансы","family":"Семья/уход","environment":"Среда/пространство","sleep":"Нерегулярный сон","motivation":"Низкая мотивация","tech":"Технологии/оборудование"},
    "distractions":{"social":"Социальные сети","notifs":"Уведомления","chat":"Мессенджеры","noise":"Фоновый шум","multitask":"Многозадачность","phone":"Телефон","fatigue":"Усталость","perfect":"Перфекционизм","procrast":"Прокрастинация","family":"Прерывания семьи","tv":"ТВ/игры"},
    "learning":{"languages":"Языки","programming":"Программирование","dataai":"Данные/ИИ","marketing":"Маркетинг","sales":"Продажи","personal_finance":"Личные финансы","music":"Музыка","design":"Искусство/дизайн","cert":"Экзамен/сертификация","softskills":"Мягкие навыки"},
    "finance":{"emergency":"Экстренный фонд","pay_debt":"Погасить долг","cut_expenses":"Сократить расходы","increase_income":"Увеличить доход","invest":"Инвестировать","buy_house":"Купить жильё/авто","save_trip":"Накопить на поездку/учёбу","credit_score":"Улучшить кредитный рейтинг"},
    "relation":{"communication":"Улучшить общение","family_time":"Больше времени с семьёй","partner":"Укрепить отношения","friends":"Найти новых друзей","network":"Профессиональный нетворкинг","conflict":"Разрешить конфликт","boundaries":"Установить здоровые границы"},
    "weekend":{"rest":"Отдых","family":"Семья","sport":"Спорт/активность","social":"Социальное","creative":"Творчество/хобби","chores":"Домашние дела","study":"Учёба/проект","travel":"Путешествие"},
    "cta":{"generate":"Создать план","regenerate":"Пересоздать","refine_area":"Уточнить область"},
    "plan":{"title":"Ваш жизненный план","progress":"Прогресс","weekly_goals":"Еженедельные цели","monthly_goals":"Ежемесячные цели","habits":"Привычки"},
    "module":{"reminders":"Умные напоминания","feedback":"Еженедельная обратная связь"},
    "reminders":{"active":"Вы будете получать персонализированные ежедневные и еженедельные напоминания.","locked":"Доступно в Pro+. Разблокируйте автоматические персонализированные напоминания."},
    "feedback":{"active":"Вы будете получать еженедельный анализ с индивидуальными рекомендациями.","locked":"Доступно в Pro+. Получайте еженедельный отчёт с предложенными улучшениями."},
    "errors":{"areas":"Выберите хотя бы одну область.","limit":"Вы достигли дневного лимита."},
    "copy":{"m1":"Я здесь, чтобы помочь вам создать лучшую версию себя.","m2":"Сегодня мы можем сделать ещё один шаг. Готовы?","m3":"Маленькие изменения, большие результаты."},
    "mock":{"goal":{"week":"Завершите 3 сессии, связанные с {{area}}","month":"Достигните ключевой вехи в {{area}}","learn":{"week":"Изучайте {{skill}} (3×20 мин)","month":"Завершите модуль или веху в {{skill}}"},"finance":{"week":"Двигайтесь к: {{goal}}","month":"Достигните финансовой вехи: {{goal}}"},"weekend":"Активность в выходной: {{w}}","refine":"Уточнённое действие в {{area}}"},"habit":{"1":"5-минутная привычка в {{area}}","2":"Напишите краткое размышление о {{area}}","learn":"Изучите {{skill}} (15 мин)","budget":"Проверьте расходы и бюджет (10 мин)","relation":"Значимый контакт (сообщение/звонок)","sleep":"Гигиена сна (10-минутная рутина)","exercise":{"start":"Ходьба 10 мин","progress":"20-минутная тренировка","maintain":"Поддержание формы 25 мин"},"diet":{"pb":"Добавить 1 дополнительную порцию овощей","hp":"Планировать белок в каждом приёме пищи","lc":"Избегать рафинированного сахара"},"morning":"Глубокий AM-блок (20 мин) для {{area}}","focus":"Сессия без уведомлений (15 мин)","stress":"Дыхательная техника 4-7-8","accountability":"Чек-ин с партнёром/коучем (5 мин)"}},
    "career":{"habit":{"focus":"Блок фокуса {{m}} мин"}},
    "remark":{"privacy":"Ваши ответы сохраняются приватно."}
  },
  "common.back":"Назад"
} };

// Nota: mantenemos recursos mínimos para no tocar la UI existente.
// A medida que migremos textos, los iremos agregando aquí.

export const resources = {
  en: { translation: { 
    ...en,
    // Project types (EN overrides)
    "projects.types.web.name":"Web Application",
    "projects.types.web.desc":"Full frontend with React, Vue or Angular",
    "projects.types.api.name":"API Backend",
    "projects.types.api.desc":"Server and database with Node.js or Python",
    "projects.types.mobile.name":"Mobile App",
    "projects.types.mobile.desc":"Native or hybrid application",
    "projects.types.fullstack.name":"Full Stack",
    "projects.types.fullstack.desc":"End‑to‑end project: frontend + backend",
    // Correcciones EN para claves que quedaron en español en el common.json
    "projects.actions.download_zip":"Download ZIP",
    "projects.actions.continue":"Continue",
    "projects.actions.new_project":"New Project",
    "projects.progress":"Progress",
    "projects.created_on":"Created",
    "projects.status.completed":"Completed",
    "projects.status.in_progress":"In progress",
    "projects.status.generating":"Generating",
    "projects.status.generating_dots":"Generating...",
    "auth.with.google":"Continue with Google","auth.with.apple":"Continue with Apple","auth.with.microsoft":"Continue with Microsoft","auth.with.facebook":"Continue with Facebook","auth.with.github":"Continue with GitHub","auth.with.linkedin":"Continue with LinkedIn","auth.or":"or","auth.legal":"By continuing you accept our","auth.terms":"Terms","auth.and":"and","auth.privacy":"Privacy","auth.errors.social":"Could not sign in with the selected provider","auth.protected_route":"Protected route: sign in to continue",
    // Hero rotating catchphrases and powered by
    "auth.promo.subscribe":"Sign up for free",
    "auth.promo.trial":"Try the platform for 7 days",
    "auth.promo.nocard":"No credit card required",
    "dashboard.hero.powered_by":"Powered by multiple artificial intelligences",
    "dashboard.hero.rotating":[
      "Learn, create and research with multiple artificial intelligences."
    ],
    // Ensure EN welcome section is in English (override Spanish leftovers)
    "dashboard.welcome.title":"Welcome, {{name}}!",
    "dashboard.welcome.body":"You are connected to the world's most advanced AI network. Use multiple AI capabilities to learn, create, research and move your projects forward.",
    "dashboard.welcome.precision.title":"Precision",
    "dashboard.welcome.precision.desc":"Answers verified by multiple AI systems",
    "dashboard.welcome.speed.title":"Speed",
    "dashboard.welcome.speed.desc":"Parallel processing for quick responses",
    "dashboard.welcome.intelligence.title":"Intelligence",
    "dashboard.welcome.intelligence.desc":"Synthesis of knowledge across multiple specialties"
  } },
  es: { translation: { 
    ...es,
    // Tipos de proyecto (ES overrides)
    "projects.types.web.name":"Aplicación Web",
    "projects.types.web.desc":"Frontend completo con React, Vue o Angular",
    "projects.types.api.name":"API Backend",
    "projects.types.api.desc":"Servidor y base de datos con Node.js o Python",
    "projects.types.mobile.name":"App Móvil",
    "projects.types.mobile.desc":"Aplicación nativa o híbrida",
    "projects.types.fullstack.name":"Full Stack",
    "projects.types.fullstack.desc":"Proyecto completo frontend + backend",
    "auth.with.google":"Continuar con Google","auth.with.apple":"Continuar con Apple","auth.with.microsoft":"Continuar con Microsoft","auth.with.facebook":"Continuar con Facebook","auth.with.github":"Continuar con GitHub","auth.with.linkedin":"Continuar con LinkedIn","auth.or":"o","auth.legal":"Al continuar aceptas nuestros","auth.terms":"Términos","auth.and":"y","auth.privacy":"Privacidad","auth.errors.social":"No se pudo iniciar sesión con el proveedor seleccionado","auth.protected_route":"Ruta protegida: inicia sesión para continuar",
    // Frases del hero y "potenciado por"
    "auth.promo.subscribe":"Suscríbete gratis",
    "auth.promo.trial":"Prueba la plataforma 7 días",
    "auth.promo.nocard":"Sin tarjeta de crédito",
    "dashboard.hero.powered_by":"Potenciado por múltiples inteligencias artificiales",
    "dashboard.hero.rotating":[
      "Aprende, crea e investiga con múltiples inteligencias artificiales."
    ]
  } },
  pt,
  fr,
  de,
  it,
  zh,
  ja,
  ko,
  ar,
  hi,
  ru,
  // Añadimos TR con un paquete base mínimo; los namespaces específicos se cargan abajo
  tr: { translation: {
    "dashboard.hero.powered_by":"Birden fazla yapay zeka ile desteklenir",
    "dashboard.hero.rotating":[
      "Birden fazla yapay zeka ile öğren, üret ve araştır."
    ],
    "dashboard.cta.life_director":"Kişisel Yapay Zeka Planı",
    "dashboard.cta.study_tutor":"Yapay Zeka Çalışma Öğretmeni",
    "dashboard.cta.create_project":"CodeProject AI",
    "dashboard.cta.deepweb":"Deep Research",
    "dashboard.cta.connect_people":"İlgi Alanlarına Göre Bağlan",
    "dashboard.cta.propose_ideas":"Fikirler ve Projeler",
    "dashboard.cta.mass_control":"Topluluk Etkisi Yapay Zekası"
  } },
};

// Utilidades para asignar claves con notación de puntos como objetos anidados
function setDeep(obj, dottedKey, value) {
  const parts = String(dottedKey).split('.');
  let cur = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    if (!cur[p] || typeof cur[p] !== 'object') cur[p] = {};
    cur = cur[p];
  }
  cur[parts[parts.length - 1]] = value;
}

function hasDeep(obj, dottedKey) {
  const parts = String(dottedKey).split('.');
  let cur = obj;
  for (let i = 0; i < parts.length; i++) {
    const p = parts[i];
    if (cur == null || typeof cur !== 'object' || !(p in cur)) return false;
    cur = cur[p];
  }
  return true;
}

function getDeep(obj, dottedKey) {
  const parts = String(dottedKey).split('.');
  let cur = obj;
  for (let i = 0; i < parts.length; i++) {
    if (cur == null) return undefined;
    cur = cur[parts[i]];
  }
  return cur;
}

function deleteDeep(obj, dottedKey) {
  const parts = String(dottedKey).split('.');
  let cur = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    if (!cur[p] || typeof cur[p] !== 'object') return;
    cur = cur[p];
  }
  delete cur[parts[parts.length - 1]];
}

// Nuevas claves de acciones de chat y código (12 idiomas). Si alguna clave existe, no se sobreescribe.
const chatActionTranslations = {
  en: {
    'chat.actions.copy_full':'Copy full answer',
    'chat.actions.copied':'Copied',
    'chat.actions.download_md':'Download (.md)',
    'chat.actions.expand':'View more',
    'chat.actions.collapse':'Collapse',
    'chat.actions.like':'Like',
    'chat.actions.dislike':'Dislike',
    'chat.actions.go_top':'Go to top',
    'chat.actions.go_end':'Go to end',
    'chat.code.copy':'Copy code',
    'chat.code.copied':'Code copied',
    'chat.code.download':'Download code',
    'chat.code.prev':'Prev',
    'chat.code.next':'Next',
    'chat.code.part_label':'Part {{current}}/{{total}}',
    'chat.code.language_fallback':'text',
    'chat.toc.title':'Table of Contents',
    'chat.readmode.open':'Reading mode',
    'chat.readmode.close':'Close reading',
    // Chat roles (labels and hints)
    'chat.roles.reasoning':'Strategic Reasoning',
    'chat.roles.reasoning.hint':'Optimizes logic, structure, and coherence.',
    'chat.roles.synthesis':'Multi‑Model Synthesis',
    'chat.roles.synthesis.hint':'Combines multiple perspectives into a unified answer.',
    'chat.roles.multilingual':'Multilingual Analysis',
    'chat.roles.multilingual.hint':'Understands and answers across languages consistently.',
    'chat.roles.code':'Contextual Coding',
    'chat.roles.code.hint':'Produces code and technical examples tailored to your query.',
    'chat.roles.context':'Context Enrichment',
    'chat.roles.context.hint':'Adds relevant context and clarifications when needed.',
    'chat.roles.creative':'Directed Creativity',
    'chat.roles.creative.hint':'Generates creative options or narratives on demand.',
    'chat.roles.safety':'Safety & Moderation',
    'chat.roles.safety.hint':'Keeps content within ethical and safety guidelines.',
    // Cognitive panel
    'chat.cognitive.activeTitle':'Active intelligences in this answer',
    'chat.cognitive.ecosystemTitle':'Supported ecosystem',
    'chat.cognitive.ecosystemDisclaimer':'Our orchestration dynamically selects a subset of intelligences and advanced techniques according to your query. The list shows the supported ecosystem.',
    // Status
    'chat.status.consulting':'Consulting AIs...',
    'chat.status.generating':'Generating...',
    'chat.status.fallback':'Using fallback mode...',
    // Meta
    'chat.meta.cached':'From cache',
    'chat.meta.refreshed':'Updated',
    'chat.meta.categories':'Categories',
    // Input and hints
    'chat.input.placeholder':'Type your next question...',
    'chat.input.sending':'Sending',
    'chat.input.cta':'Send',
    'chat.hint':'Press Enter to send',
    'chat.hint.shortcut':'Enter: send • Shift+Enter: new line',
    'chat.empty':'Ask your first question to get started.',
    // Limits
    'chat.limits.trial':'Trial plan active',
    'chat.limits.unlimited':'Plan active',
    // Errors
    'chat.error':'Error generating answer.',
    'chat.search.toggle':'Search the web (V2)',
    'chat.search.ttl':'Frequently refreshed results'
  },
  es: {
    'chat.actions.copy_full':'Copiar respuesta completa',
    'chat.actions.copied':'Copiado',
    'chat.actions.download_md':'Descargar (.md)',
    'chat.actions.expand':'Ver más',
    'chat.actions.collapse':'Contraer',
    'chat.actions.like':'Me gusta',
    'chat.actions.dislike':'No me gusta',
    'chat.actions.go_top':'Ir al inicio',
    'chat.actions.go_end':'Ir al final',
    'chat.code.copy':'Copiar código',
    'chat.code.copied':'Código copiado',
    'chat.code.download':'Descargar código',
    'chat.code.prev':'Anterior',
    'chat.code.next':'Siguiente',
    'chat.code.part_label':'Parte {{current}}/{{total}}',
    'chat.code.language_fallback':'texto',
    'chat.toc.title':'Índice',
    'chat.readmode.open':'Modo lectura',
    'chat.readmode.close':'Cerrar lectura',
    // Roles de chat (etiquetas y ayudas)
    'chat.roles.reasoning':'Razonamiento Estratégico',
    'chat.roles.reasoning.hint':'Optimiza la lógica, la estructura y la coherencia.',
    'chat.roles.synthesis':'Síntesis Multi‑Modelo',
    'chat.roles.synthesis.hint':'Combina múltiples perspectivas en una respuesta unificada.',
    'chat.roles.multilingual':'Análisis Multilingüe',
    'chat.roles.multilingual.hint':'Comprende y responde de forma consistente en varios idiomas.',
    'chat.roles.code':'Codificación Contextual',
    'chat.roles.code.hint':'Genera código y ejemplos técnicos adaptados a tu consulta.',
    'chat.roles.context':'Enriquecimiento Contextual',
    'chat.roles.context.hint':'Añade contexto y aclaraciones relevantes cuando hace falta.',
    'chat.roles.creative':'Creatividad Dirigida',
    'chat.roles.creative.hint':'Propone opciones creativas o narrativa cuando se solicita.',
    'chat.roles.safety':'Seguridad y Moderación',
    'chat.roles.safety.hint':'Mantiene el contenido dentro de pautas éticas y de seguridad.',
    // Panel cognitivo
    'chat.cognitive.activeTitle':'Inteligencias activas en esta respuesta',
    'chat.cognitive.ecosystemTitle':'Ecosistema soportado',
    'chat.cognitive.ecosystemDisclaimer':'Nuestra orquestación selecciona dinámicamente un subconjunto de inteligencias y técnicas avanzadas según tu consulta. La lista expresa el ecosistema soportado.',
    // Estado
    'chat.status.consulting':'Consultando IAs...',
    'chat.status.generating':'Generando...',
    'chat.status.fallback':'Usando modo de respaldo...',
    // Meta
    'chat.meta.cached':'Desde caché',
    'chat.meta.refreshed':'Actualizado',
    'chat.meta.categories':'Categorías',
    // Entrada y ayudas
    'chat.input.placeholder':'Escribe tu siguiente pregunta...',
    'chat.input.sending':'Enviando',
    'chat.input.cta':'Enviar',
    'chat.hint':'Presiona Enter para enviar',
    'chat.hint.shortcut':'Enter: enviar • Shift+Enter: nueva línea',
    'chat.empty':'Haz tu primera pregunta para comenzar.',
    // Límites
    'chat.limits.trial':'Plan Trial activo',
    'chat.limits.unlimited':'Plan activo',
    // Errores
    'chat.error':'Error al generar respuesta.',
    'chat.search.toggle':'Buscar en la web (V2)',
    'chat.search.ttl':'Resultados con actualización frecuente'
  },
  pt: {
    'chat.actions.copy_full':'Copiar resposta completa',
    'chat.actions.copied':'Copiado',
    'chat.actions.download_md':'Baixar (.md)',
    'chat.actions.expand':'Ver mais',
    'chat.actions.collapse':'Recolher',
    'chat.actions.like':'Gostei',
    'chat.actions.dislike':'Não gostei',
    'chat.actions.go_top':'Ir ao topo',
    'chat.actions.go_end':'Ir ao final',
    'chat.code.copy':'Copiar código',
    'chat.code.copied':'Código copiado',
    'chat.code.download':'Baixar código',
    'chat.code.prev':'Anterior',
    'chat.code.next':'Próximo',
    'chat.code.part_label':'Parte {{current}}/{{total}}',
    'chat.code.language_fallback':'texto',
    'chat.toc.title':'Índice',
    'chat.readmode.open':'Modo leitura',
    'chat.readmode.close':'Fechar leitura'
  },
  fr: {
    'chat.actions.copy_full':'Copier réponse complète',
    'chat.actions.copied':'Copié',
    'chat.actions.download_md':'Télécharger (.md)',
    'chat.actions.expand':'Voir plus',
    'chat.actions.collapse':'Réduire',
    'chat.actions.like':'J\'aime',
    'chat.actions.dislike':'Je n\'aime pas',
    'chat.actions.go_top':'Haut de page',
    'chat.actions.go_end':'Bas de page',
    'chat.code.copy':'Copier le code',
    'chat.code.copied':'Code copié',
    'chat.code.download':'Télécharger le code',
    'chat.code.prev':'Préc.',
    'chat.code.next':'Suiv.',
    'chat.code.part_label':'Partie {{current}}/{{total}}',
    'chat.code.language_fallback':'texte',
    'chat.toc.title':'Sommaire',
    'chat.readmode.open':'Mode lecture',
    'chat.readmode.close':'Fermer lecture'
  },
  de: {
    'chat.actions.copy_full':'Komplette Antwort kopieren',
    'chat.actions.copied':'Kopiert',
    'chat.actions.download_md':'Herunterladen (.md)',
    'chat.actions.expand':'Mehr anzeigen',
    'chat.actions.collapse':'Einklappen',
    'chat.actions.like':'Gefällt mir',
    'chat.actions.dislike':'Gefällt mir nicht',
    'chat.actions.go_top':'Zum Anfang',
    'chat.actions.go_end':'Zum Ende',
    'chat.code.copy':'Code kopieren',
    'chat.code.copied':'Code kopiert',
    'chat.code.download':'Code herunterladen',
    'chat.code.prev':'Zurück',
    'chat.code.next':'Weiter',
    'chat.code.part_label':'Teil {{current}}/{{total}}',
    'chat.code.language_fallback':'text',
    'chat.toc.title':'Inhaltsverzeichnis',
    'chat.readmode.open':'Lesemodus',
    'chat.readmode.close':'Lesemodus schließen'
  },
  it: {
    'chat.actions.copy_full':'Copia risposta completa',
    'chat.actions.copied':'Copiato',
    'chat.actions.download_md':'Scarica (.md)',
    'chat.actions.expand':'Mostra di più',
    'chat.actions.collapse':'Comprimi',
    'chat.actions.like':'Mi piace',
    'chat.actions.dislike':'Non mi piace',
    'chat.actions.go_top':'Vai all\'inizio',
    'chat.actions.go_end':'Vai alla fine',
    'chat.code.copy':'Copia codice',
    'chat.code.copied':'Codice copiato',
    'chat.code.download':'Scarica codice',
    'chat.code.prev':'Prec.',
    'chat.code.next':'Succ.',
    'chat.code.part_label':'Parte {{current}}/{{total}}',
    'chat.code.language_fallback':'testo',
    'chat.toc.title':'Indice',
    'chat.readmode.open':'Modalità lettura',
    'chat.readmode.close':'Chiudi lettura'
  },
  zh: {
    'chat.actions.copy_full':'复制完整回答',
    'chat.actions.copied':'已复制',
    'chat.actions.download_md':'下载 (.md)',
    'chat.actions.expand':'展开更多',
    'chat.actions.collapse':'收起',
    'chat.actions.like':'赞',
    'chat.actions.dislike':'踩',
    'chat.actions.go_top':'回到顶部',
    'chat.actions.go_end':'跳到底部',
    'chat.code.copy':'复制代码',
    'chat.code.copied':'代码已复制',
    'chat.code.download':'下载代码',
    'chat.code.prev':'上一段',
    'chat.code.next':'下一段',
    'chat.code.part_label':'第 {{current}}/{{total}} 部分',
    'chat.code.language_fallback':'文本',
    'chat.toc.title':'目录',
    'chat.readmode.open':'阅读模式',
    'chat.readmode.close':'关闭阅读'
  },
  ja: {
    'chat.actions.copy_full':'全文回答をコピー',
    'chat.actions.copied':'コピーしました',
    'chat.actions.download_md':'ダウンロード (.md)',
    'chat.actions.expand':'もっと見る',
    'chat.actions.collapse':'折りたたむ',
    'chat.actions.like':'いいね',
    'chat.actions.dislike':'よくない',
    'chat.actions.go_top':'先頭へ',
    'chat.actions.go_end':'最後へ',
    'chat.code.copy':'コードをコピー',
    'chat.code.copied':'コードをコピーしました',
    'chat.code.download':'コードをダウンロード',
    'chat.code.prev':'前へ',
    'chat.code.next':'次へ',
    'chat.code.part_label':'パート {{current}}/{{total}}',
    'chat.code.language_fallback':'テキスト',
    'chat.toc.title':'目次',
    'chat.readmode.open':'リーディングモード',
    'chat.readmode.close':'閉じる'
  },
  ko: {
    'chat.actions.copy_full':'전체 답변 복사',
    'chat.actions.copied':'복사됨',
    'chat.actions.download_md':'다운로드 (.md)',
    'chat.actions.expand':'더 보기',
    'chat.actions.collapse':'접기',
    'chat.actions.like':'좋아요',
    'chat.actions.dislike':'싫어요',
    'chat.actions.go_top':'맨 위로',
    'chat.actions.go_end':'맨 아래로',
    'chat.code.copy':'코드 복사',
    'chat.code.copied':'코드 복사됨',
    'chat.code.download':'코드 다운로드',
    'chat.code.prev':'이전',
    'chat.code.next':'다음',
    'chat.code.part_label':'부분 {{current}}/{{total}}',
    'chat.code.language_fallback':'텍스트',
    'chat.toc.title':'목차',
    'chat.readmode.open':'읽기 모드',
    'chat.readmode.close':'읽기 모드 닫기'
  },
  ar: {
    'chat.actions.copy_full':'نسخ الإجابة الكاملة',
    'chat.actions.copied':'تم النسخ',
    'chat.actions.download_md':'تنزيل (.md)',
    'chat.actions.expand':'عرض المزيد',
    'chat.actions.collapse':'إخفاء',
    'chat.actions.like':'إعجاب',
    'chat.actions.dislike':'عدم إعجاب',
    'chat.actions.go_top':'أعلى الصفحة',
    'chat.actions.go_end':'أسفل الصفحة',
    'chat.code.copy':'نسخ الكود',
    'chat.code.copied':'تم نسخ الكود',
    'chat.code.download':'تنزيل الكود',
    'chat.code.prev':'السابق',
    'chat.code.next':'التالي',
    'chat.code.part_label':'الجزء {{current}}/{{total}}',
    'chat.code.language_fallback':'نص',
    'chat.toc.title':'الفهرس',
    'chat.readmode.open':'وضع القراءة',
    'chat.readmode.close':'إغلاق القراءة'
  },
  hi: {
    'chat.actions.copy_full':'पूर्ण उत्तर कॉपी करें',
    'chat.actions.copied':'कॉपी हो गया',
    'chat.actions.download_md':'डाउनलोड (.md)',
    'chat.actions.expand':'और देखें',
    'chat.actions.collapse':'संक्षिप्त करें',
    'chat.actions.like':'पसंद',
    'chat.actions.dislike':'नापसंद',
    'chat.actions.go_top':'शीर्ष पर जाएं',
    'chat.actions.go_end':'नीचे जाएं',
    'chat.code.copy':'कोड कॉपी करें',
    'chat.code.copied':'कोड कॉपी हो गया',
    'chat.code.download':'कोड डाउनलोड करें',
    'chat.code.prev':'पिछला',
    'chat.code.next':'अगला',
    'chat.code.part_label':'भाग {{current}}/{{total}}',
    'chat.code.language_fallback':'पाठ',
    'chat.toc.title':'विषय-सूची',
    'chat.readmode.open':'पठन मोड',
    'chat.readmode.close':'पठन बंद करें'
  },
  ru: {
    'chat.actions.copy_full':'Скопировать полный ответ',
    'chat.actions.copied':'Скопировано',
    'chat.actions.download_md':'Скачать (.md)',
    'chat.actions.expand':'Показать больше',
    'chat.actions.collapse':'Свернуть',
    'chat.actions.like':'Нравится',
    'chat.actions.dislike':'Не нравится',
    'chat.actions.go_top':'К началу',
    'chat.actions.go_end':'К концу',
    'chat.code.copy':'Скопировать код',
    'chat.code.copied':'Код скопирован',
    'chat.code.download':'Скачать код',
    'chat.code.prev':'Пред',
    'chat.code.next':'След',
    'chat.code.part_label':'Часть {{current}}/{{total}}',
    'chat.code.language_fallback':'текст',
    'chat.toc.title':'Оглавление',
    'chat.readmode.open':'Режим чтения',
    'chat.readmode.close':'Закрыть чтение'
  }
};

// Claves centrales del Chat (placeholder, hints, status, meta y búsqueda) en 12 idiomas.
// Solo se aplican si faltan en el recurso destino, para no sobrescribir traducciones existentes.
const chatCoreTranslations = {
  en: {
    'chat.placeholder.answer':'Generated answer.',
    'chat.input.placeholder':'Type your next question...',
    'chat.input.sending':'Sending',
    'chat.input.cta':'Send',
    'chat.hint':'Press Enter to send',
    'chat.hint_shortcut':'Enter: send • Shift+Enter: new line',
    'chat.empty':'Ask your first question to get started.',
    'chat.status.consulting':'Consulting AIs...',
    'chat.status.generating':'Generating...',
    'chat.status.fallback':'Using fallback mode...',
    'chat.meta.cached':'From cache',
    'chat.meta.refreshed':'Updated',
    'chat.meta.categories':'Categories',
    'chat.meta.specialized':'{{count}} specialized AIs',
    'chat.meta.sources_badge':'Integrated sources',
    'chat.meta.context_badge':'Context added',
    'chat.search.toggle':'Search the web (V2)',
    'chat.search.ttl':'Frequently refreshed results',
  },
  es: {
    'chat.placeholder.answer':'Respuesta generada.',
    'chat.input.placeholder':'Escribe tu siguiente pregunta...',
    'chat.input.sending':'Enviando',
    'chat.input.cta':'Enviar',
    'chat.hint':'Presiona Enter para enviar',
    'chat.hint_shortcut':'Enter: enviar • Shift+Enter: nueva línea',
    'chat.empty':'Haz tu primera pregunta para comenzar.',
    'chat.status.consulting':'Consultando IAs...',
    'chat.status.generating':'Generando...',
    'chat.status.fallback':'Usando modo de respaldo...',
    'chat.meta.cached':'Desde caché',
    'chat.meta.refreshed':'Actualizado',
    'chat.meta.categories':'Categorías',
    'chat.meta.specialized':'{{count}} IAs especializadas',
    'chat.meta.sources_badge':'Fuentes integradas',
    'chat.meta.context_badge':'Contexto añadido',
    'chat.search.toggle':'Buscar en la web (V2)',
    'chat.search.ttl':'Resultados con actualización frecuente',
  },
  pt: {
    'chat.placeholder.answer':'Resposta gerada.',
    'chat.input.placeholder':'Digite sua próxima pergunta...',
    'chat.input.sending':'Enviando',
    'chat.input.cta':'Enviar',
    'chat.hint':'Pressione Enter para enviar',
    'chat.hint_shortcut':'Enter: enviar • Shift+Enter: nova linha',
    'chat.empty':'Faça sua primeira pergunta para começar.',
    'chat.status.consulting':'Consultando IAs...',
    'chat.status.generating':'Gerando...',
    'chat.status.fallback':'Usando modo de fallback...',
    'chat.meta.cached':'Do cache',
    'chat.meta.refreshed':'Atualizado',
    'chat.meta.categories':'Categorias',
    'chat.meta.specialized':'{{count}} IAs especializadas',
    'chat.meta.sources_badge':'Fontes integradas',
    'chat.meta.context_badge':'Contexto adicionado',
    'chat.search.toggle':'Pesquisar na web (V2)',
    'chat.search.ttl':'Resultados atualizados com frequência',
  },
  fr: {
    'chat.placeholder.answer':'Réponse générée.',
    'chat.input.placeholder':'Tapez votre prochaine question...',
    'chat.input.sending':'Envoi',
    'chat.input.cta':'Envoyer',
    'chat.hint':'Appuyez sur Entrée pour envoyer',
    'chat.hint_shortcut':'Entrée: envoyer • Maj+Entrée: nouvelle ligne',
    'chat.empty':'Posez votre première question pour commencer.',
    'chat.status.consulting':'Consultation des IA...',
    'chat.status.generating':'Génération...',
    'chat.status.fallback':'Utilisation du mode de secours...',
    'chat.meta.cached':'Depuis le cache',
    'chat.meta.refreshed':'Mis à jour',
    'chat.meta.categories':'Catégories',
    'chat.meta.specialized':'{{count}} IA spécialisées',
    'chat.meta.sources_badge':'Sources intégrées',
    'chat.meta.context_badge':'Contexte ajouté',
    'chat.search.toggle':'Rechercher sur le web (V2)',
    'chat.search.ttl':'Résultats fréquemment actualisés',
  },
  de: {
    'chat.placeholder.answer':'Generierte Antwort.',
    'chat.input.placeholder':'Schreibe deine nächste Frage...',
    'chat.input.sending':'Senden',
    'chat.input.cta':'Senden',
    'chat.hint':'Drücke Enter zum Senden',
    'chat.hint_shortcut':'Enter: senden • Shift+Enter: neue Zeile',
    'chat.empty':'Stelle deine erste Frage, um zu beginnen.',
    'chat.status.consulting':'KIs werden konsultiert...',
    'chat.status.generating':'Wird generiert...',
    'chat.status.fallback':'Fallback-Modus wird verwendet...',
    'chat.meta.cached':'Aus dem Cache',
    'chat.meta.refreshed':'Aktualisiert',
    'chat.meta.categories':'Kategorien',
    'chat.meta.specialized':'{{count}} spezialisierte KIs',
    'chat.meta.sources_badge':'Integrierte Quellen',
    'chat.meta.context_badge':'Kontext hinzugefügt',
    'chat.search.toggle':'Im Web suchen (V2)',
    'chat.search.ttl':'Häufig aktualisierte Ergebnisse',
  },
  it: {
    'chat.placeholder.answer':'Risposta generata.',
    'chat.input.placeholder':'Scrivi la tua prossima domanda...',
    'chat.input.sending':'Invio',
    'chat.input.cta':'Invia',
    'chat.hint':'Premi Invio per inviare',
    'chat.hint_shortcut':'Invio: invia • Shift+Invio: nuova riga',
    'chat.empty':'Fai la tua prima domanda per iniziare.',
    'chat.status.consulting':'Consultazione delle IA...',
    'chat.status.generating':'Generazione in corso...',
    'chat.status.fallback':'Uso della modalità di fallback...',
    'chat.meta.cached':'Dalla cache',
    'chat.meta.refreshed':'Aggiornato',
    'chat.meta.categories':'Categorie',
    'chat.meta.specialized':'{{count}} IA specializzate',
    'chat.meta.sources_badge':'Fonti integrate',
    'chat.meta.context_badge':'Contesto aggiunto',
    'chat.search.toggle':'Cerca sul web (V2)',
    'chat.search.ttl':'Risultati aggiornati frequentemente',
  },
  zh: {
    'chat.placeholder.answer':'已生成的回答。',
    'chat.input.placeholder':'输入你的下一个问题...',
    'chat.input.sending':'发送中',
    'chat.input.cta':'发送',
    'chat.hint':'按 Enter 发送',
    'chat.hint_shortcut':'Enter：发送 • Shift+Enter：换行',
    'chat.empty':'提出你的第一个问题开始吧。',
    'chat.status.consulting':'正在咨询 AI...',
    'chat.status.generating':'正在生成...',
    'chat.status.fallback':'使用备用模式...',
    'chat.meta.cached':'来自缓存',
    'chat.meta.refreshed':'已更新',
    'chat.meta.categories':'分类',
    'chat.meta.specialized':'{{count}} 个专业化 AI',
    'chat.meta.sources_badge':'集成的来源',
    'chat.meta.context_badge':'已添加上下文',
    'chat.search.toggle':'在网上搜索 (V2)',
    'chat.search.ttl':'结果经常刷新',
  },
  ja: {
    'chat.placeholder.answer':'生成された回答。',
    'chat.input.placeholder':'次の質問を入力してください...',
    'chat.input.sending':'送信中',
    'chat.input.cta':'送信',
    'chat.hint':'Enter で送信',
    'chat.hint_shortcut':'Enter: 送信 • Shift+Enter: 改行',
    'chat.empty':'最初の質問を入力して開始します。',
    'chat.status.consulting':'AIに問い合わせ中...',
    'chat.status.generating':'生成中...',
    'chat.status.fallback':'フォールバックモードを使用中...',
    'chat.meta.cached':'キャッシュから',
    'chat.meta.refreshed':'更新しました',
    'chat.meta.categories':'カテゴリ',
    'chat.meta.specialized':'専門AI {{count}} 件',
    'chat.meta.sources_badge':'統合された出典',
    'chat.meta.context_badge':'コンテキストを追加',
    'chat.search.toggle':'Webで検索 (V2)',
    'chat.search.ttl':'頻繁に更新される結果',
  },
  ko: {
    'chat.placeholder.answer':'생성된 답변입니다.',
    'chat.input.placeholder':'다음 질문을 입력하세요...',
    'chat.input.sending':'전송 중',
    'chat.input.cta':'전송',
    'chat.hint':'Enter 키로 전송',
    'chat.hint_shortcut':'Enter: 전송 • Shift+Enter: 새 줄',
    'chat.empty':'시작하려면 첫 질문을 입력하세요.',
    'chat.status.consulting':'AI 문의 중...',
    'chat.status.generating':'생성 중...',
    'chat.status.fallback':'대체 모드 사용 중...',
    'chat.meta.cached':'캐시에서',
    'chat.meta.refreshed':'업데이트됨',
    'chat.meta.categories':'카테고리',
    'chat.meta.specialized':'특화 AI {{count}}개',
    'chat.meta.sources_badge':'통합된 출처',
    'chat.meta.context_badge':'컨텍스트 추가됨',
    'chat.search.toggle':'웹에서 검색 (V2)',
    'chat.search.ttl':'자주 새로고침되는 결과',
  },
  ar: {
    'chat.placeholder.answer':'إجابة مولدة.',
    'chat.input.placeholder':'اكتب سؤالك التالي...',
    'chat.input.sending':'جارٍ الإرسال',
    'chat.input.cta':'إرسال',
    'chat.hint':'اضغط Enter للإرسال',
    'chat.hint_shortcut':'Enter: إرسال • Shift+Enter: سطر جديد',
    'chat.empty':'ابدأ بطرح سؤالك الأول.',
    'chat.status.consulting':'جارٍ استشارة الذكاءات...',
    'chat.status.generating':'جارٍ التوليد...',
    'chat.status.fallback':'يتم استخدام وضع الاحتياطي...',
    'chat.meta.cached':'من الذاكرة المؤقتة',
    'chat.meta.refreshed':'تم التحديث',
    'chat.meta.categories':'الفئات',
    'chat.meta.specialized':'{{count}} ذكاءات متخصصة',
    'chat.meta.sources_badge':'مصادر مدمجة',
    'chat.meta.context_badge':'تمت إضافة السياق',
    'chat.search.toggle':'البحث على الويب (V2)',
    'chat.search.ttl':'نتائج يتم تحديثها بشكل متكرر',
  },
  hi: {
    'chat.placeholder.answer':'उत्पन्न उत्तर।',
    'chat.input.placeholder':'अपना अगला प्रश्न लिखें...',
    'chat.input.sending':'भेजा जा रहा है',
    'chat.input.cta':'भेजें',
    'chat.hint':'भेजने के लिए Enter दबाएँ',
    'chat.hint_shortcut':'Enter: भेजें • Shift+Enter: नई पंक्ति',
    'chat.empty':'शुरू करने के लिए अपना पहला प्रश्न पूछें।',
    'chat.status.consulting':'AI से परामर्श किया जा रहा है...',
    'chat.status.generating':'उत्पन्न किया जा रहा है...',
    'chat.status.fallback':'फॉलबैक मोड उपयोग में...',
    'chat.meta.cached':'कैश से',
    'chat.meta.refreshed':'अपडेट किया गया',
    'chat.meta.categories':'श्रेणियाँ',
    'chat.meta.specialized':'{{count}} विशिष्ट AI',
    'chat.meta.sources_badge':'एकीकृत स्रोत',
    'chat.meta.context_badge':'संदर्भ जोड़ा गया',
    'chat.search.toggle':'वेब पर खोजें (V2)',
    'chat.search.ttl':'अक्सर ताज़ा होने वाले परिणाम',
  },
  ru: {
    'chat.placeholder.answer':'Сгенерированный ответ.',
    'chat.input.placeholder':'Введите следующий вопрос...',
    'chat.input.sending':'Отправка',
    'chat.input.cta':'Отправить',
    'chat.hint':'Нажмите Enter, чтобы отправить',
    'chat.hint_shortcut':'Enter: отправить • Shift+Enter: новая строка',
    'chat.empty':'Задайте свой первый вопрос, чтобы начать.',
    'chat.status.consulting':'Идёт обращение к ИИ...',
    'chat.status.generating':'Генерация...',
    'chat.status.fallback':'Используется резервный режим...',
    'chat.meta.cached':'Из кэша',
    'chat.meta.refreshed':'Обновлено',
    'chat.meta.categories':'Категории',
    'chat.meta.specialized':'{{count}} специализированных ИИ',
    'chat.meta.sources_badge':'Интегрированные источники',
    'chat.meta.context_badge':'Контекст добавлен',
    'chat.search.toggle':'Искать в интернете (V2)',
    'chat.search.ttl':'Часто обновляемые результаты',
  },
};

Object.keys(chatCoreTranslations).forEach(lng => {
  const target = resources[lng];
  if (!target) return;
  const dict = chatCoreTranslations[lng];
  Object.keys(dict).forEach(k => {
    // En inglés, forzar override para claves de chat.* porque el common.json original tenía textos en español.
    if (lng === 'en' && k.startsWith('chat.')) {
      setDeep(target.translation, k, dict[k]);
      return;
    }
    if (!hasDeep(target.translation, k)) {
      setDeep(target.translation, k, dict[k]);
    }
  });
});

Object.keys(chatActionTranslations).forEach(lng => {
  const target = resources[lng];
  if (!target) return;
  const dict = chatActionTranslations[lng];
  Object.keys(dict).forEach(k => {
    if (!hasDeep(target.translation, k)) {
      setDeep(target.translation, k, dict[k]);
    }
  });
});

const billingSupportTranslations = {
  en: {
    sidebar: { billing: 'Billing', support: 'Support' },
    billing: {
      title: 'Billing Portal',
      subtitle: 'Manage your subscription and review your payment history',
      current_plan: 'Current Plan',
      activated_at: 'Activated on',
      access_until: 'Access until',
      next_billing: 'Next billing',
      subscription_id: 'Subscription ID',
      provider: 'Provider',
      no_subscription: 'You do not have an active subscription. Upgrade your plan to access all features.',
      renew_now: 'Renew now ->',
      payment_history: 'Payment History',
      last_50: 'Last 50 records',
      no_payments: 'No payments recorded yet.',
      open_freemius_portal: 'Open Freemius portal',
      freemius_receipts_notice: 'Receipts, invoices, and subscription changes are managed in the secure Freemius portal.',
      upgrade_now: 'Upgrade to Pro ->',
      quick_actions: 'Quick Actions',
      go_to_plans: 'View Plans',
      manage_cancellation: 'Manage cancellation',
      cancel_subscription: 'Cancel Subscription',
      manage_lemon: 'Manage subscription',
      refresh: 'Refresh',
      downgrade: {
        expired: 'Your subscription has expired.',
        cancelled: 'Your subscription was cancelled.',
        payment_failed: 'Your subscription was suspended because of a failed payment.',
        generic: 'Your plan was downgraded.'
      },
      col: { date: 'Date', plan: 'Plan', amount: 'Amount', status: 'Status' },
      error: {
        no_session: 'No active session. Please log in again.',
        fetch_failed: 'Could not load billing history.'
      },
      status: {
        active: 'Active',
        pending_cancel: 'Pending cancellation',
        cancelled: 'Cancelled',
        suspended: 'Suspended',
        expired: 'Expired',
        approved: 'Approved'
      },
      pay_status: { approved: 'Successful', failed: 'Failed', pending: 'Pending' }
    },
    support: {
      title: 'Support Center',
      subtitle: 'We are here to help',
      success: {
        title: 'Message sent!',
        body: 'We received your request and will reply in less than 24 hours.',
        confirm_email: 'We sent a confirmation to your email.',
        new_message: 'Send another message'
      },
      form: {
        title: 'Send us a message',
        name: 'Name',
        name_placeholder: 'Your name',
        email: 'Email address',
        plan: 'Current plan',
        subject: 'Subject',
        message: 'Message',
        message_placeholder: 'Describe your request with as much detail as possible. The more information you provide, the faster we can help.',
        error_generic: 'Could not send the message. Please try again.',
        sending: 'Sending...',
        submit: 'Send message'
      },
      subject: {
        select: 'Select a subject...',
        bug: 'Bug report or technical issue',
        billing: 'Billing or payment question',
        cancel: 'Cancel or modify subscription',
        account: 'Account or access issue',
        suggestion: 'Suggestion or improvement',
        business: 'Business proposal or partnership',
        general: 'General question'
      },
      validation: {
        name_required: 'Please enter your name.',
        email_required: 'Please enter a valid email address.',
        subject_required: 'Please select a subject.',
        message_min: 'The message must be at least 10 characters long.',
        no_session: 'No active session. Please log in again.',
        send_failed_direct: 'Could not send the message. Try again or write directly to support@intelliverseone.ai',
        connection_error: 'Connection error. Please try again.'
      },
      info: {
        title: 'Contact information',
        email_label: 'Email',
        response_time: 'Response time',
        response_value: 'Less than 24h',
        availability: 'Availability',
        availability_value: 'Monday - Friday',
        proplus_priority: 'As a Pro+ user, your request receives priority attention.'
      }
    }
  },
  es: {
    sidebar: { billing: 'Facturación', support: 'Soporte' },
    billing: {
      title: 'Portal de Facturación',
      subtitle: 'Gestiona tu suscripción y consulta tu historial de pagos',
      current_plan: 'Plan Actual',
      activated_at: 'Activada el',
      access_until: 'Acceso hasta',
      next_billing: 'Próximo cobro',
      subscription_id: 'ID de suscripción',
      provider: 'Proveedor',
      no_subscription: 'No tienes una suscripción activa. Actualiza tu plan para acceder a todas las funciones.',
      renew_now: 'Renovar ahora ->',
      payment_history: 'Historial de Pagos',
      last_50: 'Últimos 50 registros',
      no_payments: 'No hay pagos registrados todavía.',
      open_freemius_portal: 'Abrir portal Freemius',
      freemius_receipts_notice: 'Los recibos, facturas y cambios de suscripción se consultan en el portal seguro de Freemius.',
      upgrade_now: 'Mejorar a Pro ->',
      quick_actions: 'Acciones Rápidas',
      go_to_plans: 'Ver Planes',
      manage_cancellation: 'Gestionar cancelación',
      cancel_subscription: 'Cancelar Suscripción',
      manage_lemon: 'Gestionar suscripción',
      refresh: 'Actualizar',
      downgrade: {
        expired: 'Tu suscripción ha expirado.',
        cancelled: 'Tu suscripción fue cancelada.',
        payment_failed: 'Tu suscripción fue suspendida por un pago fallido.',
        generic: 'Tu plan fue degradado.'
      },
      col: { date: 'Fecha', plan: 'Plan', amount: 'Monto', status: 'Estado' },
      error: {
        no_session: 'No hay sesión activa. Vuelve a iniciar sesión.',
        fetch_failed: 'No se pudo cargar el historial de facturación.'
      },
      status: {
        active: 'Activa',
        pending_cancel: 'Cancelación pendiente',
        cancelled: 'Cancelada',
        suspended: 'Suspendida',
        expired: 'Expirada',
        approved: 'Aprobada'
      },
      pay_status: { approved: 'Exitoso', failed: 'Fallido', pending: 'Pendiente' }
    },
    support: {
      title: 'Centro de Soporte',
      subtitle: 'Estamos aquí para ayudarte',
      success: {
        title: '¡Mensaje enviado!',
        body: 'Hemos recibido tu consulta y te responderemos en menos de 24 horas.',
        confirm_email: 'Te enviamos una confirmación a tu correo.',
        new_message: 'Enviar otro mensaje'
      },
      form: {
        title: 'Envíanos un mensaje',
        name: 'Nombre',
        name_placeholder: 'Tu nombre',
        email: 'Correo electrónico',
        plan: 'Plan actual',
        subject: 'Asunto',
        message: 'Mensaje',
        message_placeholder: 'Describe tu consulta con el mayor detalle posible. Cuanta más información nos proporciones, más rápido podemos ayudarte.',
        error_generic: 'No se pudo enviar el mensaje. Intenta de nuevo.',
        sending: 'Enviando...',
        submit: 'Enviar mensaje'
      },
      subject: {
        select: 'Selecciona un asunto...',
        bug: 'Reporte de error o problema técnico',
        billing: 'Consulta de facturación o pagos',
        cancel: 'Cancelar o modificar suscripción',
        account: 'Problema con mi cuenta o acceso',
        suggestion: 'Sugerencia o mejora',
        business: 'Propuesta de negocio o alianza',
        general: 'Pregunta general'
      },
      validation: {
        name_required: 'Por favor ingresa tu nombre.',
        email_required: 'Por favor ingresa un correo válido.',
        subject_required: 'Por favor selecciona un asunto.',
        message_min: 'El mensaje debe tener al menos 10 caracteres.',
        no_session: 'No hay sesión activa. Vuelve a iniciar sesión.',
        send_failed_direct: 'No se pudo enviar el mensaje. Intenta de nuevo o escríbenos directamente a support@intelliverseone.ai',
        connection_error: 'Error de conexión. Intenta de nuevo.'
      },
      info: {
        title: 'Información de contacto',
        email_label: 'Email',
        response_time: 'Tiempo de respuesta',
        response_value: 'Menos de 24h',
        availability: 'Disponibilidad',
        availability_value: 'Lunes - Viernes',
        proplus_priority: 'Como usuario Pro+, tu consulta recibe atención prioritaria.'
      }
    }
  },
  pt: {
    sidebar: { billing: 'Faturamento', support: 'Suporte' },
    billing: {
      title: 'Portal de Faturamento',
      subtitle: 'Gerencie sua assinatura e consulte seu histórico de pagamentos',
      current_plan: 'Plano Atual',
      activated_at: 'Ativado em',
      access_until: 'Acesso até',
      next_billing: 'Próxima cobrança',
      subscription_id: 'ID da assinatura',
      provider: 'Provedor',
      no_subscription: 'Você não tem uma assinatura ativa. Atualize seu plano para acessar todos os recursos.',
      renew_now: 'Renovar agora ->',
      payment_history: 'Histórico de Pagamentos',
      last_50: 'Últimos 50 registros',
      no_payments: 'Ainda não há pagamentos registrados.',
      open_freemius_portal: 'Abrir portal Freemius',
      freemius_receipts_notice: 'Recibos, faturas e alterações de assinatura são consultados no portal seguro da Freemius.',
      upgrade_now: 'Atualizar para Pro ->',
      quick_actions: 'Ações Rápidas',
      go_to_plans: 'Ver Planos',
      manage_cancellation: 'Gerenciar cancelamento',
      cancel_subscription: 'Cancelar Assinatura',
      manage_lemon: 'Gerenciar assinatura',
      refresh: 'Atualizar',
      downgrade: { expired: 'Sua assinatura expirou.', cancelled: 'Sua assinatura foi cancelada.', payment_failed: 'Sua assinatura foi suspensa por falha no pagamento.', generic: 'Seu plano foi rebaixado.' },
      col: { date: 'Data', plan: 'Plano', amount: 'Valor', status: 'Status' },
      error: { no_session: 'Não há sessão ativa. Faça login novamente.', fetch_failed: 'Não foi possível carregar o histórico de faturamento.' },
      status: { active: 'Ativa', pending_cancel: 'Cancelamento pendente', cancelled: 'Cancelada', suspended: 'Suspensa', expired: 'Expirada', approved: 'Aprovada' },
      pay_status: { approved: 'Bem-sucedido', failed: 'Falhou', pending: 'Pendente' }
    },
    support: {
      title: 'Central de Suporte',
      subtitle: 'Estamos aqui para ajudar',
      success: { title: 'Mensagem enviada!', body: 'Recebemos sua solicitação e responderemos em menos de 24 horas.', confirm_email: 'Enviamos uma confirmação para seu email.', new_message: 'Enviar outra mensagem' },
      form: { title: 'Envie-nos uma mensagem', name: 'Nome', name_placeholder: 'Seu nome', email: 'Email', plan: 'Plano atual', subject: 'Assunto', message: 'Mensagem', message_placeholder: 'Descreva sua solicitação com o máximo de detalhes possível. Quanto mais informações você fornecer, mais rápido poderemos ajudar.', error_generic: 'Não foi possível enviar a mensagem. Tente novamente.', sending: 'Enviando...', submit: 'Enviar mensagem' },
      subject: { select: 'Selecione um assunto...', bug: 'Relatório de erro ou problema técnico', billing: 'Dúvida de faturamento ou pagamento', cancel: 'Cancelar ou modificar assinatura', account: 'Problema com minha conta ou acesso', suggestion: 'Sugestão ou melhoria', business: 'Proposta de negócio ou parceria', general: 'Pergunta geral' },
      validation: { name_required: 'Por favor, informe seu nome.', email_required: 'Por favor, informe um email válido.', subject_required: 'Por favor, selecione um assunto.', message_min: 'A mensagem deve ter pelo menos 10 caracteres.', no_session: 'Não há sessão ativa. Faça login novamente.', send_failed_direct: 'Não foi possível enviar a mensagem. Tente novamente ou escreva diretamente para support@intelliverseone.ai', connection_error: 'Erro de conexão. Tente novamente.' },
      info: { title: 'Informações de contato', email_label: 'Email', response_time: 'Tempo de resposta', response_value: 'Menos de 24h', availability: 'Disponibilidade', availability_value: 'Segunda - Sexta', proplus_priority: 'Como usuário Pro+, sua solicitação recebe atendimento prioritário.' }
    }
  },
  fr: {
    sidebar: { billing: 'Facturation', support: 'Support' },
    billing: {
      title: 'Portail de Facturation',
      subtitle: 'Gérez votre abonnement et consultez votre historique de paiements',
      current_plan: 'Plan Actuel',
      activated_at: 'Activé le',
      access_until: "Accès jusqu'au",
      next_billing: 'Prochaine facturation',
      subscription_id: "ID d'abonnement",
      provider: 'Fournisseur',
      no_subscription: "Vous n'avez pas d'abonnement actif. Mettez votre plan à niveau pour accéder à toutes les fonctionnalités.",
      renew_now: 'Renouveler maintenant ->',
      payment_history: 'Historique des Paiements',
      last_50: '50 derniers enregistrements',
      no_payments: "Aucun paiement n'est encore enregistré.",
      open_freemius_portal: 'Ouvrir le portail Freemius',
      freemius_receipts_notice: 'Les reçus, factures et modifications d’abonnement se consultent dans le portail sécurisé Freemius.',
      upgrade_now: 'Passer à Pro ->',
      quick_actions: 'Actions Rapides',
      go_to_plans: 'Voir les Plans',
      manage_cancellation: "Gérer l'annulation",
      cancel_subscription: "Annuler l'Abonnement",
      manage_lemon: "Gérer l'abonnement",
      refresh: 'Actualiser',
      downgrade: { expired: 'Votre abonnement a expiré.', cancelled: 'Votre abonnement a été annulé.', payment_failed: 'Votre abonnement a été suspendu à cause d’un paiement échoué.', generic: 'Votre plan a été rétrogradé.' },
      col: { date: 'Date', plan: 'Plan', amount: 'Montant', status: 'Statut' },
      error: { no_session: 'Aucune session active. Connectez-vous à nouveau.', fetch_failed: "Impossible de charger l'historique de facturation." },
      status: { active: 'Actif', pending_cancel: 'Annulation en attente', cancelled: 'Annulé', suspended: 'Suspendu', expired: 'Expiré', approved: 'Approuvé' },
      pay_status: { approved: 'Réussi', failed: 'Échoué', pending: 'En attente' }
    },
    support: {
      title: 'Centre de Support',
      subtitle: 'Nous sommes là pour vous aider',
      success: { title: 'Message envoyé !', body: 'Nous avons reçu votre demande et répondrons en moins de 24 heures.', confirm_email: 'Nous avons envoyé une confirmation à votre email.', new_message: 'Envoyer un autre message' },
      form: { title: 'Envoyez-nous un message', name: 'Nom', name_placeholder: 'Votre nom', email: 'Email', plan: 'Plan actuel', subject: 'Sujet', message: 'Message', message_placeholder: 'Décrivez votre demande avec le plus de détails possible. Plus vous fournissez d’informations, plus vite nous pouvons vous aider.', error_generic: "Impossible d'envoyer le message. Réessayez.", sending: 'Envoi...', submit: 'Envoyer le message' },
      subject: { select: 'Sélectionnez un sujet...', bug: 'Rapport de bug ou problème technique', billing: 'Question de facturation ou de paiement', cancel: "Annuler ou modifier l'abonnement", account: 'Problème de compte ou d’accès', suggestion: 'Suggestion ou amélioration', business: 'Proposition commerciale ou partenariat', general: 'Question générale' },
      validation: { name_required: 'Veuillez saisir votre nom.', email_required: 'Veuillez saisir un email valide.', subject_required: 'Veuillez sélectionner un sujet.', message_min: 'Le message doit contenir au moins 10 caractères.', no_session: 'Aucune session active. Connectez-vous à nouveau.', send_failed_direct: 'Impossible d’envoyer le message. Réessayez ou écrivez directement à support@intelliverseone.ai', connection_error: 'Erreur de connexion. Réessayez.' },
      info: { title: 'Informations de contact', email_label: 'Email', response_time: 'Temps de réponse', response_value: 'Moins de 24h', availability: 'Disponibilité', availability_value: 'Lundi - Vendredi', proplus_priority: 'En tant qu’utilisateur Pro+, votre demande reçoit une attention prioritaire.' }
    }
  },
  de: {
    sidebar: { billing: 'Abrechnung', support: 'Support' },
    billing: {
      title: 'Abrechnungsportal',
      subtitle: 'Verwalten Sie Ihr Abonnement und prüfen Sie Ihren Zahlungsverlauf',
      current_plan: 'Aktueller Plan',
      activated_at: 'Aktiviert am',
      access_until: 'Zugriff bis',
      next_billing: 'Nächste Abrechnung',
      subscription_id: 'Abonnement-ID',
      provider: 'Anbieter',
      no_subscription: 'Sie haben kein aktives Abonnement. Aktualisieren Sie Ihren Plan, um alle Funktionen zu nutzen.',
      renew_now: 'Jetzt erneuern ->',
      payment_history: 'Zahlungsverlauf',
      last_50: 'Letzte 50 Einträge',
      no_payments: 'Noch keine Zahlungen erfasst.',
      open_freemius_portal: 'Freemius-Portal öffnen',
      freemius_receipts_notice: 'Belege, Rechnungen und Abo-Änderungen werden im sicheren Freemius-Portal verwaltet.',
      upgrade_now: 'Auf Pro upgraden ->',
      quick_actions: 'Schnellaktionen',
      go_to_plans: 'Pläne ansehen',
      manage_cancellation: 'Kündigung verwalten',
      cancel_subscription: 'Abonnement kündigen',
      manage_lemon: 'Abonnement verwalten',
      refresh: 'Aktualisieren',
      downgrade: { expired: 'Ihr Abonnement ist abgelaufen.', cancelled: 'Ihr Abonnement wurde gekündigt.', payment_failed: 'Ihr Abonnement wurde wegen einer fehlgeschlagenen Zahlung ausgesetzt.', generic: 'Ihr Plan wurde herabgestuft.' },
      col: { date: 'Datum', plan: 'Plan', amount: 'Betrag', status: 'Status' },
      error: { no_session: 'Keine aktive Sitzung. Bitte melden Sie sich erneut an.', fetch_failed: 'Der Abrechnungsverlauf konnte nicht geladen werden.' },
      status: { active: 'Aktiv', pending_cancel: 'Kündigung ausstehend', cancelled: 'Gekündigt', suspended: 'Ausgesetzt', expired: 'Abgelaufen', approved: 'Genehmigt' },
      pay_status: { approved: 'Erfolgreich', failed: 'Fehlgeschlagen', pending: 'Ausstehend' }
    },
    support: {
      title: 'Support-Center',
      subtitle: 'Wir sind hier, um zu helfen',
      success: { title: 'Nachricht gesendet!', body: 'Wir haben Ihre Anfrage erhalten und antworten in weniger als 24 Stunden.', confirm_email: 'Wir haben eine Bestätigung an Ihre E-Mail gesendet.', new_message: 'Weitere Nachricht senden' },
      form: { title: 'Senden Sie uns eine Nachricht', name: 'Name', name_placeholder: 'Ihr Name', email: 'E-Mail-Adresse', plan: 'Aktueller Plan', subject: 'Betreff', message: 'Nachricht', message_placeholder: 'Beschreiben Sie Ihre Anfrage so detailliert wie möglich. Je mehr Informationen Sie geben, desto schneller können wir helfen.', error_generic: 'Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.', sending: 'Wird gesendet...', submit: 'Nachricht senden' },
      subject: { select: 'Betreff auswählen...', bug: 'Fehlerbericht oder technisches Problem', billing: 'Frage zu Abrechnung oder Zahlung', cancel: 'Abonnement kündigen oder ändern', account: 'Problem mit Konto oder Zugriff', suggestion: 'Vorschlag oder Verbesserung', business: 'Geschäftsvorschlag oder Partnerschaft', general: 'Allgemeine Frage' },
      validation: { name_required: 'Bitte geben Sie Ihren Namen ein.', email_required: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.', subject_required: 'Bitte wählen Sie einen Betreff aus.', message_min: 'Die Nachricht muss mindestens 10 Zeichen lang sein.', no_session: 'Keine aktive Sitzung. Bitte melden Sie sich erneut an.', send_failed_direct: 'Die Nachricht konnte nicht gesendet werden. Versuchen Sie es erneut oder schreiben Sie direkt an support@intelliverseone.ai', connection_error: 'Verbindungsfehler. Bitte versuchen Sie es erneut.' },
      info: { title: 'Kontaktinformationen', email_label: 'E-Mail', response_time: 'Antwortzeit', response_value: 'Weniger als 24h', availability: 'Verfügbarkeit', availability_value: 'Montag - Freitag', proplus_priority: 'Als Pro+-Nutzer erhält Ihre Anfrage vorrangige Aufmerksamkeit.' }
    }
  },
  it: {
    sidebar: { billing: 'Fatturazione', support: 'Supporto' },
    billing: {
      title: 'Portale di Fatturazione',
      subtitle: 'Gestisci il tuo abbonamento e consulta lo storico dei pagamenti',
      current_plan: 'Piano Attuale',
      activated_at: 'Attivato il',
      access_until: 'Accesso fino al',
      next_billing: 'Prossimo addebito',
      subscription_id: 'ID abbonamento',
      provider: 'Provider',
      no_subscription: 'Non hai un abbonamento attivo. Aggiorna il piano per accedere a tutte le funzioni.',
      renew_now: 'Rinnova ora ->',
      payment_history: 'Storico Pagamenti',
      last_50: 'Ultimi 50 record',
      no_payments: 'Non ci sono ancora pagamenti registrati.',
      open_freemius_portal: 'Apri portale Freemius',
      freemius_receipts_notice: 'Ricevute, fatture e modifiche dell’abbonamento si consultano nel portale sicuro di Freemius.',
      upgrade_now: 'Passa a Pro ->',
      quick_actions: 'Azioni Rapide',
      go_to_plans: 'Vedi Piani',
      manage_cancellation: 'Gestisci cancellazione',
      cancel_subscription: 'Annulla Abbonamento',
      manage_lemon: 'Gestisci abbonamento',
      refresh: 'Aggiorna',
      downgrade: { expired: 'Il tuo abbonamento è scaduto.', cancelled: 'Il tuo abbonamento è stato annullato.', payment_failed: 'Il tuo abbonamento è stato sospeso per un pagamento non riuscito.', generic: 'Il tuo piano è stato declassato.' },
      col: { date: 'Data', plan: 'Piano', amount: 'Importo', status: 'Stato' },
      error: { no_session: 'Nessuna sessione attiva. Accedi di nuovo.', fetch_failed: 'Impossibile caricare lo storico di fatturazione.' },
      status: { active: 'Attivo', pending_cancel: 'Cancellazione in sospeso', cancelled: 'Annullato', suspended: 'Sospeso', expired: 'Scaduto', approved: 'Approvato' },
      pay_status: { approved: 'Riuscito', failed: 'Non riuscito', pending: 'In sospeso' }
    },
    support: {
      title: 'Centro Supporto',
      subtitle: 'Siamo qui per aiutarti',
      success: { title: 'Messaggio inviato!', body: 'Abbiamo ricevuto la tua richiesta e risponderemo in meno di 24 ore.', confirm_email: 'Abbiamo inviato una conferma alla tua email.', new_message: 'Invia un altro messaggio' },
      form: { title: 'Inviaci un messaggio', name: 'Nome', name_placeholder: 'Il tuo nome', email: 'Email', plan: 'Piano attuale', subject: 'Oggetto', message: 'Messaggio', message_placeholder: 'Descrivi la tua richiesta con più dettagli possibile. Più informazioni fornisci, più velocemente potremo aiutarti.', error_generic: 'Impossibile inviare il messaggio. Riprova.', sending: 'Invio...', submit: 'Invia messaggio' },
      subject: { select: 'Seleziona un oggetto...', bug: 'Segnalazione bug o problema tecnico', billing: 'Domanda su fatturazione o pagamenti', cancel: 'Annullare o modificare abbonamento', account: 'Problema con account o accesso', suggestion: 'Suggerimento o miglioramento', business: 'Proposta commerciale o partnership', general: 'Domanda generale' },
      validation: { name_required: 'Inserisci il tuo nome.', email_required: 'Inserisci un indirizzo email valido.', subject_required: 'Seleziona un oggetto.', message_min: 'Il messaggio deve contenere almeno 10 caratteri.', no_session: 'Nessuna sessione attiva. Accedi di nuovo.', send_failed_direct: 'Impossibile inviare il messaggio. Riprova o scrivi direttamente a support@intelliverseone.ai', connection_error: 'Errore di connessione. Riprova.' },
      info: { title: 'Informazioni di contatto', email_label: 'Email', response_time: 'Tempo di risposta', response_value: 'Meno di 24h', availability: 'Disponibilità', availability_value: 'Lunedì - Venerdì', proplus_priority: 'Come utente Pro+, la tua richiesta riceve attenzione prioritaria.' }
    }
  },
  zh: {
    sidebar: { billing: '账单', support: '支持' },
    billing: {
      title: '账单门户',
      subtitle: '管理你的订阅并查看付款历史',
      current_plan: '当前套餐',
      activated_at: '激活于',
      access_until: '访问有效期至',
      next_billing: '下次扣费',
      subscription_id: '订阅 ID',
      provider: '服务提供商',
      no_subscription: '你当前没有有效订阅。升级套餐即可使用全部功能。',
      renew_now: '立即续订 ->',
      payment_history: '付款历史',
      last_50: '最近 50 条记录',
      no_payments: '还没有付款记录。',
      open_freemius_portal: '打开 Freemius 门户',
      freemius_receipts_notice: '收据、发票和订阅变更可在安全的 Freemius 门户中查看。',
      upgrade_now: '升级到 Pro ->',
      quick_actions: '快捷操作',
      go_to_plans: '查看套餐',
      manage_cancellation: '管理取消',
      cancel_subscription: '取消订阅',
      manage_lemon: '管理订阅',
      refresh: '刷新',
      downgrade: { expired: '你的订阅已过期。', cancelled: '你的订阅已取消。', payment_failed: '你的订阅因付款失败而被暂停。', generic: '你的套餐已降级。' },
      col: { date: '日期', plan: '套餐', amount: '金额', status: '状态' },
      error: { no_session: '没有活动会话。请重新登录。', fetch_failed: '无法加载账单历史。' },
      status: { active: '有效', pending_cancel: '等待取消', cancelled: '已取消', suspended: '已暂停', expired: '已过期', approved: '已批准' },
      pay_status: { approved: '成功', failed: '失败', pending: '待处理' }
    },
    support: {
      title: '支持中心',
      subtitle: '我们随时为你提供帮助',
      success: { title: '消息已发送！', body: '我们已收到你的请求，并会在 24 小时内回复。', confirm_email: '我们已向你的邮箱发送确认信息。', new_message: '发送另一条消息' },
      form: { title: '给我们留言', name: '姓名', name_placeholder: '你的姓名', email: '电子邮件', plan: '当前套餐', subject: '主题', message: '消息', message_placeholder: '请尽可能详细地描述你的请求。信息越完整，我们就能越快帮助你。', error_generic: '无法发送消息。请重试。', sending: '发送中...', submit: '发送消息' },
      subject: { select: '选择主题...', bug: '错误报告或技术问题', billing: '账单或付款问题', cancel: '取消或修改订阅', account: '账户或访问问题', suggestion: '建议或改进', business: '商业提案或合作', general: '一般问题' },
      validation: { name_required: '请输入你的姓名。', email_required: '请输入有效的电子邮件地址。', subject_required: '请选择主题。', message_min: '消息至少需要 10 个字符。', no_session: '没有活动会话。请重新登录。', send_failed_direct: '无法发送消息。请重试或直接写信至 support@intelliverseone.ai', connection_error: '连接错误。请重试。' },
      info: { title: '联系信息', email_label: '电子邮件', response_time: '响应时间', response_value: '少于 24 小时', availability: '可用时间', availability_value: '周一 - 周五', proplus_priority: '作为 Pro+ 用户，你的请求将获得优先处理。' }
    }
  },
  ja: {
    sidebar: { billing: '請求', support: 'サポート' },
    billing: {
      title: '請求ポータル',
      subtitle: 'サブスクリプションを管理し、支払い履歴を確認します',
      current_plan: '現在のプラン',
      activated_at: '有効化日',
      access_until: 'アクセス期限',
      next_billing: '次回請求',
      subscription_id: 'サブスクリプション ID',
      provider: 'プロバイダー',
      no_subscription: '有効なサブスクリプションがありません。すべての機能を利用するにはプランをアップグレードしてください。',
      renew_now: '今すぐ更新 ->',
      payment_history: '支払い履歴',
      last_50: '最新 50 件',
      no_payments: 'まだ支払い記録はありません。',
      open_freemius_portal: 'Freemius ポータルを開く',
      freemius_receipts_notice: '領収書、請求書、サブスクリプション変更は安全な Freemius ポータルで確認できます。',
      upgrade_now: 'Pro にアップグレード ->',
      quick_actions: 'クイック操作',
      go_to_plans: 'プランを見る',
      manage_cancellation: 'キャンセルを管理',
      cancel_subscription: 'サブスクリプションをキャンセル',
      manage_lemon: 'サブスクリプションを管理',
      refresh: '更新',
      downgrade: { expired: 'サブスクリプションの有効期限が切れました。', cancelled: 'サブスクリプションはキャンセルされました。', payment_failed: '支払い失敗によりサブスクリプションが停止されました。', generic: 'プランがダウングレードされました。' },
      col: { date: '日付', plan: 'プラン', amount: '金額', status: 'ステータス' },
      error: { no_session: '有効なセッションがありません。もう一度ログインしてください。', fetch_failed: '請求履歴を読み込めませんでした。' },
      status: { active: '有効', pending_cancel: 'キャンセル保留中', cancelled: 'キャンセル済み', suspended: '停止中', expired: '期限切れ', approved: '承認済み' },
      pay_status: { approved: '成功', failed: '失敗', pending: '保留中' }
    },
    support: {
      title: 'サポートセンター',
      subtitle: 'お困りごとをサポートします',
      success: { title: 'メッセージを送信しました！', body: 'お問い合わせを受け付けました。24時間以内に返信します。', confirm_email: '確認メールを送信しました。', new_message: '別のメッセージを送る' },
      form: { title: 'メッセージを送信', name: '名前', name_placeholder: 'あなたの名前', email: 'メールアドレス', plan: '現在のプラン', subject: '件名', message: 'メッセージ', message_placeholder: 'お問い合わせ内容をできるだけ詳しく説明してください。情報が多いほど早く対応できます。', error_generic: 'メッセージを送信できませんでした。もう一度お試しください。', sending: '送信中...', submit: 'メッセージを送信' },
      subject: { select: '件名を選択...', bug: 'バグ報告または技術的な問題', billing: '請求または支払いに関する質問', cancel: 'サブスクリプションのキャンセルまたは変更', account: 'アカウントまたはアクセスの問題', suggestion: '提案または改善', business: 'ビジネス提案または提携', general: '一般的な質問' },
      validation: { name_required: '名前を入力してください。', email_required: '有効なメールアドレスを入力してください。', subject_required: '件名を選択してください。', message_min: 'メッセージは10文字以上で入力してください。', no_session: '有効なセッションがありません。もう一度ログインしてください。', send_failed_direct: 'メッセージを送信できませんでした。再試行するか support@intelliverseone.ai に直接ご連絡ください', connection_error: '接続エラーです。もう一度お試しください。' },
      info: { title: '連絡先情報', email_label: 'メール', response_time: '応答時間', response_value: '24時間以内', availability: '対応時間', availability_value: '月曜 - 金曜', proplus_priority: 'Pro+ ユーザーとして、お問い合わせは優先的に対応されます。' }
    }
  },
  ko: {
    sidebar: { billing: '결제', support: '지원' },
    billing: {
      title: '결제 포털',
      subtitle: '구독을 관리하고 결제 내역을 확인하세요',
      current_plan: '현재 플랜',
      activated_at: '활성화일',
      access_until: '이용 가능 기간',
      next_billing: '다음 결제',
      subscription_id: '구독 ID',
      provider: '제공업체',
      no_subscription: '활성 구독이 없습니다. 모든 기능을 이용하려면 플랜을 업그레이드하세요.',
      renew_now: '지금 갱신 ->',
      payment_history: '결제 내역',
      last_50: '최근 50개 기록',
      no_payments: '아직 등록된 결제가 없습니다.',
      open_freemius_portal: 'Freemius 포털 열기',
      freemius_receipts_notice: '영수증, 청구서 및 구독 변경 사항은 안전한 Freemius 포털에서 확인할 수 있습니다.',
      upgrade_now: 'Pro로 업그레이드 ->',
      quick_actions: '빠른 작업',
      go_to_plans: '플랜 보기',
      manage_cancellation: '취소 관리',
      cancel_subscription: '구독 취소',
      manage_lemon: '구독 관리',
      refresh: '새로고침',
      downgrade: { expired: '구독이 만료되었습니다.', cancelled: '구독이 취소되었습니다.', payment_failed: '결제 실패로 구독이 일시 중지되었습니다.', generic: '플랜이 다운그레이드되었습니다.' },
      col: { date: '날짜', plan: '플랜', amount: '금액', status: '상태' },
      error: { no_session: '활성 세션이 없습니다. 다시 로그인하세요.', fetch_failed: '결제 내역을 불러올 수 없습니다.' },
      status: { active: '활성', pending_cancel: '취소 대기', cancelled: '취소됨', suspended: '일시 중지됨', expired: '만료됨', approved: '승인됨' },
      pay_status: { approved: '성공', failed: '실패', pending: '대기 중' }
    },
    support: {
      title: '지원 센터',
      subtitle: '도움을 드리겠습니다',
      success: { title: '메시지가 전송되었습니다!', body: '요청을 받았으며 24시간 이내에 답변드리겠습니다.', confirm_email: '확인 메일을 보냈습니다.', new_message: '다른 메시지 보내기' },
      form: { title: '메시지 보내기', name: '이름', name_placeholder: '이름', email: '이메일 주소', plan: '현재 플랜', subject: '제목', message: '메시지', message_placeholder: '요청 내용을 가능한 한 자세히 설명하세요. 정보가 많을수록 더 빠르게 도와드릴 수 있습니다.', error_generic: '메시지를 보낼 수 없습니다. 다시 시도하세요.', sending: '전송 중...', submit: '메시지 보내기' },
      subject: { select: '제목 선택...', bug: '버그 신고 또는 기술 문제', billing: '결제 또는 청구 문의', cancel: '구독 취소 또는 변경', account: '계정 또는 접근 문제', suggestion: '제안 또는 개선', business: '비즈니스 제안 또는 파트너십', general: '일반 질문' },
      validation: { name_required: '이름을 입력하세요.', email_required: '유효한 이메일 주소를 입력하세요.', subject_required: '제목을 선택하세요.', message_min: '메시지는 최소 10자 이상이어야 합니다.', no_session: '활성 세션이 없습니다. 다시 로그인하세요.', send_failed_direct: '메시지를 보낼 수 없습니다. 다시 시도하거나 support@intelliverseone.ai로 직접 문의하세요', connection_error: '연결 오류입니다. 다시 시도하세요.' },
      info: { title: '연락처 정보', email_label: '이메일', response_time: '응답 시간', response_value: '24시간 이내', availability: '지원 시간', availability_value: '월요일 - 금요일', proplus_priority: 'Pro+ 사용자로서 요청이 우선 처리됩니다.' }
    }
  },
  ar: {
    sidebar: { billing: 'الفوترة', support: 'الدعم' },
    billing: {
      title: 'بوابة الفوترة',
      subtitle: 'أدر اشتراكك وراجع سجل المدفوعات',
      current_plan: 'الخطة الحالية',
      activated_at: 'تم التفعيل في',
      access_until: 'الوصول حتى',
      next_billing: 'الفوترة التالية',
      subscription_id: 'معرف الاشتراك',
      provider: 'المزوّد',
      no_subscription: 'ليس لديك اشتراك نشط. قم بترقية خطتك للوصول إلى جميع الميزات.',
      renew_now: 'جدد الآن ->',
      payment_history: 'سجل المدفوعات',
      last_50: 'آخر 50 سجلاً',
      no_payments: 'لا توجد مدفوعات مسجلة بعد.',
      open_freemius_portal: 'فتح بوابة Freemius',
      freemius_receipts_notice: 'يمكن مراجعة الإيصالات والفواتير وتغييرات الاشتراك من بوابة Freemius الآمنة.',
      upgrade_now: 'الترقية إلى Pro ->',
      quick_actions: 'إجراءات سريعة',
      go_to_plans: 'عرض الخطط',
      manage_cancellation: 'إدارة الإلغاء',
      cancel_subscription: 'إلغاء الاشتراك',
      manage_lemon: 'إدارة الاشتراك',
      refresh: 'تحديث',
      downgrade: { expired: 'انتهت صلاحية اشتراكك.', cancelled: 'تم إلغاء اشتراكك.', payment_failed: 'تم تعليق اشتراكك بسبب فشل الدفع.', generic: 'تم تخفيض خطتك.' },
      col: { date: 'التاريخ', plan: 'الخطة', amount: 'المبلغ', status: 'الحالة' },
      error: { no_session: 'لا توجد جلسة نشطة. يرجى تسجيل الدخول مرة أخرى.', fetch_failed: 'تعذر تحميل سجل الفوترة.' },
      status: { active: 'نشط', pending_cancel: 'الإلغاء قيد الانتظار', cancelled: 'ملغى', suspended: 'معلق', expired: 'منتهي', approved: 'موافق عليه' },
      pay_status: { approved: 'ناجح', failed: 'فشل', pending: 'قيد الانتظار' }
    },
    support: {
      title: 'مركز الدعم',
      subtitle: 'نحن هنا لمساعدتك',
      success: { title: 'تم إرسال الرسالة!', body: 'استلمنا طلبك وسنرد خلال أقل من 24 ساعة.', confirm_email: 'أرسلنا تأكيداً إلى بريدك الإلكتروني.', new_message: 'إرسال رسالة أخرى' },
      form: { title: 'أرسل لنا رسالة', name: 'الاسم', name_placeholder: 'اسمك', email: 'البريد الإلكتروني', plan: 'الخطة الحالية', subject: 'الموضوع', message: 'الرسالة', message_placeholder: 'صف طلبك بأكبر قدر ممكن من التفاصيل. كلما زادت المعلومات، استطعنا مساعدتك بشكل أسرع.', error_generic: 'تعذر إرسال الرسالة. حاول مرة أخرى.', sending: 'جارٍ الإرسال...', submit: 'إرسال الرسالة' },
      subject: { select: 'اختر موضوعاً...', bug: 'تقرير خطأ أو مشكلة تقنية', billing: 'سؤال عن الفوترة أو الدفع', cancel: 'إلغاء أو تعديل الاشتراك', account: 'مشكلة في الحساب أو الوصول', suggestion: 'اقتراح أو تحسين', business: 'عرض تجاري أو شراكة', general: 'سؤال عام' },
      validation: { name_required: 'يرجى إدخال اسمك.', email_required: 'يرجى إدخال بريد إلكتروني صالح.', subject_required: 'يرجى اختيار موضوع.', message_min: 'يجب أن تتكون الرسالة من 10 أحرف على الأقل.', no_session: 'لا توجد جلسة نشطة. يرجى تسجيل الدخول مرة أخرى.', send_failed_direct: 'تعذر إرسال الرسالة. حاول مرة أخرى أو اكتب مباشرة إلى support@intelliverseone.ai', connection_error: 'خطأ في الاتصال. حاول مرة أخرى.' },
      info: { title: 'معلومات الاتصال', email_label: 'البريد الإلكتروني', response_time: 'وقت الاستجابة', response_value: 'أقل من 24 ساعة', availability: 'التوفر', availability_value: 'الاثنين - الجمعة', proplus_priority: 'بصفتك مستخدم Pro+، يحصل طلبك على أولوية في المتابعة.' }
    }
  },
  hi: {
    sidebar: { billing: 'बिलिंग', support: 'सहायता' },
    billing: {
      title: 'बिलिंग पोर्टल',
      subtitle: 'अपनी सदस्यता प्रबंधित करें और भुगतान इतिहास देखें',
      current_plan: 'वर्तमान प्लान',
      activated_at: 'सक्रिय किया गया',
      access_until: 'एक्सेस तक',
      next_billing: 'अगली बिलिंग',
      subscription_id: 'सदस्यता ID',
      provider: 'प्रदाता',
      no_subscription: 'आपके पास सक्रिय सदस्यता नहीं है। सभी सुविधाओं तक पहुंचने के लिए अपना प्लान अपग्रेड करें।',
      renew_now: 'अभी नवीनीकरण करें ->',
      payment_history: 'भुगतान इतिहास',
      last_50: 'अंतिम 50 रिकॉर्ड',
      no_payments: 'अभी तक कोई भुगतान दर्ज नहीं है।',
      open_freemius_portal: 'Freemius पोर्टल खोलें',
      freemius_receipts_notice: 'रसीदें, चालान और सदस्यता बदलाव सुरक्षित Freemius पोर्टल में देखे जाते हैं।',
      upgrade_now: 'Pro में अपग्रेड करें ->',
      quick_actions: 'त्वरित कार्रवाइयां',
      go_to_plans: 'प्लान देखें',
      manage_cancellation: 'रद्दीकरण प्रबंधित करें',
      cancel_subscription: 'सदस्यता रद्द करें',
      manage_lemon: 'सदस्यता प्रबंधित करें',
      refresh: 'रीफ्रेश',
      downgrade: { expired: 'आपकी सदस्यता समाप्त हो गई है।', cancelled: 'आपकी सदस्यता रद्द कर दी गई है।', payment_failed: 'भुगतान विफल होने के कारण आपकी सदस्यता निलंबित कर दी गई।', generic: 'आपका प्लान डाउनग्रेड किया गया।' },
      col: { date: 'दिनांक', plan: 'प्लान', amount: 'राशि', status: 'स्थिति' },
      error: { no_session: 'कोई सक्रिय सत्र नहीं है। कृपया फिर से लॉग इन करें।', fetch_failed: 'बिलिंग इतिहास लोड नहीं हो सका।' },
      status: { active: 'सक्रिय', pending_cancel: 'रद्दीकरण लंबित', cancelled: 'रद्द', suspended: 'निलंबित', expired: 'समाप्त', approved: 'स्वीकृत' },
      pay_status: { approved: 'सफल', failed: 'विफल', pending: 'लंबित' }
    },
    support: {
      title: 'सहायता केंद्र',
      subtitle: 'हम आपकी मदद के लिए यहां हैं',
      success: { title: 'संदेश भेज दिया गया!', body: 'हमें आपका अनुरोध मिल गया है और हम 24 घंटे से कम समय में उत्तर देंगे।', confirm_email: 'हमने आपके ईमेल पर पुष्टि भेजी है।', new_message: 'दूसरा संदेश भेजें' },
      form: { title: 'हमें संदेश भेजें', name: 'नाम', name_placeholder: 'आपका नाम', email: 'ईमेल पता', plan: 'वर्तमान प्लान', subject: 'विषय', message: 'संदेश', message_placeholder: 'अपने अनुरोध को जितना संभव हो उतना विस्तार से बताएं। जितनी अधिक जानकारी देंगे, हम उतनी जल्दी मदद कर पाएंगे।', error_generic: 'संदेश भेजा नहीं जा सका। फिर से प्रयास करें।', sending: 'भेजा जा रहा है...', submit: 'संदेश भेजें' },
      subject: { select: 'विषय चुनें...', bug: 'बग रिपोर्ट या तकनीकी समस्या', billing: 'बिलिंग या भुगतान प्रश्न', cancel: 'सदस्यता रद्द या संशोधित करें', account: 'खाते या एक्सेस की समस्या', suggestion: 'सुझाव या सुधार', business: 'व्यावसायिक प्रस्ताव या साझेदारी', general: 'सामान्य प्रश्न' },
      validation: { name_required: 'कृपया अपना नाम दर्ज करें।', email_required: 'कृपया मान्य ईमेल पता दर्ज करें।', subject_required: 'कृपया एक विषय चुनें।', message_min: 'संदेश कम से कम 10 अक्षरों का होना चाहिए।', no_session: 'कोई सक्रिय सत्र नहीं है। कृपया फिर से लॉग इन करें।', send_failed_direct: 'संदेश भेजा नहीं जा सका। फिर से प्रयास करें या सीधे support@intelliverseone.ai पर लिखें', connection_error: 'कनेक्शन त्रुटि। फिर से प्रयास करें।' },
      info: { title: 'संपर्क जानकारी', email_label: 'ईमेल', response_time: 'प्रतिक्रिया समय', response_value: '24 घंटे से कम', availability: 'उपलब्धता', availability_value: 'सोमवार - शुक्रवार', proplus_priority: 'Pro+ उपयोगकर्ता होने के कारण आपके अनुरोध को प्राथमिकता दी जाएगी।' }
    }
  },
  ru: {
    sidebar: { billing: 'Оплата', support: 'Поддержка' },
    billing: {
      title: 'Портал оплаты',
      subtitle: 'Управляйте подпиской и просматривайте историю платежей',
      current_plan: 'Текущий план',
      activated_at: 'Активировано',
      access_until: 'Доступ до',
      next_billing: 'Следующее списание',
      subscription_id: 'ID подписки',
      provider: 'Провайдер',
      no_subscription: 'У вас нет активной подписки. Обновите план, чтобы получить доступ ко всем функциям.',
      renew_now: 'Продлить сейчас ->',
      payment_history: 'История платежей',
      last_50: 'Последние 50 записей',
      no_payments: 'Платежи пока не зарегистрированы.',
      open_freemius_portal: 'Открыть портал Freemius',
      freemius_receipts_notice: 'Квитанции, счета и изменения подписки доступны в безопасном портале Freemius.',
      upgrade_now: 'Перейти на Pro ->',
      quick_actions: 'Быстрые действия',
      go_to_plans: 'Посмотреть планы',
      manage_cancellation: 'Управлять отменой',
      cancel_subscription: 'Отменить подписку',
      manage_lemon: 'Управлять подпиской',
      refresh: 'Обновить',
      downgrade: { expired: 'Срок действия вашей подписки истек.', cancelled: 'Ваша подписка была отменена.', payment_failed: 'Ваша подписка была приостановлена из-за неудачного платежа.', generic: 'Ваш план был понижен.' },
      col: { date: 'Дата', plan: 'План', amount: 'Сумма', status: 'Статус' },
      error: { no_session: 'Нет активной сессии. Войдите снова.', fetch_failed: 'Не удалось загрузить историю оплаты.' },
      status: { active: 'Активна', pending_cancel: 'Ожидает отмены', cancelled: 'Отменена', suspended: 'Приостановлена', expired: 'Истекла', approved: 'Одобрена' },
      pay_status: { approved: 'Успешно', failed: 'Ошибка', pending: 'Ожидает' }
    },
    support: {
      title: 'Центр поддержки',
      subtitle: 'Мы здесь, чтобы помочь',
      success: { title: 'Сообщение отправлено!', body: 'Мы получили ваш запрос и ответим менее чем за 24 часа.', confirm_email: 'Мы отправили подтверждение на вашу почту.', new_message: 'Отправить еще сообщение' },
      form: { title: 'Отправьте нам сообщение', name: 'Имя', name_placeholder: 'Ваше имя', email: 'Электронная почта', plan: 'Текущий план', subject: 'Тема', message: 'Сообщение', message_placeholder: 'Опишите запрос как можно подробнее. Чем больше информации вы предоставите, тем быстрее мы сможем помочь.', error_generic: 'Не удалось отправить сообщение. Попробуйте снова.', sending: 'Отправка...', submit: 'Отправить сообщение' },
      subject: { select: 'Выберите тему...', bug: 'Сообщение об ошибке или техническая проблема', billing: 'Вопрос по оплате или платежам', cancel: 'Отменить или изменить подписку', account: 'Проблема с аккаунтом или доступом', suggestion: 'Предложение или улучшение', business: 'Деловое предложение или партнерство', general: 'Общий вопрос' },
      validation: { name_required: 'Пожалуйста, введите ваше имя.', email_required: 'Пожалуйста, введите корректный email.', subject_required: 'Пожалуйста, выберите тему.', message_min: 'Сообщение должно содержать не менее 10 символов.', no_session: 'Нет активной сессии. Войдите снова.', send_failed_direct: 'Не удалось отправить сообщение. Попробуйте снова или напишите напрямую на support@intelliverseone.ai', connection_error: 'Ошибка соединения. Попробуйте снова.' },
      info: { title: 'Контактная информация', email_label: 'Email', response_time: 'Время ответа', response_value: 'Менее 24 ч', availability: 'Доступность', availability_value: 'Понедельник - Пятница', proplus_priority: 'Как пользователь Pro+, ваш запрос получает приоритетное внимание.' }
    }
  },
  tr: {
    sidebar: { billing: 'Faturalandırma', support: 'Destek' },
    billing: {
      title: 'Faturalandırma Portalı',
      subtitle: 'Aboneliğinizi yönetin ve ödeme geçmişinizi inceleyin',
      current_plan: 'Mevcut Plan',
      activated_at: 'Etkinleştirme tarihi',
      access_until: 'Erişim bitişi',
      next_billing: 'Sonraki fatura',
      subscription_id: 'Abonelik ID',
      provider: 'Sağlayıcı',
      no_subscription: 'Aktif aboneliğiniz yok. Tüm özelliklere erişmek için planınızı yükseltin.',
      renew_now: 'Şimdi yenile ->',
      payment_history: 'Ödeme Geçmişi',
      last_50: 'Son 50 kayıt',
      no_payments: 'Henüz kayıtlı ödeme yok.',
      open_freemius_portal: 'Freemius portalını aç',
      freemius_receipts_notice: 'Makbuzlar, faturalar ve abonelik değişiklikleri güvenli Freemius portalında görüntülenir.',
      upgrade_now: 'Pro’ya yükselt ->',
      quick_actions: 'Hızlı İşlemler',
      go_to_plans: 'Planları Gör',
      manage_cancellation: 'İptali yönet',
      cancel_subscription: 'Aboneliği İptal Et',
      manage_lemon: 'Aboneliği yönet',
      refresh: 'Yenile',
      downgrade: { expired: 'Aboneliğinizin süresi doldu.', cancelled: 'Aboneliğiniz iptal edildi.', payment_failed: 'Aboneliğiniz başarısız ödeme nedeniyle askıya alındı.', generic: 'Planınız düşürüldü.' },
      col: { date: 'Tarih', plan: 'Plan', amount: 'Tutar', status: 'Durum' },
      error: { no_session: 'Aktif oturum yok. Lütfen tekrar giriş yapın.', fetch_failed: 'Faturalandırma geçmişi yüklenemedi.' },
      status: { active: 'Aktif', pending_cancel: 'İptal bekliyor', cancelled: 'İptal edildi', suspended: 'Askıya alındı', expired: 'Süresi doldu', approved: 'Onaylandı' },
      pay_status: { approved: 'Başarılı', failed: 'Başarısız', pending: 'Beklemede' }
    },
    support: {
      title: 'Destek Merkezi',
      subtitle: 'Size yardımcı olmak için buradayız',
      success: { title: 'Mesaj gönderildi!', body: 'Talebinizi aldık ve 24 saatten kısa sürede yanıtlayacağız.', confirm_email: 'E-postanıza bir onay gönderdik.', new_message: 'Başka mesaj gönder' },
      form: { title: 'Bize mesaj gönderin', name: 'Ad', name_placeholder: 'Adınız', email: 'E-posta adresi', plan: 'Mevcut plan', subject: 'Konu', message: 'Mesaj', message_placeholder: 'Talebinizi olabildiğince ayrıntılı açıklayın. Ne kadar çok bilgi verirseniz o kadar hızlı yardımcı olabiliriz.', error_generic: 'Mesaj gönderilemedi. Lütfen tekrar deneyin.', sending: 'Gönderiliyor...', submit: 'Mesaj gönder' },
      subject: { select: 'Bir konu seçin...', bug: 'Hata bildirimi veya teknik sorun', billing: 'Faturalandırma veya ödeme sorusu', cancel: 'Aboneliği iptal et veya değiştir', account: 'Hesap veya erişim sorunu', suggestion: 'Öneri veya iyileştirme', business: 'İş teklifi veya ortaklık', general: 'Genel soru' },
      validation: { name_required: 'Lütfen adınızı girin.', email_required: 'Lütfen geçerli bir e-posta adresi girin.', subject_required: 'Lütfen bir konu seçin.', message_min: 'Mesaj en az 10 karakter olmalıdır.', no_session: 'Aktif oturum yok. Lütfen tekrar giriş yapın.', send_failed_direct: 'Mesaj gönderilemedi. Tekrar deneyin veya doğrudan support@intelliverseone.ai adresine yazın', connection_error: 'Bağlantı hatası. Lütfen tekrar deneyin.' },
      info: { title: 'İletişim bilgileri', email_label: 'E-posta', response_time: 'Yanıt süresi', response_value: '24 saatten az', availability: 'Uygunluk', availability_value: 'Pazartesi - Cuma', proplus_priority: 'Pro+ kullanıcısı olarak talebiniz öncelikli olarak değerlendirilir.' }
    }
  },
  tr: {
    life_coach: {
      hero: { title: 'Kişisel Yapay Zeka Planı' }
    }
  }
};

Object.keys(billingSupportTranslations).forEach(lng => {
  const target = resources[lng];
  if (!target) return;
  const apply = (prefix, src) => {
    Object.keys(src).forEach(k => {
      const dotted = prefix ? `${prefix}.${k}` : k;
      const val = src[k];
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        apply(dotted, val);
      } else {
        setDeep(target.translation, dotted, val);
      }
    });
  };
  apply('', billingSupportTranslations[lng]);
});

const myGptsSeedTranslations = {
  en: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Persuasive copy for multiple formats',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Premium assistant for high-quality answers',
  },
  es: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Copy persuasivo multi-formato',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Asistente premium de calidad elevada',
  },
  pt: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Copy persuasivo multi-formato',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Assistente premium de alta qualidade',
  },
  fr: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Copywriting persuasif multi-format',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Assistant premium de haute qualite',
  },
  de: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Ueberzeugende Texte fuer mehrere Formate',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Premium-Assistent fuer hochwertige Antworten',
  },
  it: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Copy persuasivo multi-formato',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Assistente premium di alta qualita',
  },
  zh: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': '多格式说服型文案',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': '高质量高级助手',
  },
  ja: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': '複数形式に対応した説得力のあるコピー',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': '高品質な回答のためのプレミアムアシスタント',
  },
  ko: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': '다양한 형식의 설득력 있는 카피',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': '고품질 답변을 위한 프리미엄 어시스턴트',
  },
  ar: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'نصوص إقناعية متعددة الصيغ',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'مساعد متميز لإجابات عالية الجودة',
  },
  hi: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'कई प्रारूपों के लिए प्रभावशाली कॉपी',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'उच्च गुणवत्ता वाले उत्तरों के लिए प्रीमियम सहायक',
  },
  ru: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Убедительный текст для разных форматов',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Премиум-ассистент для качественных ответов',
  },
  tr: {
    'mygpts.templates.copywriter.name': 'Copywriter Pro',
    'mygpts.templates.copywriter.desc': 'Cok formatli ikna edici metin',
    'mygpts.templates.arconte.name': 'Arconte AI',
    'mygpts.templates.arconte.desc': 'Yuksek kaliteli yanitlar icin premium asistan',
  },
};

Object.keys(myGptsSeedTranslations).forEach(lng => {
  const target = resources[lng]?.translation;
  if (!target) return;
  Object.entries(myGptsSeedTranslations[lng]).forEach(([key, value]) => setDeep(target, key, value));
});

const runnerModalTranslations = {
  en: {
    'tools.runner.subtitle': 'Run with AI in real time',
    'tools.runner.input_label': 'Your text or instruction',
    'tools.runner.input_placeholder': 'Write what you want this tool to process...',
    'tools.runner.hint': 'Ctrl+Enter to run',
    'tools.runner.result_label': 'Result',
    'tools.runner.empty_input': 'Write something before running the tool',
    'tools.runner.not_wired': 'Execution is not connected yet',
    'tools.runner.generic_error': 'Error running the tool',
    'tools.runner.processing': 'Processing...',
    'tools.runner.copied': 'Result copied to clipboard',
    'mygpts.runner.subtitle': 'Run your custom AI assistant',
    'mygpts.runner.input_label': 'Your question or instruction',
    'mygpts.runner.input_placeholder': 'Ask your custom GPT anything...',
    'mygpts.runner.empty_input': 'Write something before running your GPT',
    'mygpts.runner.generic_error': 'Error running the GPT',
    'mygpts.runner.processing': 'Processing...',
    'mygpts.runner.copied': 'Result copied to clipboard',
  },
  es: {
    'tools.runner.subtitle': 'Ejecutar con IA en tiempo real',
    'tools.runner.input_label': 'Tu texto o instruccion',
    'tools.runner.input_placeholder': 'Escribe lo que quieres que procese esta herramienta...',
    'tools.runner.hint': 'Ctrl+Enter para ejecutar',
    'tools.runner.result_label': 'Resultado',
    'tools.runner.empty_input': 'Escribe algo para ejecutar la herramienta',
    'tools.runner.not_wired': 'Ejecucion aun no conectada',
    'tools.runner.generic_error': 'Error al ejecutar la herramienta',
    'tools.runner.processing': 'Procesando...',
    'tools.runner.copied': 'Resultado copiado al portapapeles',
    'mygpts.runner.subtitle': 'Ejecuta tu asistente IA personalizado',
    'mygpts.runner.input_label': 'Tu pregunta o instruccion',
    'mygpts.runner.input_placeholder': 'Preguntale cualquier cosa a tu GPT...',
    'mygpts.runner.empty_input': 'Escribe algo para ejecutar tu GPT',
    'mygpts.runner.generic_error': 'Error al ejecutar el GPT',
    'mygpts.runner.processing': 'Procesando...',
    'mygpts.runner.copied': 'Resultado copiado al portapapeles',
  },
  pt: {
    'tools.runner.subtitle': 'Execute com IA em tempo real',
    'tools.runner.input_label': 'Seu texto ou instrucao',
    'tools.runner.input_placeholder': 'Escreva o que deseja processar com esta ferramenta...',
    'tools.runner.hint': 'Ctrl+Enter para executar',
    'tools.runner.result_label': 'Resultado',
    'tools.runner.empty_input': 'Escreva algo antes de executar a ferramenta',
    'tools.runner.not_wired': 'Execucao ainda nao conectada',
    'tools.runner.generic_error': 'Erro ao executar a ferramenta',
    'tools.runner.processing': 'Processando...',
    'tools.runner.copied': 'Resultado copiado para a area de transferencia',
    'mygpts.runner.subtitle': 'Execute seu assistente de IA personalizado',
    'mygpts.runner.input_label': 'Sua pergunta ou instrucao',
    'mygpts.runner.input_placeholder': 'Pergunte qualquer coisa ao seu GPT...',
    'mygpts.runner.empty_input': 'Escreva algo antes de executar seu GPT',
    'mygpts.runner.generic_error': 'Erro ao executar o GPT',
    'mygpts.runner.processing': 'Processando...',
    'mygpts.runner.copied': 'Resultado copiado para a area de transferencia',
  },
  fr: {
    'tools.runner.subtitle': "Executer avec l'IA en temps reel",
    'tools.runner.input_label': 'Votre texte ou instruction',
    'tools.runner.input_placeholder': 'Ecrivez ce que cet outil doit traiter...',
    'tools.runner.hint': 'Ctrl+Entree pour executer',
    'tools.runner.result_label': 'Resultat',
    'tools.runner.empty_input': "Ecrivez quelque chose avant d'executer l'outil",
    'tools.runner.not_wired': "L'execution n'est pas encore connectee",
    'tools.runner.generic_error': "Erreur lors de l'execution de l'outil",
    'tools.runner.processing': 'Traitement...',
    'tools.runner.copied': 'Resultat copie dans le presse-papiers',
    'mygpts.runner.subtitle': 'Executez votre assistant IA personnalise',
    'mygpts.runner.input_label': 'Votre question ou instruction',
    'mygpts.runner.input_placeholder': 'Posez une question a votre GPT personnalise...',
    'mygpts.runner.empty_input': "Ecrivez quelque chose avant d'executer votre GPT",
    'mygpts.runner.generic_error': "Erreur lors de l'execution du GPT",
    'mygpts.runner.processing': 'Traitement...',
    'mygpts.runner.copied': 'Resultat copie dans le presse-papiers',
  },
  de: {
    'tools.runner.subtitle': 'Mit KI in Echtzeit ausfuehren',
    'tools.runner.input_label': 'Ihr Text oder Ihre Anweisung',
    'tools.runner.input_placeholder': 'Schreiben Sie, was dieses Tool verarbeiten soll...',
    'tools.runner.hint': 'Strg+Enter zum Ausfuehren',
    'tools.runner.result_label': 'Ergebnis',
    'tools.runner.empty_input': 'Schreiben Sie etwas, bevor Sie das Tool ausfuehren',
    'tools.runner.not_wired': 'Ausfuehrung ist noch nicht verbunden',
    'tools.runner.generic_error': 'Fehler beim Ausfuehren des Tools',
    'tools.runner.processing': 'Verarbeitung...',
    'tools.runner.copied': 'Ergebnis in die Zwischenablage kopiert',
    'mygpts.runner.subtitle': 'Fuehren Sie Ihren benutzerdefinierten KI-Assistenten aus',
    'mygpts.runner.input_label': 'Ihre Frage oder Anweisung',
    'mygpts.runner.input_placeholder': 'Fragen Sie Ihren benutzerdefinierten GPT alles...',
    'mygpts.runner.empty_input': 'Schreiben Sie etwas, bevor Sie Ihren GPT ausfuehren',
    'mygpts.runner.generic_error': 'Fehler beim Ausfuehren des GPT',
    'mygpts.runner.processing': 'Verarbeitung...',
    'mygpts.runner.copied': 'Ergebnis in die Zwischenablage kopiert',
  },
  it: {
    'tools.runner.subtitle': 'Esegui con IA in tempo reale',
    'tools.runner.input_label': 'Il tuo testo o istruzione',
    'tools.runner.input_placeholder': 'Scrivi cosa vuoi far elaborare a questo strumento...',
    'tools.runner.hint': 'Ctrl+Invio per eseguire',
    'tools.runner.result_label': 'Risultato',
    'tools.runner.empty_input': 'Scrivi qualcosa prima di eseguire lo strumento',
    'tools.runner.not_wired': 'Esecuzione non ancora collegata',
    'tools.runner.generic_error': 'Errore durante l esecuzione dello strumento',
    'tools.runner.processing': 'Elaborazione...',
    'tools.runner.copied': 'Risultato copiato negli appunti',
    'mygpts.runner.subtitle': 'Esegui il tuo assistente IA personalizzato',
    'mygpts.runner.input_label': 'La tua domanda o istruzione',
    'mygpts.runner.input_placeholder': 'Chiedi qualsiasi cosa al tuo GPT personalizzato...',
    'mygpts.runner.empty_input': 'Scrivi qualcosa prima di eseguire il tuo GPT',
    'mygpts.runner.generic_error': 'Errore durante l esecuzione del GPT',
    'mygpts.runner.processing': 'Elaborazione...',
    'mygpts.runner.copied': 'Risultato copiato negli appunti',
  },
  zh: {
    'tools.runner.subtitle': '使用 AI 实时运行',
    'tools.runner.input_label': '你的文本或指令',
    'tools.runner.input_placeholder': '写下你希望此工具处理的内容...',
    'tools.runner.hint': 'Ctrl+Enter 运行',
    'tools.runner.result_label': '结果',
    'tools.runner.empty_input': '运行工具前请先输入内容',
    'tools.runner.not_wired': '执行尚未连接',
    'tools.runner.generic_error': '运行工具时出错',
    'tools.runner.processing': '处理中...',
    'tools.runner.copied': '结果已复制到剪贴板',
    'mygpts.runner.subtitle': '运行你的自定义 AI 助手',
    'mygpts.runner.input_label': '你的问题或指令',
    'mygpts.runner.input_placeholder': '向你的自定义 GPT 提问...',
    'mygpts.runner.empty_input': '运行 GPT 前请先输入内容',
    'mygpts.runner.generic_error': '运行 GPT 时出错',
    'mygpts.runner.processing': '处理中...',
    'mygpts.runner.copied': '结果已复制到剪贴板',
  },
  ja: {
    'tools.runner.subtitle': 'AIでリアルタイム実行',
    'tools.runner.input_label': 'テキストまたは指示',
    'tools.runner.input_placeholder': 'このツールで処理したい内容を書いてください...',
    'tools.runner.hint': 'Ctrl+Enterで実行',
    'tools.runner.result_label': '結果',
    'tools.runner.empty_input': 'ツールを実行する前に入力してください',
    'tools.runner.not_wired': '実行はまだ接続されていません',
    'tools.runner.generic_error': 'ツールの実行中にエラーが発生しました',
    'tools.runner.processing': '処理中...',
    'tools.runner.copied': '結果をクリップボードにコピーしました',
    'mygpts.runner.subtitle': 'カスタムAIアシスタントを実行',
    'mygpts.runner.input_label': '質問または指示',
    'mygpts.runner.input_placeholder': 'カスタムGPTに質問してください...',
    'mygpts.runner.empty_input': 'GPTを実行する前に入力してください',
    'mygpts.runner.generic_error': 'GPTの実行中にエラーが発生しました',
    'mygpts.runner.processing': '処理中...',
    'mygpts.runner.copied': '結果をクリップボードにコピーしました',
  },
  ko: {
    'tools.runner.subtitle': 'AI로 실시간 실행',
    'tools.runner.input_label': '텍스트 또는 지시',
    'tools.runner.input_placeholder': '이 도구로 처리할 내용을 입력하세요...',
    'tools.runner.hint': 'Ctrl+Enter로 실행',
    'tools.runner.result_label': '결과',
    'tools.runner.empty_input': '도구를 실행하기 전에 내용을 입력하세요',
    'tools.runner.not_wired': '실행이 아직 연결되지 않았습니다',
    'tools.runner.generic_error': '도구 실행 중 오류가 발생했습니다',
    'tools.runner.processing': '처리 중...',
    'tools.runner.copied': '결과가 클립보드에 복사되었습니다',
    'mygpts.runner.subtitle': '사용자 지정 AI 어시스턴트 실행',
    'mygpts.runner.input_label': '질문 또는 지시',
    'mygpts.runner.input_placeholder': '사용자 지정 GPT에게 질문하세요...',
    'mygpts.runner.empty_input': 'GPT를 실행하기 전에 내용을 입력하세요',
    'mygpts.runner.generic_error': 'GPT 실행 중 오류가 발생했습니다',
    'mygpts.runner.processing': '처리 중...',
    'mygpts.runner.copied': '결과가 클립보드에 복사되었습니다',
  },
  ar: {
    'tools.runner.subtitle': 'تشغيل بالذكاء الاصطناعي في الوقت الفعلي',
    'tools.runner.input_label': 'النص أو التعليمات',
    'tools.runner.input_placeholder': 'اكتب ما تريد أن تعالجه هذه الأداة...',
    'tools.runner.hint': 'Ctrl+Enter للتشغيل',
    'tools.runner.result_label': 'النتيجة',
    'tools.runner.empty_input': 'اكتب شيئا قبل تشغيل الأداة',
    'tools.runner.not_wired': 'التشغيل غير متصل بعد',
    'tools.runner.generic_error': 'حدث خطأ أثناء تشغيل الأداة',
    'tools.runner.processing': 'جار المعالجة...',
    'tools.runner.copied': 'تم نسخ النتيجة إلى الحافظة',
    'mygpts.runner.subtitle': 'شغل مساعد الذكاء الاصطناعي المخصص',
    'mygpts.runner.input_label': 'سؤالك أو تعليماتك',
    'mygpts.runner.input_placeholder': 'اسأل GPT المخصص أي شيء...',
    'mygpts.runner.empty_input': 'اكتب شيئا قبل تشغيل GPT',
    'mygpts.runner.generic_error': 'حدث خطأ أثناء تشغيل GPT',
    'mygpts.runner.processing': 'جار المعالجة...',
    'mygpts.runner.copied': 'تم نسخ النتيجة إلى الحافظة',
  },
  hi: {
    'tools.runner.subtitle': 'AI के साथ रियल टाइम में चलाएं',
    'tools.runner.input_label': 'आपका टेक्स्ट या निर्देश',
    'tools.runner.input_placeholder': 'लिखें कि यह टूल क्या प्रोसेस करे...',
    'tools.runner.hint': 'चलाने के लिए Ctrl+Enter',
    'tools.runner.result_label': 'परिणाम',
    'tools.runner.empty_input': 'टूल चलाने से पहले कुछ लिखें',
    'tools.runner.not_wired': 'एक्जीक्यूशन अभी कनेक्ट नहीं है',
    'tools.runner.generic_error': 'टूल चलाने में त्रुटि',
    'tools.runner.processing': 'प्रोसेस हो रहा है...',
    'tools.runner.copied': 'परिणाम क्लिपबोर्ड में कॉपी हुआ',
    'mygpts.runner.subtitle': 'अपना कस्टम AI सहायक चलाएं',
    'mygpts.runner.input_label': 'आपका प्रश्न या निर्देश',
    'mygpts.runner.input_placeholder': 'अपने कस्टम GPT से कुछ भी पूछें...',
    'mygpts.runner.empty_input': 'GPT चलाने से पहले कुछ लिखें',
    'mygpts.runner.generic_error': 'GPT चलाने में त्रुटि',
    'mygpts.runner.processing': 'प्रोसेस हो रहा है...',
    'mygpts.runner.copied': 'परिणाम क्लिपबोर्ड में कॉपी हुआ',
  },
  ru: {
    'tools.runner.subtitle': 'Запуск с ИИ в реальном времени',
    'tools.runner.input_label': 'Ваш текст или инструкция',
    'tools.runner.input_placeholder': 'Напишите, что должен обработать этот инструмент...',
    'tools.runner.hint': 'Ctrl+Enter для запуска',
    'tools.runner.result_label': 'Результат',
    'tools.runner.empty_input': 'Введите текст перед запуском инструмента',
    'tools.runner.not_wired': 'Запуск еще не подключен',
    'tools.runner.generic_error': 'Ошибка при запуске инструмента',
    'tools.runner.processing': 'Обработка...',
    'tools.runner.copied': 'Результат скопирован в буфер обмена',
    'mygpts.runner.subtitle': 'Запустите своего пользовательского ИИ-помощника',
    'mygpts.runner.input_label': 'Ваш вопрос или инструкция',
    'mygpts.runner.input_placeholder': 'Задайте вопрос своему пользовательскому GPT...',
    'mygpts.runner.empty_input': 'Введите текст перед запуском GPT',
    'mygpts.runner.generic_error': 'Ошибка при запуске GPT',
    'mygpts.runner.processing': 'Обработка...',
    'mygpts.runner.copied': 'Результат скопирован в буфер обмена',
  },
  tr: {
    'tools.runner.subtitle': 'Yapay zeka ile gercek zamanli calistir',
    'tools.runner.input_label': 'Metniniz veya talimatiniz',
    'tools.runner.input_placeholder': 'Bu aracin islemesini istediginiz seyi yazin...',
    'tools.runner.hint': 'Calistirmak icin Ctrl+Enter',
    'tools.runner.result_label': 'Sonuc',
    'tools.runner.empty_input': 'Araci calistirmadan once bir sey yazin',
    'tools.runner.not_wired': 'Calistirma henuz bagli degil',
    'tools.runner.generic_error': 'Arac calistirilirken hata olustu',
    'tools.runner.processing': 'Isleniyor...',
    'tools.runner.copied': 'Sonuc panoya kopyalandi',
    'mygpts.runner.subtitle': 'Ozel yapay zeka asistaninizi calistirin',
    'mygpts.runner.input_label': 'Sorunuz veya talimatiniz',
    'mygpts.runner.input_placeholder': 'Ozel GPT nize istediginizi sorun...',
    'mygpts.runner.empty_input': 'GPT nizi calistirmadan once bir sey yazin',
    'mygpts.runner.generic_error': 'GPT calistirilirken hata olustu',
    'mygpts.runner.processing': 'Isleniyor...',
    'mygpts.runner.copied': 'Sonuc panoya kopyalandi',
  },
};

Object.keys(runnerModalTranslations).forEach(lng => {
  const target = resources[lng]?.translation;
  if (!target) return;
  Object.entries(runnerModalTranslations[lng]).forEach(([key, value]) => setDeep(target, key, value));
});

// Asegurar claves life_coach.* en los 12 idiomas (fallback a EN si no existen)
const lifeCoachKeys = Object.keys(en.life_coach || {});
const allLangs = Object.keys(resources);
allLangs.forEach(lng => {
  const target = resources[lng];
  if (!target) return;
  // Solo actuar si el idioma no es en/es, o si faltan claves puntuales
  const base = resources['en'].translation;
  function ensureNode(prefix, srcNode) {
    Object.keys(srcNode).forEach(sub => {
      const dotted = prefix ? `${prefix}.${sub}` : sub;
      const val = srcNode[sub];
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        if (!hasDeep(target.translation, dotted)) {
          // crear el objeto
          setDeep(target.translation, dotted, {});
        }
        ensureNode(dotted, val);
      } else {
        if (!hasDeep(target.translation, dotted)) {
          setDeep(target.translation, dotted, getDeep(base, dotted));
        }
      }
    });
  }
  if (base && base.life_coach) {
    ensureNode('life_coach', base.life_coach);
  }
});

// Traducciones específicas de life_coach para idiomas adicionales
const lifeCoachTranslations = {
  ko: {
    life_coach: {
      common: {
        select: '선택…',
        selected_count: '{{count}}개 선택됨',
        other: '기타',
        other_ph: '다른 옵션을 입력하세요'
      },
      hero: {
        title: '개인 AI 플랜',
        subtitle: '매일 함께하는 감정적·전략적 코파일럿.'
      },
      stats: {
        areas: '선택한 영역',
        habits: '총 습관',
        remaining: '오늘 남은 행동'
      },
      form: {
        title: '당신의 라이프 포커스',
        areas_label: '우선 순위 영역',
        daily_time: '하루 가능 시간',
        emotions_label: '전반적으로 어떤 기분인가요',
        emotions: { low: '낮음', medium: '보통', high: '높음' },
        motivation: '지금 무엇이 동기부여가 되나요?',
        motivation_ph: '당신의 동기를 적어주세요',
        routine: '당신의 일상은 어떤가요?',
        routine_ph: '간단히 설명하세요',
        constraints: '제약 또는 어려움 (선택 사항)',
        sleep_hours: '수면 시간',
        sleep: { less6: '6시간 미만', '6_7': '6-7', '7_8': '7-8', more8: '8시간 초과' },
        exercise_freq: '운동 빈도',
        exercise: { never: '거의 안 함', '1_2': '주 1-2회', '3_4': '주 3-4회', more4: '주 4회 이상' },
        diet_focus: '식단 초점',
        diet: { balanced: '균형 잡힌', high_protein: '고단백', low_carb: '저탄수', plant_based: '식물성 중심' },
        stress_level: '스트레스 수준',
        level: { low: '낮음', medium: '보통', high: '높음' },
        productivity_peak: '생산성 피크',
        daytime: { morning: '아침', afternoon: '오후', evening: '저녁' },
        reminder_time: '알림 선호 시간',
        distractions: '주요 방해 요소',
        learning_goal: '학습 목표',
        learning_goal_ph: '무엇을 배우고 싶나요?',
        financial_goal: '재무 목표',
        financial_goal_ph: '예: X 저축, 빚 갚기',
        relationship_goal: '관계 목표',
        relationship_goal_ph: '가족, 연인, 친구',
        weekend_routine: '주말 루틴',
        weekend_routine_ph: '보통 하는 활동',
        accountability: { label: '책임 파트너(어카운터빌리티)', solo: '혼자', buddy: '동료와 함께', coach: '코치와 함께' },
        comm_style: '소통 스타일',
        comm: { concise: '간결하게', detailed: '자세하게', motivational: '동기부여형' }
      },
      area: { health: '건강', career: '커리어', finance: '재무', relationships: '관계', personal: '자기 성장' },
      motivation: {
        health: '건강 개선', career: '전문성 성장', balance: '일·삶 균형', learn: '기술 배우기', finance: '재무 개선', emotional: '정서적 웰빙',
        consistency: '꾸준함', project: '개인 프로젝트', exam: '시험/자격증 준비', stress: '스트레스 줄이기'
      },
      routine: {
        office: '사무직 9-5', remote: '유연한 재택', student: '학생', shift: '교대/야간 근무', entrepreneur: '창업/자영업', caretaker: '돌봄 담당',
        night: '야간형', parent: '아이 있는 부모', variable: '매우 유동적'
      },
      constraints: {
        time: '시간 부족', stress: '스트레스/불안', health: '신체 건강', finance: '재정', family: '가족/돌봄', environment: '환경/공간',
        sleep: '불규칙한 수면', motivation: '낮은 동기', tech: '기술/장비'
      },
      distractions: {
        social: '소셜 미디어', notifs: '알림', chat: '메신저', noise: '주변 소음', multitask: '멀티태스킹', phone: '휴대폰', fatigue: '피로',
        perfect: '완벽주의', procrast: '미루기', family: '가족 방해', tv: 'TV/게임'
      },
      learning: {
        languages: '언어', programming: '프로그래밍', dataai: '데이터/AI', marketing: '마케팅', sales: '영업', personal_finance: '개인 재무',
        music: '음악', design: '예술/디자인', cert: '시험/자격', softskills: '소프트 스킬'
      },
      finance: {
        emergency: '비상자금', pay_debt: '빚 갚기', cut_expenses: '지출 절감', increase_income: '수입 증가', invest: '투자',
        buy_house: '주택/차 구매', save_trip: '여행/유학 저축', credit_score: '신용점수 개선'
      },
      relation: {
        communication: '소통 개선', family_time: '가족과 더 많은 시간', partner: '연인 관계 강화', friends: '새 친구 사귀기',
        network: '프로 네트워킹', conflict: '갈등 해결', boundaries: '건강한 경계 설정'
      },
      weekend: {
        rest: '휴식', family: '가족', sport: '운동/활동', social: '사교', creative: '창의/취미', chores: '집안일', study: '공부/프로젝트', travel: '여행'
      },
      cta: { generate: '플랜 생성', regenerate: '다시 생성', refine_area: '영역 다듬기' },
      plan: { title: '당신의 라이프 플랜', progress: '진행도', weekly_goals: '주간 목표', monthly_goals: '월간 목표', habits: '습관' },
      module: { reminders: '스마트 알림', feedback: '주간 피드백' },
      reminders: { active: '개인화된 일/주간 알림을 받게 됩니다.', locked: 'Pro+에서 제공. 자동·개인화 알림을 활성화하세요.' },
      feedback: { active: '매주 맞춤 권장 사항이 제공됩니다.', locked: 'Pro+에서 제공. 제안이 담긴 주간 리포트를 받아보세요.' },
      errors: { areas: '최소 하나의 영역을 선택하세요.', limit: '오늘의 제한에 도달했습니다.' },
      copy: {
        m1: '당신이 최고의 자신을 만들도록 도와드릴게요.',
        m2: '오늘도 한 걸음 더 나아가 볼까요?',
        m3: '작은 변화가 큰 결과를 만듭니다.'
      },
      mock: {
        goal: {
          week: '{{area}} 관련 세션 3회 완료',
          month: '{{area}}의 핵심 이정표 달성',
          learn: { week: '{{skill}} 학습 (20분 x 3회)', month: '{{skill}} 모듈/이정표 완료' },
          finance: { week: '진행 방향: {{goal}}', month: '재무 이정표 달성: {{goal}}' },
          weekend: '주말 활동: {{w}}',
          refine: '{{area}}에 대한 정제된 액션'
        },
        habit: {
          '1': '{{area}}에서 5분 습관',
          '2': '{{area}}에 대해 짧은 회고 쓰기',
          learn: '{{skill}} 학습 (15분)',
          budget: '지출 및 예산 점검 (10분)',
          relation: '의미 있는 연락 (메시지/통화)',
          sleep: '수면 위생 (10분 루틴)',
          exercise: { start: '10분 걷기', progress: '20분 운동 세션', maintain: '25분 컨디션 유지' },
          diet: { pb: '야채 1회분 추가', hp: '매 끼니 단백질 계획', lc: '정제당 피하기' },
          morning: '{{area}}를 위한 오전 집중 블록 (20분)',
          focus: '알림 없음 집중 세션 (15분)',
          stress: '4-7-8 호흡법',
          accountability: '파트너/코치와 체크인 (5분)'
        }
      },
      career: { habit: { focus: '{{m}}분 집중 블록' } },
      remark: { privacy: '답변은 개인적으로 저장됩니다.' }
    }
  }
  ,
  pt: {
    life_coach: {
      common: { select: 'Selecionar…', selected_count: '{{count}} selecionadas', other: 'Outro', other_ph: 'Descreva outra opção' },
      hero: { title: 'Plano Pessoal IA', subtitle: 'Plano diário personalizado para organizar prioridades, hábitos e próximos passos.' },
      stats: { areas: 'Áreas selecionadas', habits: 'Hábitos totais', remaining: 'Ações restantes hoje' },
      form: {
        title: 'Seu foco de vida', areas_label: 'Áreas prioritárias', daily_time: 'Tempo diário disponível',
        emotions_label: 'Como você se sente no geral', emotions: { low: 'Baixo', medium: 'Médio', high: 'Alto' },
        motivation: 'O que motiva você agora?', motivation_ph: 'Descreva sua motivação',
        routine: 'Como é sua rotina?', routine_ph: 'Descreva brevemente',
        constraints: 'Restrições ou desafios (opcional)',
        sleep_hours: 'Horas de sono', sleep: { less6: 'Menos de 6', '6_7': '6-7', '7_8': '7-8', more8: 'Mais de 8' },
        exercise_freq: 'Frequência de exercícios', exercise: { never: 'Nunca', '1_2': '1-2 vezes/sem', '3_4': '3-4 vezes/sem', more4: 'Mais de 4/sem' },
        diet_focus: 'Foco da alimentação', diet: { balanced: 'Equilibrada', high_protein: 'Rica em proteína', low_carb: 'Baixo carbo', plant_based: 'Baseada em plantas' },
        stress_level: 'Nível de estresse', level: { low: 'Baixo', medium: 'Médio', high: 'Alto' },
        productivity_peak: 'Pico de produtividade', daytime: { morning: 'Manhã', afternoon: 'Tarde', evening: 'Noite' },
        reminder_time: 'Horário preferido de lembretes',
        distractions: 'Principais distrações',
        learning_goal: 'Meta de aprendizado', learning_goal_ph: 'O que você quer aprender?',
        financial_goal: 'Meta financeira', financial_goal_ph: 'Ex.: economizar X, quitar dívida',
        relationship_goal: 'Meta de relacionamentos', relationship_goal_ph: 'Família, parceiro, amigos',
        weekend_routine: 'Rotina de fim de semana', weekend_routine_ph: 'Atividades típicas',
        accountability: { label: 'Responsabilização (accountability)', solo: 'Sozinho', buddy: 'Com parceiro', coach: 'Com coach' },
        comm_style: 'Estilo de comunicação', comm: { concise: 'Conciso', detailed: 'Detalhado', motivational: 'Motivacional' }
      },
      area: { health: 'Saúde', career: 'Carreira', finance: 'Finanças', relationships: 'Relacionamentos', personal: 'Crescimento pessoal' },
      motivation: { health: 'Melhorar saúde', career: 'Crescer profissionalmente', balance: 'Equilíbrio vida‑trabalho', learn: 'Aprender uma habilidade', finance: 'Melhorar finanças', emotional: 'Bem‑estar emocional', consistency: 'Ser consistente', project: 'Projeto pessoal', exam: 'Preparar exame/certificação', stress: 'Reduzir estresse' },
      routine: { office: 'Escritório 9‑5', remote: 'Remoto flexível', student: 'Estudante', shift: 'Turnos/plantões', entrepreneur: 'Empreendedor', caretaker: 'Cuidador(a)', night: 'Notívaga', parent: 'Pai/Mãe com filhos', variable: 'Muito variável' },
      constraints: { time: 'Falta de tempo', stress: 'Estresse/ansiedade', health: 'Saúde física', finance: 'Finanças', family: 'Família/cuidado', environment: 'Ambiente/espaço', sleep: 'Sono irregular', motivation: 'Baixa motivação', tech: 'Tecnologia/equipamento' },
      distractions: { social: 'Redes sociais', notifs: 'Notificações', chat: 'Mensagens', noise: 'Ruído ambiente', multitask: 'Multitarefa', phone: 'Celular', fatigue: 'Fadiga', perfect: 'Perfeccionismo', procrast: 'Procrastinação', family: 'Interrupções familiares', tv: 'TV/Jogos' },
      learning: { languages: 'Idiomas', programming: 'Programação', dataai: 'Dados/IA', marketing: 'Marketing', sales: 'Vendas', personal_finance: 'Finanças pessoais', music: 'Música', design: 'Arte/Design', cert: 'Exame/Certificação', softskills: 'Habilidades interpessoais' },
      finance: { emergency: 'Fundo de emergência', pay_debt: 'Quitar dívida', cut_expenses: 'Reduzir gastos', increase_income: 'Aumentar renda', invest: 'Investir', buy_house: 'Comprar casa/veículo', save_trip: 'Poupar para viagem/estudos', credit_score: 'Melhorar score' },
      relation: { communication: 'Melhorar comunicação', family_time: 'Mais tempo em família', partner: 'Fortalecer relacionamento', friends: 'Fazer novos amigos', network: 'Networking profissional', conflict: 'Resolver um conflito', boundaries: 'Definir limites saudáveis' },
      weekend: { rest: 'Descanso', family: 'Família', sport: 'Esporte/atividade', social: 'Social', creative: 'Criativo/hobby', chores: 'Afazeres domésticos', study: 'Estudo/projeto', travel: 'Viagens' },
      cta: { generate: 'Gerar Plano', regenerate: 'Regenerar', refine_area: 'Aprimorar área' },
      plan: { title: 'Seu Plano de Vida', progress: 'Progresso', weekly_goals: 'Metas Semanais', monthly_goals: 'Metas Mensais', habits: 'Hábitos' },
      module: { reminders: 'Lembretes inteligentes', feedback: 'Feedback semanal' },
      reminders: { active: 'Você receberá lembretes diários e semanais personalizados.', locked: 'Disponível no Pro+. Desbloqueie lembretes automáticos e personalizados.' },
      feedback: { active: 'Você receberá uma análise semanal com recomendações.', locked: 'Disponível no Pro+. Receba um relatório semanal com melhorias sugeridas.' },
      errors: { areas: 'Selecione pelo menos uma área.', limit: 'Você atingiu seu limite diário.' },
      copy: { m1: 'Estou aqui para ajudar você a construir sua melhor versão.', m2: 'Hoje podemos dar mais um passo. Pronto?', m3: 'Pequenas mudanças, grandes resultados.' },
      mock: { goal: { week: 'Completar 3 sessões relacionadas a {{area}}', month: 'Alcançar um marco importante em {{area}}', learn: { week: 'Estudar {{skill}} (3 x 20m)', month: 'Completar um módulo ou marco em {{skill}}' }, finance: { week: 'Avançar em: {{goal}}', month: 'Atingir marco financeiro: {{goal}}' }, weekend: 'Atividade de fim de semana: {{w}}', refine: 'Ação aprimorada em {{area}}' }, habit: { '1': 'Hábito de 5 minutos em {{area}}', '2': 'Escrever breve reflexão sobre {{area}}', learn: 'Aprender {{skill}} (15m)', budget: 'Revisar gastos e orçamento (10m)', relation: 'Contato significativo (mensagem/ligação)', sleep: 'Higiene do sono (rotina 10m)', exercise: { start: 'Caminhar 10m', progress: 'Sessão de exercício 20m', maintain: 'Manter condicionamento 25m' }, diet: { pb: 'Adicionar 1 porção extra de vegetais', hp: 'Planejar proteína em cada refeição', lc: 'Evitar açúcares refinados' }, morning: 'Bloco profundo de manhã (20m) para {{area}}', focus: 'Sessão sem notificações (15m)', stress: 'Técnica de respiração 4‑7‑8', accountability: 'Check‑in com parceiro/coach (5m)' } },
      career: { habit: { focus: 'Bloco de foco de {{m}}m' } },
      remark: { privacy: 'Suas respostas são salvas de forma privada.' }
    }
  },
  fr: {
    life_coach: {
      common: { select: 'Sélectionner…', selected_count: '{{count}} sélectionnées', other: 'Autre', other_ph: 'Décrivez une autre option' },
      hero: { title: 'Plan Personnel IA', subtitle: 'Un copilote émotionnel et stratégique pour t’accompagner au quotidien.' },
      stats: { areas: 'Zones sélectionnées', habits: 'Habitudes totales', remaining: 'Actions restantes aujourd’hui' },
      form: {
        title: 'Ton focus de vie', areas_label: 'Zones prioritaires', daily_time: 'Temps quotidien disponible',
        emotions_label: 'Comment te sens‑tu globalement', emotions: { low: 'Faible', medium: 'Moyen', high: 'Élevé' },
        motivation: 'Qu’est‑ce qui te motive en ce moment ?', motivation_ph: 'Décris ta motivation',
        routine: 'À quoi ressemble ta routine ?', routine_ph: 'Décris brièvement',
        constraints: 'Contraintes ou défis (optionnel)',
        sleep_hours: 'Heures de sommeil', sleep: { less6: 'Moins de 6', '6_7': '6‑7', '7_8': '7‑8', more8: 'Plus de 8' },
        exercise_freq: 'Fréquence d’exercice', exercise: { never: 'Jamais', '1_2': '1‑2 fois/sem', '3_4': '3‑4 fois/sem', more4: 'Plus de 4/sem' },
        diet_focus: 'Type d’alimentation', diet: { balanced: 'Équilibrée', high_protein: 'Riche en protéines', low_carb: 'Faible en glucides', plant_based: 'Végétale' },
        stress_level: 'Niveau de stress', level: { low: 'Faible', medium: 'Moyen', high: 'Élevé' },
        productivity_peak: 'Pic de productivité', daytime: { morning: 'Matin', afternoon: 'Après‑midi', evening: 'Soir' },
        reminder_time: 'Heure de rappel préférée',
        distractions: 'Principales distractions',
        learning_goal: 'Objectif d’apprentissage', learning_goal_ph: 'Que veux‑tu apprendre ?',
        financial_goal: 'Objectif financier', financial_goal_ph: 'Ex. : épargner X, rembourser une dette',
        relationship_goal: 'Objectif relationnel', relationship_goal_ph: 'Famille, partenaire, amis',
        weekend_routine: 'Routine du week‑end', weekend_routine_ph: 'Activités typiques',
        accountability: { label: 'Responsabilisation', solo: 'Seul(e)', buddy: 'Avec un partenaire', coach: 'Avec un coach' },
        comm_style: 'Style de communication', comm: { concise: 'Concise', detailed: 'Détaillée', motivational: 'Motivationnelle' }
      },
      area: { health: 'Santé', career: 'Carrière', finance: 'Finance', relationships: 'Relations', personal: 'Développement personnel' },
      motivation: { health: 'Améliorer la santé', career: 'Progresser pro', balance: 'Équilibre vie‑travail', learn: 'Apprendre une compétence', finance: 'Améliorer les finances', emotional: 'Bien‑être émotionnel', consistency: 'Être constant(e)', project: 'Projet personnel', exam: 'Préparer un examen/certif', stress: 'Réduire le stress' },
      routine: { office: 'Bureau 9‑5', remote: 'Télétravail flexible', student: 'Étudiant(e)', shift: 'Horaires décalés', entrepreneur: 'Entrepreneur', caretaker: 'Aidant(e)', night: 'Nocturne', parent: 'Parent avec enfants', variable: 'Très variable' },
      constraints: { time: 'Manque de temps', stress: 'Stress/Anxiété', health: 'Santé physique', finance: 'Finances', family: 'Famille/Soin', environment: 'Environnement/Espace', sleep: 'Sommeil irrégulier', motivation: 'Motivation faible', tech: 'Technologie/Équipement' },
      distractions: { social: 'Réseaux sociaux', notifs: 'Notifications', chat: 'Messagerie', noise: 'Bruit ambiant', multitask: 'Multitâche', phone: 'Téléphone', fatigue: 'Fatigue', perfect: 'Perfectionnisme', procrast: 'Procrastination', family: 'Interruptions familiales', tv: 'TV/Jeux' },
      learning: { languages: 'Langues', programming: 'Programmation', dataai: 'Données/IA', marketing: 'Marketing', sales: 'Ventes', personal_finance: 'Finances perso', music: 'Musique', design: 'Art/Design', cert: 'Examen/Certification', softskills: 'Compétences douces' },
      finance: { emergency: 'Fonds d’urgence', pay_debt: 'Rembourser une dette', cut_expenses: 'Réduire les dépenses', increase_income: 'Augmenter les revenus', invest: 'Investir', buy_house: 'Acheter maison/véhicule', save_trip: 'Épargner voyage/études', credit_score: 'Améliorer score de crédit' },
      relation: { communication: 'Améliorer la communication', family_time: 'Plus de temps en famille', partner: 'Renforcer le couple', friends: 'Se faire de nouveaux amis', network: 'Réseautage pro', conflict: 'Résoudre un conflit', boundaries: 'Fixer des limites saines' },
      weekend: { rest: 'Repos', family: 'Famille', sport: 'Sport/activité', social: 'Social', creative: 'Créatif/loisir', chores: 'Tâches ménagères', study: 'Étude/projet', travel: 'Voyage' },
      cta: { generate: 'Générer le Plan', regenerate: 'Régénérer', refine_area: 'Affiner la zone' },
      plan: { title: 'Ton Plan de Vie', progress: 'Progression', weekly_goals: 'Objectifs hebdo', monthly_goals: 'Objectifs mensuels', habits: 'Habitudes' },
      module: { reminders: 'Rappels intelligents', feedback: 'Retour hebdomadaire' },
      reminders: { active: 'Tu recevras des rappels quotidiens et hebdomadaires personnalisés.', locked: 'Disponible en Pro+. Débloque des rappels automatiques et personnalisés.' },
      feedback: { active: 'Tu recevras une analyse hebdomadaire avec des recommandations.', locked: 'Disponible en Pro+. Reçois un rapport hebdomadaire avec des améliorations.' },
      errors: { areas: 'Sélectionne au moins une zone.', limit: 'Tu as atteint ta limite quotidienne.' },
      copy: { m1: 'Je suis là pour t’aider à construire la meilleure version de toi‑même.', m2: 'Aujourd’hui, faisons un pas de plus. Prêt(e) ?', m3: 'De petits changements, de grands résultats.' },
      mock: { goal: { week: 'Compléter 3 sessions liées à {{area}}', month: 'Atteindre un jalon clé en {{area}}', learn: { week: 'Étudier {{skill}} (3 x 20m)', month: 'Compléter un module ou jalon en {{skill}}' }, finance: { week: 'Avancer vers : {{goal}}', month: 'Atteindre un jalon financier : {{goal}}' }, weekend: 'Activité du week‑end : {{w}}', refine: 'Action affinée dans {{area}}' }, habit: { '1': 'Habitude de 5 minutes en {{area}}', '2': 'Écrire une courte réflexion sur {{area}}', learn: 'Apprendre {{skill}} (15m)', budget: 'Revoir dépenses et budget (10m)', relation: 'Contact significatif (message/appel)', sleep: 'Hygiène du sommeil (routine 10m)', exercise: { start: 'Marcher 10m', progress: 'Séance d’exercice 20m', maintain: 'Maintien physique 25m' }, diet: { pb: 'Ajouter 1 portion de légumes', hp: 'Planifier des protéines à chaque repas', lc: 'Éviter les sucres raffinés' }, morning: 'Bloc profond le matin (20m) pour {{area}}', focus: 'Session sans notifications (15m)', stress: 'Technique de respiration 4‑7‑8', accountability: 'Check‑in avec partenaire/coach (5m)' } },
      career: { habit: { focus: 'Bloc de focus de {{m}}m' } },
      remark: { privacy: 'Tes réponses sont enregistrées de façon privée.' }
    }
  },
  de: {
    life_coach: {
      common: { select: 'Auswählen…', selected_count: '{{count}} ausgewählt', other: 'Andere', other_ph: 'Andere Option beschreiben' },
      hero: { title: 'Persönlicher KI-Plan', subtitle: 'Ein personalisierter Tagesplan für Prioritäten, Gewohnheiten und nächste Schritte.' },
      stats: { areas: 'Ausgewählte Bereiche', habits: 'Gesamte Gewohnheiten', remaining: 'Heutige Aktionen übrig' },
      form: {
        title: 'Dein Lebensfokus', areas_label: 'Priorisierte Bereiche', daily_time: 'Tägliche verfügbare Zeit',
        emotions_label: 'Wie fühlst du dich insgesamt', emotions: { low: 'Niedrig', medium: 'Mittel', high: 'Hoch' },
        motivation: 'Was motiviert dich derzeit?', motivation_ph: 'Beschreibe deine Motivation',
        routine: 'Wie sieht deine Routine aus?', routine_ph: 'Kurz beschreiben',
        constraints: 'Einschränkungen oder Herausforderungen (optional)',
        sleep_hours: 'Schlafstunden', sleep: { less6: 'Weniger als 6', '6_7': '6‑7', '7_8': '7‑8', more8: 'Mehr als 8' },
        exercise_freq: 'Trainingshäufigkeit', exercise: { never: 'Nie', '1_2': '1‑2x/Woche', '3_4': '3‑4x/Woche', more4: '>4x/Woche' },
        diet_focus: 'Ernährungsfokus', diet: { balanced: 'Ausgewogen', high_protein: 'Eiweißreich', low_carb: 'Kohlenhydratarm', plant_based: 'Pflanzenbasiert' },
        stress_level: 'Stresslevel', level: { low: 'Niedrig', medium: 'Mittel', high: 'Hoch' },
        productivity_peak: 'Produktivitätshoch', daytime: { morning: 'Morgen', afternoon: 'Nachmittag', evening: 'Abend' },
        reminder_time: 'Bevorzugte Erinnerungszeit',
        distractions: 'Haupt‑Ablenkungen',
        learning_goal: 'Lernziel', learning_goal_ph: 'Was möchtest du lernen?',
        financial_goal: 'Finanzziel', financial_goal_ph: 'Z. B. X sparen, Schulden tilgen',
        relationship_goal: 'Beziehungsziel', relationship_goal_ph: 'Familie, Partner, Freunde',
        weekend_routine: 'Wochenend‑Routine', weekend_routine_ph: 'Typische Aktivitäten',
        accountability: { label: 'Verantwortlichkeit (Accountability)', solo: 'Allein', buddy: 'Mit Partner', coach: 'Mit Coach' },
        comm_style: 'Kommunikationsstil', comm: { concise: 'Konzise', detailed: 'Detailliert', motivational: 'Motivierend' }
      },
      area: { health: 'Gesundheit', career: 'Karriere', finance: 'Finanzen', relationships: 'Beziehungen', personal: 'Persönliches Wachstum' },
      motivation: { health: 'Gesundheit verbessern', career: 'Beruflich wachsen', balance: 'Work‑Life‑Balance', learn: 'Fähigkeit lernen', finance: 'Finanzen verbessern', emotional: 'Emotionales Wohlbefinden', consistency: 'Konsequenz', project: 'Persönliches Projekt', exam: 'Prüfung/Zertifikat vorbereiten', stress: 'Stress reduzieren' },
      routine: { office: 'Büro 9‑5', remote: 'Flexibles Remote', student: 'Student', shift: 'Schicht/Wechsel', entrepreneur: 'Unternehmer', caretaker: 'Pflegende Person', night: 'Nachtaktiv', parent: 'Elternteil mit Kindern', variable: 'Sehr variabel' },
      constraints: { time: 'Zeitmangel', stress: 'Stress/Angst', health: 'Körperliche Gesundheit', finance: 'Finanzen', family: 'Familie/Pflege', environment: 'Umfeld/Raum', sleep: 'Unregelmäßiger Schlaf', motivation: 'Niedrige Motivation', tech: 'Technik/Ausrüstung' },
      distractions: { social: 'Soziale Medien', notifs: 'Benachrichtigungen', chat: 'Messenger', noise: 'Umgebungsgeräusche', multitask: 'Multitasking', phone: 'Telefon', fatigue: 'Müdigkeit', perfect: 'Perfektionismus', procrast: 'Aufschieben', family: 'Familienunterbrechungen', tv: 'TV/Spiele' },
      learning: { languages: 'Sprachen', programming: 'Programmierung', dataai: 'Daten/AI', marketing: 'Marketing', sales: 'Vertrieb', personal_finance: 'Private Finanzen', music: 'Musik', design: 'Kunst/Design', cert: 'Prüfung/Zertifikat', softskills: 'Soft Skills' },
      finance: { emergency: 'Notgroschen', pay_debt: 'Schulden tilgen', cut_expenses: 'Ausgaben reduzieren', increase_income: 'Einkommen erhöhen', invest: 'Investieren', buy_house: 'Haus/Fahrzeug kaufen', save_trip: 'Für Reise/Studium sparen', credit_score: 'Bonität verbessern' },
      relation: { communication: 'Kommunikation verbessern', family_time: 'Mehr Familienzeit', partner: 'Partnerschaft stärken', friends: 'Neue Freunde finden', network: 'Professionelles Netzwerk', conflict: 'Konflikt lösen', boundaries: 'Gesunde Grenzen setzen' },
      weekend: { rest: 'Erholung', family: 'Familie', sport: 'Sport/Aktivität', social: 'Sozial', creative: 'Kreativ/Hobby', chores: 'Haushalt', study: 'Studium/Projekt', travel: 'Reisen' },
      cta: { generate: 'Plan erzeugen', regenerate: 'Neu erzeugen', refine_area: 'Bereich verfeinern' },
      plan: { title: 'Dein Lebensplan', progress: 'Fortschritt', weekly_goals: 'Wöchentliche Ziele', monthly_goals: 'Monatliche Ziele', habits: 'Gewohnheiten' },
      module: { reminders: 'Smarte Erinnerungen', feedback: 'Wöchentliches Feedback' },
      reminders: { active: 'Du erhältst personalisierte tägliche und wöchentliche Erinnerungen.', locked: 'Verfügbar in Pro+. Schalte automatische, personalisierte Erinnerungen frei.' },
      feedback: { active: 'Du erhältst wöchentliche Analysen mit Empfehlungen.', locked: 'Verfügbar in Pro+. Erhalte wöchentliche Berichte mit Vorschlägen.' },
      errors: { areas: 'Wähle mindestens einen Bereich.', limit: 'Du hast dein Tageslimit erreicht.' },
      copy: { m1: 'Ich helfe dir, die beste Version deiner selbst zu werden.', m2: 'Heute gehen wir einen Schritt weiter. Bereit?', m3: 'Kleine Änderungen, große Ergebnisse.' },
      mock: { goal: { week: '3 Sitzungen zu {{area}} abschließen', month: 'Einen wichtigen Meilenstein in {{area}} erreichen', learn: { week: '{{skill}} lernen (3 x 20 Min)', month: 'Ein Modul/Etappenziel in {{skill}} abschließen' }, finance: { week: 'Vorankommen bei: {{goal}}', month: 'Finanziellen Meilenstein erreichen: {{goal}}' }, weekend: 'Wochenend‑Aktivität: {{w}}', refine: 'Verfeinerte Aktion in {{area}}' }, habit: { '1': '5‑Minuten‑Gewohnheit in {{area}}', '2': 'Kurze Reflexion über {{area}} schreiben', learn: '{{skill}} lernen (15 Min)', budget: 'Ausgaben & Budget prüfen (10 Min)', relation: 'Bedeutsamer Kontakt (Nachricht/Anruf)', sleep: 'Schlafhygiene (10 Min Routine)', exercise: { start: '10 Min Gehen', progress: '20 Min Training', maintain: '25 Min Erhaltung' }, diet: { pb: '1 Portion Gemüse hinzufügen', hp: 'Protein in jeder Mahlzeit einplanen', lc: 'Raffinierten Zucker vermeiden' }, morning: 'Tiefer Morgenblock (20 Min) für {{area}}', focus: 'Sitzung ohne Benachrichtigungen (15 Min)', stress: '4‑7‑8‑Atemtechnik', accountability: 'Check‑in mit Partner/Coach (5 Min)' } },
      career: { habit: { focus: 'Fokus‑Block von {{m}} Min' } },
      remark: { privacy: 'Deine Antworten werden vertraulich gespeichert.' }
    }
  },
  it: {
    life_coach: {
      common: { select: 'Seleziona…', selected_count: '{{count}} selezionate', other: 'Altro', other_ph: 'Descrivi un’altra opzione' },
      hero: { title: 'Piano Personale IA', subtitle: 'Un copilota emotivo e strategico che ti accompagna ogni giorno.' },
      stats: { areas: 'Aree selezionate', habits: 'Abitudini totali', remaining: 'Azioni rimaste oggi' },
      form: {
        title: 'Il tuo focus di vita', areas_label: 'Aree prioritarie', daily_time: 'Tempo giornaliero disponibile',
        emotions_label: 'Come ti senti in generale', emotions: { low: 'Basso', medium: 'Medio', high: 'Alto' },
        motivation: 'Cosa ti motiva ora?', motivation_ph: 'Descrivi la tua motivazione',
        routine: 'Com’è la tua routine?', routine_ph: 'Descrivila brevemente',
        constraints: 'Vincoli o difficoltà (opzionale)',
        sleep_hours: 'Ore di sonno', sleep: { less6: 'Meno di 6', '6_7': '6‑7', '7_8': '7‑8', more8: 'Più di 8' },
        exercise_freq: 'Frequenza di esercizio', exercise: { never: 'Mai', '1_2': '1‑2 volte/set', '3_4': '3‑4 volte/set', more4: 'Più di 4/set' },
        diet_focus: 'Focalizzazione alimentare', diet: { balanced: 'Equilibrata', high_protein: 'Proteica', low_carb: 'Basso carbo', plant_based: 'Vegetale' },
        stress_level: 'Livello di stress', level: { low: 'Basso', medium: 'Medio', high: 'Alto' },
        productivity_peak: 'Picco di produttività', daytime: { morning: 'Mattina', afternoon: 'Pomeriggio', evening: 'Sera' },
        reminder_time: 'Ora preferita dei promemoria',
        distractions: 'Principali distrazioni',
        learning_goal: 'Obiettivo di apprendimento', learning_goal_ph: 'Cosa vuoi imparare?',
        financial_goal: 'Obiettivo finanziario', financial_goal_ph: 'Es.: risparmiare X, estinguere debiti',
        relationship_goal: 'Obiettivo relazioni', relationship_goal_ph: 'Famiglia, partner, amici',
        weekend_routine: 'Routine del weekend', weekend_routine_ph: 'Attività tipiche',
        accountability: { label: 'Responsabilità (accountability)', solo: 'Da solo', buddy: 'Con un partner', coach: 'Con un coach' },
        comm_style: 'Stile di comunicazione', comm: { concise: 'Conciso', detailed: 'Dettagliato', motivational: 'Motivazionale' }
      },
      area: { health: 'Salute', career: 'Carriera', finance: 'Finanze', relationships: 'Relazioni', personal: 'Crescita personale' },
      motivation: { health: 'Migliorare la salute', career: 'Crescere professionalmente', balance: 'Equilibrio vita‑lavoro', learn: 'Imparare una competenza', finance: 'Migliorare le finanze', emotional: 'Benessere emotivo', consistency: 'Essere costante', project: 'Progetto personale', exam: 'Preparare un esame/certificazione', stress: 'Ridurre lo stress' },
      routine: { office: 'Ufficio 9‑5', remote: 'Remoto flessibile', student: 'Studente', shift: 'Turni', entrepreneur: 'Imprenditore', caretaker: 'Caregiver', night: 'Notturno', parent: 'Genitore con figli', variable: 'Molto variabile' },
      constraints: { time: 'Mancanza di tempo', stress: 'Stress/ansia', health: 'Salute fisica', finance: 'Finanze', family: 'Famiglia/cura', environment: 'Ambiente/spazio', sleep: 'Sonno irregolare', motivation: 'Bassa motivazione', tech: 'Tecnologia/attrezzatura' },
      distractions: { social: 'Social media', notifs: 'Notifiche', chat: 'Messaggistica', noise: 'Rumore', multitask: 'Multitasking', phone: 'Telefono', fatigue: 'Fatica', perfect: 'Perfezionismo', procrast: 'Procrastinazione', family: 'Interruzioni familiari', tv: 'TV/Giochi' },
      learning: { languages: 'Lingue', programming: 'Programmazione', dataai: 'Dati/IA', marketing: 'Marketing', sales: 'Vendite', personal_finance: 'Finanza personale', music: 'Musica', design: 'Arte/Design', cert: 'Esame/Certificazione', softskills: 'Competenze trasversali' },
      finance: { emergency: 'Fondo di emergenza', pay_debt: 'Estinguere debiti', cut_expenses: 'Ridurre spese', increase_income: 'Aumentare entrate', invest: 'Investire', buy_house: 'Comprare casa/veicolo', save_trip: 'Risparmiare per viaggio/studio', credit_score: 'Migliorare punteggio creditizio' },
      relation: { communication: 'Migliorare la comunicazione', family_time: 'Più tempo in famiglia', partner: 'Rafforzare la coppia', friends: 'Fare nuovi amici', network: 'Networking professionale', conflict: 'Risoluzione di un conflitto', boundaries: 'Porre limiti sani' },
      weekend: { rest: 'Riposo', family: 'Famiglia', sport: 'Sport/attività', social: 'Sociale', creative: 'Creativo/hobby', chores: 'Faccende domestiche', study: 'Studio/progetto', travel: 'Viaggi' },
      cta: { generate: 'Genera Piano', regenerate: 'Rigenera', refine_area: 'Affina area' },
      plan: { title: 'Il Tuo Piano di Vita', progress: 'Progresso', weekly_goals: 'Obiettivi settimanali', monthly_goals: 'Obiettivi mensili', habits: 'Abitudini' },
      module: { reminders: 'Promemoria intelligenti', feedback: 'Feedback settimanale' },
      reminders: { active: 'Riceverai promemoria giornalieri e settimanali personalizzati.', locked: 'Disponibile in Pro+. Sblocca promemoria automatici e personalizzati.' },
      feedback: { active: 'Riceverai un’analisi settimanale con raccomandazioni.', locked: 'Disponibile in Pro+. Ottieni un report settimanale con suggerimenti.' },
      errors: { areas: 'Seleziona almeno un’area.', limit: 'Hai raggiunto il limite giornaliero.' },
      copy: { m1: 'Sono qui per aiutarti a costruire la tua migliore versione.', m2: 'Oggi possiamo fare un passo in più. Pronto?', m3: 'Piccoli cambiamenti, grandi risultati.' },
      mock: { goal: { week: 'Completare 3 sessioni relative a {{area}}', month: 'Raggiungere un traguardo chiave in {{area}}', learn: { week: 'Studiare {{skill}} (3 x 20m)', month: 'Completare un modulo o traguardo in {{skill}}' }, finance: { week: 'Avanzare verso: {{goal}}', month: 'Raggiungere traguardo finanziario: {{goal}}' }, weekend: 'Attività del weekend: {{w}}', refine: 'Azione affinata in {{area}}' }, habit: { '1': 'Abitudine da 5 minuti in {{area}}', '2': 'Scrivi una breve riflessione su {{area}}', learn: 'Imparare {{skill}} (15m)', budget: 'Rivedi spese e budget (10m)', relation: 'Contatto significativo (messaggio/chiamata)', sleep: 'Igiene del sonno (routine 10m)', exercise: { start: 'Camminare 10m', progress: 'Sessione di esercizio 20m', maintain: 'Mantenimento 25m' }, diet: { pb: 'Aggiungere 1 porzione di verdure', hp: 'Pianificare proteine in ogni pasto', lc: 'Evitare zuccheri raffinati' }, morning: 'Blocco profondo al mattino (20m) per {{area}}', focus: 'Sessione senza notifiche (15m)', stress: 'Tecnica di respirazione 4‑7‑8', accountability: 'Check‑in con partner/coach (5m)' } },
      career: { habit: { focus: 'Blocco di focus di {{m}}m' } },
      remark: { privacy: 'Le tue risposte vengono salvate privatamente.' }
    }
  },
  zh: {
    life_coach: {
      common: { select: '选择…', selected_count: '已选择 {{count}} 项', other: '其他', other_ph: '填写其他选项' },
      hero: { title: '个人 AI 计划', subtitle: '每天陪伴你的情感与战略副驾驶。' },
      stats: { areas: '已选领域', habits: '总习惯数', remaining: '今日剩余行动' },
      form: {
        title: '你的生活重点', areas_label: '优先领域', daily_time: '可用的每日时间',
        emotions_label: '整体感觉如何', emotions: { low: '低', medium: '中', high: '高' },
        motivation: '你现在的动力是什么？', motivation_ph: '描述你的动力',
        routine: '你的日常是怎样的？', routine_ph: '简要描述',
        constraints: '限制或挑战（可选）',
        sleep_hours: '睡眠时长', sleep: { less6: '少于6小时', '6_7': '6‑7', '7_8': '7‑8', more8: '多于8小时' },
        exercise_freq: '锻炼频率', exercise: { never: '从不', '1_2': '每周1‑2次', '3_4': '每周3‑4次', more4: '每周4次以上' },
        diet_focus: '饮食侧重', diet: { balanced: '均衡', high_protein: '高蛋白', low_carb: '低碳水', plant_based: '植物性' },
        stress_level: '压力水平', level: { low: '低', medium: '中', high: '高' },
        productivity_peak: '效率高峰', daytime: { morning: '上午', afternoon: '下午', evening: '晚上' },
        reminder_time: '偏好的提醒时间',
        distractions: '主要分心因素',
        learning_goal: '学习目标', learning_goal_ph: '你想学什么？',
        financial_goal: '财务目标', financial_goal_ph: '例如：存 X，偿还债务',
        relationship_goal: '人际关系目标', relationship_goal_ph: '家庭、伴侣、朋友',
        weekend_routine: '周末习惯', weekend_routine_ph: '常做的活动',
        accountability: { label: '责任搭档（Accountability）', solo: '单独', buddy: '搭档', coach: '教练' },
        comm_style: '沟通风格', comm: { concise: '简洁', detailed: '详细', motivational: '激励型' }
      },
      area: { health: '健康', career: '职业', finance: '财务', relationships: '关系', personal: '个人成长' },
      motivation: { health: '改善健康', career: '职业成长', balance: '工作生活平衡', learn: '学习一项技能', finance: '改善财务', emotional: '情绪健康', consistency: '保持自律', project: '个人项目', exam: '备考/认证', stress: '减轻压力' },
      routine: { office: '办公室 9‑5', remote: '灵活远程', student: '学生', shift: '倒班/轮班', entrepreneur: '企业家', caretaker: '照护者', night: '夜猫子', parent: '有孩子的父母', variable: '高度变化' },
      constraints: { time: '时间不足', stress: '压力/焦虑', health: '身体健康', finance: '财务', family: '家庭/照护', environment: '环境/空间', sleep: '睡眠不规律', motivation: '动力不足', tech: '技术/设备' },
      distractions: { social: '社交媒体', notifs: '通知', chat: '聊天', noise: '环境噪音', multitask: '多任务', phone: '手机', fatigue: '疲劳', perfect: '完美主义', procrast: '拖延', family: '家庭打扰', tv: '电视/游戏' },
      learning: { languages: '语言', programming: '编程', dataai: '数据/AI', marketing: '营销', sales: '销售', personal_finance: '个人理财', music: '音乐', design: '艺术/设计', cert: '考试/认证', softskills: '软技能' },
      finance: { emergency: '应急基金', pay_debt: '还清债务', cut_expenses: '减少开支', increase_income: '增加收入', invest: '投资', buy_house: '购置房车', save_trip: '为旅行/学习储蓄', credit_score: '提升信用评分' },
      relation: { communication: '改善沟通', family_time: '更多家庭时间', partner: '强化伴侣关系', friends: '结交新朋友', network: '职业社交', conflict: '解决冲突', boundaries: '设定健康边界' },
      weekend: { rest: '休息', family: '家庭', sport: '运动/活动', social: '社交', creative: '创意/爱好', chores: '家务', study: '学习/项目', travel: '旅行' },
      cta: { generate: '生成计划', regenerate: '重新生成', refine_area: '细化领域' },
      plan: { title: '你的生活计划', progress: '进度', weekly_goals: '每周目标', monthly_goals: '每月目标', habits: '习惯' },
      module: { reminders: '智能提醒', feedback: '每周反馈' },
      reminders: { active: '你将收到个性化的每日及每周提醒。', locked: 'Pro+ 可用。解锁自动个性化提醒。' },
      feedback: { active: '你将收到每周分析与建议。', locked: 'Pro+ 可用。获取包含改进建议的每周报告。' },
      errors: { areas: '至少选择一个领域。', limit: '你已达到今日限制。' },
      copy: { m1: '我在这里帮助你成为更好的自己。', m2: '今天再迈进一步，准备好了吗？', m3: '小改变，大成果。' },
      mock: { goal: { week: '完成与 {{area}} 相关的 3 次练习', month: '在 {{area}} 达成关键里程碑', learn: { week: '学习 {{skill}}（3 x 20 分钟）', month: '完成 {{skill}} 的一个模块或里程碑' }, finance: { week: '向 {{goal}} 迈进', month: '达成财务里程碑：{{goal}}' }, weekend: '周末活动：{{w}}', refine: '{{area}} 的精细化行动' }, habit: { '1': '{{area}} 的 5 分钟习惯', '2': '写下关于 {{area}} 的简短反思', learn: '学习 {{skill}}（15 分钟）', budget: '回顾支出与预算（10 分钟）', relation: '有意义的联系（消息/电话）', sleep: '睡眠卫生（10 分钟例行）', exercise: { start: '步行 10 分钟', progress: '20 分钟锻炼', maintain: '25 分钟维持' }, diet: { pb: '增加 1 份蔬菜', hp: '每餐规划蛋白质', lc: '避免精制糖' }, morning: '上午深度专注（20 分钟）用于 {{area}}', focus: '无通知专注（15 分钟）', stress: '4‑7‑8 呼吸法', accountability: '与搭档/教练打卡（5 分钟）' } },
      career: { habit: { focus: '{{m}} 分钟专注块' } },
      remark: { privacy: '你的答案将被私密保存。' }
    }
  },
  ja: {
    life_coach: {
      common: { select: '選択…', selected_count: '{{count}} 件選択', other: 'その他', other_ph: '別の選択肢を記入' },
      hero: { title: 'パーソナルAIプラン', subtitle: '毎日に寄り添う感情的・戦略的コパイロット。' },
      stats: { areas: '選択した領域', habits: '合計習慣数', remaining: '本日の残りアクション' },
      form: {
        title: 'あなたのライフフォーカス', areas_label: '優先領域', daily_time: '1日の利用可能時間',
        emotions_label: '全体的な気分', emotions: { low: '低', medium: '中', high: '高' },
        motivation: '今のモチベーションは？', motivation_ph: 'モチベーションを記述',
        routine: '日々のルーティンは？', routine_ph: '簡潔に記述',
        constraints: '制約・課題（任意）',
        sleep_hours: '睡眠時間', sleep: { less6: '6時間未満', '6_7': '6‑7', '7_8': '7‑8', more8: '8時間超' },
        exercise_freq: '運動頻度', exercise: { never: 'ほぼしない', '1_2': '週1‑2回', '3_4': '週3‑4回', more4: '週4回以上' },
        diet_focus: '食事の重点', diet: { balanced: 'バランス重視', high_protein: '高たんぱく', low_carb: '低炭水化物', plant_based: '植物性中心' },
        stress_level: 'ストレスレベル', level: { low: '低', medium: '中', high: '高' },
        productivity_peak: '生産性ピーク', daytime: { morning: '午前', afternoon: '午後', evening: '夜' },
        reminder_time: '希望のリマインド時刻',
        distractions: '主な気を散らすもの',
        learning_goal: '学習目標', learning_goal_ph: '何を学びたいですか？',
        financial_goal: '金銭目標', financial_goal_ph: '例：Xを貯金、借金返済',
        relationship_goal: '人間関係の目標', relationship_goal_ph: '家族、パートナー、友人',
        weekend_routine: '週末のルーティン', weekend_routine_ph: 'よく行う活動',
        accountability: { label: 'アカウンタビリティ', solo: 'ひとりで', buddy: '相棒と', coach: 'コーチと' },
        comm_style: 'コミュニケーションスタイル', comm: { concise: '簡潔', detailed: '詳細', motivational: 'モチベーション重視' }
      },
      area: { health: '健康', career: 'キャリア', finance: '財務', relationships: '人間関係', personal: '自己成長' },
      motivation: { health: '健康を改善', career: '職業的成長', balance: 'ワークライフバランス', learn: 'スキルを学ぶ', finance: '財務を改善', emotional: '感情の健康', consistency: '継続性', project: '個人プロジェクト', exam: '試験/資格の準備', stress: 'ストレスを減らす' },
      routine: { office: 'オフィス 9‑5', remote: '柔軟なリモート', student: '学生', shift: 'シフト/交代制', entrepreneur: '起業家', caretaker: '介護者', night: '夜型', parent: '子どものいる親', variable: '非常に不規則' },
      constraints: { time: '時間不足', stress: 'ストレス/不安', health: '身体の健康', finance: '財務', family: '家族/ケア', environment: '環境/スペース', sleep: '不規則な睡眠', motivation: '低い動機', tech: '技術/設備' },
      distractions: { social: 'SNS', notifs: '通知', chat: 'メッセージ', noise: '環境音', multitask: 'マルチタスク', phone: 'スマホ', fatigue: '疲労', perfect: '完璧主義', procrast: '先延ばし', family: '家族の割り込み', tv: 'テレビ/ゲーム' },
      learning: { languages: '言語', programming: 'プログラミング', dataai: 'データ/AI', marketing: 'マーケティング', sales: '営業', personal_finance: 'パーソナルファイナンス', music: '音楽', design: 'アート/デザイン', cert: '試験/資格', softskills: 'ソフトスキル' },
      finance: { emergency: '緊急資金', pay_debt: '借金返済', cut_expenses: '支出削減', increase_income: '収入増加', invest: '投資', buy_house: '住宅/車購入', save_trip: '旅行/留学の貯蓄', credit_score: '信用スコア向上' },
      relation: { communication: 'コミュニケーション改善', family_time: '家族との時間を増やす', partner: 'パートナー関係を強化', friends: '新しい友達を作る', network: 'プロのネットワーク', conflict: '対立の解決', boundaries: '健全な境界線を設定' },
      weekend: { rest: '休息', family: '家族', sport: '運動/活動', social: '社交', creative: '創作/趣味', chores: '家事', study: '勉強/プロジェクト', travel: '旅行' },
      cta: { generate: 'プランを生成', regenerate: '再生成', refine_area: '領域を洗練' },
      plan: { title: 'あなたのライフプラン', progress: '進捗', weekly_goals: '週間目標', monthly_goals: '月間目標', habits: '習慣' },
      module: { reminders: 'スマートリマインダー', feedback: '週間フィードバック' },
      reminders: { active: '毎日・毎週のパーソナライズド通知を受け取ります。', locked: 'Pro+で利用可能。自動で個別化された通知を解放。' },
      feedback: { active: '毎週の分析と推奨が届きます。', locked: 'Pro+で利用可能。改善提案を含む週次レポートを取得。' },
      errors: { areas: '少なくとも1つの領域を選択してください。', limit: '本日の上限に達しました。' },
      copy: { m1: '最高の自分を築くお手伝いをします。', m2: '今日ももう一歩、進みましょう。', m3: '小さな変化が大きな成果に。' },
      mock: { goal: { week: '{{area}} に関連するセッションを3回達成', month: '{{area}}の重要なマイルストーンを達成', learn: { week: '{{skill}} を学ぶ（20分×3）', month: '{{skill}} のモジュール/マイルストーンを完了' }, finance: { week: '前進：{{goal}}', month: '財務マイルストーン達成：{{goal}}' }, weekend: '週末アクティビティ：{{w}}', refine: '{{area}} の洗練されたアクション' }, habit: { '1': '{{area}} での5分習慣', '2': '{{area}} について短いリフレクションを書く', learn: '{{skill}} を学ぶ（15分）', budget: '支出と予算の見直し（10分）', relation: '意味のある連絡（メッセージ/電話）', sleep: '睡眠衛生（10分ルーティン）', exercise: { start: '10分歩く', progress: '20分運動', maintain: '25分維持' }, diet: { pb: '野菜1食分を追加', hp: '毎食タンパク質を計画', lc: '精製糖を避ける' }, morning: '午前のディープブロック（20分） {{area}}', focus: '通知なしのセッション（15分）', stress: '4‑7‑8 呼吸法', accountability: '相棒/コーチとチェックイン（5分）' } },
      career: { habit: { focus: '{{m}}分の集中ブロック' } },
      remark: { privacy: '回答はプライベートに保存されます。' }
    }
  },
  ar: {
    life_coach: {
      common: { select: 'اختر…', selected_count: '{{count}} محددة', other: 'أخرى', other_ph: 'اذكر خياراً آخر' },
      hero: { title: 'خطة ذكاء اصطناعي شخصية', subtitle: 'خطة يومية مخصصة لتنظيم الأولويات والعادات والخطوات التالية.' },
      stats: { areas: 'المجالات المحددة', habits: 'إجمالي العادات', remaining: 'الإجراءات المتبقية اليوم' },
      form: {
        title: 'تركيز حياتك', areas_label: 'المجالات ذات الأولوية', daily_time: 'الوقت المتاح يومياً',
        emotions_label: 'كيف تشعر بشكل عام', emotions: { low: 'منخفض', medium: 'متوسط', high: 'مرتفع' },
        motivation: 'ما الذي يحفّزك الآن؟', motivation_ph: 'صف دافعك',
        routine: 'كيف تبدو روتينك؟', routine_ph: 'صف بإيجاز',
        constraints: 'قيود أو تحديات (اختياري)',
        sleep_hours: 'ساعات النوم', sleep: { less6: 'أقل من 6', '6_7': '6‑7', '7_8': '7‑8', more8: 'أكثر من 8' },
        exercise_freq: 'معدّل التمرين', exercise: { never: 'أبداً', '1_2': '1‑2 مرّة/أسبوع', '3_4': '3‑4 مرات/أسبوع', more4: 'أكثر من 4/أسبوع' },
        diet_focus: 'تركيز النظام الغذائي', diet: { balanced: 'متوازن', high_protein: 'عالي البروتين', low_carb: 'منخفض الكربوهيدرات', plant_based: 'نباتي' },
        stress_level: 'مستوى التوتر', level: { low: 'منخفض', medium: 'متوسط', high: 'مرتفع' },
        productivity_peak: 'ذروة الإنتاجية', daytime: { morning: 'صباح', afternoon: 'بعد الظهر', evening: 'مساء' },
        reminder_time: 'وقت التذكير المفضل',
        distractions: 'أهم المشتتات',
        learning_goal: 'هدف التعلّم', learning_goal_ph: 'ماذا تريد أن تتعلم؟',
        financial_goal: 'هدف مالي', financial_goal_ph: 'مثال: ادخار X، سداد دين',
        relationship_goal: 'هدف العلاقات', relationship_goal_ph: 'العائلة، الشريك، الأصدقاء',
        weekend_routine: 'روتين نهاية الأسبوع', weekend_routine_ph: 'أنشطة معتادة',
        accountability: { label: 'المساءلة', solo: 'لوحدي', buddy: 'مع شريك', coach: 'مع مدرّب' },
        comm_style: 'أسلوب التواصل', comm: { concise: 'موجز', detailed: 'مفصّل', motivational: 'تحفيزي' }
      },
      area: { health: 'الصحة', career: 'المسيرة', finance: 'المال', relationships: 'العلاقات', personal: 'النمو الشخصي' },
      motivation: { health: 'تحسين الصحة', career: 'النمو المهني', balance: 'توازن الحياة والعمل', learn: 'تعلّم مهارة', finance: 'تحسين المال', emotional: 'الصحة العاطفية', consistency: 'الالتزام', project: 'مشروع شخصي', exam: 'التحضير لاختبار/شهادة', stress: 'تقليل التوتر' },
      routine: { office: 'مكتب 9‑5', remote: 'عن بعد مرن', student: 'طالب', shift: 'نوبات/متغيّر', entrepreneur: 'ريادي', caretaker: 'مقدّم رعاية', night: 'مسائي', parent: 'أب/أم مع أطفال', variable: 'متغيّر جداً' },
      constraints: { time: 'نقص الوقت', stress: 'توتر/قلق', health: 'الصحة الجسدية', finance: 'المال', family: 'العائلة/الرعاية', environment: 'البيئة/المكان', sleep: 'نوم غير منتظم', motivation: 'انخفاض الدافعية', tech: 'التقنية/المعدات' },
      distractions: { social: 'وسائل التواصل', notifs: 'الإشعارات', chat: 'المراسلة', noise: 'الضجيج', multitask: 'تعدد المهام', phone: 'الهاتف', fatigue: 'الإجهاد', perfect: 'الكمالية', procrast: 'التسويف', family: 'مقاطعات العائلة', tv: 'التلفاز/الألعاب' },
      learning: { languages: 'اللغات', programming: 'البرمجة', dataai: 'البيانات/الذكاء الاصطناعي', marketing: 'التسويق', sales: 'المبيعات', personal_finance: 'المالية الشخصية', music: 'الموسيقى', design: 'الفن/التصميم', cert: 'اختبار/شهادة', softskills: 'المهارات اللينة' },
      finance: { emergency: 'صندوق الطوارئ', pay_debt: 'سداد الدين', cut_expenses: 'خفض النفقات', increase_income: 'زيادة الدخل', invest: 'الاستثمار', buy_house: 'شراء منزل/مركبة', save_trip: 'ادخار لرحلة/دراسة', credit_score: 'تحسين السجل الائتماني' },
      relation: { communication: 'تحسين التواصل', family_time: 'وقت أكثر مع العائلة', partner: 'تقوية العلاقة', friends: 'تكوين صداقات جديدة', network: 'شبكات مهنية', conflict: 'حلّ نزاع', boundaries: 'وضع حدود صحية' },
      weekend: { rest: 'راحة', family: 'عائلة', sport: 'رياضة/نشاط', social: 'اجتماعي', creative: 'إبداع/هواية', chores: 'أعمال منزلية', study: 'دراسة/مشروع', travel: 'سفر' },
      cta: { generate: 'إنشاء الخطة', regenerate: 'إعادة الإنشاء', refine_area: 'تحسين المجال' },
      plan: { title: 'خطّة حياتك', progress: 'التقدم', weekly_goals: 'أهداف أسبوعية', monthly_goals: 'أهداف شهرية', habits: 'العادات' },
      module: { reminders: 'تذكيرات ذكية', feedback: 'ملاحظات أسبوعية' },
      reminders: { active: 'ستتلقى تذكيرات يومية وأسبوعية مخصّصة.', locked: 'متاح في Pro+. فعّل التذكيرات التلقائية المخصّصة.' },
      feedback: { active: 'ستتلقى تحليلاً أسبوعياً مع توصيات.', locked: 'متاح في Pro+. احصل على تقرير أسبوعي مع اقتراحات.' },
      errors: { areas: 'اختر مجالاً واحداً على الأقل.', limit: 'وصلت إلى الحدّ اليومي.' },
      copy: { m1: 'أنا هنا لأساعدك على بناء أفضل نسخة منك.', m2: 'يمكننا اليوم التقدّم خطوة إضافية. مستعد؟', m3: 'تغييرات صغيرة تصنع نتائج كبيرة.' },
      mock: { goal: { week: 'أكمل 3 جلسات متعلقة بـ {{area}}', month: 'تحقيق إنجاز رئيسي في {{area}}', learn: { week: 'ادرس {{skill}} (3 × 20د)', month: 'أكمل وحدة أو إنجازاً في {{skill}}' }, finance: { week: 'التقدّم نحو: {{goal}}', month: 'تحقيق إنجاز مالي: {{goal}}' }, weekend: 'نشاط نهاية الأسبوع: {{w}}', refine: 'إجراء محسّن في {{area}}' }, habit: { '1': 'عادة 5 دقائق في {{area}}', '2': 'اكتب تأملاً قصيراً حول {{area}}', learn: 'تعلّم {{skill}} (15د)', budget: 'مراجعة المصاريف والميزانية (10د)', relation: 'تواصل ذو معنى (رسالة/اتصال)', sleep: 'نظافة النوم (روتين 10د)', exercise: { start: 'المشي 10د', progress: 'جلسة تمرين 20د', maintain: 'حفاظ 25د' }, diet: { pb: 'أضف حصة خضار إضافية', hp: 'خطّط للبروتين بكل وجبة', lc: 'تجنّب السكريات المكررة' }, morning: 'كتلة تركيز صباحية (20د) لـ {{area}}', focus: 'جلسة بلا إشعارات (15د)', stress: 'تقنية تنفّس 4‑7‑8', accountability: 'تواصل مع الشريك/المدرّب (5د)' } },
      career: { habit: { focus: 'كتلة تركيز {{m}} دقيقة' } },
      remark: { privacy: 'تُحفظ إجاباتك بشكل خاص.' }
    }
  },
  hi: {
    life_coach: {
      common: { select: 'चुनें…', selected_count: '{{count}} चयनित', other: 'अन्य', other_ph: 'अन्य विकल्प लिखें' },
      hero: { title: 'व्यक्तिगत AI योजना', subtitle: 'प्राथमिकताओं, आदतों और अगले कदमों को व्यवस्थित करने की व्यक्तिगत दैनिक योजना।' },
      stats: { areas: 'चयनित क्षेत्र', habits: 'कुल आदतें', remaining: 'आज की शेष क्रियाएं' },
      form: {
        title: 'आपका जीवन‑फोकस', areas_label: 'प्राथमिकता वाले क्षेत्र', daily_time: 'दैनिक उपलब्ध समय',
        emotions_label: 'कुल मिलाकर आप कैसा महसूस करते हैं', emotions: { low: 'कम', medium: 'मध्यम', high: 'उच्च' },
        motivation: 'अभी आपको क्या प्रेरित करता है?', motivation_ph: 'अपनी प्रेरणा लिखें',
        routine: 'आपकी दिनचर्या कैसी है?', routine_ph: 'संक्षेप में लिखें',
        constraints: 'बंधन/चुनौतियाँ (वैकल्पिक)',
        sleep_hours: 'नींद के घंटे', sleep: { less6: '6 से कम', '6_7': '6‑7', '7_8': '7‑8', more8: '8 से अधिक' },
        exercise_freq: 'व्यायाम की आवृत्ति', exercise: { never: 'कभी नहीं', '1_2': 'सप्ताह में 1‑2 बार', '3_4': 'सप्ताह में 3‑4 बार', more4: 'सप्ताह में 4+ बार' },
        diet_focus: 'आहार फोकस', diet: { balanced: 'संतुलित', high_protein: 'उच्च प्रोटीन', low_carb: 'लो‑कार्ब', plant_based: 'प्लांट‑बेस्ड' },
        stress_level: 'तनाव स्तर', level: { low: 'कम', medium: 'मध्यम', high: 'उच्च' },
        productivity_peak: 'उत्पादकता शिखर', daytime: { morning: 'सुबह', afternoon: 'दोपहर', evening: 'शाम' },
        reminder_time: 'पसंदीदा रिमाइंडर समय',
        distractions: 'मुख्य विचलन',
        learning_goal: 'सीखने का लक्ष्य', learning_goal_ph: 'आप क्या सीखना चाहते हैं?',
        financial_goal: 'वित्तीय लक्ष्य', financial_goal_ph: 'उदा.: X बचत, कर्ज चुकाना',
        relationship_goal: 'रिश्तों का लक्ष्य', relationship_goal_ph: 'परिवार, साथी, मित्र',
        weekend_routine: 'सप्ताहांत की दिनचर्या', weekend_routine_ph: 'सामान्य गतिविधियाँ',
        accountability: { label: 'जिम्मेदारी भागीदार (Accountability)', solo: 'अकेले', buddy: 'साथी के साथ', coach: 'कोच के साथ' },
        comm_style: 'संचार शैली', comm: { concise: 'संक्षिप्त', detailed: 'विस्तृत', motivational: 'प्रेरक' }
      },
      area: { health: 'स्वास्थ्य', career: 'कैरियर', finance: 'वित्त', relationships: 'संबंध', personal: 'व्यक्तिगत विकास' },
      motivation: { health: 'स्वास्थ्य सुधार', career: 'पेशेवर विकास', balance: 'काम‑जीवन संतुलन', learn: 'एक कौशल सीखना', finance: 'वित्त सुधार', emotional: 'भावनात्मक कल्याण', consistency: 'निरंतरता', project: 'व्यक्तिगत प्रोजेक्ट', exam: 'परीक्षा/प्रमाणन की तैयारी', stress: 'तनाव घटाना' },
      routine: { office: 'दफ़्तर 9‑5', remote: 'लचीला रिमोट', student: 'छात्र', shift: 'शिफ्ट/रोटेशन', entrepreneur: 'उद्यमी', caretaker: 'देखभालकर्ता', night: 'रात्रिचर', parent: 'बच्चों वाले माता‑पिता', variable: 'बहुत परिवर्तनशील' },
      constraints: { time: 'समय की कमी', stress: 'तनाव/चिंता', health: 'शारीरिक स्वास्थ्य', finance: 'वित्त', family: 'परिवार/देखभाल', environment: 'पर्यावरण/स्थान', sleep: 'अनियमित नींद', motivation: 'कम प्रेरणा', tech: 'तकनीक/उपकरण' },
      distractions: { social: 'सोशल मीडिया', notifs: 'सूचनाएँ', chat: 'संदेश', noise: 'शोर', multitask: 'मल्टीटास्किंग', phone: 'फ़ोन', fatigue: 'थकान', perfect: 'परफेक्शनिज़्म', procrast: 'टालमटोल', family: 'परिवार के व्यवधान', tv: 'टीवी/गेम्स' },
      learning: { languages: 'भाषाएँ', programming: 'प्रोग्रामिंग', dataai: 'डाटा/एआई', marketing: 'ब्रांडिंग/मार्केटिंग', sales: 'बिक्री', personal_finance: 'व्यक्तिगत वित्त', music: 'संगीत', design: 'कला/डिज़ाइन', cert: 'परीक्षा/प्रमाणन', softskills: 'सॉफ्ट स्किल्स' },
      finance: { emergency: 'आपातकालीन निधि', pay_debt: 'कर्ज़ चुकाना', cut_expenses: 'खर्च कम करना', increase_income: 'आय बढ़ाना', invest: 'निवेश', buy_house: 'घर/वाहन खरीदना', save_trip: 'यात्रा/पढ़ाई के लिए बचत', credit_score: 'क्रेडिट स्कोर सुधार' },
      relation: { communication: 'संचार में सुधार', family_time: 'परिवार के साथ अधिक समय', partner: 'संबंध को मजबूत करना', friends: 'नए मित्र बनाना', network: 'पेशेवर नेटवर्किंग', conflict: 'विवाद सुलझाना', boundaries: 'स्वस्थ सीमाएँ तय करना' },
      weekend: { rest: 'आराम', family: 'परिवार', sport: 'खेल/गतिविधि', social: 'मिलना‑जुलना', creative: 'रचनात्मक/शौक', chores: 'घरेलू कार्य', study: 'पढ़ाई/प्रोजेक्ट', travel: 'यात्रा' },
      cta: { generate: 'प्लान बनाएँ', regenerate: 'पुनः जनरेट', refine_area: 'क्षेत्र परिशोधित करें' },
      plan: { title: 'आपकी जीवन योजना', progress: 'प्रगति', weekly_goals: 'साप्ताहिक लक्ष्य', monthly_goals: 'मासिक लक्ष्य', habits: 'आदतें' },
      module: { reminders: 'स्मार्ट रिमाइंडर्स', feedback: 'साप्ताहिक फीडबैक' },
      reminders: { active: 'आपको दैनिक और साप्ताहिक निजी रिमाइंडर्स मिलेंगे।', locked: 'Pro+ में उपलब्ध। स्वचालित निजी रिमाइंडर्स अनलॉक करें।' },
      feedback: { active: 'आपको साप्ताहिक विश्लेषण और सुझाव मिलेंगे।', locked: 'Pro+ में उपलब्ध। सुझावों के साथ साप्ताहिक रिपोर्ट पाएं।' },
      errors: { areas: 'कम से कम एक क्षेत्र चुनें।', limit: 'आप अपने दैनिक सीमा तक पहुँचे।' },
      copy: { m1: 'मैं आपकी बेहतरीन स्व‑छवि बनाने में साथ हूँ।', m2: 'आज एक कदम और आगे बढ़ते हैं—तैयार?', m3: 'छोटे बदलाव, बड़े नतीजे।' },
      mock: { goal: { week: '{{area}} से संबंधित 3 सत्र पूरे करें', month: '{{area}} में एक प्रमुख माइलस्टोन प्राप्त करें', learn: { week: '{{skill}} पढ़ाई (3 × 20m)', month: '{{skill}} का एक मॉड्यूल/माइलस्टोन पूरा' }, finance: { week: 'आगे बढ़ें: {{goal}}', month: 'वित्तीय माइलस्टोन: {{goal}}' }, weekend: 'सप्ताहांत गतिविधि: {{w}}', refine: '{{area}} में परिष्कृत कार्रवाई' }, habit: { '1': '{{area}} में 5‑मिनट की आदत', '2': '{{area}} पर छोटा चिंतन लिखें', learn: '{{skill}} सीखें (15m)', budget: 'खर्च और बजट की समीक्षा (10m)', relation: 'सार्थक संपर्क (संदेश/कॉल)', sleep: 'नींद स्वच्छता (10m रूटीन)', exercise: { start: '10m पैदल चलना', progress: '20m व्यायाम सत्र', maintain: '25m मेंटेनेंस' }, diet: { pb: 'एक अतिरिक्त सब्जी की सर्विंग जोड़ें', hp: 'हर भोजन में प्रोटीन योजना', lc: 'रिफाइंड शुगर से बचें' }, morning: '{{area}} के लिए सुबह का डीप ब्लॉक (20m)', focus: 'बिना नोटिफिकेशन सत्र (15m)', stress: '4‑7‑8 श्वसन तकनीक', accountability: 'साथी/कोच के साथ चेक‑इन (5m)' } },
      career: { habit: { focus: '{{m}}m का फोकस ब्लॉक' } },
      remark: { privacy: 'आपके उत्तर निजी रूप से सहेजे जाते हैं।' }
    }
  },
  ru: {
    life_coach: {
      common: { select: 'Выбрать…', selected_count: 'Выбрано: {{count}}', other: 'Другое', other_ph: 'Укажите другой вариант' },
      hero: { title: 'Персональный ИИ-план', subtitle: 'Эмоциональный и стратегический помощник на каждый день.' },
      stats: { areas: 'Выбранные области', habits: 'Всего привычек', remaining: 'Осталось действий сегодня' },
      form: {
        title: 'Твой жизненный фокус', areas_label: 'Приоритетные области', daily_time: 'Доступное время в день',
        emotions_label: 'Как ты в целом себя чувствуешь', emotions: { low: 'Низкий', medium: 'Средний', high: 'Высокий' },
        motivation: 'Что тебя сейчас мотивирует?', motivation_ph: 'Опиши свою мотивацию',
        routine: 'Какая у тебя рутина?', routine_ph: 'Кратко опиши',
        constraints: 'Ограничения или сложности (необязательно)',
        sleep_hours: 'Часы сна', sleep: { less6: 'Меньше 6', '6_7': '6‑7', '7_8': '7‑8', more8: 'Более 8' },
        exercise_freq: 'Частота тренировок', exercise: { never: 'Никогда', '1_2': '1‑2 раза/нед', '3_4': '3‑4 раза/нед', more4: 'Более 4/нед' },
        diet_focus: 'Фокус питания', diet: { balanced: 'Сбалансированный', high_protein: 'Белковый', low_carb: 'Низкоуглеводный', plant_based: 'Растительный' },
        stress_level: 'Уровень стресса', level: { low: 'Низкий', medium: 'Средний', high: 'Высокий' },
        productivity_peak: 'Пик продуктивности', daytime: { morning: 'Утро', afternoon: 'День', evening: 'Вечер' },
        reminder_time: 'Предпочтительное время напоминаний',
        distractions: 'Основные отвлекающие факторы',
        learning_goal: 'Цель обучения', learning_goal_ph: 'Что хочешь изучить?',
        financial_goal: 'Финансовая цель', financial_goal_ph: 'Напр.: накопить X, закрыть долг',
        relationship_goal: 'Цель в отношениях', relationship_goal_ph: 'Семья, партнёр, друзья',
        weekend_routine: 'Рутина выходных', weekend_routine_ph: 'Типичные занятия',
        accountability: { label: 'Ответственность (accountability)', solo: 'Один', buddy: 'С напарником', coach: 'С коучем' },
        comm_style: 'Стиль общения', comm: { concise: 'Кратко', detailed: 'Подробно', motivational: 'Мотивирующе' }
      },
      area: { health: 'Здоровье', career: 'Карьера', finance: 'Финансы', relationships: 'Отношения', personal: 'Личностный рост' },
      motivation: { health: 'Улучшить здоровье', career: 'Профессиональный рост', balance: 'Баланс работы и жизни', learn: 'Выучить навык', finance: 'Улучшить финансы', emotional: 'Эмоциональное благополучие', consistency: 'Стабильность', project: 'Личный проект', exam: 'Подготовка к экзамену/сертиф.', stress: 'Снизить стресс' },
      routine: { office: 'Офис 9‑5', remote: 'Гибрид/удалёнка', student: 'Студент', shift: 'Смены/график', entrepreneur: 'Предприниматель', caretaker: 'Опекун', night: '«Сова»', parent: 'Родитель с детьми', variable: 'Очень вариативно' },
      constraints: { time: 'Нехватка времени', stress: 'Стресс/тревога', health: 'Физическое здоровье', finance: 'Финансы', family: 'Семья/забота', environment: 'Среда/пространство', sleep: 'Нерегулярный сон', motivation: 'Низкая мотивация', tech: 'Техника/оборудование' },
      distractions: { social: 'Соцсети', notifs: 'Уведомления', chat: 'Мессенджеры', noise: 'Шум', multitask: 'Мультизадачность', phone: 'Телефон', fatigue: 'Усталость', perfect: 'Перфекционизм', procrast: 'Прокрастинация', family: 'Семейные отвлечения', tv: 'ТВ/Игры' },
      learning: { languages: 'Языки', programming: 'Программирование', dataai: 'Данные/ИИ', marketing: 'Маркетинг', sales: 'Продажи', personal_finance: 'Личные финансы', music: 'Музыка', design: 'Искусство/Дизайн', cert: 'Экзамен/Сертификация', softskills: 'Гибкие навыки' },
      finance: { emergency: 'Резервный фонд', pay_debt: 'Погасить долг', cut_expenses: 'Сократить расходы', increase_income: 'Увеличить доход', invest: 'Инвестировать', buy_house: 'Купить жильё/авто', save_trip: 'Копить на поездку/учёбу', credit_score: 'Поднять кредитный рейтинг' },
      relation: { communication: 'Улучшить коммуникацию', family_time: 'Больше времени с семьёй', partner: 'Укрепить отношения', friends: 'Завести новых друзей', network: 'Проф.нетворкинг', conflict: 'Разрешить конфликт', boundaries: 'Выстроить здоровые границы' },
      weekend: { rest: 'Отдых', family: 'Семья', sport: 'Спорт/активность', social: 'Соц.', creative: 'Творчество/хобби', chores: 'Домашние дела', study: 'Учёба/проект', travel: 'Путешествия' },
      cta: { generate: 'Сгенерировать план', regenerate: 'Пересоздать', refine_area: 'Уточнить область' },
      plan: { title: 'Твой жизненный план', progress: 'Прогресс', weekly_goals: 'Еженедельные цели', monthly_goals: 'Ежемесячные цели', habits: 'Привычки' },
      module: { reminders: 'Умные напоминания', feedback: 'Еженедельная обратная связь' },
      reminders: { active: 'Ты будешь получать персональные напоминания ежедневно и еженедельно.', locked: 'Доступно в Pro+. Разблокируй авто‑напоминания.' },
      feedback: { active: 'Ты получишь еженедельный анализ с рекомендациями.', locked: 'Доступно в Pro+. Еженедельный отчёт с улучшениями.' },
      errors: { areas: 'Выбери хотя бы одну область.', limit: 'Достигнут дневной лимит.' },
      copy: { m1: 'Я помогу тебе стать лучшей версией себя.', m2: 'Сегодня сделаем ещё один шаг. Готов?', m3: 'Маленькие изменения — большие результаты.' },
      mock: { goal: { week: 'Выполнить 3 сессии по {{area}}', month: 'Достичь ключевой вехи в {{area}}', learn: { week: 'Изучать {{skill}} (3 × 20 мин)', month: 'Завершить модуль/веху по {{skill}}' }, finance: { week: 'Продвигаться к: {{goal}}', month: 'Достичь финансовой вехи: {{goal}}' }, weekend: 'Активность на выходных: {{w}}', refine: 'Уточнённое действие по {{area}}' }, habit: { '1': '5‑минутная привычка в {{area}}', '2': 'Короткая заметка‑рефлексия по {{area}}', learn: 'Учить {{skill}} (15 мин)', budget: 'Просмотр расходов и бюджета (10 мин)', relation: 'Значимый контакт (сообщение/звонок)', sleep: 'Гигиена сна (10‑мин рутина)', exercise: { start: '10 мин ходьбы', progress: '20 мин тренировка', maintain: '25 мин поддержание' }, diet: { pb: 'Добавить 1 порцию овощей', hp: 'Запланировать протеин в каждый приём пищи', lc: 'Избегать рафинированного сахара' }, morning: 'Глубокий блок утром (20 мин) для {{area}}', focus: 'Сессия без уведомлений (15 мин)', stress: 'Техника дыхания 4‑7‑8', accountability: 'Чек‑ин с напарником/коучем (5 мин)' } },
      career: { habit: { focus: 'Фокус‑блок на {{m}} мин' } },
      remark: { privacy: 'Твои ответы сохраняются приватно.' }
    }
  }
};

Object.keys(lifeCoachTranslations).forEach(lng => {
  const target = resources[lng];
  if (!target) return;
  const node = lifeCoachTranslations[lng];
  function apply(prefix, src) {
    Object.keys(src).forEach(k => {
      const dotted = prefix ? `${prefix}.${k}` : k;
      const val = src[k];
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        apply(dotted, val);
      } else {
        setDeep(target.translation, dotted, val);
      }
    });
  }
  apply('', node);
});

export function setupI18n(defaultLng = 'en') {
  const supported = Object.keys(resources);
  const normalized = String(defaultLng || 'en').toLowerCase().split('-')[0];
  const targetLng = supported.includes(normalized) ? normalized : 'en';

  // Si ya estaba inicializado (HMR), asegurar que las nuevas claves se fusionen en caliente
  if (i18n.isInitialized) {
    try {
      supported.forEach(lng => {
        const bundle = resources[lng]?.translation || {};
        // deep=true, overwrite=true para forzar overrides (incluye chat.* en EN)
        i18n.addResourceBundle(lng, 'translation', bundle, true, true);
        // Añadir/actualizar namespace específico de Tutor de Estudio IA en todos los idiomas soportados (fallback automático a EN)
        const mapStudyTutor = { en: studyTutorEn, es: studyTutorEs, pt: studyTutorPt, fr: studyTutorFr, de: studyTutorDe, it: studyTutorIt, zh: studyTutorZh, ja: studyTutorJa, ko: studyTutorKo, ar: studyTutorAr, hi: studyTutorHi, ru: studyTutorRu, tr: studyTutorTr };
        const bundleStudyTutor = mapStudyTutor[lng] || studyTutorEn;
        i18n.addResourceBundle(lng, 'studyTutor', bundleStudyTutor, true, true);

        // Añadir/actualizar namespace específico de Deep Research en todos los idiomas soportados (fallback automático a EN)
        try {
          const deepwebPath = `./locales/${lng}/deepweb.json`;
          // Import dinámico para evitar errores si el archivo no existe
          let bundleDeepweb;
          switch (lng) {
            case 'en': bundleDeepweb = require('./locales/en/deepweb.json'); break;
            case 'es': bundleDeepweb = require('./locales/es/deepweb.json'); break;
            case 'pt': bundleDeepweb = require('./locales/pt/deepweb.json'); break;
            case 'fr': bundleDeepweb = require('./locales/fr/deepweb.json'); break;
            case 'de': bundleDeepweb = require('./locales/de/deepweb.json'); break;
            case 'it': bundleDeepweb = require('./locales/it/deepweb.json'); break;
            case 'zh': bundleDeepweb = require('./locales/zh/deepweb.json'); break;
            case 'ja': bundleDeepweb = require('./locales/ja/deepweb.json'); break;
            case 'ko': bundleDeepweb = require('./locales/ko/deepweb.json'); break;
            case 'ar': bundleDeepweb = require('./locales/ar/deepweb.json'); break;
            case 'hi': bundleDeepweb = require('./locales/hi/deepweb.json'); break;
            case 'ru': bundleDeepweb = require('./locales/ru/deepweb.json'); break;
            case 'tr': bundleDeepweb = require('./locales/tr/deepweb.json'); break;
            default: bundleDeepweb = require('./locales/en/deepweb.json'); break;
          }
          i18n.addResourceBundle(lng, 'deepweb', bundleDeepweb, true, true);
        } catch (e) {
          // Si el archivo no existe, fallback a EN
          try {
            const bundleDeepweb = require('./locales/en/deepweb.json');
            i18n.addResourceBundle(lng, 'deepweb', bundleDeepweb, true, true);
          } catch (_) {}
        }

        // Añadir/actualizar namespace específico de Connect en todos los idiomas soportados (fallback automático a EN)
        try {
          const connectPath = `./locales/${lng}/connect.json`;
          let bundleConnect;
          switch (lng) {
            case 'en': bundleConnect = require('./locales/en/connect.json'); break;
            case 'es': bundleConnect = require('./locales/es/connect.json'); break;
            case 'pt': bundleConnect = require('./locales/pt/connect.json'); break;
            case 'fr': bundleConnect = require('./locales/fr/connect.json'); break;
            case 'de': bundleConnect = require('./locales/de/connect.json'); break;
            case 'it': bundleConnect = require('./locales/it/connect.json'); break;
            case 'zh': bundleConnect = require('./locales/zh/connect.json'); break;
            case 'ja': bundleConnect = require('./locales/ja/connect.json'); break;
            case 'ko': bundleConnect = require('./locales/ko/connect.json'); break;
            case 'ar': bundleConnect = require('./locales/ar/connect.json'); break;
            case 'hi': bundleConnect = require('./locales/hi/connect.json'); break;
            case 'ru': bundleConnect = require('./locales/ru/connect.json'); break;
            case 'tr': bundleConnect = require('./locales/tr/connect.json'); break;
            default: bundleConnect = require('./locales/en/connect.json'); break;
          }
          i18n.addResourceBundle(lng, 'connect', bundleConnect, true, true);
        } catch (e) {
          try {
            const bundleConnect = require('./locales/en/connect.json');
            i18n.addResourceBundle(lng, 'connect', bundleConnect, true, true);
          } catch (_) {}
        }

        // Añadir/actualizar namespace específico de Propose/Ideas (cubre 12 idiomas + TR)
        try {
          let bundlePropose;
          switch (lng) {
            case 'en': bundlePropose = require('./locales/en/propose.json'); break;
            case 'es': bundlePropose = require('./locales/es/propose.json'); break;
            case 'pt': bundlePropose = require('./locales/pt/propose.json'); break;
            case 'fr': bundlePropose = require('./locales/fr/propose.json'); break;
            case 'de': bundlePropose = require('./locales/de/propose.json'); break;
            case 'it': bundlePropose = require('./locales/it/propose.json'); break;
            case 'zh': bundlePropose = require('./locales/zh/propose.json'); break;
            case 'ja': bundlePropose = require('./locales/ja/propose.json'); break;
            case 'ko': bundlePropose = require('./locales/ko/propose.json'); break;
            case 'ar': bundlePropose = require('./locales/ar/propose.json'); break;
            case 'hi': bundlePropose = require('./locales/hi/propose.json'); break;
            case 'ru': bundlePropose = require('./locales/ru/propose.json'); break;
            case 'tr': bundlePropose = require('./locales/tr/propose.json'); break;
            default: bundlePropose = require('./locales/en/propose.json'); break;
          }
          i18n.addResourceBundle(lng, 'propose', bundlePropose, true, true);
        } catch (e) {
          try { const bundlePropose = require('./locales/en/propose.json'); i18n.addResourceBundle(lng, 'propose', bundlePropose, true, true); } catch (_) {}
        }

        // Añadir/actualizar namespace específico de Mass Control en todos los idiomas (fallback automático a EN)
        try {
          let bundleMass;
          switch (lng) {
            case 'en': bundleMass = require('./locales/en/mass_control.json'); break;
            case 'es': bundleMass = require('./locales/es/mass_control.json'); break;
            case 'pt': bundleMass = require('./locales/pt/mass_control.json'); break;
            case 'fr': bundleMass = require('./locales/fr/mass_control.json'); break;
            case 'de': bundleMass = require('./locales/de/mass_control.json'); break;
            case 'it': bundleMass = require('./locales/it/mass_control.json'); break;
            case 'zh': bundleMass = require('./locales/zh/mass_control.json'); break;
            case 'ja': bundleMass = require('./locales/ja/mass_control.json'); break;
            case 'ko': bundleMass = require('./locales/ko/mass_control.json'); break;
            case 'ar': bundleMass = require('./locales/ar/mass_control.json'); break;
            case 'hi': bundleMass = require('./locales/hi/mass_control.json'); break;
            case 'ru': bundleMass = require('./locales/ru/mass_control.json'); break;
            case 'tr': bundleMass = require('./locales/tr/mass_control.json'); break;
            default: bundleMass = require('./locales/en/mass_control.json'); break;
          }
          i18n.addResourceBundle(lng, 'mass_control', bundleMass, true, true);
        } catch (e) {
          try { const bundleMass = require('./locales/en/mass_control.json'); i18n.addResourceBundle(lng, 'mass_control', bundleMass, true, true); } catch (_) {}
        }

        // Saneamiento: evitar que 'chat.hint' sea objeto por claves puntuales 'chat.hint.shortcut'
        const store = i18n.getDataByLanguage(lng)?.translation || {};
        const hintVal = getDeep(store, 'chat.hint');
        if (hintVal && typeof hintVal !== 'string') {
          // Forzar string correcto
          const fallback = chatCoreTranslations[lng]?.['chat.hint'] || 'Press Enter to send';
          setDeep(store, 'chat.hint', fallback);
        }
        if (hasDeep(store, 'chat.hint.shortcut')) {
          deleteDeep(store, 'chat.hint.shortcut');
        }
        const shortcutVal = chatCoreTranslations[lng]?.['chat.hint_shortcut'];
        if (shortcutVal && !hasDeep(store, 'chat.hint_shortcut')) {
          setDeep(store, 'chat.hint_shortcut', shortcutVal);
        }
      });
      // Opcional: actualizar idioma si cambió la preferencia inicial
      if (targetLng && i18n.language !== targetLng) {
        i18n.changeLanguage(targetLng).catch(() => {});
      }
    } catch (_) {}
    return i18n;
  }

  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: targetLng,
      // Forzar siempre el fallback a inglés cuando falten claves o el idioma no exista
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
      // Evitar warnings en dev
      returnNull: false,
      returnEmptyString: false,
    });
  
  try {
    // Saneamiento post-init (primer arranque)
    supported.forEach(lng => {
      const store = i18n.getDataByLanguage(lng)?.translation || {};
      const hintVal = getDeep(store, 'chat.hint');
      if (hintVal && typeof hintVal !== 'string') {
        const fallback = chatCoreTranslations[lng]?.['chat.hint'] || 'Press Enter to send';
        setDeep(store, 'chat.hint', fallback);
      }
      if (hasDeep(store, 'chat.hint.shortcut')) {
        deleteDeep(store, 'chat.hint.shortcut');
      }
      const shortcutVal = chatCoreTranslations[lng]?.['chat.hint_shortcut'];
      if (shortcutVal && !hasDeep(store, 'chat.hint_shortcut')) {
        setDeep(store, 'chat.hint_shortcut', shortcutVal);
      }
      i18n.addResourceBundle(lng, 'translation', store, true, true);
      // Cargar namespace específico de Tutor de Estudio IA en todos los idiomas (semillas); fallbackLng='en' cubre claves faltantes
      const map = { en: studyTutorEn, es: studyTutorEs, pt: studyTutorPt, fr: studyTutorFr, de: studyTutorDe, it: studyTutorIt, zh: studyTutorZh, ja: studyTutorJa, ko: studyTutorKo, ar: studyTutorAr, hi: studyTutorHi, ru: studyTutorRu, tr: studyTutorTr };
      const bundleNs = map[lng] || studyTutorEn;
      i18n.addResourceBundle(lng, 'studyTutor', bundleNs, true, true);

      // Cargar namespace específico de Deep Research en todos los idiomas (semillas); usar fallback a EN si faltan archivos
      try {
        let bundleDeepweb;
        switch (lng) {
          case 'en': bundleDeepweb = require('./locales/en/deepweb.json'); break;
          case 'es': bundleDeepweb = require('./locales/es/deepweb.json'); break;
          case 'pt': bundleDeepweb = require('./locales/pt/deepweb.json'); break;
          case 'fr': bundleDeepweb = require('./locales/fr/deepweb.json'); break;
          case 'de': bundleDeepweb = require('./locales/de/deepweb.json'); break;
          case 'it': bundleDeepweb = require('./locales/it/deepweb.json'); break;
          case 'zh': bundleDeepweb = require('./locales/zh/deepweb.json'); break;
          case 'ja': bundleDeepweb = require('./locales/ja/deepweb.json'); break;
          case 'ko': bundleDeepweb = require('./locales/ko/deepweb.json'); break;
          case 'ar': bundleDeepweb = require('./locales/ar/deepweb.json'); break;
          case 'hi': bundleDeepweb = require('./locales/hi/deepweb.json'); break;
          case 'ru': bundleDeepweb = require('./locales/ru/deepweb.json'); break;
          case 'tr': bundleDeepweb = require('./locales/tr/deepweb.json'); break;
          default: bundleDeepweb = require('./locales/en/deepweb.json'); break;
        }
        i18n.addResourceBundle(lng, 'deepweb', bundleDeepweb, true, true);
      } catch (e) {
        try {
          const bundleDeepweb = require('./locales/en/deepweb.json');
          i18n.addResourceBundle(lng, 'deepweb', bundleDeepweb, true, true);
        } catch (_) {}
      }

      // Cargar namespace específico de Connect en todos los idiomas (semillas); usar fallback a EN si faltan archivos
      try {
        let bundleConnect;
        switch (lng) {
          case 'en': bundleConnect = require('./locales/en/connect.json'); break;
          case 'es': bundleConnect = require('./locales/es/connect.json'); break;
          case 'pt': bundleConnect = require('./locales/pt/connect.json'); break;
          case 'fr': bundleConnect = require('./locales/fr/connect.json'); break;
          case 'de': bundleConnect = require('./locales/de/connect.json'); break;
          case 'it': bundleConnect = require('./locales/it/connect.json'); break;
          case 'zh': bundleConnect = require('./locales/zh/connect.json'); break;
          case 'ja': bundleConnect = require('./locales/ja/connect.json'); break;
          case 'ko': bundleConnect = require('./locales/ko/connect.json'); break;
          case 'ar': bundleConnect = require('./locales/ar/connect.json'); break;
          case 'hi': bundleConnect = require('./locales/hi/connect.json'); break;
          case 'ru': bundleConnect = require('./locales/ru/connect.json'); break;
          case 'tr': bundleConnect = require('./locales/tr/connect.json'); break;
          default: bundleConnect = require('./locales/en/connect.json'); break;
        }
        i18n.addResourceBundle(lng, 'connect', bundleConnect, true, true);
      } catch (e) {
        try {
          const bundleConnect = require('./locales/en/connect.json');
          i18n.addResourceBundle(lng, 'connect', bundleConnect, true, true);
        } catch (_) {}
      }
      
      // Añadir/actualizar namespace específico de Propose/Ideas en todos los idiomas
      try {
        let bundlePropose;
        switch (lng) {
          case 'en': bundlePropose = require('./locales/en/propose.json'); break;
          case 'es': bundlePropose = require('./locales/es/propose.json'); break;
          case 'pt': bundlePropose = require('./locales/pt/propose.json'); break;
          case 'fr': bundlePropose = require('./locales/fr/propose.json'); break;
          case 'de': bundlePropose = require('./locales/de/propose.json'); break;
          case 'it': bundlePropose = require('./locales/it/propose.json'); break;
          case 'zh': bundlePropose = require('./locales/zh/propose.json'); break;
          case 'ja': bundlePropose = require('./locales/ja/propose.json'); break;
          case 'ko': bundlePropose = require('./locales/ko/propose.json'); break;
          case 'ar': bundlePropose = require('./locales/ar/propose.json'); break;
          case 'hi': bundlePropose = require('./locales/hi/propose.json'); break;
          case 'ru': bundlePropose = require('./locales/ru/propose.json'); break;
          case 'tr': bundlePropose = require('./locales/tr/propose.json'); break;
          default: bundlePropose = require('./locales/en/propose.json'); break;
        }
        i18n.addResourceBundle(lng, 'propose', bundlePropose, true, true);
      } catch (e) {
        try { const bundlePropose = require('./locales/en/propose.json'); i18n.addResourceBundle(lng, 'propose', bundlePropose, true, true); } catch (_) {}
      }

      // Cargar namespace específico de Mass Control en todos los idiomas (fallback EN si falta archivo)
      try {
        let bundleMass;
        switch (lng) {
          case 'en': bundleMass = require('./locales/en/mass_control.json'); break;
          case 'es': bundleMass = require('./locales/es/mass_control.json'); break;
          case 'pt': bundleMass = require('./locales/pt/mass_control.json'); break;
          case 'fr': bundleMass = require('./locales/fr/mass_control.json'); break;
          case 'de': bundleMass = require('./locales/de/mass_control.json'); break;
          case 'it': bundleMass = require('./locales/it/mass_control.json'); break;
          case 'zh': bundleMass = require('./locales/zh/mass_control.json'); break;
          case 'ja': bundleMass = require('./locales/ja/mass_control.json'); break;
          case 'ko': bundleMass = require('./locales/ko/mass_control.json'); break;
          case 'ar': bundleMass = require('./locales/ar/mass_control.json'); break;
          case 'hi': bundleMass = require('./locales/hi/mass_control.json'); break;
          case 'ru': bundleMass = require('./locales/ru/mass_control.json'); break;
          case 'tr': bundleMass = require('./locales/tr/mass_control.json'); break;
          default: bundleMass = require('./locales/en/mass_control.json'); break;
        }
        i18n.addResourceBundle(lng, 'mass_control', bundleMass, true, true);
      } catch (e) {
        try { const bundleMass = require('./locales/en/mass_control.json'); i18n.addResourceBundle(lng, 'mass_control', bundleMass, true, true); } catch (_) {}
      }
    });
  } catch (_) {}
  return i18n;
}

export default i18n;
